import {
  Component, OnInit, KeyValueDiffers, AfterViewInit, ViewChild, ViewChildren, HostListener, ElementRef,
  QueryList, NgZone, Renderer2, ChangeDetectorRef
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import * as $ from 'jquery';

import { ActivatedRoute, Router } from '@angular/router';
import { OnDestroy, OnChanges, DoCheck, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { EmbedVideoService } from 'ngx-embed-video';
import { AngularCropperjsComponent } from 'angular-cropperjs';
import { DragulaService } from 'ng2-dragula';
import * as dragula from 'dragula';
import * as autoScroll from 'dom-autoscroller';
import { SnotifyService } from 'ng-snotify';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';
import { DomSanitizer } from '@angular/platform-browser';
import * as QuillNamespace from 'quill';
import * as QuillDelta from 'quill-delta';
import { isEqual } from 'lodash';
const Quill: any = QuillNamespace;
import { DaterangePickerComponent } from 'ng2-daterangepicker';
import { forkJoin } from 'rxjs';
import { cloneDeep } from 'lodash';
import Editor from "../../../../assets/js/ckeditor";

import { ColorPickerService } from 'ngx-color-picker';
import { data } from 'jquery';
import { StoryContainerService } from '../../story-container/story-container.service';
import { AuthenticationService } from '../../../service/authentication.service';
import { LocalstorageService } from '../../../service/localstorage.service';
import { GoogleAnalyticsService } from '../../../service/google-analytics.service';
import { PlainClipboard } from '../../../service/PlainClipboard.service';
import { StaticDataService } from '../../../service/static-data.service';
import { Config } from '../../../config/config';
import { RestDataService } from '../../../service/rest-data.service';
import { SharedDataService } from '../../../service/shared-data.service';
import { ElementModuleComponent } from '../../element-module/element-module.component';
import { TagsCreatorComponent } from '../../tags-creator/tags-creator.component';
import { WebStoriesComponent } from '../../web-stories/web-stories.component';
import { environment } from '../../../../environments/environment';
import { VersioningTree } from '../../../service/linked-list.service';
import { StoryContainerComponent } from '../../story-container/story-container.component';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';
@Component({
  selector: '.app-lite-story-container',
  templateUrl: './lite-story-container.component.html',
  styleUrls: ['./lite-story-container.component.css']
})
export class LiteStoryContainerComponent implements OnInit, OnDestroy, DoCheck, AfterViewInit {
  subscription: Subscription[] = [];
  form: FormGroup;
  sourceList = ['DIGITAL', 'PRINT', 'AGENCY'];
  selectedFile: File = null;
  SingleselectedFile: File = null;
  id = this.route.snapshot.paramMap.get('id');
  page_id = StaticDataService.story_page_id;
  save_api = StaticDataService.story_save_api;
  get_api = StaticDataService.story_get_api;
  version_api = StaticDataService.story_version_api;
  all_element_api = StaticDataService.element_byids_api;
  lockAcquire_api = StaticDataService.story_lockAcquire_api;
  lockRelease_api = StaticDataService.story_lockRelease_api;
  unlock_story_api = StaticDataService.story_unlock_api;
  url_generate_api = StaticDataService.url_generate_api;
  keywords_generate_api = StaticDataService.keywords_generate_api;
  showMarket = false;
  storyEditMode = true;
  toggleflag = false;
  autosave: any;
  pdfSrc: string;
  storyType: string;
  isPhotopopup = false;
  isVideopopup = false;
  isLightbox = false;
  temporaryChangesFlag = false;
  headlinePopup = false;
  tagResetFlag = true;
  suggestTags = [];
  suggestTagsTemp = [];
  changeFlag = false;
  focusElement = '';
  focusOnLeadMedia = false;
  focusOnHeadline = false;
  focusOnSummary = false;
  innerFocusFlag = false;
  editMode: boolean;
  invalidData: boolean;
  storyLoaded = false;
  disableSelectType = true;
  firstLoadCheck = 0;
  selectedValue: string;
  childKeyDownEvent = false;
  showPhotoGallery = true;
  errorModalOnPublish = false;
  validationFlag = false;
  errorDisplayArray = [];
  showLoader = false;
  wirePreviewStory = null;
  originalStory = null;
  togglePreview = false;
  marketCode: string;
  marketText: string;
  adTitle: string = '';
  addIconClick: boolean = true
  marketPopup = false;
  matchPopup = false;
  isLiveblogEmbedCalled:boolean;
  isCanonicalReadoOnly = false;
  // languageTrans = false;
  selectedType = '';
  activeFeed = 'metadata';
  liveBlogShowMaxEle=StaticDataService.livblogShowMaxEle;
  copyliveBlogShowMaxEle:number=this.liveBlogShowMaxEle;
  singleCalendarConfig = {
    'singleDatePicker': true,
    'showDropdowns': true,
    'timePicker': true,
    'timePicker24Hour': true,
    'timePickerSeconds': false,
    'showCustomRangeLabel': false,
    'alwaysShowCalendars': true,
    'opens': 'center',
    'drops': 'down'
  };
  flagdata = {};
  storyFlowIndex: number;
  storyFlowArray = [
    ['CREATED', 'FILED', 'EDITED', 'SCHEDULED', 'EMBARGO', 'PUBLISHED', 'KILLED'], // current state
    ['1', '2', '3', '4', '7', '', ''], // CTA
    ['purple', 'blue', 'orange', 'orange', 'blue', 'blue', 'blue'], // color of primary CTA
    ['9', '10', '6,10', '5', '8', '12,13,14,16', '15'], // Secondary CTA
    ['CREATED', 'FILED', 'EDITED', '', '', 'PUBLISHED', 'KILLED'] // status display text
  ];
  storyFlowActionArray = [
    // 1
    {
      displayName: 'File Story',
      methodName: 'fileCurrentStory',
      functionType: 'button',
      id: 'fileStory'
    },
    // 2
    {
      displayName: 'Finished Editing',
      methodName: 'editCurrentStory',
      functionType: 'button',
      id: 'finishedEditing'
    },
    // 3
    {
      displayName: 'Schedule to Publish',
      methodName: 'scheduleCurrentStory',
      functionType: 'calendar',
      modelIdForTime: 'scheduledAt',
      id: 'scheduleToPublish'
    },
    // 4
    {
      displayName: 'Change Schedule',
      methodName: 'scheduleCurrentStory',
      functionType: 'calendar',
      modelIdForTime: 'scheduledAt',
      id: 'changeSchedule'
    },
    // 5
    {
      displayName: 'Remove Schedule',
      methodName: 'unScheduleCurrentStory',
      functionType: 'button',
      id: 'removeSchedule'
    },
    // 6
    {
      displayName: 'Embargo',
      methodName: 'embargoCurrentStory',
      functionType: 'calendar',
      modelIdForTime: 'embargoAt',
      id: 'embargo'
    },
    // 7
    {
      displayName: 'Change Embargo',
      methodName: 'embargoCurrentStory',
      functionType: 'calendar',
      modelIdForTime: 'embargoAt',
      id: 'changeEmbargo'
    },
    // 8
    {
      displayName: 'Remove Embargo',
      methodName: 'unEmbargoCurrentStory',
      functionType: 'button',
      id: 'removeEmbargo'
    },
    // 9
    {
      displayName: 'Discard Story',
      methodName: 'deleteCurrentStory',
      functionType: 'button',
      id: 'discardStory'
    },
    // 10
    {
      displayName: 'Move Back',
      methodName: 'revertStoryState',
      functionType: 'button',
      id: 'moveBack'
    },
    // 11
    {
      displayName: 'Pick for Editing',
      methodName: 'pickForEditingCurrentStory',
      functionType: 'button',
      id: 'pickForEditing'
    },
    // 12
    {
      displayName: 'Soft Publish',
      methodName: 'softPublish',
      functionType: 'button',
      id: 'softPublish'
    },
    // 13
    {
      displayName: 'Change URL',
      methodName: 'changeStoryURL',
      functionType: 'button',
      id: 'changeUrl'
    },
    // 14
    {
      displayName: 'Kill Story',
      methodName: 'killStoryURL',
      functionType: 'button',
      id: 'killStory'
    },
    // 15
    {
      displayName: 'UnKill Story',
      methodName: 'unkillStoryURL',
      functionType: 'button',
      id: 'unkillStory'
    },
    // 16
    {
      displayName: 'Purge Story',
      methodName: 'purgeStory',
      functionType: 'button',
      id: 'purgeStory'
    }
  ];
  currentcardID: string;
  enableMultipleRelatedStory= false;
  flowCTAButtons = [];
  flowSecCTAButtons = [];
  revertListFlag = false;
  storySetFlag: boolean;
  lastStoryTempData: any;
  tempStoryData = {
    'mobileHeadline': '',
    'mobileAppNotificationHeadline': '',
    'browserNotificationHeadline': '',
    'facebookHeadline': '',
    'twitterHeadline': '',
    'Headline': '',
    'urlHeadline': '',
    'headline': '',
    'newsletterHeadline': '',
    'newsletterSummary': '',
    'quickReadSummary': '',
    'h2HeaderHeadline': '',
    'h3HeaderHeadline': ''
  };
  versionHistory: any = {};
  versionLock = false;
  previousVersionstoryData = null;
  lastStoryData: any;
  storyData: any;
  publishFlag = false;
  metaToggleFlag = true;
  leadMediaImageToggle = false;
  leadMediaVideoToggle = false;
  showElementPopup = false;
  showAmazonPopup = false;
  tableReusablePopup = false;
  fieldSet = [
    {
      labelName: 'Reported By',
      focusFlag: false,
      dataModelId: 'storyData.metadata.reportedBy',
      dataModelIdWithObject: 'storyData.metadata.reportedByList',
      metadataModelId: 'reportedBy',
      inputPlaceholder: 'Name of Reporter(s)',
      auto: true,
      metadataModelIdWithObject: 'reportedByList'
    },
    {
      labelName: 'Written By',
      focusFlag: false,
      dataModelId: 'storyData.metadata.writtenBy',
      dataModelIdWithObject: 'storyData.metadata.writtenByList',
      metadataModelId: 'writtenBy',
      inputPlaceholder: 'Name of Writer(s)',
      auto: true,
      metadataModelIdWithObject: 'writtenByList'
    },
    {
      labelName: 'Edited By',
      focusFlag: false,
      dataModelId: 'storyData.metadata.editedBy',
      dataModelIdWithObject: 'storyData.metadata.editedByList',
      metadataModelId: 'editedBy',
      inputPlaceholder: 'Name of Editor(s)',
      auto: true,
      metadataModelIdWithObject: 'editedByList'
    },
    {
      labelName: 'Agency By Line',
      focusFlag: false,
      dataModelId: 'storyData.metadata.agencyByLine',
      metadataModelId: 'agencyByLine',
      inputPlaceholder: 'Ageny\'s Author',
      auto: false
    },
  ];
  authorFieldSet = {
    labelName: 'By Line',
    focusFlag: false,
    dataModelId: 'storyData.metadata.authors',
    dataModelIdWithObject: 'storyData.metadata.authorsList',
    metadataModelId: 'authors',
    metadataModelIdWithObject: 'authorsList',
    auto: true,
    inputPlaceholder: 'Add Byline here..'
  };
  postedByFieldSet = {
    labelName: 'Posted By',
    focusFlag: false,
    dataModelId: 'storyData.metadata.postedBy',
    dataModelIdWithObject: 'storyData.metadata.postedByList',
    metadataModelId: 'postedByList',
    metadataModelIdWithObject: 'postedByList',
    auto: true,
    inputPlaceholder: 'Add Posted By here..'
  };
  monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  toolbarToggle = false;
  imageCaption: string;
  paraContent = null;
  paraFlag = false;
  isLightboxVideo = false;
  errorheadlineMaxLength = 80;
  lMDomainId: String = "5aeab8eefc36f218b0e0866b";
  isLMdomain: Boolean = false;

  @ViewChild('headlineEl', {static: false}) headlineElement: ElementRef;
  @ViewChild('summaryEl',{static: false}) summaryElement: ElementRef;
  @ViewChild('introEl',{static: false}) introElement: ElementRef;
  @ViewChild(ElementModuleComponent,{static: false}) elRefunction: ElementModuleComponent;


  @ViewChildren('elReferenc') elReference: QueryList<any>;
  @ViewChildren('newElement') elRef: ElementModuleComponent;
  @ViewChildren('leadElement') leadelRef: ElementModuleComponent;
  @ViewChildren('leadElementl') leadelRefl: ElementModuleComponent;
  @ViewChildren('newListElement') elListRef: ElementModuleComponent;
  @ViewChildren('newPhotostoryElement') elPhotostoryRef: ElementModuleComponent;
  @ViewChildren('newLiveblogElement') elLiveRef: ElementModuleComponent;
  @ViewChildren('sectionInput') sectionField;
  @ViewChildren('subSectionInput') subSectionField;
  @ViewChildren('categoryInput') categoryField;
  @ViewChildren('brandInput') brandField;
  @ViewChildren('brandEleInput') brandEleField;
  @ViewChildren('modelInput') modelField;
  @ViewChildren('modelEleInput') modelEleField;
  @ViewChildren('categoryEleInput') categoryEleField;
  @ViewChild('categoryList',{static: false}) categoryList;
  @ViewChild('brandList',{static: false}) brandList;
  @ViewChild('modelList',{static: false}) modelList;
  @ViewChildren('subSectionL2Input') subSectionL2Field;
  @ViewChildren('agencyInput') agencyField;
  @ViewChildren('contentBucketInput') contentBucketField;
  @ViewChildren('primaryLocationInput') primaryLocationField;
  @ViewChildren('columnInput') columnField;
  @ViewChildren('attributionInput') attributionField;
  @ViewChild('sectionList',{static: false}) sectionList;
  @ViewChild('subSectionList',{static: false}) subSectionList;
  @ViewChild('subSectionL2List',{static: false}) subSectionL2List;
  @ViewChild('agencyList',{static: false}) agencyList;
  @ViewChild('contentBucketList',{static: false}) contentBucketList;
  @ViewChild('primaryLocationList',{static: false}) primaryLocationList;
  @ViewChild('columnList',{static: false}) columnList;
  @ViewChild('attributionList',{static: false}) attributionList;
  @ViewChildren('autoscroll') autoscroll: ElementRef;
  @ViewChild('preivewMobile',{static: false}) mobprev: ElementRef;
  @ViewChild('preivewDesktop',{static: false}) deskprev: ElementRef;
  @ViewChild('secondaryCTAs',{static: false}) secondaryCTA: ElementRef;
  @ViewChild('toolbarInlineImage',{static: false}) inlineImageToolbar: ElementRef;
  @ViewChild('toolbarSampleImage',{static: false}) sampleImageToolbar: ElementRef;
  @ViewChild('toolbarReview',{static: false}) inlineImagereview: ElementRef;
  @ViewChild('toolbarEmbed',{static: false}) inlineEmbed: ElementRef;
  @ViewChild('toolbarTable',{static: false}) inlineTable: ElementRef;

  @ViewChild('uploadGalleryId',{static: false}) galleryUploadElement: ElementRef;
  @ViewChild('pickGalleryId',{static: false}) galleryPickElement: ElementRef;
  @ViewChild('addLiveblogButton',{static: false}) liveblogButton: ElementRef;
  @ViewChild('addLiveblogPostButton',{static: false}) liveblogAddButton: ElementRef;
  @ViewChild('addListicleButton',{static: false}) listicleButton: ElementRef;
  @ViewChild('firstMeta',{static: false}) topMeta: TagsCreatorComponent;
  @ViewChild('webStoryElement',{static: false}) webStoryElementRef: WebStoriesComponent;

  authorsSuggestion = [];
  topicsSuggestion = [];
  agencySuggestion = [];
  contentBucketSuggestion = [];
  primaryLocationSuggestion = [];
  columnSuggestion = [];
  agencyQuery = '';
  contentBucketQuery = '';
  primaryLocationQuery = '';
  columnQuery = '';
  filteredAgencySuggestion = [];
  filteredContentBucketSuggestion = [];
  filteredPrimaryLocationSuggestion = [];
  filteredColumnSuggestion = [];
  insideSection = false;
  insideBrand = false;
  insideCategory = false;
  insideModel = false;
  insideSubSection = false;
  insideSubSectionL2 = false;
  showHeadlineerror = false;
  insideAgency = false;
  insideContentBucket = false;
  insidePrimaryLocation = false;
  insideColumn = false;
  sectionSuggestion = [];
  subSectionSuggestion = {};
  brandSuggestion = [];
  brandSuggestionMain = [];
  modelSuggestionMain = [];
  modelSuggestion : any;
  categories = [];
  categorySuggestion = [];
  categorySuggestionMain = [];
  subSectionL2Suggestion = {};
  allSubSections = [];
  allModels = [];
  allSubSectionsL2 = [];
  sectionQuery = '';
  brandQuery = '';
  categoryQuery = '';
  modelQuery = '';
  filteredSectionSuggestion = [];
  filteredBrandSuggestion = [];
  filteredCategorySuggestion = [];
  filteredModelSuggestion = [];
  subSectionQuery = '';
  subSectionL2Query = '';
  filteredSubSectionSuggestion = [];
  filteredSubSectionL2Suggestion = [];
  sectionValue: FormControl = new FormControl();
  showLanuageTab = false;
  showWebStoriesTab =  false;
  isLightboxLogo = false;
  isLightboxCoverImage = false;
  topBottom = ['Top', 'Bottom'];
  leftRight = ['Left', 'Right'];
  automaticQuickReadEnabled = this.sharedService.isdomainConfig('story','automaticQuickReads');
  editableDisclaimer = this.sharedService.isdomainConfig('story','editableDisclaimer');
  inlineImageFlag = false;
  sampleImageFlag = false;
  howToStepsInlineImageFlag = false;
  marketValue: string;

  toolbarConfig = {
    toolbar: [
      // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic'],
      ['link'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      // ['blockquote']
    ],
    keyboard: {
      bindings: {
        tab: false
      }
    }
  };
  listicleToolbarConfig = {
    toolbar: [
      // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic'],
      ['link'],
      // ['blockquote']
    ],
    keyboard: {
      bindings: {
        tab: false
      }
    }
  };
  headlineToolbar = {
    toolbar: [
      ['italic'],
      // [{ 'list': 'bullet' }]
    ],
    keyboard: {
      bindings: {
        tab: false,
        handleEnter: {
          key: 13,
          handler: function () {
            // Do nothing
          }
        }
      }
    }
    // maxLength: 80
  };
  summaryToolbar = {
    toolbar: [
      // ['italic'],
      [{ 'list': 'bullet' }]
    ],
    keyboard: {
      bindings: {
        tab: false
      }
    }
  };
  summaryToolbarWithHyperlink = {
    toolbar: [
      // ['italic'],
      [{ 'list': 'bullet' }],
      ['link']
    ],
    keyboard: {
      bindings: {
        tab: false
      }
    }
  };
  lastFocusedCard = null;
  focusedCard = null;
  tempCardArray = {
    ids: [],
    objs: [],
    elIds: [],
    format: []
  };
  videoUrl = '';
  videoDuration = 0;
  videoUrlPopup = false;
  @ViewChild('angularCropper169',{static:false}) public angularCropper169: AngularCropperjsComponent;
  @ViewChild('angularCropper11',{static:false}) public angularCropper11: AngularCropperjsComponent;
  @ViewChild('angularCropper23',{static:false}) public angularCropper23: AngularCropperjsComponent;
  cropperConfig169 = {
    aspectRatio: 16 / 9,
    cropBoxResizable: false,
    cropBoxMovable: false,
    dragMode: 'move',
    viewMode: 1,
    toggleDragModeOnDblClick: false,
    autoCropArea: 0,
    movable: true,
    scalable: true,
    zoomable: true
  };
  cropperConfig11 = {
    aspectRatio: 1 / 1,
    cropBoxResizable: false,
    cropBoxMovable: false,
    dragMode: 'move',
    viewMode: 1,
    toggleDragModeOnDblClick: false,
    autoCropArea: 0,
    movable: true,
    scalable: true,
    zoomable: true
  };

  cropperConfig23 = {
    aspectRatio: 2 / 3,
    cropBoxResizable: false,
    cropBoxMovable: false,
    dragMode: 'move',
    viewMode: 1,
    toggleDragModeOnDblClick: false,
    autoCropArea: 0,
    movable: true,
    scalable: true,
    zoomable: true
  };
  initZoom169 = 2;
  initZoom11 = 2;
  initZoom23 = 2;
  cropperImageUrl = {
    url: null,
    data: null,
    blobData: null
  };
  showCropper = false;
  tempLeadMedia = null;
  showRelatedStoryPopup = false;
  relatedStoryMultipleSelectFlag: boolean;
  tempRelatedStoryId = null;
  tempRelatedElementId = null;
  inlineImageToggle = false;
  inlineReviewToggle = false;
  inlineEmbedToggle = false;
  inlineTableToggle = false;
  timer: any;
  headline = '';
  summary = '';
  storyWordCount = 0;
  subs = new Subscription();
  headlineEditor = null;
  summaryEditor = null;
  introEditor = null;
  saveInQueue = 0;
  notificationMap = {
    facebook: false,
    twitter: false,
    app: false,
    desktop: false
  };
  embedPopup = false;
  embedCode = '';
  embedSourceUrl = '';
  embedSubType = '';
  focusArray = [];
  ifVersionTimeline = false;
  scroll: any;
  lastFocusedElement = null;
  isLocked = false;
  socialMap = {
    facebook: false,
    twitter: false,
    mobile: false,
    web: false
  };
  tagTwitterAuthor = false;
  socialMapCounter = {
    'facebook': 0,
    'twitter': 0,
    'mobile': 0,
    'web': 0
  };
  elementCountFlag = false;
  elementDataArray = null;
  serverUrl = this.config.get('product').socketUrl;
  stompClient = null;
  currentSelection = 0;
  excludeImageListingIds = [];
  allRelated = [];
  targetLaguages = [];
  windowFocused = false;
  updateCardDataInterval = null;
  lastindex = null;
  tempParaId = null;
  tempParaData = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
  showTempPara = false;
  hideElementId = null;
  changeURLBody = false;
  urlBody = '';
  killStoryPopup = false;
  killURL = '';
  versions: any;
  wireImageUrl = this.config.get('product').wireImageUrl;
  requestInQueue = 0;
  pendingCallsInQueue = [];
  breakingNewsImageUrl = null;
  publishPopup = false;
  wireDisclaimers = [];
  headlineFocusFlag = false;
  summaryFocusFlag = false;
  introFocusFlag = false;
  previewPopup = false;
  previewUrl = null;
  previewPlatform = null;
  iframeStyle = null;
  iframeLoading = 0;
  viewPortItems = [];
  viewPoerItemLiveblogEmbed=[];
  Elements = {};
  ismetaTitle:boolean;
  enableSummaryHyperlink:string=StaticDataService.enableSummaryHyperlink
  ismetaDescription:boolean;
  @ViewChild('tabcont',{static: false}) tabCont: ElementRef;
  @ViewChild('storySec', {static: false}) storySec: ElementRef;


  initialElementCount = 12;
  buffer = 10;

  pickStoryImageLoad = false;

  lastDate = {};

  @ViewChild(DaterangePickerComponent,{static: false}) private picker: DaterangePickerComponent;

  lastResponseCode = null;
  queueForPosts = 0;

  sponsoredTags = [
    { id: 'SPONSORED', name: 'SPONSORED' },
    { id: 'PROMOTIONAL', name: 'PROMOTIONAL' },
    { id: 'ADVERTORIAL', name: 'ADVERTORIAL' },
    { id: 'PARTNERED', name: 'PARTNERED' },
    { id: 'BRAND POST', name: 'BRAND POST' }
  ];

  previousStoryState = null;
  countryMap = {};
  countryArray = [];
  notificationLocation = [];
  topToggleOpen = true;

  tablePopup = false;
  tableHTML = '';
  public Editor = Editor;
  tableConfig = {
    toolbar: ['bold', 'italic', 'underline', 'numberedList', 'bulletedList', 'link', '|', 'insertTable'],
    table: {
      contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
    }
  };
  domainConfig = {};
  pinnedMediaImageToggle = false;
  isPinnedPhotopopup = false;
  isPinnedLigthbox = false;
  flagForPinnedElement = false;
  homepageToggle = false;
  homepageCalendarConfig = {
    'singleDatePicker': true,
    'showDropdowns': true,
    'timePicker': true,
    'timePicker24Hour': true,
    'timePickerSeconds': false,
    'showCustomRangeLabel': false,
    'alwaysShowCalendars': true,
    'opens': 'center',
    'drops': 'down',
    'locale': {
      'format': 'M/DD/YYYY hh:mm'
    }
  };
  endTimeCalendarConfig = {
    'singleDatePicker': true,
    'showDropdowns': true,
    'timePicker': true,
    'timePicker24Hour': true,
    'timePickerSeconds': false,
    'showCustomRangeLabel': false,
    'alwaysShowCalendars': true,
    'opens': 'center',
    'drops': 'down',
    'locale': {
      'format': 'M/DD/YYYY hh:mm'
    }
  };
  @ViewChild(DaterangePickerComponent, {static:false}) private homepageDate: DaterangePickerComponent;
  @ViewChild(DaterangePickerComponent,{static: false}) private validityDate: DaterangePickerComponent;
  videoLeadImage = '';

  cropperToShow;
  public ckEditor = Editor;
  public ckEditor2 = Editor;
  public ckEditor3 = Editor;
  ckconfig = {
    toolbar: ['numberedList', 'bulletedList', 'link'],
    link: {
      decorators: {
        isExternal: {
          mode: 'automatic',
          callback: url => url,
          attributes: {
            target: '_blank'
          }
        }
      }
    }
  };
  ckconfigLiveblogIntroPara = {
    toolbar: ['heading'],
    heading: {
      options: [
        { model: 'heading2', view: 'h2', title: 'Headline 2', class: 'ck-heading_heading2' },
        { model: 'paragraph', view: 'p', title: 'Paragraph', class: '' }
      ]
      },
  };
  cksummaryconfig = {
    toolbar: ['bulletedList', 'link'],
    link: {
      decorators: {
        isExternal: {
          mode: 'automatic',
          callback: url => url,
          attributes: {
            target: '_blank'
          }
        }
      }
    }
  };
  ckplainconfig = {
    toolbar: [],
    link: {
      decorators: {
        isExternal: {
          mode: 'automatic',
          callback: url => url,
          attributes: {
            target: '_blank'
          }
        }
      }
    }
  };
  lastSelection = {
    'headline': null,
    'summary': null,
    'intro': null
  };
  isCKEditorEnabled;
  summaryPopup = false;

  elementChangeData: any = {};
  saveFlag = false;
  imageUploadInProgress = false;
  headlineMaxLength;
  disabledStoryTypes = [];
  summaryMaxLength;
  elementDestination = null;
  disabledMetaFields = [];
  disabledPreviews = [];
  isMoreButtonEnabled = false;
  quotePopup = false;
  quoteText = '';
  urlValidationFlag = false;
  headlineErrors = [];
  summaryErrors = [];
  headlineRestrictionChecks = [];
  summaryRestrictionChecks = [];
  newMetas = [];
  captionRestrictionEnabled = false;
  liveBlogEndTimeFlag = false;
  isMultipleLeadImageAllowed = false;
  amazonAdCount: any = 0;
  amazonNewAd: boolean;
  newAdName: string;
  newAdEmbed: string;
  showAmazonMeta: boolean = false;
  showLShapeBand: boolean = false;
  amazonAdDisplay: boolean;
  liveblogIntroEmbed:boolean;
  enableLiveBlogIntroElements:any;
  enablePremiumStoryDatetime:boolean;
  allowspecialChar:string=StaticDataService.allowSpecialCharKeywordsTags;
  cropAllGallery: boolean = false;
  isAuthorIdEnabled = false;
  isAuthorSuggestionEnabled = false;
  isSegmentedNotificationEnabled = false;
  lShapeBandDisplay: boolean;
  enbaleHeadingLiveblogIntroPara:boolean;
  isBrandModelEnable: boolean = false;
  isPremiumSection:boolean=false;
  premiumStoryDays:number=StaticDataService.defaultPremiumStoryDays;
  enableQuickIgnoreFlag: boolean = false;
  currentSelectedSection: number;
  insideAddedSection: boolean = false;
  videoFeedDomains = '';
  videoAlreadyExist: boolean = false;
  attributionSuggestion: any;
  insideAttribution: boolean = false;
  filteredAttributionSuggestion: any;
  attributionQuery = '';
  mutualFundList: any;
  mutualFundSuggestion: any = [];
  marketSuggestion: any = [];
  marketList: any;
  newMarketList: any;
  showMutualFunds: any;
  elementDataLoaded = false;
  leadMediaVideoFlag: boolean = false;
  showLeadThumbnailCropper: boolean = false;
  twitterAccounts: any = [];
  twitterCheck = {};
  deactivateMarketSuggestion: boolean;
  isAutomaticBylineForBreakingNews = '';
  storytypesForMandatorySummary = [];
  storySentenceCount = 0;
  storySyllableCount = 0;
  readibilityType: string;
  showChartPopup = false;
  showFaqPopup = false;
  breakingNewsImageCaption = null;
  autoBacklinkingDone = false;
  automatedChartDone = false;
  openWebEngagePopup = false;
  applicationDropdownSettings = {};
  segmentDropdownSettings = {};
  notificationTypeDropdownSettings = {};
  tagDropdownSettings = {};
  showStepPopup = false;
  tags = [];
  segments = [];
  applications: any = [];
  deviceType: string = 'Web';
  notificationType: any = [];
  selectedApplications = [];
  devices: string[];
  selectedSegments = [];
  currentSegmentIds: string[];
  selectedTags = [];
  currentTagIds: string[];
  notification: any = {};
  selectedNotificationType: any = [];
  selectedNotificationTypeObject: any = {};
  mandatoryFieldUrl = false;
  mandatoryImageUrl = false;
  mandatoryFieldStoryId = false;
  mandatoryFieldMessage = false;
  isStoryUrlCreatedFromHeadline = true;
  webEngageSheduledAt: any;
  webengageAnalyticsData: any[];
  moengageAnalyticsData: any[];
  openSeoDetailsPopup = false;
  seoDetails = null;
  seoColor = 'blue';
  seoColorTitle = 'none';
  seoColorMeta = '';
  seoColorPageHeading = '';
  seoColorWord = '';
  seoColorLinksSummary = '';
  seoColorKeywordDens = '';
  seoDatas: any = [];
  pendingToasts: number;
  alreadyPublished = false;
  seoComments: any;
  enableSeoScore = false;
  enableAMPValidation = false;
  seoScoreShowDetail = false;
  seoScoreShowScore = false;
  seoOverallScore: any;
  autoBacklinkingInProgress: boolean;
  automatedChartAdditionInProgress: boolean;
  subscriptionCheck: Subscription;
  openAmpDetailsPopup: boolean = false;
  ampButtonColor = 'icon-breaking';
  showAmpDetails: boolean = false;
  ampResult = '';
  marketKeywords: any;
  automatedMarketFlag: boolean;
  isSlideTitleEnabled = this.sharedService.isdomainConfig('story', 'isSlideTitleEnabled');
  enableKeywordsDrag = false;
  metaTitleChanged = false;
  metaDescriptionChanged = false;
  seoUrlChanged = false;
  storyDataToRestore: any;
  elementDataToRestore: any;
  enableRestoreVersion = false;
  callManualSaveFromVersion = false;
  enableVersionRestoration = false;
  enableVersionRestorationForStoryType: any;
  revertedIndex = -1;
  recosensejsonData: any;
  SingleselectedGifFile: File = null;
  leadMediaImageGifToggle = false;
  pickStoryImageLoadGif = false;
  imageUploadInProgressGif = false;
  SingleselectedFileFlag = false;
  SingleselectedGifFileFlag = false;
  enableGifMedia = false;
  leadMediaImageGif = false;
  moSegmentDropdownSettings = {};
  crossDomainDropdownSettings = {};
  currentMoSegmentIds: string[];
  currentCrossDomainIds: string[];
  openSegmentPopup = false;
  newSegment = '';
  mandatoryFieldSegment = false;
  moSegments:any = [];
  crossDomains:any =[];
  selectedMoSegments:any = [];
  selectedCrossDomains:any = [];
  moEngaeRespponse = false;
  crossDomainResponse = false;
  webEngageResponse = false;
  enableWebEngage = false;
  enableMoEngage = false;
  enableCrossDomainNotification = false;
  amazonAdSearchPopup = false;
  dataFormAmazonList=[];
  enableAffiliate:boolean;
  enableQuickSummaryLength:boolean
  affiliateDisclaimer:string;
  revertElements = [];
  isRecosense: Boolean = false;
  sameFields: string;

  showStoryVersion = false;
  storyVersionindex = 0;

  tempFaqData: FormGroup;
  faqs: FormArray;
  currentStep = 0;
  tempRecipeData: FormGroup;
  tempHowToStepsData: FormGroup;
  steps: FormArray;
  secondMeta : string = '';
  minuteMeta : string = '';
  logoPosition = null;
  logoUrl = null;
  public fontColor: string = '#000000';
  relatedVideoStoryCase: boolean;
  autoEmbedVideoAdded: boolean;
  enablePlagiarism: boolean;
  plagData: any;
  openPlagURL: boolean;
  autoBackLinkList=[];
  enableBacklinkList:boolean;
  quickReadMax: number;
  quickReadMin: number=0;
  fetching: boolean;
  enableLeadVideoCaption:boolean;

  showPodcastPopup = false;
  publisherListArray = [];

  blogDisclaimer: any;
  showProductPopup: boolean;
  insideBrandEle: boolean;
  brandEleQuery: string = '';
  modelEleQuery: string = '';
  productElement = {};
  insideModelEle: boolean;
  categoryEleQuery: string = '';
  insideCategoryEle: boolean;
  showCategoryProductPopup: boolean;
  modelSuggestionValues: any = {};

  enableLeadVideoImageCaption:boolean;
  enableInlineRelatedStoryHowto:boolean;
  enableCategory = false;
  showRecipePopup: boolean
  enableBrand=false;
  enableModel=false;
  recipeInlineImageFlag: boolean = false;
  showHowToStepsCropper: boolean = false;
  showRecipeStepsCropper: boolean = false;
  relatedStoryType:string='';
  showPlagText: boolean;
  highlightedText: any;
  disableEditPara: boolean;
  blogDisclaimerEdit: any = '';
  editDisclaimer: boolean = false;
  tempResponse : any = [];
  moEngageSlugs : any = [];
  moSlugSettings: { singleSelection: boolean; text: string; selectAllText: string; unSelectAllText: string; enableSearchFilter: boolean; primaryKey: string; labelKey: string; noDataLabel: string; itemsShowLimit: number; closeDropDownOnSelection: boolean; maxHeight: number; } | { singleSelection: boolean; primaryKey: string; labelKey: string; noDataLabel: string; itemsShowLimit: number; enableSearchFilter: boolean; closeDropDownOnSelection: boolean; maxHeight: number; text?: undefined; selectAllText?: undefined; unSelectAllText?: undefined; };
  selectedMoSlug: any;
  tempElementList: any = [];
  selectPremiumDate:any='';
  newMarketSuggestion: any = [];

  productCategoryApiSubscription: any;
  disableSendButton: boolean;
  showJW: boolean = false;
  showYT: boolean = false;
  enableJW = 'true';
  enableYT = false;
  stopPlagiarismPublish: any;
  maxPlagiarism: number;
  userRestrictedSections: any = [];
  schedulingStoryFlag: boolean;
  showAlsoReadStoryPopup: boolean;

  croppingInProgress = false;
  imageCroppingQue : any[] = [];
  totalImageCardCount = 0;
  showViewImagePopup:boolean=false;
  viewImagesData=[];
  isDraggedImages:boolean;
  sampleImageToggle: boolean = false;
  sampleImgList: any[];
  sampleGalleryFlag: boolean;
  enableContentBucketInput:boolean;
  enableContentBucketStories:any;
  private httpMethod: HttpClient

  constructor(
    private config: Config,
    private http: HttpClient,
    private httpBackend: HttpBackend,
    private restService: RestDataService,
    private route: ActivatedRoute,
    private router: Router,
    private differs: KeyValueDiffers,
    private sharedService: SharedDataService,
    private location: Location,
    private embedService: EmbedVideoService,
    private dragulaService: DragulaService,
    private snotify: SnotifyService,
    private ngZone: NgZone,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private changeDetector: ChangeDetectorRef,
    private storyContainerService:StoryContainerService,
    private authenticationService:AuthenticationService,
    private formBuilder: FormBuilder,
    private localstorageService:LocalstorageService,
    private cpService: ColorPickerService,
    private gaService:GoogleAnalyticsService
  ) {
    this.httpMethod = new HttpClient(httpBackend);
    this.versions = new VersioningTree();
    dragulaService.dragend.subscribe(value => {
      this.dragend(value);
      setTimeout(e => {
        this.checkIfLastIsPara(false);
      }, 70);
    });
    dragulaService.setOptions('sixth-bag', {
      moves: function (el, container, handle) {
        return (handle.className === 'handle sortpara' || handle.className === 'icon-move');
      }
    });
    
    this.sharedService.getCurrentDomainConfig(this.getDomainConfig.bind(this));
    this.domainConfig = this.sharedService.currentDomainConfiguration;
    this.isCKEditorEnabled = (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['vernacular-editor']
      && this.domainConfig['config']['story']['vernacular-editor'] === 'true');
    this.quickReadMax = this.domainConfig['config']['story']['quickReadMax'] ?
      Number(this.domainConfig['config']['story']['quickReadMax']) : 60;
    this.quickReadMin = this.domainConfig['config']['story']['quickReadMin'] ?
      Number(this.domainConfig['config']['story']['quickReadMin']) : this.quickReadMin;
    this.headlineMaxLength = this.getHeadlineMaxLength(false);
    this.snotify.clear();
    this.disabledStoryTypes = this.domainConfig['disabledStoryType'];
    this.disabledMetaFields = (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['disabledMeta']
      && this.domainConfig['config']['disabledMeta']['fields']) ? this.domainConfig['config']['disabledMeta']['fields'].split(',') : [];
    this.disabledPreviews = (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['disabledMeta']
      && this.domainConfig['config']['disabledMeta']['preview']) ? this.domainConfig['config']['disabledMeta']['preview'].split(',') : [];
    this.storytypesForMandatorySummary = (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']
      && this.domainConfig['config']['story']['summaryMandatoryTypes'])
      ? this.domainConfig['config']['story']['summaryMandatoryTypes'].split(',') : [];
    const metaSet = this.fieldSet.map(e => e.metadataModelId).concat(['column']).filter(e => (this.disabledMetaFields.indexOf(e) === -1));
    this.isMoreButtonEnabled = metaSet.length > 0;
    this.urlValidationFlag = this.isURLValidationEnabled();
    this.headlineRestrictionChecks = this.isHeadlineRestrictionEnabled();
    this.summaryRestrictionChecks = this.isSummaryRestrictionEnabled();
    this.isCanonicalReadoOnly = this.sharedService.isdomainConfig('story', 'isCanonicalReadoOnly');
    this.automatedMarketFlag = this.sharedService.isdomainConfig('story', 'automatedMarketFlag');
    this.stopPlagiarismPublish = this.sharedService.isdomainConfig('story', 'stopPlagPublish');
    this.newMetas = this.domainConfig['dynamicMeta'];
    this.captionRestrictionEnabled = (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['imageRestriction']
      && this.domainConfig['config']['story']['imageRestriction'] !== '');
    this.isMultipleLeadImageAllowed = (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['image'] && this.domainConfig['config']['image']['multipleLeadImage'] === 'true');
    this.isAuthorIdEnabled = (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['authorId']
      && this.domainConfig['config']['story']['authorId'] === 'true');
    this.isAuthorSuggestionEnabled = (this.domainConfig && this.domainConfig['config']
    && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['authorSuggestion']
    && this.domainConfig['config']['story']['authorSuggestion'] === 'true');
    this.isSegmentedNotificationEnabled = (this.domainConfig && this.domainConfig['config']
    && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['segmentedNotification']
    && this.domainConfig['config']['story']['segmentedNotification'] === 'true');
    this.videoFeedDomains = (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['videoFeed'] && this.domainConfig['config']['videoFeed']['domains']
      && this.domainConfig['config']['videoFeed']['domains'].trim() !== '') ?
      this.domainConfig['config']['videoFeed']['domains'].trim() : 'HT,LM';
    this.isAutomaticBylineForBreakingNews = (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['automaticBylineForBreakingNews']
      && this.domainConfig['config']['story']['automaticBylineForBreakingNews'].trim() !== '') ?
      this.domainConfig['config']['story']['automaticBylineForBreakingNews'].trim() : '';
    this.showMutualFunds = this.domainConfig['config']['story']['showMutualFunds'];
    this.enableMultipleRelatedStory = this.sharedService.isdomainConfig('story','enableMultipleRelatedStory')
    this.applicationDropdownSettings = this.sharedService.getDropDownSettings(false, 'id', 'name');
    this.segmentDropdownSettings = this.sharedService.getDropDownSettings(false, 'id', 'name');
    this.moSegmentDropdownSettings = this.sharedService.getDropDownSettings(false, 'id', 'name');
    this.moSegmentDropdownSettings['singleSelection'] = true;
    this.moSlugSettings = this.sharedService.getDropDownSettings(true, 'id', 'itemName');
    this.moSlugSettings['singleSelection'] = true;
    this.moSlugSettings['enableSearchFilter'] = true;
    this.moSlugSettings['enableFilterSelectAll'] = false;
    this.crossDomainDropdownSettings = this.sharedService.getDropDownSettings(false, 'id', 'name');
    this.notificationTypeDropdownSettings = this.sharedService.getDropDownSettings(true, 'id', 'name');
    this.tagDropdownSettings = this.sharedService.getDropDownSettings(false, 'id', 'tagName');
   /* if (this.domainConfig['config'] && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['notificationEnabled']) {
      this.fetchApplications();
      this.fetchSegments();
      this.fetchMoSegments();
      this.fetchMoengageSlug();
      this.fetchCrossDomains();
      this.fetchTags();
      this.fetchNotificationType();
    }*/
    this.enableSeoScore = this.sharedService.isdomainConfig('story','enableSEOScore');
    this.enablePlagiarism = this.sharedService.isdomainConfig('story','enablePlagiarism');
    if(this.enablePlagiarism) {
      if(this.domainConfig['config'] && this.domainConfig['config']['story'] &&
            this.domainConfig['config']['story']['maxPlagiarism']) {
              this.maxPlagiarism = Number(this.domainConfig['config']['story']['maxPlagiarism']);
      } else {
        this.maxPlagiarism = 75;
      }
    }
    this.enableAMPValidation = this.sharedService.isdomainConfig('story','enableAMPValidation');
    this.enableKeywordsDrag = this.sharedService.isdomainConfig('story','enableKeywordsDrag');
    this.enableGifMedia = this.sharedService.isdomainConfig('story','enableGifMedia');
    this.enableWebEngage = this.sharedService.isdomainConfig('story','enableWebEngage');
    this.enableMoEngage = this.sharedService.isdomainConfig('story','enableMoEngage');
    this.enableCrossDomainNotification = this.sharedService.isdomainConfig('story','enableCrossDomainNotification');
    this.enableVersionRestoration = this.sharedService.isdomainConfig('story','enableVersionRestoration');
    this.enableVersionRestorationForStoryType = this.domainConfig['config']['story']['enableVersionRestorationForStoryType'];
    console.log(this.enableMoEngage + "enableMoEngage");
    console.log(this.enableCrossDomainNotification + "enableCrossDomainNotification");
    if(this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story'] &&
    this.domainConfig['config']['story']['webStoryLogoUrl'])
    {
      this.logoUrl = this.domainConfig['config']['story']['webStoryLogoUrl'];
    }
    else{
      this.logoUrl="assets/images/webstories/logoHT.png";
    }
    this.enableCategory = this.domainConfig['config']['story']['enableCategory'] ? this.domainConfig['config']['story']['enableCategory'] : false;
    this.enableJW = this.domainConfig['config']['story']['enableJW'] ? this.domainConfig['config']['story']['enableJW'] : 'true';
    this.enableYT = this.domainConfig['config']['video']['isYouTube'] ? this.domainConfig['config']['video']['isYouTube'] : false;
    this.enableBrand=this.domainConfig['config']['story']['enableBrand']?this.domainConfig['config']['story']['enableBrand']:false;
    this.enableModel=this.domainConfig['config']['story']['enableModel']?this.domainConfig['config']['story']['enableModel']:false;
 
    if(this.enableJW === 'true')
    {
      this.showJW = true;
      this.showYT = false;
    }
    else if(this.enableYT)
    {
      this.showJW = false;
      this.showYT = true;
    }
  }
  fetchMoengageSlug() {
    this.moEngageSlugs = [];
    this.http.get(this.config.get('product').baseUrl
    + "/api/cms/moengage/slug/all").subscribe((response) => {
        if(response){
          this.tempResponse = response;
          this.tempResponse.map((item, index) => {
            this.moEngageSlugs.push({
              "id" : index,
              "itemName" : item
            })
            // console.log(item)
          })

        }
    },(error)=>{
      console.log(error);
      // this.snotify.error('Error While fetching Segments', '', this.sharedService.getConfig(false));
    });
  }


  addOrRemovePlaceholder(editorInstance, model) {
    const toolbar = editorInstance.ui.view.element.getElementsByClassName('ck-toolbar__items');
    const ck_on = (toolbar && toolbar.length > 0 && toolbar[0]) ? toolbar[0].getElementsByClassName('ck-on').length : 0;
    const hasData = this.getFocus(model) || editorInstance.getData() || (ck_on !== 0);
    if (hasData) {
      this.removePlaceholder(editorInstance);
    } else {
      this.addPlaceholder(editorInstance, model);
    }
  }

  addPlaceholder(editorInstance, model) {
    const editableElement = editorInstance.ui.getEditableElement();
    this.renderer.addClass(editableElement.children[0], 'ck-placeholder');
    this.renderer.setAttribute(editableElement.children[0], 'id', this.getPlaceHolderIds(model))
    this.renderer.setAttribute(editableElement.children[0], 'data-placeholder', this.getPlaceHolder(model));
  }

  removePlaceholder(editorInstance) {
    const editableElement = editorInstance.ui.getEditableElement();
    this.renderer.removeAttribute(editableElement.children[0], 'data-placeholder');
    this.renderer.removeClass(editableElement.children[0], 'ck-placeholder');
  }

  getPlaceHolderIds(model) {
    switch (model) {
      case 'headline':
        return 'enterHeadlineText';
      case 'summary':
        return 'addSummaryText';
      case 'intro':
        return 'enterIntroPara';
      default:
        return '';
    }
  }

  getPlaceHolder(model) {
    switch (model) {
      case 'headline':
        return 'Enter Story (Mobile) Headline..';
      case 'summary':
        return 'Enter Summary';
      case 'intro':
        return 'Enter Intro Para';
      default:
        return '';
    }
  }

  getFocus(model) {
    switch (model) {
      case 'headline':
        return this.headlineFocusFlag;
      case 'summary':
        return this.summaryFocusFlag;
      case 'intro':
        return this.introFocusFlag;
      default:
        return false;
    }
  }

  ckEditorEnableReadOnlyMode(editor){
    if(!this.storyEditMode){
      editor.enableReadOnlyMode('storyElement')
    } 
  }

  ckchanges(ev, label, model) {
    this.ckEditorEnableReadOnlyMode(ev.editor);
    if (label === 'ready') {
      const clipboardPlugin = ev.plugins.get('ClipboardPipeline');
      const editingView = ev.editing.view;
      editingView.document.on('clipboardInput', (evt, data) => {
        if (ev.isReadOnly) {
          return;
        }
        const dataTransfer = data.dataTransfer;
        const plaintext = dataTransfer.getData('text/plain');
        const htmltext = dataTransfer.getData('text/html');
        let text; // = this.htmlToPlainTextExcludingAttributes(htmltext).replace(/<table.+?<\/table>/g, '');
        switch (model) {
          case 'intro':
            text = this.text2HTML(plaintext).replace(/<\p><\/p>/gm, '').replace(/<br ?\/?>/g, '');
            break;
          case 'headline':
            const doc = ev.model.document;
            const selection = doc.selection;
            const range = selection.getFirstRange();
            const selectionDiff = range ? (range['end']['path'][1] - range['start']['path'][1]) : 0;
            const len = this.stripHtml(this.headline).length;
            text = this.htmlToPlainTextExcludingPara(plaintext).substring(0, this.headlineMaxLength + selectionDiff - len);
            break;
          case 'summary':
            text = this.htmlToPlainTextExcludingPara(plaintext);
            break;
          case 'table':
            const div = document.createElement('div');
            div.innerHTML = this.htmlToPlainTextExcludingAttributes(htmltext.replace(StaticDataService.regexForComments, ''));
            text = div.innerHTML;
            break;
          default: break;
        }
        data.content = ev.data.htmlProcessor.toView( text );
      });
      switch (model) {
        case 'headline':
          this.headlineEditor = ev;
          break;
        case 'summary':
          this.summaryEditor = ev;
          break;
        case 'intro':
          this.introEditor = ev;
          break;
        default: break;
      }
      this.addOrRemovePlaceholder(ev, model);
    }
    if (label === 'focus') {
      this.focusedCard = null;
      this.lastindex = null;
      const doc = ev.editor.model.document;
      const selection = doc.selection;
      const selrange = selection.getFirstRange();
      const currentSelection = selrange['end']['path'];
      switch (model) {
        case 'headline':
          this.headlineClear();
          this.headlineFocusFlag = true;
          this.lastSelection.headline = currentSelection;
          break;
        case 'summary':
          this.summaryFocusFlag = true;
          this.lastSelection.summary = currentSelection;
          if (!this.summary || this.summary.trim() === '') {
            const b = this.summaryElement.nativeElement.getElementsByClassName('ck-toolbar__items');
            const a = b[1].children;
            if (a.length > 0 && a[0].className.indexOf('ck-on') === -1) {
              a[0].click();
            }
          }
          break;
        case 'intro':
          this.introFocusFlag = true;
          this.lastSelection.intro = currentSelection;
          break;
        default: break;
      }
      this.addOrRemovePlaceholder(ev.editor, model);
    }
    if (label === 'blur') {
      switch (model) {
        case 'headline':
          this.headlineFocusFlag = false;
          this.lastSelection.headline = null;
          break;
        case 'summary':
          this.summaryFocusFlag = false;
          this.lastSelection.summary = null;
          break;
        case 'intro':
          this.introFocusFlag = false;
          this.lastSelection.intro = null;
          break;
        default: break;
      }
      this.addOrRemovePlaceholder(ev.editor, model);
    }
    if (label === 'change') {
      this.addOrRemovePlaceholder(ev.editor, model);
      if (model === 'headline') {
        this.storyData.mobileHeadline = this.htmlToPlaintextExcludeItalic(this.headline);
        // if (this.storyData.metadata.status != 'PUBLISHED')
        //   this.storyData.metadata.seoUrl = this.storyData.mobileHeadline;
      }
      if (model === 'summary') {
        if(!!this.storyData.summaryStatus && this.storyData.summaryStatus=="Automated"){
          this.storyData.summaryStatus="Automated_Edited";
        }
        if (this.isSummaryTagStripDisabled()) {
          this.storyData.summary = this.summary;
        } else {
          if (this.isSummaryHyperlinkEnabled()) {
            this.storyData.summary = this.htmlToPlaintextExcludeBulletListAndHyperlink(this.summary);
          } else {
            this.storyData.summary = this.htmlToPlaintextExcludeBulletList(this.summary);
          }
        }
        // this.storyData.metadata.metaDescription = $(this.summaryEditor.getData().replace(new RegExp('</li><li>', 'g'), '\n')).text();
        if(this.disabledMetaFields.indexOf('enableSummaryHyperlink')==-1 &&
           this.enableSummaryHyperlink.includes(this.storyType)){
          this.storyData.summary = this.htmlToPlaintextExcludeBulletListAndHyperlink(this.summary);
        }
      }
    }
  }


  hotkeypress($event) {
    const data = this.headlineEditor.getData();
    const striptext = this.stripHtml(data);
    //  console.log('web id' + this.storyData.webId);
    if (striptext.length >= this.headlineMaxLength) {
      return false;
    }
  }

  compareSelectionArrays(arr1, arr2) {
    return (arr1[0] === arr2[0] && arr1[1] === arr2[1]);
  }

  headlineKeyUpEvent($event) {
    const key = $event.keyCode || $event.charCode;
    const doc = this.headlineEditor.model.document;
    const selection = doc.selection;
    const selrange = selection.getFirstRange();
    const currentSelection = selrange['end']['path'];

    if (key === 39 || key === 40) {
      const root = doc.getRoot();
      const totalNodes = root['_children']['length'];
      const lastNode = root['_children']['_nodes'][totalNodes - 1]['_children']['_nodes'];
      const lastNodeLength = lastNode['length'];
      const totalSelection = [
        (totalNodes ? (totalNodes - 1) : 0),
        (lastNodeLength > 0 ? lastNode[lastNodeLength - 1]['offsetSize'] : 0)
      ];
      if (this.compareSelectionArrays(currentSelection, this.lastSelection['headline'])
        && this.compareSelectionArrays(currentSelection, totalSelection)) {
        this.summaryEditor.editing.view.focus();
        this.setFocus('summary');
        return false;
      }
    }
    setTimeout(e => {
      this.lastSelection.headline = currentSelection;
    }, 0);
  }
  changeDisclaimer() {
    this.storyData.metadata.blogDisclaimer = this.blogDisclaimerEdit;
  }


  summaryKeyUpEvent($event) {
    const key = $event.keyCode || $event.charCode;
    const doc = this.summaryEditor.model.document;
    const selection = doc.selection;
    const selrange = selection.getFirstRange();
    const currentSelection = selrange['end']['path'];
    switch (key) {
      case 40:
      case 39:
        const root = doc.getRoot();
        const totalNodes = root['_children']['length'];
        const lastNode = root['_children']['_nodes'][totalNodes - 1]['_children']['_nodes'];
        const lastNodeLength = lastNode['length'];
        const totalSelection = [
          (totalNodes ? (totalNodes - 1) : 0),
          (lastNodeLength > 0 ? lastNode[lastNodeLength - 1]['offsetSize'] : 0)
        ];
        if (this.compareSelectionArrays(currentSelection, this.lastSelection['summary'])
          && this.compareSelectionArrays(currentSelection, totalSelection)) {
          switch (this.storyType) {
            case 'story':
              if (this.storyData.leadMedia.elements.length === 0) {
                if (this.storyData.elements && (this.storyData.elements.length > 0)) {
                  if (this.showTempPara && (this.storyData.elements[0] === this.hideElementId)) {
                    this.elRef['last'].setFocusOnThis('start');
                  } else {
                    this.elReference['_results'][0].setFocusOnThis('start');
                  }
                } else {
                  this.elRef['last'].setFocusOnThis(null);
                }
              } else {
                this.leadelRef['_results'][0].setFocusOnThis('start');
              }
              break;
            case 'video':
              if (this.storyData.leadMedia.elements.length === 0) {
                if (this.storyData.elements.length > 0) {
                  this.elReference['_results'][0].setFocusOnThis('start');
                }
              } else {
                this.leadelRef['_results'][0].setFocusOnThis('start');
              }
              break;
            case 'gallery':
              if (this.storyData.elements && (this.storyData.elements.length > 0)) {
                this.elReference['_results'][0].setFocusOnThis(null);
              } else {
                this.galleryUploadElement.nativeElement.focus();
              }
              break;
            case 'mediagallery':
              if (this.storyData.elements && (this.storyData.elements.length > 0)) {
                this.elReference['_results'][0].setFocusOnThis(null);
              } else {
                this.galleryUploadElement.nativeElement.focus();
              }
              break;
            // case 'deadlink':
            //   if (this.storyData.elements && (this.storyData.elements.length > 0)) {
            //     this.elReference['_results'][0].setFocusOnThis(null);
            //   } else {
            //     this.galleryUploadElement.nativeElement.focus();
            //   }
            //   break;
            case 'liveblog':
            case 'listicle':
              if (this.storyData.leadMedia.elements.length === 0) {
                this.introEditor.editing.view.focus();
              } else {
                this.leadelRef['_results'][0].setFocusOnThis('start');
              }
              break;
          }
        }
        break;
      case 38:
      case 37:
        if (this.compareSelectionArrays(currentSelection, this.lastSelection['summary'])
          && this.compareSelectionArrays(currentSelection, [0, 0])) {
          this.headlineEditor.focus();
          this.setFocus('headline');
          return false;
        }
        break;
    }
    setTimeout(e => {
      this.lastSelection.summary = currentSelection;
    }, 0);
  }

  introKeyUpEvent($event) {
    const key = $event.keyCode || $event.charCode;
    const doc = this.introEditor.model.document;
    const selection = doc.selection;
    const selrange = selection.getFirstRange();
    const currentSelection = selrange['end']['path'];
    switch (key) {
      case 40:
      case 39:
        const root = doc.getRoot();
        const totalNodes = root['_children']['length'];
        const lastNode = root['_children']['_nodes'][totalNodes - 1]['_children']['_nodes'];
        const lastNodeLength = lastNode['length'];
        const totalSelection = [
          (totalNodes ? (totalNodes - 1) : 0),
          (lastNodeLength > 0 ? lastNode[lastNodeLength - 1]['offsetSize'] : 0)
        ];
        if (this.compareSelectionArrays(currentSelection, this.lastSelection['intro'])
          && this.compareSelectionArrays(currentSelection, totalSelection)) {
          switch (this.storyType) {
            case 'liveblog':
              this.elLiveRef['_results'][0].setFocusOnThis('start');
              break;
            case 'mintlite':
              this.elLiveRef['_results'][0].setFocusOnThis('start');
              break;
            case 'listicle':
              if (this.storyData.elements && (this.storyData.elements.length > 0)) {
                this.elReference['_results'][0].setFocusOnThis('start');
              } else {
                this.elListRef['_results'][0].setFocusOnThis('start');
              }
              break;
          }
        }
        break;
      case 38:
      case 37:
        if (this.compareSelectionArrays(currentSelection, this.lastSelection['intro'])
          && this.compareSelectionArrays(currentSelection, [0, 0])) {
          if (this.storyData.leadMedia.elements.length !== 0) {
            this.leadelRef['results']['last'].setFocusOnThis(null);
          } else {
            this.summaryEditor.editing.view.focus();
            this.setFocus('summary');
          }
        }
        break;
    }
    setTimeout(e => {
      this.lastSelection.intro = currentSelection;
    }, 0);
  }

  headlineKeyDownEventCk($event) {
    const key = $event.keyCode || $event.charCode;
    const ctrl_shift = (($event.ctrlKey || $event.metaKey) && $event.shiftKey);
    const data = this.headlineEditor.getData();
    const striptext = this.stripHtml(data);
    const selection = this.headlineEditor.model.document.selection;
    switch (key) {
      case 52:
        if (ctrl_shift && (striptext.length < this.headlineMaxLength)) {
          this.headlineEditor.model.change(writer => {
            this.headlineEditor.model.insertContent(writer.createText('₹'), selection);
          });
        }
        break;
      case 114:
        if ($event.shiftKey) {
          $event.preventDefault();
          const range = selection.getFirstRange();
          this.headlineEditor.model.change(writer => {
            const currentAttributes = selection.getAttributes();
            writer.insertText('|#+|', currentAttributes, range.end);
            writer.insertText('|#+|', currentAttributes, range.start);
            const text = this.headlineEditor.getData();
            const textSplit = text.split('|#+|');
            if (textSplit.length > 2) {
              const content = textSplit[1];
              textSplit[1] = (this.stripHtml(content) === this.stripHtml(content).toUpperCase())
                ? content.toLowerCase() : content.toUpperCase();
              const totalPara = textSplit.join('');
              this.headlineEditor.setData(totalPara);
            }
          });
          $event.stopPropagation();
        }
        break;
    }
  }


  summaryKeyDownEventCk($event) {
    const key = $event.keyCode || $event.charCode;
    const selection = this.summaryEditor.model.document.selection;
    const b = this.summaryElement.nativeElement.getElementsByClassName('ck-toolbar__items');
    const a = b[1].children;
    const ctrl_shift = (($event.ctrlKey || $event.metaKey) && $event.shiftKey);
    switch (key) {
      case 52:
        if (ctrl_shift) {
          this.summaryEditor.model.change(writer => {
            this.summaryEditor.model.insertContent(writer.createText('₹'), selection);
          });
        }
        break;
      case 50:
        if (ctrl_shift) {
          // console.log('bullet point');
          $event.preventDefault();
          if (a.length > 0) {
            a[0].click();
          }
          $event.stopPropagation();
        }
        break;
      case 72:
        if (ctrl_shift && this.isSummaryHyperlinkEnabled()) {
          // console.log('hyperlink');
          $event.preventDefault();
          if (a.length > 1) {
            a[1].click();
          }
          $event.stopPropagation();
        }
        break;
      case 114:
        if ($event.shiftKey) {
          $event.preventDefault();
          const range = selection.getFirstRange();
          this.summaryEditor.model.change(writer => {
            const currentAttributes = selection.getAttributes();
            writer.insertText('|#+|', currentAttributes, range.end);
            writer.insertText('|#+|', currentAttributes, range.start);
            const text = this.summaryEditor.getData();
            const textSplit = text.split('|#+|');
            if (textSplit.length > 2) {
              const content = textSplit[1];
              textSplit[1] = (this.stripHtml(content) === this.stripHtml(content).toUpperCase())
                ? content.toLowerCase() : content.toUpperCase();
              const totalPara = textSplit.join('');
              this.summaryEditor.setData(totalPara);
            }
          });
          $event.stopPropagation();
        }
        break;
    }
  }

  
  amazonAds = [];
  deleteAmazonAd(ev) {
    this.amazonAds.splice(ev, 1);
    this.adTitle = '';
  }
  saveAmazonEmbed() {
    if (this.newAdName && this.adTitle ) {
      this.amazonAds.push({ key: this.newAdName, value: this.newAdEmbed ,isPresent:true});
    } else {
      this.snotify.error('Enter Ad Name and title', '', this.sharedService.getConfig(false));
    }
    this.amazonNewAd = false;
  }
  addAmazonMeta() {
    this.newAdName = "";
    this.newAdEmbed = "";
    this.amazonNewAd = true;
    this.addIconClick = false;
  }



  introKeyDownEventCk($event) {
    const key = $event.keyCode || $event.charCode;
    const selection = this.introEditor.model.document.selection;
    const b = this.introElement.nativeElement.getElementsByClassName('ck-toolbar__items');
    const a = b[1].children;
    const ctrl_shift = (($event.ctrlKey || $event.metaKey) && $event.shiftKey);
    switch (key) {
      case 49:
        if (ctrl_shift && this.storyType !== 'listicle') {
          // console.log('number point');
          $event.preventDefault();
          if (a.length > 0) {
            a[0].click();
          }
          $event.stopPropagation();
        }
        break;
      case 52:
        if (ctrl_shift) {
          this.introEditor.model.change(writer => {
            this.introEditor.model.insertContent(writer.createText('₹'), selection);
          });
        }
        break;
      case 50:
        if (ctrl_shift && this.storyType !== 'listicle') {
          // console.log('bullet point');
          $event.preventDefault();
          if (a.length > 1) {
            a[1].click();
          }
          $event.stopPropagation();
        }
        break;
      case 72:
        if (ctrl_shift) {
          // console.log('hyperlink');
          $event.preventDefault();
          if (a.length > 2) {
            a[2].click();
          }
          $event.stopPropagation();
        }
        break;
      case 114:
        if ($event.shiftKey) {
          $event.preventDefault();
          const range = selection.getFirstRange();
          this.introEditor.model.change(writer => {
            const currentAttributes = selection.getAttributes();
            writer.insertText('|#+|', currentAttributes, range.end);
            writer.insertText('|#+|', currentAttributes, range.start);
            const text = this.introEditor.getData();
            const textSplit = text.split('|#+|');
            if (textSplit.length > 2) {
              const content = textSplit[1];
              textSplit[1] = (this.stripHtml(content) === this.stripHtml(content).toUpperCase())
                ? content.toLowerCase() : content.toUpperCase();
              const totalPara = textSplit.join('');
              this.introEditor.setData(totalPara);
            }
          });
          $event.stopPropagation();
        }
        break;
    }
  }

  

  @HostListener('window:keydown', ['$event'])
  public hotkeysdown($event) {
    // console.log('story => common keydown');
    const key = $event.keyCode || $event.charCode;
    const focusedElement: HTMLElement = document.activeElement as HTMLElement;
    const ctrl_shift = (($event.ctrlKey || $event.metaKey) && $event.shiftKey);
    switch (key) {
      case 27:
        this.sharedService.sendData('key27');
        if (this.insideSection) {
          this.insideSection = false;
        }
        if (this.insideCategory) {
          this.insideCategory = false;
        }
        if (this.insideBrand) {
          this.insideBrand = false;
        }
        if (this.insideModel) {
          this.insideModel = false;
        }
        if (this.insideAddedSection) {
          this.insideAddedSection = false;
        }
        if (this.insideSubSection) {
          this.insideSubSection = false;
        }
        if (this.insideSubSectionL2) {
          this.insideSubSectionL2 = false;
        }
        if (this.insideAgency) {
          this.insideAgency = false;
        }
        if (this.insideContentBucket) {
          this.insideContentBucket = false;
        }
        if (this.insideColumn) {
          this.insideColumn = false;
        }
        if (this.insideAttribution) {
          this.insideAttribution = false;
        }
        if (this.isLightbox) {
          this.isLightbox = false;
        }
        // isPinnedLigthbox
        if (this.isPinnedLigthbox) {
          this.isPinnedLigthbox = false;
        }
        if (this.leadMediaImageToggle) {
          this.leadMediaImageToggle = false;
        }
        if (this.leadMediaImageGifToggle) {
          this.leadMediaImageGifToggle = false;
        }
        if (this.leadMediaVideoToggle) {
          this.leadMediaVideoToggle = false;
        }
        if (this.pinnedMediaImageToggle) {
          this.pinnedMediaImageToggle = false;
        }
        if (this.inlineImageFlag) {
          this.disableInlineImage();
        }
        if (this.howToStepsInlineImageFlag || this.recipeInlineImageFlag) {
          this.disableStepsInlineImage();
        }
        if (this.inlineImageToggle) {
          this.inlineImageToggle = false;
        }
        if (this.inlineReviewToggle) {
          this.inlineReviewToggle = false;
        }
        if (this.inlineEmbedToggle) {
          this.inlineEmbedToggle = false;
        }
        if (this.inlineTableToggle) {
          this.inlineTableToggle = false;
        }
        if (this.showRelatedStoryPopup) {
          this.closeRelatedStoryModal(null);
        }
        if (this.videoUrlPopup) {
          this.router.navigate(['/lite/dash/workspace']);
        }
        if (this.changeURLBody) {
          this.closeURLbody();
        }
        if (this.killStoryPopup) {
          this.closeKillURL();
        }
        if (this.embedPopup) {
          this.closeEmbedPopup();
        }
        if (this.headlinePopup) {
          this.discareUrlChanges(false);
        }
        if (this.showCropper || this.showHowToStepsCropper) {
          this.cancelCropping();
        }
        if (this.focusOnLeadMedia) {
          this.focusOnLeadMedia = false;
        }
        if (this.revertListFlag) {
          this.revertListFlag = false;
        }
        if (this.previewPopup) {
          this.closePreview();
        }
        if (this.isLightboxVideo) {
          this.disableshowVideoGallery();
        }
        if (this.quotePopup) {
          this.closeQuotePopup();
        }
        if (this.showElementPopup) {
          this.closeElementModal(null);
        }
        if (this.showAmazonPopup) {
          this.closeElementModal(null);
        }
        if (this.tableReusablePopup) {
          this.closeElementModal(null);
        }

        break;
      case 70:
        if (ctrl_shift) {
          // console.log('update state');
          $event.preventDefault();
          if (this.storyData && this.storyData['metadata']['status']) {
            const status = this.storyData['metadata']['status'];
            if (status === 'CREATED') {
              this.checkForPendingRequests('fileCurrentStory', 0, null);
            }
            if (status === 'FILED') {
              this.checkForPendingRequests('editCurrentStory', 0, null);
            }
            if (status === 'EDITED') {
              this.openPublish(true);
            }
          }
        }
        break;
      case 83:
        if ($event.ctrlKey || $event.metaKey) {
          event.preventDefault();
          // console.log('save story');
          this.manualSave();
          if (!this.childKeyDownEvent) {
            focusedElement.focus();
          }
          event.stopPropagation();
        }
        break;
      case 78:
        if (ctrl_shift) {
          event.preventDefault();
          // console.log('new story');
          window.open(window.location.origin + '/lite/dash/story/new', '_blank');
          event.stopPropagation();
        }
        break;
      case 77:
        if ($event.ctrlKey || $event.metaKey) {
          event.preventDefault();
          // console.log('new meta');
          focusedElement.blur();
          this.topMeta.focusOnInput();
          event.stopPropagation();
        }
        break;
      case 80:
        if (ctrl_shift) {
          event.preventDefault();
          // console.log('publish story');
          this.openPublish(true);
          event.stopPropagation();
        }
        break;
      case 13:
        if (!$event.shiftKey) {
          if (this.mobprev && (focusedElement === this.mobprev.nativeElement)) {
            this.openPreview('mobile');
          }
          if (this.deskprev && (focusedElement === this.deskprev.nativeElement)) {
            this.openPreview('desktop');
          }
          if ((this.storyType === 'gallery') &&
            ((this.galleryUploadElement && focusedElement === this.galleryUploadElement.nativeElement)
              || (this.galleryPickElement && focusedElement === this.galleryPickElement.nativeElement)
            )) {
            focusedElement.click();
          }
          if ((this.storyType === 'liveblog') && this.liveblogButton && (focusedElement === this.liveblogButton.nativeElement)) {
            this.addLiveblogElement();
          }
          if ((this.storyType === 'liveblog') && this.liveblogAddButton && (focusedElement === this.liveblogAddButton.nativeElement)) {
            this.addLiveblogPost();
          }
          if ((this.storyType === 'mintlite') && this.liveblogButton && (focusedElement === this.liveblogButton.nativeElement)) {
            this.addLiveblogElementLite();
          }
          if ((this.storyType === 'mintlite') && this.liveblogAddButton && (focusedElement === this.liveblogAddButton.nativeElement)) {
            this.addLiveblogPostLite();
          }
          if ((this.storyType === 'listicle') && this.listicleButton && (focusedElement === this.listicleButton.nativeElement)) {
            this.addListicleElement();
          }
        }
        break;
      case 40:
        if (!$event.shiftKey) {
          if (this.mobprev && this.deskprev && focusedElement === this.mobprev.nativeElement) {
            this.deskprev.nativeElement.focus();
          }
          if (this.deskprev && focusedElement === this.deskprev.nativeElement) {
            this.innerFocusFlag = true;
          }
          if ((this.storyType === 'gallery') && this.galleryUploadElement &&
            this.galleryPickElement && (focusedElement === this.galleryUploadElement.nativeElement)) {
            this.galleryPickElement.nativeElement.focus();
          }
          if ((this.storyType === 'liveblog') && this.liveblogButton && (focusedElement === this.liveblogButton.nativeElement)) {
            if (this.storyData.elements.length > 0) {
              this.elReference['_results'][0].setFocusOnThis('start');
            }
          }
        }
        break;
      case 38:
        if (!$event.shiftKey) {
          if (this.deskprev && this.mobprev && focusedElement === this.deskprev.nativeElement) {
            this.mobprev.nativeElement.focus();
          }
          if ((this.storyType === 'gallery') && this.galleryUploadElement && (focusedElement === this.galleryUploadElement.nativeElement)) {
            if (this.storyData.elements.length > 0) {
              const id = this.storyData.elements[this.storyData.elements.length - 1];
              const index = this.viewPortItems.indexOf(id);
              if (index > -1) {
                this.elReference['_results'][index].setFocusOnThis(null);
              }
            } else {
              if (this.isCKEditorEnabled) {
                this.summaryEditor.editing.view.focus();
              } else {
                this.summaryEditor.focus();
              }
              this.setFocus('summary');
            }
          }
          if ((this.storyType === 'gallery') && this.galleryPickElement && this.galleryUploadElement
            && (focusedElement === this.galleryPickElement.nativeElement)) {
            this.galleryUploadElement.nativeElement.focus();
          }
          if ((this.storyType === 'liveblog') && this.liveblogButton && (focusedElement === this.liveblogButton.nativeElement)) {
            this.elLiveRef['_results'][0].setFocusOnThis(null);
          }
          if ((this.storyType === 'listicle' || this.storyType === 'highlights') && this.listicleButton
            && (focusedElement === this.listicleButton.nativeElement)) {
            this.elListRef['_results'][0].setFocusOnThis(null);
          }
        }
        break;
    }
  }

  stripHtml(html) {
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  increasePendingCount() {
    this.requestInQueue += 1;
  }
  decreasePendingCount(counts) {
    if (this.requestInQueue > 0) {
      if ((counts !== null) && (counts >= this.requestInQueue)) {
        this.requestInQueue = 0;
      } else {
        this.requestInQueue -= 1;
      }
    }
  }

  summaryHtmlToPlainText(summary) {
    summary = summary.replace('</li><li>', '\\n');
    summary = summary.replace('<li>', '');
    summary = summary.replace('</li>', '');
    summary = summary.replace('<ul>', '');
    summary = summary.replace('</ul>', '');

    return summary;
  }

  htmlToPlaintextExcludeItalic(text) {
    if (typeof text === 'string') {
      return text ? String(text).replace(new RegExp('<em>', 'g'), '~@em@~').replace(new RegExp('</em>', 'g'), '~@/em@~')
        .replace(new RegExp('<i>', 'g'), '~@i@~').replace(new RegExp('</i>', 'g'), '~@/i@~')
        .replace(new RegExp('<rupee>', 'g'), '~@rupee@~').replace(new RegExp('</rupee>', 'g'), '~@/rupee@~')
        .replace(/<[^>]+>/gm, '')
        .replace(/\&nbsp;/g, ' ')
        .replace(new RegExp('~@i@~', 'g'), '<i>').replace(new RegExp('~@/i@~', 'g'), '</i>').replace('\n', '')
        .replace(new RegExp('~@em@~', 'g'), '<em>').replace(new RegExp('~@/em@~', 'g'), '</em>').replace('\n', '')
        .replace(new RegExp('~@rupee@~', 'g'), '<rupee>').replace(new RegExp('~@/rupee@~', 'g'), '</rupee>').replace('\n', '').trim() : '';
    } else {
      return text;
    }
  }

  htmlToPlaintextExcludeBulletList(text) {
    if (typeof text === 'string') {
      return text ? String(text).replace(new RegExp('<ul>', 'g'), '~@ul@~').replace(new RegExp('</ul>', 'g'), '~@/ul@~')
        .replace(new RegExp('<li>', 'g'), '~@li@~').replace(new RegExp('</li>', 'g'), '~@/li@~')
        .replace(new RegExp('<rupee>', 'g'), '~@rupee@~').replace(new RegExp('</rupee>', 'g'), '~@/rupee@~')
        .replace(/<[^>]+>/gm, '')
        .replace(/\&nbsp;/g, ' ')
        .replace(new RegExp('~@li@~', 'g'), '<li>').replace(new RegExp('~@/li@~', 'g'), '</li>')
        .replace(new RegExp('~@ul@~', 'g'), '<ul>').replace(new RegExp('~@/ul@~', 'g'), '</ul>')
        .replace(new RegExp('~@rupee@~', 'g'), '<rupee>').replace(new RegExp('~@/rupee@~', 'g'), '</rupee>') : '';
    } else {
      return text;
    }
  }

  // <(div|/div|br|p|/p)[^>]{0,}>
  htmlToPlaintextExcludeBulletListAndHyperlink(text) {
    if (typeof text === 'string') {
      return text ? String(text).replace(new RegExp('<ul>', 'g'), '~@ul@~').replace(new RegExp('</ul>', 'g'), '~@/ul@~')
        .replace(new RegExp('<li>', 'g'), '~@li@~').replace(new RegExp('</li>', 'g'), '~@/li@~')
        .replace(new RegExp('<rupee>', 'g'), '~@rupee@~').replace(new RegExp('</rupee>', 'g'), '~@/rupee@~')
        .replace(/<(div|\/div|br|p|\/p|ol|\/ol|strong|\/strong|u|\/u|em|\/em)[^>]{0,}>/g, '')
        .replace(new RegExp('~@li@~', 'g'), '<li>').replace(new RegExp('~@/li@~', 'g'), '</li>')
        .replace(new RegExp('~@ul@~', 'g'), '<ul>').replace(new RegExp('~@/ul@~', 'g'), '</ul>')
        .replace(new RegExp('~@rupee@~', 'g'), '<rupee>').replace(new RegExp('~@/rupee@~', 'g'), '</rupee>') : '';
    } else {
      return text;
    }
  }

  htmlSpecialCharToText(text) {
    // const tevmbrgvr = '&nbsp;&amp;&quot;&lt;&gt;';
    const translate_re = /&(nbsp|amp|quot|lt|gt);/g;
    const translate = {
      'nbsp': ' ',
      'amp': '&',
      'quot': '\'',
      'lt': '<',
      'gt': '>'
    };
    return (text.replace(translate_re,
      (match, entity) => {
        return translate[entity];
      })
    );
  }

  ngAfterViewInit() {
    if (document.getElementsByTagName('ng2-pdfjs-viewer')[0]
      && document.getElementsByTagName('ng2-pdfjs-viewer')[0].getElementsByTagName('iframe')[0]
      && document.getElementsByTagName('ng2-pdfjs-viewer')[0].getElementsByTagName('iframe')[0]
        .contentDocument.getElementsByClassName('page')[0]) {
      const height = document.getElementsByTagName('ng2-pdfjs-viewer')[0]
        .getElementsByTagName('iframe')[0].contentDocument.getElementsByClassName('page')[0].clientHeight;
      // console.log("height of pdf.." + height);
      document.getElementsByTagName('ng2-pdfjs-viewer')[0].getElementsByTagName('iframe')[0]
        .setAttribute('style', 'height:' + height + 'px;');
    }
  }

  get self() { return this; }

  // story state functions

  stateChangeInit() {
    this.publishFlag = true;
    console.log('word stateChangeInit');
    this.changeFlag = true;
    this.revertListFlag = false;
  }

  fileCurrentStory() {
    this.storyData.metadata.status = 'FILED';
    this.stateChangeInit();
    this.overrideSave();
  }

  editCurrentStory() {
    this.storyData.metadata.status = 'EDITED';
    this.stateChangeInit();
    this.overrideSave();
  }

  getTimeRightNow() {
    const timeRightNow = new Date();
    return timeRightNow.getTime();
  }

  scheduleCheckAlert(){
    if (this.checkIfLiveblogHeadlineMismatch()) {
      const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true); // Omit props what i don't need
      this.snotify.confirm('Story page headline and Landing page headline are different. Do you wish to continue?', '', {
        ...config,
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.scheduleChecks();
              this.snotify.remove(toast.id);
              this.googleAnalytics("Skippable Alerts","Story page headline and Landing page headline are different. Do you wish to continue?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' ,null);
            }, bold: false
          },
          {
            text: 'No', action: (toast) => {
              this.discareUrlChanges(true);
              this.snotify.remove(toast.id);
              this.googleAnalytics("Skippable Alerts","Story page headline and Landing page headline are different. Do you wish to continue?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' ,null);
            }
          }
        ]
      });
    } else {
      this.scheduleChecks();
    }
  }

  scheduleCurrentStory() {
    this.schedulingStoryFlag = true;
    if (this.disableElement('publish-story')) {
      const timeRightNow = new Date();
      if (timeRightNow.getTime() < this.storyData.scheduledAt) {
        if(this.sharedService.isdomainConfig('story','enableDuplicateAlert')) {
          const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true);
          this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/story/status/'+this.storyData.id, )
          .subscribe(
            data => {
              let text = '';
              console.log(data)
              if(data.duplicateFields && data.duplicateFields[0]) {
                text = text + data.duplicateFields[0];
              }
              if(data.duplicateFields && data.duplicateFields[1]) {
                text = text + ' & ' + data.duplicateFields[1];
              }
              if(data.isDuplicateStory !== "No") {
                this.snotify.confirm('Story with matching ' + text + ' found. Do you still want to continue publish?', '', {
                  ...config,
                  buttons: [
                    {
                      text: 'Yes', action: (toast) => {
                        this.storyData.metadata.duplicateStoryPublishAlert = 'true';
                        this.scheduleCheckAlert();
                        this.snotify.remove(toast.id);
                        this.googleAnalytics("Skippable Alerts",'Story with matching ' + text + ' found. Do you still want to continue publish?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' ,null);

                      }, bold: false
                    },
                    {
                      text: 'No', action: (toast) => {
                        this.snotify.clear();
                        this.googleAnalytics("Skippable Alerts",'Story with matching ' + text + ' found. Do you still want to continue publish?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' ,null);
                      }
                    }
                  ]
                });
                for(const url of data.canonicalUrl) {
                  this.snotify.confirm(url , '', {
                    ...config,
                    buttons: [
                      {
                        text: 'Open URL', action: (toast) => {
                          window.open(url, '_blank');
                          this.snotify.remove(toast.id);
                        }, bold: false
                      },
                    ]
                  });
                }
              } else {
                this.scheduleCheckAlert();
              }
            } ,
            error => {
              this.snotify.error(error.message, '', this.sharedService.getConfig(false));
              this.snotify.warning("Publishing without checking for duplicates", this.sharedService.getConfig(false))
              this.scheduleCheckAlert();
            }
          );
        } else {
          this.scheduleCheckAlert();
        }
      } else {
        this.snotify.info('Enter a time in future', '', this.sharedService.getConfig(false));
        this.storyData.scheduledAt = this.lastDate['scheduledAt'];
        this.setCalendarDate();
      }
    } else {
      this.publishError();
    }
  }

  scheduleChecks() {
    if (this.storyData.metadata.breakingNews) {
      if (this.storyData.leadMedia && this.storyData.leadMedia.elements
        && (this.storyData.leadMedia.elements.length === 0) && (this.breakingNewsImageUrl !== null)) {
        this.saveDefaultLeadForStory(this.breakingNewsImageUrl, imageid => {
          this.storyData.leadMedia.elements = [imageid];
          if (this.storyType === 'story' && this.storyData.elements.length === 0) {
            this.setDeafultBody(paraid => {
              this.storyData.elements.push(paraid);
              this.viewPortItems.push(paraid);
              setTimeout(e4 => {
                this.scheduleFunctions();
              }, 10);
              setTimeout(e3 => {
                this.checkIfLastIsPara(null);
              }, 200);
            });
          } else {
            setTimeout(e4 => {
              this.scheduleFunctions();
            }, 10);
          }
        });
      } else {
        if (this.storyType === 'story' && this.storyData.elements && this.storyData.elements.length === 0) {
          this.setDeafultBody(paraid => {
            this.storyData.elements.push(paraid);
            this.viewPortItems.push(paraid);
            setTimeout(e4 => {
              this.scheduleFunctions();
            }, 10);
            setTimeout(e3 => {
              this.checkIfLastIsPara(null);
            }, 200);
          });
        } else {
          setTimeout(e4 => {
            this.scheduleFunctions();
          }, 10);
        }
      }
    } else {
      this.scheduleFunctions();
    }
  }

  scheduleFunctions() {
    this.removeLastParaIfEmpty();
    this.checkCanoicalUrl(this.storyData.metadata.url);
    this.multipleHeadlineCheck();
    this.storyEditMode = false;
    this.schedulingStoryFlag = false;
    this.storyData.metadata.status = 'SCHEDULED';
    this.stateChangeInit();
    this.overrideSave();
  }

  unScheduleCurrentStory() {
    this.setCalendarDate();
    this.storyData.metadata.status = 'EDITED';
    this.storyData.scheduledAt = null;
    this.storyEditMode = true;
    this.stateChangeInit();
    this.overrideSave();
  }

  setType($event) {
    if ($event) {
      // this.storyData.type = $event.target.value;
      this.selectedType = $event.target.value;
      this.sharedService.setValue(this.selectedType);

    }
  }

  embargoCurrentStory() {
    const timeRightNow = new Date();
    if (timeRightNow.getTime() < this.storyData.embargoAt) {
      this.storyData.metadata.status = 'EMBARGO';
      this.stateChangeInit();
      this.overrideSave();
    } else {
      this.snotify.info('Enter a time in future', '', this.sharedService.getConfig(false));
      this.storyData.embargoAt = this.lastDate['embargoAt'];
      this.setCalendarDate();
    }
  }

  unEmbargoCurrentStory() {
    this.setCalendarDate();
    this.storyData.metadata.status = 'EDITED';
    this.storyData.embargoAt = null;
    this.stateChangeInit();
    this.overrideSave();
  }

  setExpiryTime() {
    const timeRightNow = new Date();
    if (timeRightNow.getTime() < this.storyData.expireAt) {
      this.storyData.softPublished = true;
      this.stateChangeInit();
      this.overrideSave();
    } else {
      this.snotify.info('Enter a time in future', '', this.sharedService.getConfig(false));
      if (!this.storyData.expiryDate || this.storyData.expiryDate === null) {
        this.storyData.expireAt = null;
      } else {
        this.storyData.expireAt = this.lastDate['expireAt'];
      }
      this.setCalendarDate();
    }
  }

  // revertStoryState() {}

  pickForEditingCurrentStory() {
    const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    const role = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[currentDomain].role;
    if (role && role !== 'ROLE_ADMIN' && role !== 'ROLE_SUPER_ADMIN' && role !== 'ROLE_EDITOR' && role!=='ROLE_SITE_MANAGER') {
      this.snotify.error('You don’t have permission to unlock a story', '', this.sharedService.getConfig(false));
    } else {
      this.unlockStory(this.id, flag => {
        if (flag) {
          this.lockAcquire(this.id, flag2 => {
            if (flag2) {
              this.storyEditMode = true;
              this.initStoryView(this.id, false);
              // console.log('edit now');
            } else {
              // console.log('lock nhi mila');
            }
          });
        } else {
          // console.log('lock not acquired');
          this.changeFlag = false;
          this.storyEditMode = false;
        }
      });
    }
  }

  changeStoryURL() {
    const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    const role = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[currentDomain].role;
    if (role && role !== 'ROLE_ADMIN' && role !== 'ROLE_SUPER_ADMIN' && role !== 'ROLE_EDITOR' && role!=='ROLE_SITE_MANAGER') {
      this.snotify.error('You don’t have permission to change the URL', '', this.sharedService.getConfig(false));
    } else {
      // console.log('changing url of story');
      this.changeURLBody = true;
      this.sharedService.overflowhidden();
      if (this.isStoryUrlCreatedFromHeadline) {
        // this.urlBody = (this.storyData.headline !== null && this.storyData.headline.trim() !== '') ?
        //   this.storyData.headline : this.storyData.headline;

        this.urlBody = (this.storyData.metadata.seoUrl !== null && this.storyData.metadata.seoUrl.trim() !== '') ?
          this.storyData.metadata.seoUrl : this.storyData.mobileHeadline;0
      }
      else {
        this.urlBody = (this.storyData.urlHeadline !== null && this.storyData.urlHeadline.trim() !== '') ?
          this.storyData.urlHeadline : this.storyData.urlHeadline;
      }
      this.isValid(this.urlBody);
    }
  }

  getMetaTitle() {
    // this.storyData.metadata.status === "PUBLISHED" ||
    // if ( ((!this.storyData.crosstenantPhotoGallery) && (this.metaTitleChanged || (this.storyData.metadata != null
    //   && this.storyData.metadata.metaTitle != null && this.storyData.metadata.metaTitle.trim() != ''))) && !this.storyData.metadata.copyFromHeadline) {
    //     this.ismetaTitle=false;
    //   return this.storyData.metadata.metaTitle;
    if ( ((!this.storyData.crosstenantPhotoGallery)) && !this.storyData.metadata.copyFromHeadline) {
        this.ismetaTitle=false;
      return this.storyData.metadata.metaTitle;
    }
    if(this.storyData.metadata.copyFromHeadline){
      this.ismetaTitle=true;
      return this.storyData.metadata.metaTitle=this.storyData.mobileHeadline.replace(/\&nbsp;/g, '');
    }
  }

  updateMetaTitle(event) {
    this.metaTitleChanged = true;
    this.storyData.metadata.metaTitle = event.replace(/\&nbsp;/g, '');
  }

  getMetaDescription() {
// this.storyData.metadata.status === "PUBLISHED" ||
    // if ( ((!this.storyData.crosstenantPhotoGallery) && (this.metaDescriptionChanged || (this.storyData.metadata != null
    //   && this.storyData.metadata.metaDescription != null && this.storyData.metadata.metaDescription.trim() != ''))) && !this.storyData.metadata.copyFromHeadline){
    //     this.ismetaDescription=false;
    //     return this.storyData.metadata.metaDescription;
    // }
    if ( ((!this.storyData.crosstenantPhotoGallery)) && !this.storyData.metadata.copyFromHeadline){
        this.ismetaDescription=false;
        return this.storyData.metadata.metaDescription;
    }
    else if(this.storyData.metadata.copyFromHeadline){
      this.ismetaDescription=true;
      if(this.storyData.type === 'web-story')
        {
          return this.storyData.metadata.metaDescription = cloneDeep(this.storyData.summary);;
        }else{
          return this.storyData.metadata.metaDescription= (this.summaryEditor != null) ? $(this.summaryEditor.getData().replace(new RegExp('</li><li>', 'g'), '\n')).text() : null;
        }
    }
    else {
      if(this.isCKEditorEnabled)
        if(this.storyData.type === 'web-story')
        {
          return this.storyData.metadata.metaDescription = cloneDeep(this.storyData.summary);
        }else{
          return (this.summaryEditor != null) ? $(this.summaryEditor.getData().replace(new RegExp('</li><li>', 'g'), '\n')).text() : null;
        }
      else {
        if(this.storyData.type === 'web-story')
        {
          return this.storyData.metadata.metaDescription = cloneDeep(this.storyData.summary);
        }else{
          return (this.summaryEditor != null) ? this.summaryEditor.getText() : null;
        }
      }
    }
  }

  updateMetaDescription(event) {
    this.metaDescriptionChanged = true;
    this.storyData.metadata.metaDescription = event.replace(/\&nbsp;/g, '');
  }

  onChange({ editor }: ChangeEvent,model) {
    switch(model) {
      case 'headline': this.headline = editor.getData();
      break;
      case 'summary': this.summary = editor.getData();
      break;
      case 'intro': this.storyData.introBody = editor.getData();
      break;
      case 'tableHTML': this.tableHTML = editor.getData();
      break;
      default:
      break;
    }
    if (model === 'headline') {
      this.storyData.mobileHeadline = this.htmlToPlaintextExcludeItalic(this.headline);
      // if (this.storyData.metadata.status != 'PUBLISHED')
      //   this.storyData.metadata.seoUrl = this.storyData.mobileHeadline;
    }
    if (model === 'summary') {
      if(!!this.storyData.summaryStatus && this.storyData.summaryStatus=="Automated"){
        this.storyData.summaryStatus="Automated_Edited";
      }
      if (this.isSummaryTagStripDisabled()) {
        this.storyData.summary = this.summary;
      } else {
        if (this.isSummaryHyperlinkEnabled()) {
          this.storyData.summary = this.htmlToPlaintextExcludeBulletListAndHyperlink(this.summary);
        } else {
          this.storyData.summary = this.htmlToPlaintextExcludeBulletList(this.summary);
        }
      }
      // this.storyData.metadata.metaDescription = $(this.summaryEditor.getData().replace(new RegExp('</li><li>', 'g'), '\n')).text();
      if(this.disabledMetaFields.indexOf('enableSummaryHyperlink')==-1 &&
         this.enableSummaryHyperlink.includes(this.storyType)){
        this.storyData.summary = this.htmlToPlaintextExcludeBulletListAndHyperlink(this.summary);
      }
    }
  }

  getSeoURL() {
    if (this.storyData.metadata.status == 'PUBLISHED' || this.seoUrlChanged || this.storyData.metadata.seoUrl.trim() != '')
      return this.storyData.metadata.seoUrl;
    else
      return this.storyData.mobileHeadline.replace(/\&nbsp;/g, '');
  }

  updateSeoURL(event) {
    this.seoUrlChanged = true;
    this.storyData.metadata.seoUrl = event.replace(/\&nbsp;/g, '');
  }

  closeURLbody() {
    this.changeURLBody = false;
    this.urlBody = '';
    this.revertListFlag = false;
    this.sharedService.overflowauto();
  }


  changeURL() {
    const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    const role = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[currentDomain].role;
    if (role && role !== 'ROLE_ADMIN' && role !== 'ROLE_SUPER_ADMIN' && role !== 'ROLE_EDITOR' && role!=='ROLE_SITE_MANAGER') {
      this.snotify.error('You don’t have permission to change the URL', '', this.sharedService.getConfig(false));
    } else {
      if (this.urlBody.trim() !== '') {
        this.increasePendingCount();
        this.restService.http_post(
          this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), this.page_id, this.url_generate_api),
          {
            'articleId': this.storyData.id,
            'headline': this.urlBody.trim()
          },
          result => {
            // console.log(result);
            this.decreasePendingCount(null);
            const url = this.storyData.metadata.url;
            if (result.status === 200) {
              // console.log(result.error.text);
              if (this.isStoryUrlCreatedFromHeadline) {
                this.storyData.headline = this.urlBody.trim();
              }
              else {
                this.storyData.urlHeadline = this.urlBody.trim();
              }
              if (!this.storyData.metadata.alternateUrls) {
                this.storyData.metadata.alternateUrls = [url];
                this.storyData.metadata.url = result.error.text;
              } else {
                this.storyData.metadata.alternateUrls.push(url);
                this.storyData.metadata.url = result.error.text;
              }
              this.storyData.metadata.seoUrl = this.urlBody.trim();
              // Do here
              this.snotify.success('URL changed successfuly', '', this.sharedService.getConfig(false));
              this.closeURLbody();
            } else {
              // console.log(result);
            }
          });
      } else {
        // console.log('check the disable check');
      }
    }
  }

  killStoryURL() {
    const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    const role = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[currentDomain].role;
    if (role && role !== 'ROLE_ADMIN' && role !== 'ROLE_SUPER_ADMIN') {
      this.snotify.error('You don’t have permission to Kill a story', '', this.sharedService.getConfig(false));
    } else {
      // console.log('killing url of story');
      this.killStoryPopup = true;
      this.killURL = '';
      this.sharedService.overflowhidden();
    }
  }

  closeKillURL() {
    this.killStoryPopup = false;
    this.killURL = '';
    this.revertListFlag = false;
    this.sharedService.overflowauto();
  }

  isValid(text) {
    this.invalidData = this.urlValidationFlag ? !(this.isStringInEnglish(text)) : false;
    // if (text) {
    //   const regex = /[^\x00-\x7F’]/i;
    //   if (regex.test(text)) {
    //     this.invalidData = true;
    //   } else {
    //     this.invalidData = false;
    //     // this.temporaryChangesFlag = true;
    //   }
    // }
    // if (text === '' || text === null || text === undefined) {
    //   this.invalidData = true;
    // }
  }


  killStory() {
    const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    const role = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[currentDomain].role;
    if (role && role !== 'ROLE_ADMIN' && role !== 'ROLE_SUPER_ADMIN') {
      this.snotify.error('You don’t have permission to Kill a story', '', this.sharedService.getConfig(false));
    } else {
      this.destroyStoryAutoSaveInterval();
      const url = this.storyData.metadata.url;
      const nextURL = (this.killURL.trim() !== '') ? this.killURL.trim() : '';
      // console.log('kill this story and its dreams');
      this.storyData.metadata.deleteMode = 'PERMANENT_REDIRECT';
      this.storyData.metadata.redirectUrl = nextURL;
      this.increasePendingCount();
      this.restService.http_delete(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.get_api)
        + '/' + this.storyData.id,
        this.storyData
        , data => {
          this.decreasePendingCount(null);
          // console.log(data);
          if (!data.hasOwnProperty('error')) {
            if (data.status === 406) {
              this.storyData.metadata.deleteMode = null;
              this.storyData.metadata.redirectUrl = '';
              this.snotify.error('Enter a valid URL', '', this.sharedService.getConfig(false));
              this.overrideSave();
            } else {
              this.storyData = data;
              if (!this.storyData.metadata.alternateUrls) {
                this.storyData.metadata.alternateUrls = [url];
              } else {
                if (this.storyData.metadata.alternateUrls.indexOf(url) < 0) {
                  this.storyData.metadata.alternateUrls.push(url);
                }
              }
              this.snotify.success('Story Killed', '', this.sharedService.getConfig(false));
              this.overrideSave();
              this.closeKillURL();
            }
          } else {
            this.storyData.metadata.deleteMode = null;
            this.storyData.metadata.redirectUrl = '';
            this.snotify.error(data.error, '', this.sharedService.getConfig(false));
          }
        });
    }
  }

  unkillStoryURL() {
    const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    const role = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[currentDomain].role;
    if (role && role !== 'ROLE_ADMIN' && role !== 'ROLE_SUPER_ADMIN') {
      this.snotify.error('You don’t have permission to UnKill a story', '', this.sharedService.getConfig(false));
    } else {
      if (this.disableElement('publish-story')) {
        this.revertListFlag = false;
        this.storyData.metadata.deleteMode = null;
        this.storyData.metadata.redirectUrl = '';
        this.finishPublish();
      } else {
        this.publishError();
      }
    }
  }

  deleteCurrentStory() {
    // console.log('deleted');
    if (this.storyData.id !== null) {
      this.revertListFlag = false;
      this.publishFlag = true;
      this.storyData.isDeleted = 1;
      console.log('word deleteCurrentStory');
      this.changeFlag = true;
      this.overrideSave();
    }
    setTimeout(e => {
      this.router.navigate(['/lite/dash/workspace']);
    }, 200);
  }

  openPublish(flagForKeywordCheck) {
    if (this.storyData && this.storyData.metadata && !this.storyData.metadata.keywords) {
      this.storyData.metadata.keywords = [];
    }
    if (this.disableElement('publish-story')) {
      if (this.checkIfLiveblogHeadlineMismatch()) {
        const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true); // Omit props what i don't need
        this.snotify.confirm('Story page headline and Landing page headline are different. Do you wish to continue?', '', {
          ...config,
          buttons: [
            {
              text: 'Yes', action: (toast) => {
                this.startPublishing(flagForKeywordCheck, e => {
                  this.finishPublish();
                });
                this.snotify.remove(toast.id);
                this.googleAnalytics("Skippable Alerts","Story page headline and Landing page headline are different. Do you wish to continue?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' , null);
              }, bold: false
            },
            {
              text: 'No', action: (toast) => {
                this.discareUrlChanges(true);
                this.snotify.remove(toast.id);
                this.googleAnalytics("Skippable Alerts","Story page headline and Landing page headline are different. Do you wish to continue?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' , null);
              }
            }
          ]
        });
      }
      else {
        this.startPublishing(flagForKeywordCheck, e => {
          this.finishPublish();
        });
      }
    } else {
      console.log("open publish ")
      this.publishError();
    }
  }

  startPublishing(flagForKeywordCheck, callback) {
    const elem = (this.storyData.elements && (this.storyData.elements.length === 1)
      && this.storyData.elements[0] && this.Elements[this.storyData.elements[0]]
      && this.Elements[this.storyData.elements[0]].type === 'paragraph'
      && this.Elements[this.storyData.elements[0]].paragraph
      && (
        !this.Elements[this.storyData.elements[0]].paragraph.body
        || (this.htmlToPlaintext(this.Elements[this.storyData.elements[0]].paragraph.body).trim() === '')
        || (this.Elements[this.storyData.elements[0]].paragraph.body === null)
      )
    ) ?
      true : false;
    // console.log(this.htmlToPlaintext(this.Elements[this.storyData.elements[0]].paragraph.body).trim() !== '');
    var text =
      (this.storyType !== 'deadlink' && (this.storyData && this.storyData.metadata && (!this.storyData.metadata.keywords
        || (this.storyData.metadata.keywords === null) || (this.storyData.metadata.keywords.length < 1))) ? 'keywords, ' : '') +
      ((this.storyData && (!this.storyData.summary || this.htmlToPlaintext(this.storyData.summary).trim() === '')) ? 'summary, ' : '') +
      (
        (
          (
            this.storyData && this.storyType && (this.storyType === 'story')
            && (!this.storyData.elements || this.storyData.elements === null || this.storyData.elements.length === 0 || elem)
          )

        ) ? 'paragraph, ' : '');
    if (this.isPrimaryLocationEnabled() && this.storyData.metadata.section === 'entertainment') {
      if (this.storyData.metadata && (!this.storyData.metadata.primaryLocation || this.storyData.metadata.primaryLocation.trim() === '')) {
        text = text + "Primary Location";
      }
    }
    this.pendingToasts = 0;
    let publishingCheckPopups = this.sharedService.isdomainConfig('story', 'readibilityEase') || this.sharedService.isdomainConfig('story', 'enableSEOScore');
    if (flagForKeywordCheck && !this.storyData.metadata.breakingNews && text !== '') {
      const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true); // Omit props what i don't need
      this.snotify.confirm('You have not entered ' + text + ' Continue?', '', {
        ...config,
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              if (!publishingCheckPopups) {
                callback();
              } else {
                this.publishingToasts(callback);
              }
              this.snotify.remove(toast.id);
              this.googleAnalytics("Skippable Alerts",'You have not entered ' + text + ' Continue?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' , null);

            }, bold: false
          },
          {
            text: 'No', action: (toast) => {
              this.snotify.remove(toast.id);
              this.googleAnalytics("Skippable Alerts",'You have not entered ' + text + ' Continue?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' , null);
            }
          }
        ]
      });
    } else {
      if (!publishingCheckPopups) {
        callback();
      } else {
        this.publishingToasts(callback);
      }
    }
  }
  publishingToasts(callback) {
    let extraToasts = false;
    this.alreadyPublished = false;
    if (this.storyData.type === 'story' && this.sharedService.isdomainConfig('story', 'readibilityEase')) {
      extraToasts = true;
      this.readibilityCheck(callback);
    }
    if (this.sharedService.isdomainConfig('story', 'enableSEOScore')) {
      extraToasts = true;
      this.seoCheck(callback);
    }
    setTimeout(e => {
      if (extraToasts === false) {
        callback();
      }
    }, 100);

  }
  seoCheck(callback: any) {
    if (this.seoDetails) {
      let seoPercentage = this.seoDetails['data']['overview']['overallSeoScore'] / 3;
      if (seoPercentage < 30) {
        this.pendingToasts += 1;
        const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true); // Omit props what i don't need
        this.snotify.confirm('The SEO Score is less than 30%, do you still want to Publish?', '', {
          ...config,
          buttons: [
            {
              text: 'Yes', action: (toast) => {
                if (this.pendingToasts === 1) {
                  this.pendingToasts--;
                  callback();
                } else {
                  this.pendingToasts--;
                }
                this.snotify.remove(toast.id);
                this.googleAnalytics("Skippable Alerts",'The SEO Score is less than 30%, do you still want to Publish?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' , null);
              }, bold: false
            },
            {
              text: 'No', action: (toast) => {
                this.snotify.clear()
                this.pendingToasts--;
                this.googleAnalytics("Skippable Alerts",'The SEO Score is less than 30%, do you still want to Publish?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' , null);
              }
            }
          ]
        });
      } else {
        setTimeout(e => {
          if (this.pendingToasts === 0 && !this.alreadyPublished) {
            this.alreadyPublished = true;
            callback();
          }
        }, 100);
      }
    } else {
      setTimeout(e => {
        if (this.pendingToasts === 0 && !this.alreadyPublished) {
          this.alreadyPublished = true;
          callback();
        }
      }, 100);
    }
  }
  readibilityCheck(callback) {
    if (this.readibilityType === 'High') {
      setTimeout(e => {
        if (this.pendingToasts === 0 && !this.alreadyPublished) {
          this.alreadyPublished = true;
          callback();
        }
      }, 100);
    }
    if (this.sharedService.isdomainConfig('story', 'readibilityEase') === true) {
      if (this.readibilityType === 'Medium' || this.readibilityType === 'Low') {
        this.pendingToasts += 1;
        const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true); // Omit props what i don't need
        this.snotify.confirm('The Readability Ease for the story is ' + this.readibilityType + '. Do you still want to Proceed?', '', {
          ...config,
          buttons: [
            {
              text: 'Yes', action: (toast) => {
                if (this.pendingToasts === 1) {
                  this.pendingToasts--;
                  callback();
                } else {
                  this.pendingToasts--;
                }
                this.snotify.remove(toast.id);
                this.googleAnalytics("Skippable Alerts",'The Readability Ease for the story is ' + this.readibilityType + '. Do you still want to Proceed?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' , null);
              }, bold: false
            },
            {
              text: 'No', action: (toast) => {
                this.googleAnalytics("Skippable Alerts",'The Readability Ease for the story is ' + this.readibilityType + '. Do you still want to Proceed?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' , null);
                this.snotify.clear()
                this.pendingToasts--;
              }
            }
          ]
        });
      }
    }
  }

  cancelPublish() {
    this.publishPopup = false;
  }

  finishPublish() {
    this.checkForPendingRequests('publishCurrentStory', 0, null);
    this.cancelPublish();
  }

  publishCurrentStory() {
    this.publishingChecks();
  }

  saveDefaultLeadForStory(url, callback) {
    const defaultImagecardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
    defaultImagecardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    defaultImagecardData['id'] = null;
    // if (url.hasOwnProperty('ampImage')) {
    //   defaultImagecardData.image.images['ampImage'] = url['ampImage'];
    // }
    // defaultImagecardData.image.images['original'] = url['original'];
    // defaultImagecardData.image.images['960x540'] = url['960x540'];
    // defaultImagecardData.image.images['600x338'] = url['600x338'];
    // defaultImagecardData.image.images['250x250'] = url['250x250'];
    // defaultImagecardData.image.images['90x90'] = url['90x90'];
    defaultImagecardData.image.images = url;
    defaultImagecardData.image.caption = this.breakingNewsImageCaption;
    defaultImagecardData['parentElementId'] = 8425817;

    this.increasePendingCount();
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      defaultImagecardData, data => {
        this.decreasePendingCount(null);
        if (!data.hasOwnProperty('error')) {
          callback(data.id);
        } else {
          this.snotify.error('Could not set default Lead Media, Server error', '', this.sharedService.getConfig(false));
        }
      });
  }

  setDeafultBody(callback) {
    const defaultPara = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
    defaultPara.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    defaultPara['paragraph']['body'] = '<p>More details awaited</p>';
    this.increasePendingCount();
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      defaultPara, data => {
        this.decreasePendingCount(null);
        if (!data.hasOwnProperty('error')) {
          callback(data.id);
        } else {
          this.snotify.error('Could not set default body, Server error', '', this.sharedService.getConfig(false));
        }
      });
  }

  publishingChecks() {
    if (this.storyData.metadata.breakingNews) {
      if (this.storyData.leadMedia && this.storyData.leadMedia.elements
        && (this.storyData.leadMedia.elements.length === 0) && (this.breakingNewsImageUrl !== null)) {
        this.saveDefaultLeadForStory(this.breakingNewsImageUrl, imageid => {
          this.storyData.leadMedia.elements = [imageid];
          if (this.storyType === 'story' && this.storyData.elements.length === 0) {
            this.setDeafultBody(paraid => {
              this.storyData.elements.push(paraid);
              this.viewPortItems.push(paraid);
              setTimeout(e4 => {
                this.publishFunctions();
              }, 10);
              setTimeout(e3 => {
                this.checkIfLastIsPara(null);
              }, 200);
            });
          } else {
            setTimeout(e4 => {
              this.publishFunctions();
            }, 10);
          }
        });
      } else {
        if (this.storyType === 'story' && this.storyData.elements && this.storyData.elements.length === 0) {
          this.setDeafultBody(paraid => {
            this.storyData.elements.push(paraid);
            this.viewPortItems.push(paraid);
            setTimeout(e4 => {
              this.publishFunctions();
            }, 10);
            setTimeout(e3 => {
              this.checkIfLastIsPara(null);
            }, 200);
          });
        } else {
          setTimeout(e4 => {
            this.publishFunctions();
          }, 10);
        }
      }
    } else {
      this.publishFunctions();
    }
  }
getUpdatedRecosenseKeword(keywords,recosenseKeywords){
  return  keywords.filter(function(n) { return recosenseKeywords.indexOf(n) !== -1;});
}
publishFunctions() {
    this.removeLastParaIfEmpty();
    this.checkCanoicalUrl(this.storyData.metadata.url);
    this.multipleHeadlineCheck();
    if(this.isRecosense && this.storyData.metadata.keywords && this.storyData.metadata.recosenseKeywords) {
      this.storyData.metadata.recosenseKeywords=this.getUpdatedRecosenseKeword(this.storyData.metadata.keywords,this.storyData.metadata.recosenseKeywords);
    }
    // this.storyData.metadata.status !== 'PUBLISHED' || (!this.storyData.metadata.status) &&
    if( this.storyType !== 'deadlink' && this.storyData.metadata && this.storyData.metadata.copyFromHeadline) {
      this.storyData.metadata.metaTitle = this.storyData.mobileHeadline.replace(/\&nbsp;/g, '');
      if(this.isCKEditorEnabled)
        if(this.storyData.type === 'web-story')
        {
          this.storyData.metadata.metaDescription = cloneDeep(this.storyData.summary);
        }else{
          this.storyData.metadata.metaDescription = (this.summaryEditor) ? $(this.summaryEditor.getData().replace(new RegExp('</li><li>', 'g'), '\n')).text() : null;
        }
      else
        if(this.storyData.type === 'web-story')
        {
          this.storyData.metadata.metaDescription = cloneDeep(this.storyData.summary);
        }else{
          this.storyData.metadata.metaDescription = (this.summaryEditor) ? this.summaryEditor.getText() : null;
        }
    }
    if(this.storyType !== 'deadlink' && this.storyData.metadata && !this.storyData.metadata.metaTitle) {
      return this.snotify.error('Please Enter Meta Title','',this.sharedService.getConfig(false))
   }
    if(this.storyType !== 'deadlink' && this.storyData.metadata && !this.storyData.metadata.metaDescription) {
       return this.snotify.error('Please Enter Meta Description','',this.sharedService.getConfig(false))
    }
    this.storyData.metadata.status = 'PUBLISHED';
    if (this.enableLeadVideoCaption && this.storyData.leadMedia && this.storyData.leadMedia.video && this.storyData.leadMedia.video.body !=''
    && !this.storyData.leadMedia.video.caption && this.storyData.type =='story') {
      return this.snotify.error('Please Enter Video Caption','',this.sharedService.getConfig(false))
    }
    if (this.enableLeadVideoImageCaption && this.storyData.leadMedia && this.storyData.leadMedia.video && this.storyData.leadMedia.video.body !='' && this.storyData.leadMedia.video.image
    && !this.storyData.leadMedia.video.image.caption && this.storyData.type =='story') {
      return this.snotify.error("Please Enter Video's Image Caption",'',this.sharedService.getConfig(false))
    }
    this.storyEditMode = true;
    this.stateChangeInit();
    const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    const role = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[currentDomain].role;

    if (role && role !== 'ROLE_REPORTER') {
      this.snotify.info('Publishing in progress', '', this.sharedService.getConfig(false));
    }
    this.overrideSave();
  }

  publishError() {
    this.errorModalOnPublish = true;
    this.validationFlag = true;
    this.errorDisplayArray = [];

    // 1 for headline
    // 2 for section
    // 3 for section and subsection
    // 4 for agency and byline
    // 5 for summary blank
    // 6 for summary erroneous
    // 7 lead not cropped
    // 8 lead not present
    // 9 keywords not present
    // 12 check image caption
    // 13 Primary location validation
    // 14 URL headline english validation
    // 15 Headline restrictions
    // 16 Summary Restrictions
    // 18 all images cropped
    // 19 Deadlink URL
    // 20 Summary blank - domain and story type based check
    // 22 for Brand and Model
    // 23 for lead Gif not Cropped
    // 24 cross tenant check
    // 25 plag check
    // this.snotify.clear();
    if (this.storyData !== null && this.storyData.metadata !== null) {
      if (!this.storyData.metadata.breakingNews) {
        if (this.storyType !== 'gallery' && this.storyType !== 'liveblog'
          && this.storyType !== 'mintlite' && this.storyType !== 'mediagallery' && this.storyType !== 'deadlink' && this.storyType !== 'photostory') {
          if (this.storyType === 'listicle' || this.storyType === 'highlights') {
            this.callForErrorChecks([1, 3, 4, 6, 7, 12, 13, 14, 15, 16, 17, 20, 21, 22]);
            this.errorDisplayArray = [1, 3, 4, 6, 7, 12, 13, 14, 15, 16, 17, 20, 21, 22];
          } else {
            this.callForErrorChecks([1, 3, 4, 6, 7, 12, 13, 14, 15, 16, 17, 20, 21, 22, 23, 25]);
            this.errorDisplayArray = [1, 3, 4, 6, 7, 12, 13, 14, 15, 16, 17, 20, 21, 22, 23, 25];
          }
        }
        if (this.storyType === 'gallery') {
          this.callForErrorChecks([1, 3, 4, 6, 8, 12, 13, 14, 15, 16, 17, 18, 20, 21, 22, 24]);
          this.errorDisplayArray = [1, 3, 4, 6, 8, 12, 13, 14, 15, 16, 17, 18, 20, 21, 22, 24];
        }
        if (this.storyType === 'liveblog') {
          this.callForErrorChecks([1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 22]);
          this.errorDisplayArray = [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 22];
        }
        if (this.storyType === 'mediagallery') {
          this.callForErrorChecks([1, 3, 4, 6, 8, 12, 13, 14, 15, 16, 17, 20, 21, 22]);
          this.errorDisplayArray = [1, 3, 4, 6, 8, 12, 13, 14, 15, 16, 17, 20, 21, 22];
        }
        if (this.storyType === 'mintlite') {
          this.callForErrorChecks([1, 3, 4, 5, 6, 9, 10, 11, 13, 14]);
          this.errorDisplayArray = [1, 3, 4, 5, 6, 9, 10, 11, 13, 14];
        }
        if (this.storyType === 'deadlink') {
          this.callForErrorChecks([1, 5, 8, 19]);
          this.errorDisplayArray = [1, 5, 8, 19];
        }
        if (this.storyType === 'photostory') {
          this.callForErrorChecks([1, 2, 4, 5, 8, 11, 12, 21, 22]);
          this.errorDisplayArray = [1, 2, 4, 5, 8, 11, 12, 21, 22];
        }
      } else {
        if (this.storyType !== 'gallery' && this.storyType !== 'liveblog'
          && this.storyType !== 'mintlite' && this.storyType !== 'mediagallery' && this.storyType !== 'deadlink') {
          if (this.storyType === 'listicle' || this.storyType === 'highlights' || this.storyType === 'photostory') {
            this.callForErrorChecks([1, 2, 4, 6, 12, 13, 14, 15, 16, 17, 20, 21, 22]);
            this.errorDisplayArray = [1, 2, 4, 6, 12, 13, 14, 15, 16, 17, 20, 21, 22];
          } else {
            this.callForErrorChecks([1, 2, 4, 6, 12, 13, 14, 15, 16, 17, 20, 21, 22, 23, 25]);
            this.errorDisplayArray = [1, 2, 4, 6, 12, 13, 14, 15, 16, 17, 20, 21, 22, 23, 25];
          }
        }
        if (this.storyType === 'gallery') {
          this.callForErrorChecks([1, 2, 4, 6, 8, 12, 13, 14, 15, 16, 17, 18, 20, 21, 22, 24]);
          this.errorDisplayArray = [1, 2, 4, 6, 8, 12, 13, 14, 15, 16, 17, 18, 20, 21, 22, 24];
        }
        if (this.storyType === 'liveblog') {
          this.callForErrorChecks([1, 2, 4, 6, 8, 10, 11, 12, 13, 14, 15, 16, 17]);
          this.errorDisplayArray = [1, 2, 4, 6, 8, 10, 11, 12, 13, 14, 15, 16, 17];
        }
        if (this.storyType === 'mediagallery') {
          this.callForErrorChecks([1, 3, 4, 6, 8, 12, 13, 14, 15, 16, 17, 20]);
          this.errorDisplayArray = [1, 3, 4, 6, 8, 12, 13, 14, 15, 16, 17, 20];
        }
        if (this.storyType === 'mintlite') {
          this.callForErrorChecks([1, 3, 4, 5, 6, 9, 10, 11, 13, 14]);
          this.errorDisplayArray = [1, 3, 4, 5, 6, 9, 10, 11, 13, 14];
        }
        if (this.storyType === 'deadlink') {
          this.callForErrorChecks([1, 5, 8, 19]);
          this.errorDisplayArray = [1, 5, 8, 19];
        }
        if (this.storyType === 'photostory') {
          this.callForErrorChecks([1, 2, 4, 5, 8, 11, 12]);
          this.errorDisplayArray = [1, 2, 4, 5, 8, 11, 12];
        }
      }
    }

  }

  callForErrorChecks(array) {
    // 1 for headline
    // 2 for section
    // 3 for section and subsection
    // 4 for agency and byline
    // 5 for summary blank
    // 6 for summary erroneous
    // 7 lead not cropped
    // 8 lead not present
    // 9 keywords not present
    // 12 check image caption
    // 13 Primary location validation
    // 14 URL headline english validation
    // 15 Headline restrictions
    // 16 Summary Restrictions
    // 18 all images cropped
    // 19 Deadlink URL present
    // 21 for Brand
    // 22 for Brand and Model
    // 23 for lead Gif not Cropped
    if (this.storyData !== null) {
      if ((array.indexOf(1) > -1) && (this.checkHeadlineForPublishing(false))) {
        this.checkHeadlineForPublishing(true);
      }
      if (array.indexOf(2) > -1) {
        this.checkSection(true, false);
      }
      if (array.indexOf(3) > -1) {
        this.checkSection(true, true);
      }
      // if (array.indexOf(21) > -1) {
      //   // console.log("checkBrand for brand");
      //   this.checkBrand(true, false);
      // }
      if (array.indexOf(22) > -1) {
        // console.log("checkBrand for model");
        this.checkBrand(true, true);
      }
      if ((array.indexOf(4) > -1) && (this.checkAgency(null))) {
        this.snotify.error('Fill Byline', '', this.sharedService.getConfig(false));
      }

      if ((array.indexOf(5) > -1) && (this.storyData.summary === null || this.storyData.summary.trim() === '')) {
        this.snotify.error('Fill Summary', '', this.sharedService.getConfig(false));
      }

      if ((array.indexOf(6) > -1) && (!this.checkSummary(this.storyData.summary))) {
        this.snotify.error('Summary format is erroneous', '', this.sharedService.getConfig(false));
      }

      if ((array.indexOf(7) > -1) && (!this.checkLeadMedia())) {
        this.snotify.error('Lead Image is not cropped', '', this.sharedService.getConfig(false));
      }

      if ((array.indexOf(8) > -1) && ((this.storyData.leadMedia.elements.length < 1))) {
        this.snotify.error('Add lead media', '', this.sharedService.getConfig(false));
      }

      if ((array.indexOf(9) > -1) && (this.storyData.metadata.keywords === null || this.storyData.metadata.keywords.length < 1)) {
        this.snotify.error('Add Keywords', '', this.sharedService.getConfig(false));
      }

      if ((array.indexOf(10) > -1) && (this.storyData.introBody === null || this.htmlToPlaintext(this.storyData.introBody).trim() === '')) {
        this.snotify.error('Fill Intro Body', '', this.sharedService.getConfig(false));
      }

      if ((array.indexOf(11) > -1) && (this.storyData.elements && this.storyData.elements.length < 1)) {
        if (this.storyType === 'liveblog') {
          this.snotify.error('Please enter at least 1 post before publishing', '', this.sharedService.getConfig(false));
        }
        else if (this.storyType === 'photostory') {
          this.snotify.error('Please enter at least 1 Slide before publishing', '', this.sharedService.getConfig(false));
        }

      }
      if (array.indexOf(12) > -1) {
        this.checkImageCaption(true);
      }
      if ((array.indexOf(13) > -1) && this.isPrimaryLocationEnabled() && !this.checkPrimaryLocation()) {
        this.snotify.error('Fill Location', '', this.sharedService.getConfig(false));
      }
      if ((array.indexOf(14) > -1) && this.checkIfUrlHeadlineIsValid()) {
        this.snotify.error('URL headline is not in English', '', this.sharedService.getConfig(false));
      }
      if (array.indexOf(15) > -1) {
        const arr = this.checkHeadlineRestrictedCharacters();
        if (arr.flag) {
          this.snotify.error('Headline contains restricted characters like  " {} [] ', '', this.sharedService.getConfig(false));
        }
        this.headlineErrors = arr.err;
      }
      if (array.indexOf(16) > -1) {
        const arr = this.checkSummaryRestrictedCharacters();
        if (arr.flag) {
          this.snotify.error('Summary contains restricted characters like "', '', this.sharedService.getConfig(false));
        }
        this.summaryErrors = arr.err;
      }
      if (array.indexOf(17) > -1 && this.checkCaptionRestrictedCharacters()) {
        this.snotify.error('Images contain restricted characters like " [] {} ! * ^', '', this.sharedService.getConfig(false));
      }
      if (array.indexOf(18) > -1 && this.cropAllGallery && this.checkAllImagesCropped()) {
        console.log(this.cropAllGallery, this.checkAllImagesCropped())
        this.snotify.error('All Images Not Cropped', '', this.sharedService.getConfig(false));
      }
      if (array.indexOf(19) > -1 && this.checkDeadlinkUrl()) {
        this.snotify.error('Please enter Deadlink URL', '', this.sharedService.getConfig(false));
      }

      if ((array.indexOf(20) > -1) && this.isSummaryMandatoryDomainBased()) {
        this.snotify.error('Fill Summary', '', this.sharedService.getConfig(false));
      }

      if ((array.indexOf(23) > -1) && (this.enableGifMedia === true && this.storyData.leadMediaGif && this.storyData.leadMediaGif.elements && this.storyData.leadMediaGif.elements.length > 0 && this.leadelRefl['_results'][0].cardData.image.images['960x540'] === null)) {
        this.snotify.error('Gif Image is not cropped', '', this.sharedService.getConfig(false));
      }
      if ((array.indexOf(24) > -1) && this.checkCrossTenantDifference()) {
        this.snotify.error('Please enter different ' + this.sameFields + ' before publishing.', '', this.sharedService.getConfig(false));
      }

      if (this.storyData.expireAt != null) {
        this.storyData.expireAt = null;
        this.setCalendarDate();
      }

    }
  }
  checkDeadlinkUrl() {
    if (!this.storyData.metadata.deadLinkUrl) {
      return true;
    }
  }

  setCheckForErrorIndication(index) {

    if (this.storyData !== null && this.validationFlag) {
      if ((index === 1) && (this.errorDisplayArray.indexOf(1) > -1) && (this.checkHeadlineForPublishing(false))) {
        // errormsg += 'Headline must have more than 5 characters\n';
        // this.setFocus('headline');
        // this.checkHeadlineForPublishing(true);
        return true;
      }
      if ((index === 2) && (this.errorDisplayArray.indexOf(2) > -1 || this.errorDisplayArray.indexOf(3) > -1)
        && (this.storyData.metadata.section === null || this.storyData.metadata.section.trim() === '')) {
        // this.checkSection(true, false);
        if (this.storyType === 'gallery' || this.storyType === 'video') {
          if ((this.storyType === 'gallery' && this.sectionQuery !== 'photos') || (this.storyType === 'video' && this.sectionQuery !== 'videos'))
            return true;
        } else {
          return true;
        }

      }
      if ((index === 3) && this.errorDisplayArray.indexOf(3) > -1 && this.checkSection(null, true) && this.domainConfig && this.domainConfig['config']
        && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['checkForSubSection'] === 'true') {
        // this.checkSection(true, true);

        return true;
      }
      // console.log(this.storyData.metadata.agency);
      if ((index === 4) && (this.errorDisplayArray.indexOf(4) > -1) && (this.checkAgency(null))) {
        // errormsg += 'Fill agency\n';
        // this.snotify.error('Fill Byline', '', this.sharedService.getConfig(false));
        return true;
      }

      if ((index === 5) && (this.errorDisplayArray.indexOf(5) > -1)
        && (this.storyData.summary === null || this.storyData.summary.trim() === '')) {
        // this.snotify.error('Fill Summary', '', this.sharedService.getConfig(false));
        return true;
      }

      if ((index === 6) && (this.errorDisplayArray.indexOf(6) > -1) && (!this.checkSummary(this.storyData.summary))) {
        // this.snotify.error('Summary format is erroneous', '', this.sharedService.getConfig(false));
        return true;
      }

      if ((index === 7) && (this.errorDisplayArray.indexOf(7) > -1) && (!this.checkLeadMedia())) {
        // this.snotify.error('Lead Image is not cropped', '', this.sharedService.getConfig(false));
        // console.log('came here');
        return true;
      }

      if ((index === 23) && (this.errorDisplayArray.indexOf(23) > -1) && (this.enableGifMedia === true && this.storyData.leadMediaGif && this.storyData.leadMediaGif.elements && this.storyData.leadMediaGif.elements.length > 0 && this.leadelRefl['_results'][0].cardData.image.images['960x540'] === null)) {
        return true;
      }
      if ((index === 8) && (this.errorDisplayArray.indexOf(8) > -1) && (this.storyData.leadMedia.elements.length < 1)) {
        //this.snotify.error('Add lead media', '', this.sharedService.getConfig(false));
        return true;
      }

      if ((index === 9) && (this.errorDisplayArray.indexOf(9) > -1)
        && (this.storyData.metadata.keywords === null || this.storyData.metadata.keywords.length < 1)) {
        // this.snotify.error('Add Keywords', '', this.sharedService.getConfig(false));
        return true;
      }

      if ((index === 10) && (this.errorDisplayArray.indexOf(10) > -1)
        && (this.storyData.introBody === null || this.htmlToPlaintext(this.storyData.introBody).trim() === '')) {
        // this.snotify.error('Fill Intro Body', '', this.sharedService.getConfig(false));
        return true;
      }

      if ((index === 11) && (this.errorDisplayArray.indexOf(11) > -1)
        && (this.storyData.elements && this.storyData.elements.length < 1)) {
        return true;
      }

      if ((index === 13) && (this.errorDisplayArray.indexOf(13) > -1 && this.isPrimaryLocationEnabled() && !this.checkPrimaryLocation())) {
        return true;
      }

      // if ((index === 21) && (this.errorDisplayArray.indexOf(21) > -1 || this.errorDisplayArray.indexOf(22) > -1)
      //   && (this.storyData.metadata.brand === null || this.storyData.metadata.brand.trim() === '')) {
      //   return true;
      // }
      // console.log("called from 1")
      if ((index === 22) && this.errorDisplayArray.indexOf(22) > -1 && this.domainConfig && this.domainConfig['config']
        && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['checkForModel'] === 'true' &&
        this.storyData.metadata.brand != "" && this.storyData.metadata.model == "") {
        return true;
      }

      return false;
    } else {
      return false;
    }
  }

  closeErrorModal() {
    this.errorModalOnPublish = false;
    this.validationFlag = false;
  }


  checkStateOfStory() {
    if (this.storyData && this.storyData.metadata.status && this.storyFlowArray[0].indexOf(this.storyData.metadata.status) > -1) {
      this.storyFlowIndex = this.storyFlowArray[0].indexOf(this.storyData.metadata.status);
    } else {
      this.storyFlowIndex = 0;
    }
    this.flowCTAButtons = this.storyFlowArray[1][this.storyFlowIndex].split(',');
    this.flowSecCTAButtons = this.storyFlowArray[3][this.storyFlowIndex].split(',');
  }

  revertStoryState() {
    if (this.storyFlowIndex > 0) {
      if (this.storyData.metadata.status === 'FILED') {
        this.storyData.metadata.status = 'CREATED';
      }
      if (this.storyData.metadata.status === 'EDITED') {
        this.storyData.metadata.status = 'FILED';
      }
      this.stateChangeInit();
      this.overrideSave();
    }
  }
  public selectedDate(value: any, model_id: string, datepicker?: any) {
    this.lastDate[model_id] = this.storyData[model_id];
    this.storyData[model_id] = value.start.unix() * 1000;
    this.liveBlogEndTimeFlag = true;
  }

  checkForPendingRequests(method, retrycount, timetaken) {
    if (this.requestInQueue > 0) {
      if ((timetaken === null) || ((timetaken !== null) && (timetaken < 120000))) {
        if (retrycount === 0) {
          this.snotify.info('Story Elements saving in Progress', '', this.sharedService.getConfig(false));
        }
        setTimeout(ev => {
          this.checkForPendingRequests(method, ++retrycount, (timetaken + 150));
        }, 150);
      } else {
        this.decreasePendingCount(this.requestInQueue);
        this.snotify.error('There seems to be a problem with network or servers', '', this.sharedService.getConfig(false));
      }
    } else {
      this.snotify.clear();
      this[method]();
    }
  }

  calendarEventsHandler(e: any, model_id: string, method) {
    if (e.event.type === 'apply') {
      if (method) {
        this.checkForPendingRequests(method, 0, null);
      }
    }

    if (e.event.type === 'cancel') {
    }
  }
  selectPremiumScheduleDate(value) {
    console.log('selectPremiumScheduleDate comp',value.start.unix() * 1000)
    this.selectPremiumDate=value.start.unix() * 1000;
  }
  calendarPremiumEventsHandler(value) {
    if (value.event.type === 'apply') {
      console.log('calendarPremiumEventsHandler',this.selectPremiumDate)
      this.storyData.metadata['premiumDate']=this.selectPremiumDate;
    }

    if (value.event.type === 'cancel') {
      this.selectPremiumDate='';
    }
  }

  openCalendar(model) {
  }

  ///////

  startScroll() {
    if (this.storySec && this.storySec !== null) {
      const scroll = autoScroll([
        this.storySec.nativeElement
      ], {
        margin: 30,
        maxSpeed: 20,
        scrollWhenOutside: true,
        autoScroll: function () {
          return this.down;
        }
      });
    } else {
      setTimeout(e => {
        this.startScroll();
      }, 1000);
    }
  }

  ngOnInit() {
    this.sharedService.overflowhidden();
    this.sharedService.sendData('storyEditor|true');
    this.sharedService.sendData('storyPageScroll|true');
    this.startScroll();
    this.getLanguage();
    this.getStoryMetaList();
    this.getUserPermittedSections();
    this.enableQuickSummaryLength=this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']  && this.domainConfig['config']['story']['enableQuickSummaryLength']=='true';
    this.enableAffiliate=this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']  && this.domainConfig['config']['story']['enableAffiliate']=='true';
    this.blogDisclaimer=this.domainConfig['config']['story']['blogDisclaimer'];
    this.affiliateDisclaimer=this.domainConfig['config']['story']['affiliateDisclaimer'];
    this.isRecosense=this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']  && this.domainConfig['config']['story']['isRecosense']=='true';
    this.enableBacklinkList=this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']  && this.domainConfig['config']['story']['enableBacklinkList']=='true';
    this.enableLeadVideoCaption=this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']  && this.domainConfig['config']['story']['enableLeadVideoCaption']=='true';
    this.enableLeadVideoImageCaption=this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']  && this.domainConfig['config']['story']['enableLeadVideoImageCaption']=='true';
    this.enableInlineRelatedStoryHowto=this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']  && this.domainConfig['config']['story']['enableInlineRelatedStoryHowto']=='true';
    this.lShapeBandDisplay = this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['lShapeBand'] === 'true';
    this.cropAllGallery = this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['image'] && this.domainConfig['config']['image']['cropAll'] === 'true';
    this.amazonAdDisplay = this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['amazonMeta'] === 'true';
    this.liveblogIntroEmbed = this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['liveblogIntroEmbed']=='true';
    this.enableLiveBlogIntroElements = this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['enableLiveBlogIntroElements'] ==undefined?[]:this.domainConfig['config']['story']['enableLiveBlogIntroElements'].split(',');
    this.lShapeBandDisplay = this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']
      && this.domainConfig['config']['story']['lShapeBand'] === 'true';
    this.enablePremiumStoryDatetime = this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']
      && this.domainConfig['config']['story']['enablePremiumStoryDatetime'] === 'true';
    this.enbaleHeadingLiveblogIntroPara = this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']
      && this.domainConfig['config']['story']['enbaleHeadingLiveblogIntroPara'] === 'true';
    this.allowspecialChar = this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']
      && this.domainConfig['config']['story']['allowspecialChar']?this.domainConfig['config']['story']['allowspecialChar']:this.allowspecialChar;
    this.enableSummaryHyperlink = this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']
      && this.domainConfig['config']['story']['enableSummaryHyperlink']?this.domainConfig['config']['story']['enableSummaryHyperlink']:this.enableSummaryHyperlink;
    this.liveBlogShowMaxEle = this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['liveblog']
      && this.domainConfig['config']['liveblog']['liveBlogShowMaxEle']?Number(this.domainConfig['config']['liveblog']['liveBlogShowMaxEle']):this.liveBlogShowMaxEle;
      this.copyliveBlogShowMaxEle= this.liveBlogShowMaxEle;
    this.cropperToShow = (this.domainConfig['imageRatios'] && (this.domainConfig['imageRatios'].length > 0))
      ? this.domainConfig['imageRatios'] : StaticDataService.defaultConfig.imageRatios;
    this.isBrandModelEnable = this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']
      && this.domainConfig['config']['story']['isBrandModelEnable'] === 'true';
      this.isPremiumSection=this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']
      && this.domainConfig['config']['story']['isPremiumSection'] === 'true';
      this.enableQuickIgnoreFlag = this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']
      && this.domainConfig['config']['story']['enableQuickIgnoreFlag'] === 'true';
     //to enable content bucket input list in the meta section for auto
      this.enableContentBucketInput = this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']
      && this.domainConfig['config']['story']['enableContentBucketInput'] === 'true';
     
      this.enableContentBucketStories = this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']
      && this.domainConfig['config']['story']['enableContentBucketStories']?this.domainConfig['config']['story']['enableContentBucketStories'].split(','):[] ;
     
      this.premiumStoryDays = this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']
      && this.domainConfig['config']['story']['premiumStoryDays']? Number(this.domainConfig['config']['story']['premiumStoryDays']):this.premiumStoryDays;
    const drake = dragula();
    let bag: any = this.dragulaService.find('sixth-bag');
    if (bag === undefined) {
      this.dragulaService.add('sixth-bag', drake);
      bag = this.dragulaService.find('sixth-bag');
    }
    if (this.checkIfNotificationPlatformEnabled('multipleTwitter')) {
      this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/notify/twitter/details').subscribe(
        result => {
          this.twitterAccounts = result;
        }
      );

    }
    if (localStorage.getItem('tempImage')) {
      localStorage.removeItem('tempImage');
    }
    this.subscription.push(this.sharedService.getData().subscribe(x => {
      if (x === 'publish') {
        if (this.storyData) {
          this.storyData.softPublished = false;
          this.storyData.tagTwitterAuthor = this.tagTwitterAuthor;
          if(this.isAuthorIdEnabled) {
            this.storyData.metadata.authors = [];
          } else {
            this.storyData.metadata.authorsList = [];
          }
        }
        if(this.sharedService.isdomainConfig('story','enableDuplicateAlert')) {
          const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true);
          this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/story/status/'+this.storyData.id, )
          .subscribe(
            data => {
              let text = '';
              console.log(data)
              if(data.duplicateFields && data.duplicateFields[0]) {
                text = text + data.duplicateFields[0];
              }
              if(data.duplicateFields && data.duplicateFields[1]) {
                text = text + ' & ' + data.duplicateFields[1];
              }
              if(data.isDuplicateStory !== "No") {
                this.snotify.confirm('Story with matching ' + text + ' found. Do you still want to continue publish?', '', {
                  ...config,
                  buttons: [
                    {
                      text: 'Yes', action: (toast) => {
                        this.storyData.metadata.duplicateStoryPublishAlert = 'true';
                        this.openPublish(true);
                        this.snotify.remove(toast.id);
                        this.googleAnalytics("Skippable Alerts",'Story with matching ' + text + ' found. Do you still want to continue publish?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' , null);
                      }, bold: false
                    },
                    {
                      text: 'No', action: (toast) => {
                        this.snotify.clear();
                        this.googleAnalytics("Skippable Alerts",'Story with matching ' + text + ' found. Do you still want to continue publish?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' , null);
                      }
                    }
                  ]
                });
                for(const url of data.canonicalUrl) {
                  this.snotify.confirm(url , '', {
                    ...config,
                    buttons: [
                      {
                        text: 'Open URL', action: (toast) => {
                          window.open(url, '_blank');
                          this.snotify.remove(toast.id);
                        }, bold: false
                      },
                    ]
                  });
                }
              } else {
                this.openPublish(true);
              }
            } ,
            error => {
              this.snotify.error(error.message, '', this.sharedService.getConfig(false));
              this.snotify.warning("Publishing without checking for duplicates", this.sharedService.getConfig(false))
              this.openPublish(true);
            }
          );
        } else {
          this.openPublish(true);
        }

        // this.openPublish(true);
      }
      if (x === 'manual-save') {
        this.manualSave();
      }
    }));
    this.generateStoryAutoSaveInterval();
    if (this.id && this.id.indexOf('?domain') > -1) {
      this.id = this.id.substring(0, this.id.indexOf('?domain'));
    }
    setTimeout(e3 => {
      if (this.id !== null) {
        this.togglePreview = true;
        this.lockAcquire(this.id, flag => {
          if (flag) {
            this.initStoryView(this.id, false);
            this.storyEditMode = true;
          } else {
            // this.storyData = false;
            this.initStoryView(this.id, true);
            this.changeFlag = false;
            this.storyEditMode = false;
          }
        });
      } else {
        this.route.queryParams.subscribe(params => {
          const dataNew = JSON.parse(localStorage.getItem(params['refId']));
          if (params['refId'] && localStorage.getItem(params['refId'])) {
            if(dataNew.source === 'photogalleryfeed') {
              this.storyData = JSON.parse(JSON.stringify(StaticDataService.defaultStoryData));
                this.storyData.metadata.secondarySections = [];
                this.storyData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
                this.showTempPara = true;
                this.disableSelectType = false;
                this.togglePreview = true;
                this.showLanuageTab = true;
                const story = JSON.parse(dataNew['story']);

                this.headline = story.mobileHeadline;
                this.summary = story.summary;
                this.storyData.mobileHeadline = this.htmlToPlaintext(story.mobileHeadline);
                this.storyData.summary = story.summary;
                this.sharedService.setTitle(this.htmlToPlaintext(story.mobileHeadline));
                this.versions.addItem(story);
                story.metadata.agency = '';
                story.metadata.section = '';
                story.metadata.subSection = '';
                story.metadata.seoUrl = '';
                story.metadata.sectionId = null;
                story.metadata.subSectionId = null;
                story.metadata.sectionUrl = null;
                story.metadata.subSectionUrl = null;
                // story.metadata.metaDescription = '';
                // story.metadata.metaTitle = '';
                story.metadata.canonicalUrl = '';
                story.metadata.url = '';
                story.metadata.status = "CREATED";
                story.metadata.oldHeadline = this.headline;
                story.metadata.oldSummary = this.summary;
                // story.metadata.oldMetaTitle = story.metadata.metaTitle;
                // story.metadata.oldMetaDescription = story.metadata.metaDescription;
                this.storyData.metadata = story.metadata;
                // this.populateMeta(story);
                this.storyData.crosstenantPhotoGallery = true;
                this.storyData.elements = dataNew['elements'];
                this.viewPortItems = dataNew['elements'];
            }
            else if(dataNew.source === 'storyFeed') {
              this.storyData = JSON.parse(JSON.stringify(StaticDataService.defaultStoryData));
                this.storyData.metadata.secondarySections = [];
                this.storyData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
                this.showTempPara = true;
                this.disableSelectType = false;
                this.togglePreview = true;
                this.showLanuageTab = true;
                const story = JSON.parse(dataNew['story']);
                console.log(story);
                this.headline = story.mobileHeadline;
                this.summary = story.summary;
                this.storyData.mobileHeadline = story.mobileHeadline;
                this.storyData.summary = story.summary;
                this.sharedService.setTitle(this.htmlToPlaintext(story.mobileHeadline));
                this.versions.addItem(story);
                story.metadata.agency = '';
                story.metadata.section = '';
                story.metadata.subSection = '';
                story.metadata.seoUrl = '';
                story.metadata.sectionId = null;
                story.metadata.subSectionId = null;
                story.metadata.sectionUrl = null;
                story.metadata.subSectionUrl = null;
                // story.metadata.metaDescription = '';
                // story.metadata.metaTitle = '';
                // story.metadata.canonicalUrl = '';
                story.metadata.url = '';
                story.metadata.status = "CREATED";
                story.metadata.oldHeadline = this.headline;
                story.metadata.oldSummary = this.summary;
                // story.metadata.oldMetaTitle = story.metadata.metaTitle;
                // story.metadata.oldMetaDescription = story.metadata.metaDescription;
                this.storyData.metadata = story.metadata;
                // this.populateMeta(story);
                // this.storyData.crosstenantPhotoGallery = true;

                this.storyData.elements = dataNew['elements'];
                this.viewPortItems = dataNew['elements'];
                const isLeadtrue = !!(story['leadMedia'] && story['leadMedia']['image']
                    && story['leadMedia']['image']['images'] && story['leadMedia']['image']['images'])
                    || (story['leadMedia'] && story['leadMedia']['video']
                    && story['leadMedia']['video']['body']);
                    if(isLeadtrue){
                      this.pickStoryImageLoad = true;
                      this.storyData.leadMedia=story.leadMedia;
                    }
                // const isLeadGiftrue = !!(story['leadMediaGif'] && story['leadMediaGif']['image']
                //     && story['leadMediaGif']['image']['images'] && story['leadMediaGif']['image']['images']['1600x900']);
                //     if(isLeadGiftrue){
                //       this.pickStoryImageLoadGif = true;
                //       this.storyData.leadMediaGif=story.leadMediaGif;
                //     }
                    this.pickStoryImageLoad = false;
                    // this.pickStoryImageLoadGif=false;
            }
            else if(dataNew.source === 'LHphotogalleryfeed') {
              console.log("NEW LH photo gallery")
              this.storyData = JSON.parse(JSON.stringify(StaticDataService.defaultStoryData));
              const story = JSON.parse(dataNew['story']);
              this.storyData.mobileHeadline = this.htmlToPlaintextExcludeItalic(story.headline);
              this.headline = story.headline;
              this.storyData.metadata.status = "CREATED";
              this.storyData.metadata.oldHeadline = this.headline;
              this.storyData.metadata.oldSummary = this.summary;
              this.storyData.crosstenantPhotoGallery = true;
              this.storyData.elements = dataNew['elements'];
              this.viewPortItems = dataNew['elements'];
              this.sharedService.setTitle(this.htmlToPlaintext(story.mobileHeadline));
            } else if(dataNew.source === 'translationFeed') {
              this.showLoader = true;
              this.storyData = JSON.parse(JSON.stringify(StaticDataService.defaultStoryData));
                this.storyData.metadata.secondarySections = [];
                this.storyData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
                this.showTempPara = true;
                this.disableSelectType = false;
                this.togglePreview = true;
                this.showLanuageTab = true;
                const story = JSON.parse(dataNew['story']);
                this.headline = dataNew['headline'];
                this.summary = dataNew['summary'];
                this.storyData.mobileHeadline = this.headline;
                this.storyData.summary = this.summary;
                this.sharedService.setTitle(this.htmlToPlaintext(this.headline));
                this.versions.addItem(story);
                story.metadata.agency = '';
                story.metadata.section = '';
                story.metadata.subSection = '';
                story.metadata.seoUrl = '';
                story.metadata.sectionId = null;
                story.metadata.subSectionId = null;
                story.metadata.sectionUrl = null;
                story.metadata.subSectionUrl = null;
                story.metadata.canonicalUrl = '';
                story.metadata.url = '';
                story.metadata.status = "CREATED";
                story.metadata.oldHeadline = this.headline;
                story.metadata.oldSummary = this.summary;
                this.storyData.metadata = story.metadata;
                // this.populateMeta(story);
                this.storyData.elements = dataNew['elements'];
                this.storyData.leadMedia.elements = dataNew['leadElement'];
                this.viewPortItems = dataNew['elements'];
                if(dataNew['translated'] === 'translated') {
                  let translatedFeed;
                  setTimeout(() => {
                    translatedFeed = JSON.parse(dataNew['elementData']);
                    for (const id of this.storyData.elements) {
                      const data = this.Elements[id];
                      const index = this.viewPortItems.indexOf(id);
                      if (index > -1) {
                       if(this.elReference['_results'][index] && this.elReference['_results'][index].cardType === 'paragraph') {
                        this.elReference['_results'][index].cardData.paragraph = translatedFeed[index].paragraph;
                       }
                      }
                    }
                  }, 2000);
                }
                setTimeout(() => {
                  this.showLoader = false;
                }, 3000);
            }
            else{
            const story = JSON.parse(dataNew['story']);
            // const story2 = $.extend(true, {}, story);
            const story2 = Object.assign({}, JSON.parse(dataNew['story']));
            const images = JSON.parse(dataNew['images']);
            this.originalStory = JSON.parse(dataNew['originalData']);
            const allStoryObj = JSON.parse(dataNew['originalData'])['story'][0];
            // console.log('original', dataNew);
            if (images.length > 0) {
              this.pickStoryImageLoad = true;
            }
            const key = dataNew['key'];
            localStorage.removeItem(params['refId']);
            if (story) {
              story.metadata.agency = '';
              story.metadata.section = '';
              story.metadata.subSection = '';
              this.storyData = story;
              if (this.domainConfig && this.domainConfig['config']
                && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['disableHeadlineLimit'] === 'true') {
                this.headlineMaxLength = this.getHeadlineMaxLength(true);
                this.showHeadlineerror = true;
              }
              this.headline = story.mobileHeadline;
              this.summary = story.summary;
              this.sharedService.setTitle(this.htmlToPlaintext(story.mobileHeadline));
              this.versions.addItem(story);
              this.storyData.metadata.storyType = dataNew['source'];
              this.populateMeta(story2);
              // console.log((story2.metadata && story2.metadata.agency && story2.metadata.agency.toLowerCase() === 'popper'));
              if (story2.metadata && story2.metadata.agency && story2.metadata.agency.toLowerCase() === 'popper') {
                const options = StaticDataService.options;
                const url = this.config.get('product').baseUrl
                  + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element');
                const isLeadtrue = !!(allStoryObj['leadMedia'] && allStoryObj['leadMedia']['image']
                  && allStoryObj['leadMedia']['image']['images'] && allStoryObj['leadMedia']['image']['images']['16X9']);
                let leadMediarequest = null;
                if (allStoryObj['metadata']) {
                  this.storyData['metadata']['tags'] = allStoryObj['metadata']['tags'];
                  this.storyData['metadata']['keywords'] = allStoryObj['metadata']['keywords'];
                  this.storyData['metadata']['topic'] = allStoryObj['metadata']['topic'];
                  this.storyData['metadata']['location'] = allStoryObj['metadata']['location'];
                  this.storyData['metadata']['section'] = allStoryObj['metadata']['section'];
                  this.storyData['metadata']['subSection'] = allStoryObj['metadata']['subSection'];
                  this.sectionQuery = allStoryObj['metadata']['section'] ? allStoryObj['metadata']['section'] : '';
                  this.subSectionQuery = allStoryObj['metadata']['subSection'] ? allStoryObj['metadata']['subSection'] : '';
                  this.brandQuery = allStoryObj['metadata']['brand'] ? allStoryObj['metadata']['brand'] : '';
                  this.categoryQuery = allStoryObj['metadata']['category'] ? allStoryObj['metadata']['category'] : '';
                  this.modelQuery = allStoryObj['metadata']['model'] ? allStoryObj['metadata']['model'] : '';
                }
                if (isLeadtrue) {
                  this.pickStoryImageLoad = true;
                  const image = allStoryObj['leadMedia']['image'];
                  const defaultImagecardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
                  defaultImagecardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
                  defaultImagecardData.image.images['original'] = image.images['16X9'];
                  defaultImagecardData.image['caption'] = image['caption'];
                  defaultImagecardData.image.images['ampImage'] = image.images['16X9'];
                  defaultImagecardData.image.images['960x540'] = image.images['16X9'];
                  defaultImagecardData.image.images['600x338'] = image.images['16X9'];
                  defaultImagecardData.image.images['250x250'] = image.images['1X1'];
                  defaultImagecardData.image.images['90x90'] = image.images['1X1'];
                  defaultImagecardData['parentElementId'] = 8425817;
                  leadMediarequest = this.http.post(url, JSON.stringify(defaultImagecardData), options);
                }
                const bodyContent = dataNew['para'];
                const tmp = document.createElement('DIV');
                tmp.innerHTML = bodyContent;
                const elementArr = tmp.children;
                let requestarray = isLeadtrue ? [leadMediarequest] : [];
                // console.log(elementArr);
                Array.from(elementArr).forEach(element => {
                  const tag = element.tagName;
                  if (tag === 'P') {
                    const paraCard = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
                    paraCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
                    paraCard['paragraph']['body'] = element['outerHTML'];
                    requestarray.push(this.http.post(url, JSON.stringify(paraCard), options));
                  } else if (tag === 'IMG') {
                    const defaultImagecardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
                    defaultImagecardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
                    defaultImagecardData.image.images['original'] = element['src'];
                    defaultImagecardData.image['caption'] = element['alt'] ? element['alt'] : '';
                    defaultImagecardData.parentElementId = 8425817;
                    requestarray.push(this.http.post(url, JSON.stringify(defaultImagecardData), options));
                  } else if (tag === 'IFRAME') {
                    const embedCard = JSON.parse(JSON.stringify(StaticDataService.defaultEmbedCardData));
                    embedCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
                    embedCard.embed.body = element['outerHTML'];
                    requestarray.push(this.http.post(url, JSON.stringify(embedCard), options));
                  }
                });
                this.increasePendingCount();
                forkJoin(requestarray)
                  .subscribe(resultarray => {
                    this.decreasePendingCount(null);
                    let elems = [];
                    if (isLeadtrue) {
                      const leadEl = resultarray.slice(0, 1);
                      const resultEl = resultarray.slice(1, resultarray.length);
                      elems = resultEl.map(e => e['id']);
                      this.storyData.leadMedia.elements = [leadEl[0]['id']];
                      this.pickStoryImageLoad = false;
                    } else {
                      elems = resultarray.map(e => e['id']);
                    }
                    this.storyData.elements = elems;
                    this.viewPortItems = elems;
                    this.showTempPara = false;
                    this.tempParaId = null;
                    setTimeout(e => {
                      this.checkIfLastIsPara(false);
                    }, 1500);
                  });
              }
              else if (story2.metadata && story2.metadata.agency && story2.metadata.agency.toLowerCase() === 'affiliate') {
                const options = StaticDataService.options;
                const url = this.config.get('product').baseUrl
                  + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element');
                const isLeadtrue = !!(allStoryObj['leadMedia'] && allStoryObj['leadMedia']['image']
                  && allStoryObj['leadMedia']['image']['images'] && allStoryObj['leadMedia']['image']['images']['16X9']);
                let leadMediarequest = null;
                if (allStoryObj['metadata']) {
                  this.storyData['metadata']['tags'] = allStoryObj['metadata']['tags'];
                  this.storyData['metadata']['keywords'] = allStoryObj['metadata']['keywords'];
                  this.storyData['metadata']['topic'] = allStoryObj['metadata']['topic'];
                  this.storyData['metadata']['location'] = allStoryObj['metadata']['location'];
                  this.storyData['metadata']['section'] = allStoryObj['metadata']['section'];
                  this.storyData['metadata']['subSection'] = allStoryObj['metadata']['subSection'];
                  this.sectionQuery = allStoryObj['metadata']['section'] ? allStoryObj['metadata']['section'] : '';
                  this.subSectionQuery = allStoryObj['metadata']['subSection'] ? allStoryObj['metadata']['subSection'] : '';
                  this.brandQuery = allStoryObj['metadata']['brand'] ? allStoryObj['metadata']['brand'] : '';
                  this.categoryQuery = allStoryObj['metadata']['category'] ? allStoryObj['metadata']['category'] : '';
                  this.modelQuery = allStoryObj['metadata']['model'] ? allStoryObj['metadata']['model'] : '';
                }
                if (isLeadtrue) {
                  this.pickStoryImageLoad = true;
                  const image = allStoryObj['leadMedia']['image'];
                  const defaultImagecardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
                  defaultImagecardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
                  defaultImagecardData.image.images['original'] = image.images['16X9'];
                  defaultImagecardData.image['caption'] = image['caption'];
                  defaultImagecardData.image.images['ampImage'] = image.images['16X9'];
                  defaultImagecardData.image.images['960x540'] = image.images['16X9'];
                  defaultImagecardData.image.images['600x338'] = image.images['16X9'];
                  defaultImagecardData.image.images['250x250'] = image.images['1X1'];
                  defaultImagecardData.image.images['90x90'] = image.images['1X1'];
                  defaultImagecardData['parentElementId'] = 8425817;
                  leadMediarequest = this.http.post(url, JSON.stringify(defaultImagecardData), options);
                }
                const bodyContent = dataNew['para'];
                const tmp = document.createElement('DIV');
                tmp.innerHTML = bodyContent;
                const elementArr = tmp.children;
                let requestarray = isLeadtrue ? [leadMediarequest] : [];
                // console.log(elementArr);
                Array.from(elementArr).forEach(element => {
                  const tag = element.tagName;
                  if (tag === 'P' || tag=='DIV') {
                    const paraCard = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
                    paraCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
                    paraCard['paragraph']['body'] = element['outerHTML'];
                    requestarray.push(this.http.post(url, JSON.stringify(paraCard), options));
                  } else if (tag === 'IMG') {
                    const defaultImagecardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
                    defaultImagecardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
                    defaultImagecardData.image.images['original'] = element['src'];
                    defaultImagecardData.image['caption'] = element['alt'] ? element['alt'] : '';
                    defaultImagecardData.parentElementId = 8425817;
                    requestarray.push(this.http.post(url, JSON.stringify(defaultImagecardData), options));
                  } else if (tag === 'IFRAME') {
                    const embedCard = JSON.parse(JSON.stringify(StaticDataService.defaultEmbedCardData));
                    embedCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
                    embedCard.embed.body = element['outerHTML'];
                    requestarray.push(this.http.post(url, JSON.stringify(embedCard), options));
                  }
                });
                this.increasePendingCount();
                forkJoin(requestarray)
                  .subscribe(resultarray => {
                    this.decreasePendingCount(null);
                    let elems = [];
                    if (isLeadtrue) {
                      const leadEl = resultarray.slice(0, 1);
                      const resultEl = resultarray.slice(1, resultarray.length);
                      elems = resultEl.map(e => e['id']);
                      this.storyData.leadMedia.elements = [leadEl[0]['id']];
                      this.pickStoryImageLoad = false;
                    } else {
                      elems = resultarray.map(e => e['id']);
                    }
                    this.storyData.elements = elems;
                    this.viewPortItems = elems;
                    this.showTempPara = false;
                    this.tempParaId = null;
                    setTimeout(e => {
                      this.checkIfLastIsPara(false);
                    }, 1500);
                  });
              }
              else {
                const paraCard = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
                paraCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
                paraCard['paragraph']['body'] = dataNew['para'];

                this.increasePendingCount();
                this.restService.http_post(this.config.get('product').baseUrl
                  + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
                  paraCard, result2 => {
                    this.decreasePendingCount(null);
                    if (images.length > 0) {
                      setTimeout(ee => {
                        // console.log('wire image upload initiated');
                        this.alsoAddImages(images, key);
                      }, 150);
                    }
                    setTimeout(e => {
                      this.storyData.elements.push(result2.id);
                      this.viewPortItems.push(result2.id);
                      this.showTempPara = false;
                      this.tempParaId = null;
                    }, 100);
                  });
              }
            }
            }
          } else {
            this.storyData = JSON.parse(JSON.stringify(StaticDataService.defaultStoryData));
            this.storyData.metadata.secondarySections = [];
            this.storyData.metadata.secondaryBrands = [];
            this.storyData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
            this.showTempPara = true;
            this.disableSelectType = false;
            this.togglePreview = true;
            this.showLanuageTab = true;
          }
          if (params['type']) {
            if (
              (this.disabledStoryTypes.indexOf(params['type']) === -1)
              &&
              (params['type'] === 'story'
                || params['type'] === 'gallery'
                || params['type'] === 'listicle'
                || params['type'] === 'liveblog'
                || params['type'] === 'video'
                || params['type'] === 'highlights'
                || params['type'] === 'mintlite'
                || params['type'] === 'mediagallery'
                || params['type'] === 'deadlink'
                || params['type'] === 'photostory'
                || params['type'] === 'web-story')
            ) {
              this.storyType = params['type'];
              if (params['type'] === 'video') {
                this.videoUrlPopup = true;
                this.sharedService.setTitle('New Video Story');
              } else if (params['type'] === 'story') {
                this.sharedService.setTitle('New Story');
              } else if (params['type'] === 'gallery') {
                this.sharedService.setTitle('New Photo Gallery');
              } else if (params['type'] === 'mediagallery') {
                this.sharedService.setTitle('New Media Gallery');
              } else if (params['type'] === 'listicle') {
                this.sharedService.setTitle('New Listicle Story');
              } else if (params['type'] === 'photostory') {
                this.sharedService.setTitle('New Photo Story');
              } else if (params['type'] === 'highlights') {
                this.sharedService.setTitle('New HighLights');
              } else if (params['type'] === 'liveblog') {
                this.sharedService.setTitle('New LiveBlog');
              }
              else if (params['type'] === 'mintlite') {
                this.sharedService.setTitle('New Mint Lite Story');
              }
              else if (params['type'] === 'deadlink') {
                this.sharedService.setTitle('New Deadlink');
              }
              else if (params['type'] === 'web-story') {
                this.sharedService.setTitle('New Web Story');
                this.showWebStoriesTab = true;
              }
            } else {
              this.storyType = 'story';
              this.sharedService.setTitle('New Story');
            }
          } else {
            this.storyType = 'story';
            this.sharedService.setTitle('New Story');
          }
          if (document.getElementById('headline')) {
            document.getElementById('headline').focus();
          }
          this.checkStateOfStory();
          if (this.storyType === 'liveblog') {
            this.selectedType = 'liveblog';
          }
          if (this.storyType === 'photostory') {
            this.selectedType = 'photostory';
          }
          if (this.storyType === 'mintlite') {
            this.selectedType = 'mintlite';
          }
          if (this.storyType === 'listicle') {
            this.selectedType = 'listicle';
          }
          if (this.storyType === 'highlights') {
            this.selectedType = 'highlights';
          }
        });
        setTimeout(e => {
          this.id = 'new';
          this.storyData.type = this.storyType;
          this.summaryMaxLength = this.getSummaryMaxLength();
          this.storyLoaded = true;
          this.storyEditMode = true;
          setTimeout(e2 => {
            if (this.isCKEditorEnabled) {
              if(this.headlineEditor) {
                this.headlineEditor.editing.view.focus();
              }
            } else {
              if(this.headlineEditor) {
                this.headlineEditor.setSelection(this.headline ? this.headline.length : 0, 0);
              }
            }
          }, 150);
        }, 250);
      }
    }, 100);
    this.sharedService.sendData('saved|false');
    this.snowplowAnalytics('Metadata');

    this.getPodcastPublishers();

  }
  getUserPermittedSections() {
    const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    const restrictedSectionsObj = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[currentDomain].sections
    // this.userRestrictedSections
    if(restrictedSectionsObj && restrictedSectionsObj.length>0) {
    for(let item of restrictedSectionsObj) {
      if(item) {
        this.userRestrictedSections.push(item.alias)
      }
    }
  }
    console.log(this.userRestrictedSections)
  }
  precheckedPlag() {
    if(!this.plagData && this.storyData.metadata.plagiarismChecked) {
      this.restService.http_get(this.config.get('product').utilUrl + '/api/cms/plagiarism-check/story/'+this.storyData.id)
      .subscribe(
        result => {
          if (!result.hasOwnProperty('error')) {
            this.plagData = result[0];
          } else {
            this.storyData.metadata.paraContentChanged = true;
            this.storyData.metadata.plagiarismChecked = false;
          }
        }
      );
    }
  }
  getConfigLiveBlogIntroPara(){
    if (this.isCKEditorEnabled) {
     return this.enbaleHeadingLiveblogIntroPara?this.ckconfigLiveblogIntroPara:this.ckplainconfig;
    }
   }
  onParaContentChanged(ev) {
    this.storyData.metadata.paraContentChanged = true;
  }


  getMarketList() {
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/story/market/indices?type=!mf&size=10000')
      .subscribe(
        data => {
          this.marketSuggestion = data.filter((item) => {
            return item['indicesType'] !== "NEW";
          });
          this.newMarketSuggestion = data.filter((item) => {
            return item['indicesType'] === "NEW";
          });
        }
      );
  }

  getMutualFundList() {
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/story/market/indices?type=mf&size=10000')
      .subscribe(
        data => {
          this.mutualFundSuggestion = data;
        }
      );
  }

  getMarketSuggestion() {
    if (this.marketList && this.marketList.length === 0) {
      return this.marketSuggestion;
    }
    this.deactivateMarketSuggestion = true;
    return [];
  }
  getMFSuggestion() {
    if (this.mutualFundList && this.mutualFundList.length === 0) {
      return this.mutualFundSuggestion;
    }
    this.deactivateMarketSuggestion = true;
    return [];
  }
  getNewMarketSuggestion() {
    if (this.newMarketList && this.newMarketList.length === 0) {
      return this.newMarketSuggestion;
    }
    this.deactivateMarketSuggestion = true;
    return [];
  }

  getLanguage() {
    const domain = sessionStorage.getItem(StaticDataService.domainLiteral);
    const domainAll = JSON.parse(localStorage.getItem(StaticDataService.domains_all));
    if (localStorage.getItem(StaticDataService.domains_all)) {
      for (let i = 0; i < domainAll.length; i++) {
        if (domainAll[i]['id'] === domain) {
          this.targetLaguages = Object.entries
            (JSON.parse(localStorage.getItem(StaticDataService.domains_all))[i]['languages']).map
            (([name, id]) => ({ name, id }));
        }
      }
      if (this.targetLaguages.length > 0) {
        for (let j = 0; j < this.targetLaguages.length; j++) {
          if (this.targetLaguages[j].name === 'English') {
            this.showLanuageTab = true;
            this.togglePreview = true;
          }
        }
      }
    }

  }
  alsoAddImages(arr, key) {
    // console.log(arr, key);
    if (key === 'images') {
      for (let i = 0; i < arr.length; i++) {
        const j = i;
        this.uploadAndCreateElement(arr[j], null, id => {
          // console.log('image' + j + ' => ' + id);
          if (j === 0) {
            this.storyData.leadMedia.elements = [id];
            this.pickStoryImageLoad = false;
          } else {
            this.storyData.elements.push(id);
            this.viewPortItems.push(id);
          }
        });
      }
    }

    if (key === 'listImages') {
      // console.log('andar hai');
      for (let i = 0; i < arr.length; i++) {
        const j = i;
        // console.log(j);
        this.uploadAndCreateElement(arr[j].url, arr[j].caption, id => {
          // console.log('image' + j + ' => ' + id);
          if (j === 0) {
            this.pickStoryImageLoad = false;
            this.storyData.leadMedia.elements = [id];
          } else {
            this.storyData.elements.push(id);
            this.viewPortItems.push(id);
          }
        });
      }
    }

    setTimeout(e => {
      this.checkIfLastIsPara(false);
    }, 1500);
  }

  uploadAndCreateElement(url, caption, callback) {
    // console.log(url, caption);\
    const defaultImagecardData = JSON.parse(JSON.stringify(url.includes('pdf')
      ? StaticDataService.defaultDocumentData : StaticDataService.defaultImageCardData));
    defaultImagecardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    const fd = new FormData();
    fd.set('file', url);
    this.increasePendingCount();
    this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadByUrlEndPoint, fd).
      subscribe(res => {
        this.decreasePendingCount(null);
        defaultImagecardData.id = null;
        defaultImagecardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
        defaultImagecardData.image.caption = caption ? caption : '';
        defaultImagecardData.image.images['original'] = res['images']['original'];
        this.increasePendingCount();
        this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
          defaultImagecardData, result => {
            this.decreasePendingCount(null);
            if (!result.hasOwnProperty('error')) {
              callback(result.id);
            } else {
              callback(false);
            }
          });
      });
  }

  populateMeta(story) {
    if (
      this.agencySuggestion.length > 0
    ) {
      const agencies = this.agencySuggestion.map(e => e.toLowerCase());
      if (story.metadata.agency && story.metadata.agency.trim() !== '') {
        // console.log(this.agencySuggestion, story.metadata.agency, this.agencySuggestion.indexOf(story.metadata.agency));
        const index = agencies.indexOf(story.metadata.agency.toLowerCase());
        if (index > -1) {
          this.agencyQuery = story.metadata.agency;
          this.storyData.metadata.agency = story.metadata.agency;
          this.storyData.metadata.agencyId = null;
        }
      }
    } else {
      setTimeout(e => {
        this.populateMeta(story);
      }, 200);
    }
  }

  checkSpecialChars(imageFileName) {
    let regex = new RegExp(/[^a-zA-z0-9-_.\s]+/g);
    let m;
      m = regex.exec(imageFileName);
      if (m) {
          imageFileName = imageFileName.replace(regex, '');
          console.log("rejected => ", imageFileName)
          this.snotify.error('Special Chars not Allowed in uploaded image', '', this.sharedService.getConfig(false));
          return true;
      }
    if(imageFileName.length > 50) {
      this.snotify.error('File Name should be less than 50 Charecters', '', this.sharedService.getConfig(false));
      imageFileName = imageFileName.slice(0,50);
      return true;
    }
    return false;
  }

  dragstart(ev) {
    // console.log('dragging', ev);
    const container = this.storySec.nativeElement;
    // console.log(container);
    document.onmousemove = e => {
      const event = e || window.event;
      const mouseY = event['pageY'] - container.offsetTop;
      const scrollTop = container.scrollTop;
      const scrollBottom = container.offsetHeight - scrollTop;
      const elementHeight = ev[1].getBoundingClientRect().height;
      if ((mouseY - (elementHeight / 2)) < scrollTop) {
        // console.log('up');
        container.scrollBy(0, -15);
      } else if ((mouseY + elementHeight) > scrollBottom) {
        // console.log('down');
        container.scrollBy(0, 15);
      } else {
        // console.log('see calc');
      }
    };
  }

  dragend(ev) {
    // console.log('dragend', ev);
    document.onmousemove = null;
    if(ev[0]=='view-images-bag'){
      //inside photogallery viewimages
      this.isDraggedImages=true;
    }
  }

  filterAutoCompleteUp(event, model) {
    // console.log("filterAutoCompleteUp: "+event);
    // console.log("filterAutoCompleteUp: "+model);
    if (event.keyCode !== 9 && event.keyCode !== 27 && event.key !== 'Enter') {
      if (model === 'section') {
        // console.log('inside => ' + this.insideSection);
        if (this.insideSection) {
          if (this.sectionQuery.length > 0) {
            if (this.domainConfig['config'] && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['restrictSection'] && this.storyType == 'gallery') {
              this.sectionSuggestion = this.sectionSuggestion.filter(e => e == 'photos');
            } else if (this.domainConfig['config'] && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['restrictSection'] && this.storyType == 'video') {
              this.sectionSuggestion = this.sectionSuggestion.filter(e => e == 'videos');
            }
            this.filteredSectionSuggestion = this.sectionSuggestion.filter(function (el) {
              return el.toLowerCase().indexOf(this.sectionQuery.toLowerCase()) > -1;
            }.bind(this));
            console.log(this.filteredSectionSuggestion)
          } else {
            this.storyData.metadata.section = '';
            this.storyData.metadata.subSection = '';
            this.storyData.metadata.subSectionL2 = '';
            this.subSectionQuery = '';
            this.subSectionL2Query = '';
            this.filteredSectionSuggestion = this.sectionSuggestion;
          }
        } else {
          this.insideSection = true;
          this.filteredSectionSuggestion = [];
        }

      } else if (model === 'subSection') {
        console.log("backspave for subsection" + this.insideSubSection)
        if (this.insideSubSection) {
          if (this.storyData.metadata.section !== null && this.storyData.metadata.section.trim() !== '') {
            if (this.subSectionQuery.length > 0) {
              this.filteredSubSectionSuggestion = this.subSectionSuggestion[this.storyData.metadata.section].filter(function (el) {
                return el.toLowerCase().indexOf(this.subSectionQuery.toLowerCase()) > -1;
              }.bind(this));
            } else {
              console.log("updating when subSection empty");
              this.storyData.metadata.subSection = '';
              this.storyData.metadata.subSectionL2 = '';
              this.subSectionL2Query = '';
              this.filteredSubSectionSuggestion = this.subSectionSuggestion[this.storyData.metadata.section];
            }
          } else {
            if (this.subSectionQuery.length > 0) {
              this.filteredSubSectionSuggestion = this.allSubSections.filter(function (el) {
                return el.toLowerCase().indexOf(this.subSectionQuery.toLowerCase()) > -1;
              }.bind(this));
            } else {
              this.storyData.metadata.subSection = '';
              this.storyData.metadata.subSectionL2 = '';
              this.subSectionL2Query = '';
              this.filteredSubSectionSuggestion = this.allSubSections;
            }
          }
        } else {
          this.insideSubSection = true;
          this.filteredSubSectionSuggestion = [];
        }
      } else if (model === 'subSectionL2') {
        if (this.insideSubSectionL2) {
          if (this.storyData.metadata.section !== null && this.storyData.metadata.section !== '') {
            if (this.storyData.metadata.subSection !== null && this.storyData.metadata.subSection !== '') {
              if (this.subSectionL2Query.length > 0) {
                this.filteredSubSectionL2Suggestion = this.subSectionL2Suggestion[this.storyData.metadata.subSection].filter(function (el) {
                  return el.toLowerCase().indexOf(this.subSectionL2Query.toLowerCase()) > -1;
                }.bind(this));
              } else {
                this.storyData.metadata.subSectionL2 = '';
                this.filteredSubSectionL2Suggestion = this.subSectionL2Suggestion[this.storyData.metadata.subSection];
              }
            } else {
              const sug = this.subSectionSuggestion[this.storyData.metadata.section];
              const keys = Object.keys(this.subSectionL2Suggestion);
              let suggestions = [];
              for (let i = 0; i <= keys.length; i++) {
                if (i < keys.length) {
                  const a = keys[i];
                  if (sug.indexOf(a) > -1) {
                    suggestions = this.filteredSubSectionL2Suggestion.concat(this.subSectionL2Suggestion[a]);
                  }
                } else {
                  if (this.subSectionL2Query.length > 0) {
                    this.filteredSubSectionL2Suggestion = suggestions.filter(function (el) {
                      return el.toLowerCase().indexOf(this.subSectionL2Query.toLowerCase()) > -1;
                    }.bind(this));
                  } else {
                    this.storyData.metadata.subSectionL2 = '';
                    this.filteredSubSectionL2Suggestion = suggestions;
                  }
                }
              }
            }
          } else {
            if (this.subSectionL2Query.length > 0) {
              this.filteredSubSectionL2Suggestion = this.allSubSectionsL2.filter(function (el) {
                return el.toLowerCase().indexOf(this.subSectionL2Query.toLowerCase()) > -1;
              }.bind(this));
            } else {
              this.storyData.metadata.subSectionL2 = '';
              this.filteredSubSectionL2Suggestion = this.allSubSectionsL2;
            }
          }
        } else {
          this.insideSubSectionL2 = true;
          this.filteredSubSectionL2Suggestion = [];
        }

      } else if (model === 'agency') {
        if (this.insideAgency) {
          if (this.agencyQuery.length > 0) {
            this.filteredAgencySuggestion = this.agencySuggestion.filter(function (el) {
              return el.toLowerCase().indexOf(this.agencyQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            this.storyData.metadata.agency = '';
            this.agencyQuery = '';
            this.storyData.metadata.agencyId = null;
            this.filteredAgencySuggestion = this.agencySuggestion;
          }
        } else {
          this.insideAgency = true;
          this.filteredAgencySuggestion = [];
        }
      }
      else if (model === 'contentBucket') {
        if (this.insideContentBucket) {
          if (this.contentBucketQuery.length > 0) {
            this.filteredContentBucketSuggestion = this.contentBucketSuggestion.filter(function (el) {
              return el.toLowerCase().indexOf(this.contentBucketQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            this.storyData.metadata.contentBucket = '';
            this.contentBucketQuery = '';
            // this.storyData.metadata.agencyId = null;
            this.filteredContentBucketSuggestion = this.contentBucketSuggestion;
          }
        } else {
          this.insideContentBucket = true;
          this.filteredContentBucketSuggestion = [];
        }
      }
      else if (model === 'primaryLocation') {
        if (this.insidePrimaryLocation) {
          if (this.primaryLocationQuery.length > 0) {
            this.filteredPrimaryLocationSuggestion = this.primaryLocationSuggestion.filter(function (el) {
              return el.toLowerCase().indexOf(this.primaryLocationQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            this.storyData.metadata.primaryLocation = '';
            this.primaryLocationQuery = '';
            // this.storyData.metadata.agencyId = null;
            this.filteredPrimaryLocationSuggestion = this.primaryLocationSuggestion;
          }
        } else {
          this.insidePrimaryLocation = true;
          this.filteredPrimaryLocationSuggestion = [];
        }
      } else if (model === 'column') {
        if (this.insideColumn) {
          if (this.columnQuery.length > 0) {
            this.filteredColumnSuggestion = this.columnSuggestion.filter(function (el) {
              return el.toLowerCase().indexOf(this.columnQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            this.storyData.metadata.column = '';
            this.columnQuery = '';
            this.filteredColumnSuggestion = this.columnSuggestion;
          }
        } else {
          this.insideColumn = true;
          this.filteredColumnSuggestion = [];
        }
      }
      else if (model === 'attribution') {
        if (this.insideAttribution) {
          if (this.attributionQuery.length > 0) {
            const dataArray = this.attributionSuggestion;
            dataArray.splice(0, 1);
            if (this.attributionSuggestion.indexOf(this.attributionQuery) === -1) {
              dataArray.unshift(this.attributionQuery);
            }
            this.filteredAttributionSuggestion = dataArray.filter(function (el) {
              return el.toLowerCase().indexOf(this.attributionQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            this.storyData.metadata.attribution = '';
            this.attributionQuery = '';
            this.filteredAttributionSuggestion = this.attributionSuggestion;
          }
        } else {
          this.insideAttribution = true;
          this.filteredAttributionSuggestion = [];
        }
      } else if (model === 'category') {
        // console.log('inside => ' + this.insideSection);
        if (this.insideCategory) {
          if (this.categoryQuery.length > 0) {
            this.filteredCategorySuggestion = this.categorySuggestionMain.filter(function (el) {
              return el.toLowerCase().indexOf(this.categoryQuery.toLowerCase()) > -1;
            }.bind(this));
            // console.log('array => ' + this.filteredSectionSuggestion);
          } else {
            this.storyData.metadata.category = ''
            this.storyData.metadata.brand = '';
            this.storyData.metadata.model = '';
            this.brandQuery = ''
            this.modelQuery = '';
            this.filteredCategorySuggestion = this.categorySuggestionMain;
          }
        } else {
          // this.insideBrand = true;
          this.filteredCategorySuggestion = [];
        }

      } else if (model === 'brand') {
        // console.log('inside => ' + this.insideSection);
        if (this.insideBrand) {
            if(this.storyData.metadata.brand !== this.brandQuery){
              let el = this.categories.filter(e => (e.categoryName == this.storyData.metadata.category));
              if(el[0]){
                if(this.brandQuery.length == 0) {
                  this.storyData.metadata.brand = '';
                  this.storyData.metadata.model = '';
                  this.modelQuery = '';
                  this.filteredModelSuggestion = [];
                }
                if(this.productCategoryApiSubscription != null && this.productCategoryApiSubscription != undefined)
                  this.productCategoryApiSubscription.unsubscribe();
                  this.productCategoryApiSubscription = this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/story/brandproduct/' + el[0].id + '?searchChars=' + this.brandQuery)
                .subscribe(
                  data => {
                    if(data)
                    {
                      this.brandSuggestionMain = [];
                      for(const brand in data)
                      {
                        this.brandSuggestionMain.push(brand);
                        let models = data[brand];

                        let brandModels = [];
                        for(const model in models)
                        {
                          this.allModels.push(model);
                          brandModels.push(model);
                        }
                        this.modelSuggestionMain[brand]=brandModels;
                      }

                      this.filteredBrandSuggestion = this.brandSuggestionMain;

                      if (this.brandQuery.length > 0) {
                      } else {
                        this.storyData.metadata.brand = '';
                        this.storyData.metadata.model = '';
                        this.modelQuery = '';
                      }

                    } else {
                      this.storyData.metadata.brand = '';
                      this.storyData.metadata.model = '';
                      this.modelQuery = '';
                      this.filteredBrandSuggestion = [];
                    }
                  });

              } else {
                if (this.brandQuery.length > 0) {
                  this.filteredBrandSuggestion = this.brandSuggestionMain.filter(function (el) {
                    return el.toLowerCase().indexOf(this.brandQuery.toLowerCase()) > -1;
                  }.bind(this));
                  // console.log('array => ' + this.filteredSectionSuggestion);
                }
              }
            } else {
              this.filteredBrandSuggestion = this.brandSuggestionMain;
            }
        } else {
          // this.insideBrand = true;
          this.filteredBrandSuggestion = [];
        }

      } else if (model === 'brandEle') {
        // console.log('inside => ' + this.insideSection);
        if (this.insideBrandEle) {
          if (this.brandEleQuery.length > 0) {
            this.filteredBrandSuggestion = this.brandSuggestion.filter(function (el) {
              return el.toLowerCase().indexOf(this.brandEleQuery.toLowerCase()) > -1;
            }.bind(this));
            // console.log('array => ' + this.filteredSectionSuggestion);
          }
          else {
            this.modelEleQuery = '';
            this.filteredBrandSuggestion = this.brandSuggestion;
          }
        } else {
          // this.insideBrand = true;
          this.filteredBrandSuggestion = [];
        }

      } else if (model === 'model') {
        console.log("backspave for model" + this.insideModel)
        if (this.insideModel) {
          if (this.storyData.metadata.brand !== null && this.storyData.metadata.brand.trim() !== '') {
            if (this.modelQuery.length > 0) {
              this.filteredModelSuggestion = this.modelSuggestionMain[this.storyData.metadata.brand].filter(function (el) {
                return el.toLowerCase().indexOf(this.modelQuery.toLowerCase()) > -1;
              }.bind(this));
            } else {
              this.storyData.metadata.model = '';
              this.filteredModelSuggestion = this.modelSuggestionMain[this.storyData.metadata.brand];
            }
          } else {
            if (this.modelQuery.length > 0) {
              this.filteredModelSuggestion = this.allModels.filter(function (el) {
                return el.toLowerCase().indexOf(this.modelQuery.toLowerCase()) > -1;
              }.bind(this));
            } else {
              this.storyData.metadata.model = '';
              this.filteredModelSuggestion = this.allModels;
            }
          }
        } else {
          this.insideModel = true;
          this.filteredModelSuggestion = [];
        }
      } else if (model === 'modelEle') {
        if (this.insideModelEle) {
          if(this.productElement['brand'] && this.productElement['brand'] !== '') {
            if (this.modelEleQuery.length > 0) {
              this.filteredModelSuggestion = this.modelSuggestion[this.productElement['brand']].filter(function (el) {
                return el.toLowerCase().indexOf(this.modelEleQuery.toLowerCase()) > -1;
              }.bind(this));
            } else {
              this.productElement['model'] = '';
              this.filteredModelSuggestion = this.modelSuggestion[this.productElement['brand']];
            }
          }
        } else {
          // this.insideModelEle = true;
          this.filteredModelSuggestion = [];
        }
      } else if (model === 'modelCategoryEle') {
        if (this.insideModelEle) {
          if(this.productElement['brand'] && this.productElement['brand'] !== '') {
            if (this.modelEleQuery.length > 0) {
              this.modelSuggestion = this.modelSuggestionValues;
              this.filteredModelSuggestion = Object.keys(this.modelSuggestion[this.productElement['brand']]).filter(function (el) {
                return el.toLowerCase().indexOf(this.modelEleQuery.toLowerCase()) > -1;
              }.bind(this));
            }
            else {
              // this.productElement['model'] = '';
              this.filteredModelSuggestion = [];
            }
          }
        } else {
          // this.insideModelEle = true;
          this.filteredModelSuggestion = [];
        }
      } else if (model === 'categoryEle') {
          if (this.insideCategoryEle) {
            if (this.categoryEleQuery.length > 0) {
              this.filteredCategorySuggestion = this.categorySuggestion.filter(function (el) {
                return el.categoryName.toLowerCase().indexOf(this.categoryEleQuery.toLowerCase()) > -1;
              }.bind(this));
              // console.log('array => ' + this.filteredSectionSuggestion);
            }
            else {
              this.categoryEleQuery = '';
              this.filteredCategorySuggestion = this.categorySuggestion;
            }
          } else {
            // this.insideBrand = true;
            this.filteredCategorySuggestion = [];
          }
      }

    }
    // this.currentSelection = 0;
    return true;
  }

  filterAutoCompleteDown(event, model) {
    // console.log("filterAutoCompleteDown"+event);
    // console.log("filterAutoCompleteDown"+model);
    if (event.key === 'Enter') {
      if (model === 'section') {
        this.insideSection = false;
        this.selectAutoComplete(model, this.filteredSectionSuggestion[this.currentSelection]);
      }
      if (model === 'subSection') {
        this.insideSubSection = false;
        this.selectAutoComplete(model, this.filteredSubSectionSuggestion[this.currentSelection]);
      }
      if (model === 'subSectionL2') {
        this.insideSubSectionL2 = false;
        this.selectAutoComplete(model, this.filteredSubSectionL2Suggestion[this.currentSelection]);
      }
      if (model === 'agency') {
        this.insideAgency = false;
        this.selectAutoComplete(model, this.filteredAgencySuggestion[this.currentSelection]);
      }
      if (model === 'contentBucket') {
        this.insideContentBucket = false;
        this.selectAutoComplete(model, this.filteredContentBucketSuggestion[this.currentSelection]);
      }
      if (model === 'primaryLocation') {
        this.insidePrimaryLocation = false;
        this.selectAutoComplete(model, this.filteredPrimaryLocationSuggestion[this.currentSelection]);
      }
      if (model === 'column') {
        this.insideColumn = false;
        this.selectAutoComplete(model, this.filteredColumnSuggestion[this.currentSelection]);
      }
      if (model === 'attribution') {
        this.insideAttribution = false;
        this.selectAutoComplete(model, this.filteredAttributionSuggestion[this.currentSelection]);
      }
      if (model === 'category') {
        this.insideCategory = false;
        this.selectAutoComplete(model, this.filteredCategorySuggestion[this.currentSelection]);
      }
      if (model === 'brand') {
        this.insideBrand = false;
        // this.selectAutoComplete(model, this.filteredBrandSuggestion[this.currentSelection]);
      }
      if (model === 'model') {
        this.insideModel = false;
        this.selectAutoComplete(model, this.filteredModelSuggestion[this.currentSelection]);
      }
    } else if (event.keyCode === 40) {
      event.preventDefault();
      if (model === 'section') {
        if (this.currentSelection < (this.filteredSectionSuggestion.length - 1)) {
          this.currentSelection += 1;
          this.sectionList.nativeElement.scrollBy(0, 23);
        }
      }
      if (model === 'subSection') {
        if (this.currentSelection < (this.filteredSubSectionSuggestion.length - 1)) {
          this.currentSelection += 1;
          this.subSectionList.nativeElement.scrollBy(0, 23);
        }
      }
      if (model === 'subSectionL2') {
        if (this.currentSelection < (this.filteredSubSectionL2Suggestion.length - 1)) {
          this.currentSelection += 1;
          this.subSectionL2List.nativeElement.scrollBy(0, 23);
        }
      }
      if (model === 'agency') {

        if (this.currentSelection < (this.filteredAgencySuggestion.length - 1)) {
          this.currentSelection += 1;
          this.agencyList.nativeElement.scrollBy(0, 23);
        }
      }
      if (model === 'contentBucket') {

        if (this.currentSelection < (this.filteredContentBucketSuggestion.length - 1)) {
          this.currentSelection += 1;
          this.contentBucketList.nativeElement.scrollBy(0, 23);
        }
      }
      if (model === 'primaryLocation') {

        if (this.currentSelection < (this.filteredPrimaryLocationSuggestion.length - 1)) {
          this.currentSelection += 1;
          this.primaryLocationList.nativeElement.scrollBy(0, 23);
        }
      }
      if (model === 'column') {
        if (this.currentSelection < (this.filteredColumnSuggestion.length - 1)) {
          this.currentSelection += 1;
          this.columnList.nativeElement.scrollBy(0, 23);
        }
      }
      if (model === 'attribution') {
        if (this.currentSelection < (this.filteredAttributionSuggestion.length - 1)) {
          this.currentSelection += 1;
          this.attributionList.nativeElement.scrollBy(0, 23);
        }
      }
      if (model === 'brand') {
        if (this.currentSelection < (this.filteredBrandSuggestion.length - 1)) {
          this.currentSelection += 1;
          this.brandList.nativeElement.scrollBy(0, 23);
        }
      }
      if (model === 'model') {
        if (this.currentSelection < (this.filteredModelSuggestion.length - 1)) {
          this.currentSelection += 1;
          this.modelList.nativeElement.scrollBy(0, 23);
        }
      }
      event.stopPropagation();
    } else if (event.keyCode === 27) {
      event.preventDefault();
      this.insideSection = false;
      this.insideAddedSection = false;
      this.insideSubSection = false;
      this.insideSubSectionL2 = false;
      this.insideAgency = false;
      this.insidePrimaryLocation = false;
      this.insideColumn = false;
      this.insideAttribution = false;
      this.insideBrand = false;
      this.insideCategory = false;
      this.insideModel = false;
      event.stopPropagation();
    } else if (event.keyCode === 38) {
      event.preventDefault();
      if (this.currentSelection > 0) {
        this.currentSelection -= 1;
        if (model === 'section') {
          this.sectionList.nativeElement.scrollBy(0, -23);
        }
        if (model === 'subSection') {
          this.subSectionList.nativeElement.scrollBy(0, -23);
        }
        if (model === 'brand') {
          this.brandList.nativeElement.scrollBy(0, -23);
        }
        if (model === 'model') {
          this.modelList.nativeElement.scrollBy(0, -23);
        }
        if (model === 'subSectionL2') {
          this.subSectionL2List.nativeElement.scrollBy(0, -23);
        }
        if (model === 'agency') {
          this.agencyList.nativeElement.scrollBy(0, -23);
        }
        if (model === 'contentBucket') {
          this.contentBucketList.nativeElement.scrollBy(0, -23);
        }
        if (model === 'primaryLocation') {
          this.primaryLocationList.nativeElement.scrollBy(0, -23);
        }
        if (model === 'column') {
          this.columnList.nativeElement.scrollBy(0, -23);
        }
        if (model === 'attribution') {
          this.attributionList.nativeElement.scrollBy(0, -23);
        }
      }
      event.stopPropagation();
    } else if (event.keyCode === 9) {
      console.log('tab on 9' + model);
      if (this.insideAgency || this.insideSection || this.insideSubSection
        || this.insideSubSectionL2 || this.insideColumn || this.insideAttribution || this.insidePrimaryLocation
        || this.insideBrand || this.insideModel || this.insideCategory || this.insideContentBucket) {
        this.focusOutSuggest(model);
      }
    } else if (event.keyCode === 8) {
      console.log('tab on ' + model);
      if (this.sectionSuggestion.indexOf(this.storyData.metadata.section) === -1) {
        this.sectionSuggestion.push(this.storyData.metadata.section)
      }
      if (this.brandSuggestionMain.indexOf(this.storyData.metadata.brand) === -1) {
        this.brandSuggestionMain.push(this.storyData.metadata.brand)
      }
    }
    else {
      this.currentSelection = 0;
    }
    // console.log(this.currentSelection);
    return true;
  }

  selectAutoComplete(model, item) {
    if (model === 'section') {
      this.sectionQuery = item;
      this.storyData.metadata.section = item;
      this.storyData.metadata.sectionId = null;
      // console.log(this.subSectionSuggestion, item);
      // console.log(
      //   !(this.subSectionSuggestion.hasOwnProperty(item))
      //   , (this.subSectionSuggestion[item].length < 1)
      //   , (this.subSectionSuggestion[item].indexOf(this.storyData.metadata.subSection) < 0));
      if(this.isPremiumSection && this.storyType=='story'){
        let actualStr="premium";
        let receiveStr=item.toLowerCase();
        this.storyData.metadata.premiumStory= actualStr==receiveStr?true:false;
      }
      if (
        !(this.subSectionSuggestion.hasOwnProperty(item))
        || (this.subSectionSuggestion[item].length < 1)
        || (this.subSectionSuggestion[item].indexOf(this.storyData.metadata.subSection) < 0)) {
        this.storyData.metadata.subSection = '';
        this.subSectionQuery = '';
        this.storyData.metadata.subSectionL2 = '';
        this.subSectionL2Query = '';
        this.storyData.metadata.subSectionId = null;
        this.storyData.metadata.subSectionL2Id = null;

      }
      this.filteredSectionSuggestion = [];
    } else if (model === 'subSection') {
      this.subSectionQuery = item;
      this.storyData.metadata.subSection = item;
      this.storyData.metadata.subSectionId = null;
      if (this.storyData.metadata.section === null || this.storyData.metadata.section === '') {
        for (const section in this.subSectionSuggestion) {
          if (section && this.subSectionSuggestion[section].indexOf(item) > -1) {
            this.storyData.metadata.section = section;
            this.sectionQuery = section;
            break;
          }
        }
      }
      if (
        !(this.subSectionL2Suggestion.hasOwnProperty(item))
        || (this.subSectionL2Suggestion[item].length < 1)
        || (this.subSectionL2Suggestion[item].indexOf(this.storyData.metadata.subSectionL2) < 0)) {
        this.storyData.metadata.subSectionL2 = '';
        this.subSectionL2Query = '';
        this.storyData.metadata.subSectionL2Id = null;
      }
      this.filteredSubSectionSuggestion = [];
    } else if (model === 'subSectionL2') {
      this.subSectionL2Query = item;
      this.storyData.metadata.subSectionL2 = item;
      this.storyData.metadata.subSectionL2Id = null;
      // console.log(item);
      if (this.storyData.metadata.section === null || this.storyData.metadata.section === '') {
        for (const subSection in this.subSectionL2Suggestion) {
          if (subSection && this.subSectionL2Suggestion[subSection].indexOf(item) > -1) {
            // console.log(subSection);
            this.storyData.metadata.subSection = subSection;
            this.subSectionQuery = subSection;
            for (const section in this.subSectionSuggestion) {
              if (section && this.subSectionSuggestion[section].indexOf(subSection) > -1) {
                this.storyData.metadata.section = section;
                // console.log(section);
                this.sectionQuery = section;
                break;
              }
            }
            break;
          }
        }
      } else {
        if (this.storyData.metadata.subSection === null || this.storyData.metadata.subSection === '') {
          for (const subSection in this.subSectionL2Suggestion) {
            if (subSection && this.subSectionL2Suggestion[subSection].indexOf(item) > -1) {
              this.storyData.metadata.subSection = subSection;
              this.subSectionQuery = subSection;
              break;
            }
          }
        }
      }
      this.filteredSubSectionL2Suggestion = [];
    } else if (model === 'agency') {
      this.agencyQuery = item;
      this.storyData.metadata.agency = item;
      this.storyData.metadata.agencyId = null;
      this.filteredAgencySuggestion = [];
      if (item === 'WSJ') {
        this.storyData.metadata.premiumStory = false;
      }
    }else if (model === 'contentBucket') {
      this.contentBucketQuery = item;
      this.storyData.metadata.contentBucket = item;
      this.filteredContentBucketSuggestion = [];
    }  
    else if (model === 'primaryLocation') {
      this.primaryLocationQuery = item;
      this.storyData.metadata.primaryLocation = item;
      this.removeSecondaryLocation(item);
      // this.storyData.metadata.agencyId = null;
      this.filteredPrimaryLocationSuggestion = [];
    } else if (model === 'column') {
      this.columnQuery = item;
      this.storyData.metadata.column = item;
      this.filteredColumnSuggestion = [];
    }
    else if (model === 'attribution') {
      this.attributionQuery = item;
      this.storyData.metadata.attribution = item;
      this.filteredAgencySuggestion = [];
    }
    else if (model === 'category') {



      if(this.storyData.metadata.category != item)
      {
        this.allModels = [];
        this.modelSuggestion = {};
        this.filteredBrandSuggestion = [];
        this.filteredModelSuggestion = [];
        this.brandSuggestionMain = [];
        this.modelSuggestionMain = [];
      }
      this.categoryQuery = item;
      this.storyData.metadata.category = item;
      // product brand call through category and change brand suggestion and model suggestion ashish
      this.storyData.metadata.brand = '';
      this.brandQuery = '';
      this.storyData.metadata.model = '';
      this.modelQuery = '';
      let el = this.categories.filter(e => (e.categoryName == item));
      this.filteredCategorySuggestion = [];
      if(el && el.length>0)
      {
        if(this.productCategoryApiSubscription != null && this.productCategoryApiSubscription != undefined)
          this.productCategoryApiSubscription.unsubscribe();
        this.productCategoryApiSubscription = this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/story/brandproduct/' + el[0].id)
        .subscribe(
          data => {
            if(data)
            {
              for(const brand in data)
              {
                this.brandSuggestionMain.push(brand);
                let models = data[brand];

                let brandModels = [];
                for(const model in models)
                {
                  this.allModels.push(model);
                  brandModels.push(model);
                }
                this.modelSuggestionMain[brand]=brandModels;
              }
            }
          });
      }
      /*if (
        !(this.modelSuggestion.hasOwnProperty(item))
        || (this.modelSuggestion[item].length < 1)
        || (this.modelSuggestion[item].indexOf(this.storyData.metadata.model) < 0)) {
        this.storyData.metadata.brand = '';
        this.brandQuery = '';
        this.storyData.metadata.model = '';
        this.modelQuery = '';
      }*/
    } else if (model === 'brand') {
      this.brandQuery = item;
      this.storyData.metadata.brand = item;
      if (
        !(this.modelSuggestionMain.hasOwnProperty(item))
        || (this.modelSuggestionMain[item].length < 1)
        || (this.modelSuggestionMain[item].indexOf(this.storyData.metadata.model) < 0)) {
        this.storyData.metadata.model = '';
        this.modelQuery = '';
      }
      this.filteredBrandSuggestion = [];
      this.loadModels(item);
    } else if (model === 'brandEle') {
      this.productElement['brand'] = item;
      this.brandEleQuery = item;
      this.loadModels(item);

    } else if (model === 'categoryEle') {
      this.brandSuggestion = [];
      this.modelSuggestion = [];
      this.brandEleQuery = '';
      this.modelEleQuery = '';
      this.productElement = {
        'category' : item.categoryName,
        'categoryId' : item.id,
        'brand' : '',
        'model' : ''
      }
      this.categoryEleQuery = item.categoryName;
      console.log(this.productElement)
      if(this.productCategoryApiSubscription != null && this.productCategoryApiSubscription != undefined)
        this.productCategoryApiSubscription.unsubscribe();
      this.productCategoryApiSubscription = this.restService.http_get(this.config.get('product').baseUrl
          + '/api/cms/story/brandproduct/' + item.id)
          .subscribe(
            data => {
              this.brandSuggestion = Object.keys(data);
              this.modelSuggestion = (data);
              console.log(this.modelSuggestion)
              this.modelSuggestionValues = data;
            }
          );

    }
     else if (model === 'model') {
      this.modelQuery = item;
      this.storyData.metadata.model = item;
      if (this.storyData.metadata.brand === null || this.storyData.metadata.brand === '') {
        for (const brand in this.modelSuggestionMain) {
          if (brand && this.modelSuggestionMain[brand].indexOf(item) > -1) {
            this.storyData.metadata.brand = brand;
            this.brandQuery = brand;
            break;
          }
        }
      }
      this.filteredModelSuggestion = [];
    }
    else if (model === 'modelEle') {
      this.productElement['model'] = item;
      if(this.domainConfig['elementsDisabled'].indexOf('categoryProductElement') === -1) {
        this.productElement['modelId'] = this.modelSuggestionValues[this.productElement['brand']][item][0] ? this.modelSuggestionValues[this.productElement['brand']][item][0] : '';
        this.productElement['url'] = this.modelSuggestionValues[this.productElement['brand']][item][1] ? this.modelSuggestionValues[this.productElement['brand']][item][1] : '';
      }
      this.modelEleQuery = item;
    }
  }
  secondarySectionChangesHandler(ev) {
    // console.log(this.storyData.metadata.secondarySections)
    // if(this.storyData.metadata.secondarySections === null) {
    //   this.storyData.metadata.secondarySections = [];
    // }
    // this.storyData.metadata.secondarySections.push(ev);
    //console.log(ev)
  }

  secondaryBrandChangesHandler(ev) {
  }

  flagForSubSection() {
    // false if no subsection for the section
    if (
      (this.storyData.metadata.section && this.storyData.metadata.section.trim() !== '')
      &&
      !(this.subSectionSuggestion.hasOwnProperty(this.storyData.metadata.section)
        || this.subSectionSuggestion[this.storyData.metadata.section]
        || this.subSectionSuggestion[this.storyData.metadata.section].indexOf(this.storyData.metadata.subSection) < 0)
    ) {
      this.storyData.metadata.subSection = '';
      this.subSectionQuery = '';
      // console.log('return true');
      return true;
    } else {
      // console.log('return false');
      return false;
    }
  }

  flagForModel() {
    // false if no subsection for the section
    if (
      (this.storyData.metadata.brand && this.storyData.metadata.brand.trim() !== '')
      &&
      !(this.modelSuggestionMain.hasOwnProperty(this.storyData.metadata.brand)
        || this.modelSuggestionMain[this.storyData.metadata.brand]
        || this.modelSuggestionMain[this.storyData.metadata.brand].indexOf(this.storyData.metadata.model) < 0)
    ) {
      this.storyData.metadata.model = '';
      this.modelQuery = '';
      // console.log('return true');
      return true;
    } else {
      // console.log('return false');
      return false;
    }
  }
  closePlagText() {
    this.showPlagText = false;
  }
  openPlagTextpopup() {
    this.showPlagText = true;
    this.highlightedText = this.plagData.paraContent;
    setTimeout(() => {
      document.getElementById('plagData').scrollIntoView()
    }, 200);


  }

  @HostListener('document:click', ['$event'])
  handleClick(event) {
    const clickedComponent = event.target;
    if (this.secondaryCTA && !this.secondaryCTA.nativeElement.contains(clickedComponent)
      &&
      (
        ((document.getElementsByClassName('daterangepicker') && (document.getElementsByClassName('daterangepicker')).length > 1)
          && !(document.getElementsByClassName('daterangepicker'))[1].contains(clickedComponent))
        || ((document.getElementsByClassName('daterangepicker')).length < 2)
      )
    ) {
      this.revertListFlag = false;
    }

    if (this.inlineImageToolbar && !this.inlineImageToolbar.nativeElement.contains(clickedComponent)) {
      this.inlineImageToggle = false;
    }
    if (this.sampleImageToolbar && !this.sampleImageToolbar.nativeElement.contains(clickedComponent)) {
      this.sampleImageToggle = false;
    }
    if (this.inlineImagereview && !this.inlineImagereview.nativeElement.contains(clickedComponent)) {
      this.inlineReviewToggle = false;
    }
    if (this.inlineEmbed && !this.inlineEmbed.nativeElement.contains(clickedComponent)) {
      this.inlineEmbedToggle = false;
    }
    if (this.inlineTable && !this.inlineTable.nativeElement.contains(clickedComponent)) {
      this.inlineTableToggle = false;
    }

    if (this.sectionField['_results'][0] && clickedComponent === this.sectionField['_results'][0].nativeElement) {
      this.insideSection = true;
      if (this.sectionQuery === '') {
        this.filteredSectionSuggestion = this.sectionSuggestion;
      }
      this.insideAgency = false;
      this.insidePrimaryLocation = false;
      this.insideColumn = false;
      this.insideAttribution = false;
      this.insideSubSection = false;
      this.insideSubSectionL2 = false;
      this.insideContentBucket=false;
      this.filteredSubSectionL2Suggestion = [];
      this.filteredSubSectionSuggestion = [];
      this.filteredAgencySuggestion = [];
      this.filteredPrimaryLocationSuggestion = [];
      this.filteredColumnSuggestion = [];
      this.filteredContentBucketSuggestion=[];
    }
    else if (this.subSectionField['_results'][0] && clickedComponent === this.subSectionField['_results'][0].nativeElement) {
      console.log("in model result");
      this.insideSubSection = true;
      if (this.subSectionQuery === '') {
        if (this.storyData.metadata.section !== null && this.storyData.metadata.section !== '') {
          this.filteredSubSectionSuggestion = this.subSectionSuggestion[this.storyData.metadata.section];
        } else {
          this.filteredSubSectionSuggestion = this.allSubSections;
        }
      }
      this.insideSection = false;
      this.insideAddedSection = false;
      this.insideAgency = false;
      this.insideContentBucket=false;
      this.insidePrimaryLocation = false;
      this.insideColumn = false;
      this.insideAttribution = false;
      this.insideSubSectionL2 = false;
      this.filteredAgencySuggestion = [];
      this.filteredPrimaryLocationSuggestion = [];
      this.filteredSubSectionL2Suggestion = [];
      this.filteredSectionSuggestion = [];
      this.filteredColumnSuggestion = [];
      this.filteredContentBucketSuggestion=[];
    } else if (this.agencyField['_results'][0] && clickedComponent === this.agencyField['_results'][0].nativeElement) {
      this.insideAgency = true;
      if (this.agencyQuery === '') {
        this.filteredAgencySuggestion = this.agencySuggestion;
      }
    } else if (this.contentBucketField['_results'][0] && clickedComponent === this.contentBucketField['_results'][0].nativeElement) {
      this.insideContentBucket = true;
      if (this.contentBucketQuery === '') {
        this.filteredContentBucketSuggestion = this.contentBucketSuggestion;
      }
      this.insidePrimaryLocation = false;
      this.insideSection = false;
      this.insideAddedSection = false;
      this.insideSubSection = false;
      this.insideSubSectionL2 = false;
      this.insideColumn = false;
      this.insideAttribution = false;
      this.insideContentBucket=false;
      this.filteredColumnSuggestion = [];
      this.filteredSubSectionL2Suggestion = [];
      this.filteredPrimaryLocationSuggestion = [];
      this.filteredSectionSuggestion = [];
      this.filteredSubSectionSuggestion = [];
    } else if (this.primaryLocationField['_results'][0] && clickedComponent === this.primaryLocationField['_results'][0].nativeElement) {
      this.insidePrimaryLocation = true;
      if (this.primaryLocationQuery === '') {
        this.filteredPrimaryLocationSuggestion = this.primaryLocationSuggestion;
      }
      this.insideSection = false;
      // this.insideAddedSection =false;
      this.insideAgency = false;
      this.insideContentBucket=false;
      this.insideSubSection = false;
      this.insideSubSectionL2 = false;
      this.insideColumn = false;
      this.insideAttribution = false;
      this.filteredColumnSuggestion = [];
      this.filteredSubSectionL2Suggestion = [];
      this.filteredSectionSuggestion = [];
      this.filteredAgencySuggestion = [];
      this.filteredSubSectionSuggestion = [];
      this.filteredContentBucketSuggestion=[];
    } else if (this.columnField['_results'][0] && clickedComponent === this.columnField['_results'][0].nativeElement) {
      this.insideColumn = true;
      if (this.columnQuery === '') {
        this.filteredColumnSuggestion = this.columnSuggestion;
      }
      this.insideAttribution = false;
      this.insideSection = false;
      this.insideSubSection = false;
      this.insideSubSectionL2 = false;
      this.insideAgency = false;
      this.insideContentBucket=false;
      this.insidePrimaryLocation = false;
      this.filteredAgencySuggestion = [];
      this.filteredPrimaryLocationSuggestion = [];
      this.filteredSubSectionL2Suggestion = [];
      this.filteredSectionSuggestion = [];
      this.filteredSubSectionSuggestion = [];
      this.filteredContentBucketSuggestion=[];
    } else if (this.attributionField['_results'][0] && clickedComponent === this.attributionField['_results'][0].nativeElement) {
      this.insideAttribution = true;
      if (this.attributionQuery === '') {
        this.filteredAttributionSuggestion = this.attributionSuggestion;
      }
      this.insideColumn = false;
      this.insideSection = false;
      this.insideAddedSection = false;
      this.insideSubSection = false;
      this.insideSubSectionL2 = false;
      this.insideAgency = false;
      this.insideContentBucket=false;
      this.insidePrimaryLocation = false;
      this.filteredAgencySuggestion = [];
      this.filteredPrimaryLocationSuggestion = [];
      this.filteredSubSectionL2Suggestion = [];
      this.filteredSectionSuggestion = [];
      this.filteredSubSectionSuggestion = [];
      this.filteredContentBucketSuggestion=[];
    } else if (this.subSectionL2Field['_results'][0] && clickedComponent === this.subSectionL2Field['_results'][0].nativeElement) {
      this.insideSubSectionL2 = true;
      if (this.subSectionL2Query === '') {
        if (this.storyData.metadata.section !== null && this.storyData.metadata.section !== '') {
          if (this.storyData.metadata.subSection !== null && this.storyData.metadata.subSection !== '') {
            this.filteredSubSectionL2Suggestion = this.subSectionL2Suggestion[this.storyData.metadata.subSection];
          } else {
            const sug = this.subSectionSuggestion[this.storyData.metadata.section];
            for (const subl2 in this.subSectionL2Suggestion) {
              if (subl2) {
                const a = subl2;
                if (sug.indexOf(a) > -1) {
                  this.filteredSubSectionL2Suggestion = this.filteredSubSectionL2Suggestion.concat(this.subSectionL2Suggestion[a]);
                }
              }
            }
          }
        } else {
          this.filteredSubSectionL2Suggestion = this.allSubSectionsL2;
        }
      }
      this.insideSection = false;
      this.insideAddedSection = false;
      this.insideSubSection = false;
      this.insideAgency = false;
      this.insideContentBucket=false;
      this.insidePrimaryLocation = false;
      this.insideColumn = false;
      this.insideAttribution = false;
      this.filteredColumnSuggestion = [];
      this.filteredSectionSuggestion = [];
      this.filteredAgencySuggestion = [];
      this.filteredPrimaryLocationSuggestion = [];
      this.filteredSubSectionSuggestion = [];
      this.filteredContentBucketSuggestion=[];
    } else if (this.categoryField['_results'][0] && clickedComponent === this.categoryField['_results'][0].nativeElement) {
      this.insideCategory = true;
      if (this.categoryQuery === '') {
        this.filteredCategorySuggestion = this.categorySuggestionMain;
      }
      this.insideAgency = false;
      this.insideContentBucket=false;
      this.insidePrimaryLocation = false;
      this.insideColumn = false;
      this.insideAttribution = false;
      this.insideSection = false
      this.insideSubSection = false;
      this.insideBrand = false;
      this.insideModel = false;
      this.insideSubSectionL2 = false;
      this.filteredSubSectionL2Suggestion = [];
      this.filteredSubSectionSuggestion = [];
      this.filteredAgencySuggestion = [];
      this.filteredPrimaryLocationSuggestion = [];
      this.filteredColumnSuggestion = [];
      this.filteredContentBucketSuggestion=[];
    } else if (this.brandField['_results'][0] && clickedComponent === this.brandField['_results'][0].nativeElement) {
      this.insideBrand = true;
      if (this.brandQuery === '') {
        this.filteredBrandSuggestion = this.brandSuggestionMain;
      }
      this.insideAgency = false;
      this.insideContentBucket=false;
      this.insidePrimaryLocation = false;
      this.insideColumn = false;
      this.insideAttribution = false;
      this.insideSection = false
      this.insideSubSection = false;
      this.insideModel = false;
      this.insideSubSectionL2 = false;
      this.filteredSubSectionL2Suggestion = [];
      this.filteredSubSectionSuggestion = [];
      this.filteredAgencySuggestion = [];
      this.filteredPrimaryLocationSuggestion = [];
      this.filteredColumnSuggestion = [];
      this.filteredContentBucketSuggestion=[];
    }
    else if (this.brandEleField['_results'][0] && clickedComponent === this.brandEleField['_results'][0].nativeElement) {
      this.insideBrandEle = true
      if (this.brandEleQuery === '') {
        this.filteredBrandSuggestion = this.brandSuggestion;
      }
      this.insideAgency = false;
      this.insideContentBucket=false;
      this.insideBrand = false;
      this.insidePrimaryLocation = false;
      this.insideColumn = false;
      this.insideAttribution = false;
      this.insideSection = false
      this.insideSubSection = false;
      this.insideCategory = false;
      this.insideModel = false;
      this.insideSubSectionL2 = false;
      this.filteredSubSectionL2Suggestion = [];
      this.filteredSubSectionSuggestion = [];
      this.filteredAgencySuggestion = [];
      this.filteredPrimaryLocationSuggestion = [];
      this.filteredColumnSuggestion = [];
      this.filteredContentBucketSuggestion=[];
    }
    else if (this.modelField['_results'][0] && clickedComponent === this.modelField['_results'][0].nativeElement) {
      console.log("in model result");
      this.insideModel = true;
      if (this.modelQuery === '') {
        if (this.storyData.metadata.brand !== null && this.storyData.metadata.brand !== '') {
          this.filteredModelSuggestion = this.modelSuggestionMain[this.storyData.metadata.brand];
        } else {
          this.filteredModelSuggestion = this.allModels;
        }
      }
      this.insideSection = false;
      this.insideAddedSection = false;
      this.insideAgency = false;
      this.insideContentBucket=false;
      this.insidePrimaryLocation = false;
      this.insideColumn = false;
      this.insideAttribution = false;
      this.insideSubSection = false;
      this.insideCategory = false;
      //this.insideBrand = false;
      this.insideSubSectionL2 = false;
      this.filteredAgencySuggestion = [];
      this.filteredPrimaryLocationSuggestion = [];
      this.filteredSubSectionL2Suggestion = [];
      this.filteredSectionSuggestion = [];
      this.filteredColumnSuggestion = [];
      this.filteredContentBucketSuggestion=[];
    }
    else if (this.modelEleField['_results'][0] && clickedComponent === this.modelEleField['_results'][0].nativeElement) {
    if(this.showProductPopup) {
      this.brandSuggestion = this.brandSuggestionMain;
      this.modelSuggestion = this.modelSuggestionMain;
    }

      this.insideModelEle = true;
      if(Object.keys(this.modelSuggestionValues).length !== 0) {
        this.modelSuggestion = this.modelSuggestionValues;
      }
      if (this.modelEleQuery === '') {
        if(this.productElement['brand'] && this.productElement['brand'] !== '') {
          this.filteredModelSuggestion = this.modelSuggestion[this.productElement['brand']] ? this.modelSuggestion[this.productElement['brand']] : [];
          if(this.domainConfig['elementsDisabled'].indexOf('categoryProductElement') === -1) {
            this.modelSuggestion = Object.keys(this.modelSuggestion[this.productElement['brand']]);
            this.filteredModelSuggestion = this.modelSuggestion ? this.modelSuggestion : [];
          }
        }
      }
      this.insideSection = false;
      this.insideAddedSection = false;
      this.insideAgency = false;
      this.insideContentBucket=false;
      this.insidePrimaryLocation = false;
      this.insideColumn = false;
      this.insideAttribution = false;
      this.insideSubSection = false;
      this.insideBrand = false;
      this.insideBrandEle = false;
      this.insideModel = false;
      this.insideSubSectionL2 = false;
      this.filteredAgencySuggestion = [];
      this.filteredPrimaryLocationSuggestion = [];
      this.filteredSubSectionL2Suggestion = [];
      this.filteredSectionSuggestion = [];
      this.filteredColumnSuggestion = [];
      this.filteredContentBucketSuggestion=[];
    } else if (this.categoryEleField['_results'][0] && clickedComponent === this.categoryEleField['_results'][0].nativeElement) {
      this.insideCategoryEle = true;
      if (this.categoryEleQuery === '') {
        this.filteredCategorySuggestion = this.categorySuggestion;
      }
      this.insideSection = false;
      this.insideAddedSection = false;
      this.insideAgency = false;
      this.insideContentBucket=false;
      this.insidePrimaryLocation = false;
      this.insideColumn = false;
      this.insideAttribution = false;
      this.insideSubSection = false;
      this.insideBrand = false;
      this.insideBrandEle = false;
      this.insideModel = false;
      this.insideModelEle = false;
      this.insideSubSectionL2 = false;
      this.filteredAgencySuggestion = [];
      this.filteredPrimaryLocationSuggestion = [];
      this.filteredSubSectionL2Suggestion = [];
      this.filteredSectionSuggestion = [];
      this.filteredColumnSuggestion = [];
      this.filteredContentBucketSuggestion=[];
    } else {
      this.insideSection = false;
      this.insideAddedSection = false;
      this.insideSubSection = false;
      this.insideAgency = false;
      this.insideContentBucket=false;
      this.insidePrimaryLocation = false;
      this.insideSubSectionL2 = false;
      this.insideColumn = false;
      this.insideAttribution = false;
      this.insideCategoryEle = false;
      this.insideModel = false;
      this.insideCategory = false;
      this.insideBrand = false;
      this.insideBrandEle = false;
      this.insideModelEle = false;
      this.filteredColumnSuggestion = [];
      this.filteredSubSectionL2Suggestion = [];
      this.filteredSectionSuggestion = [];
      this.filteredSubSectionSuggestion = [];
      this.filteredAgencySuggestion = [];
      this.filteredPrimaryLocationSuggestion = [];
      this.filteredContentBucketSuggestion=[];
    }
    this.currentSelection = 0;
  }

  focusEleSuggest(model) {
    if (model === 'brandEle') {
      this.insideBrandEle = true;
      if (this.brandEleQuery === '') {
        this.filteredBrandSuggestion = this.brandSuggestion;
      }
    }
    if(model === 'modelEle') {
      this.insideModelEle = true;
      if (this.modelEleQuery === '') {
        if(this.productElement['brand'] && this.productElement['brand'] !== '') {
          this.filteredModelSuggestion = this.modelSuggestion[this.productElement['brand']] ? this.modelSuggestion[this.productElement['brand']] : [];
        } else {
          this.filteredModelSuggestion = [];
        }
      }
    }
    if (model === 'categoryEle') {
      this.insideCategoryEle = true;
      if (this.categoryEleQuery === '') {
        this.filteredCategorySuggestion = this.categorySuggestion;
      }
    }
    this.currentSelection = 0;
    this.filterAutoCompleteUp({ keyCode: 0 }, model);
  }

  focusInSuggest(model) {
    if (model === 'section') {
      this.insideSection = true;
      if (this.sectionQuery === '') {
        this.filteredSectionSuggestion = this.sectionSuggestion;
      }
    }
    if (model === 'subSection') {
      this.insideSubSection = true;
      if (this.subSectionQuery === '') {
        if (this.storyData.metadata.section !== null && this.storyData.metadata.section !== '') {
          this.filteredSubSectionSuggestion = this.subSectionSuggestion[this.storyData.metadata.section];
        } else {
          this.filteredSubSectionSuggestion = this.allSubSections;
        }
      }
    }

    if (model === 'category') {
      this.insideCategory = true;
      if (this.categoryQuery === '') {
        this.filteredCategorySuggestion = this.categorySuggestionMain;
      }
    }
    if (model === 'brand') {
      this.insideBrand = true;
      if (this.brandQuery === '') {
        this.filteredBrandSuggestion = this.brandSuggestionMain;
      }
    }

    if (model === 'model') {
      this.insideModel = true;
      if (this.modelQuery === '') {
        if (this.storyData.metadata.brand !== null && this.storyData.metadata.brand !== '') {
          this.filteredModelSuggestion = this.modelSuggestionMain[this.storyData.metadata.brand];
        } else {
          this.filteredModelSuggestion = this.allModels;
        }
      }
    }
    if (model === 'modelElement') {
        this.filteredModelSuggestion = this.allModels;
    }

    if (model === 'subSectionL2') {
      this.insideSubSectionL2 = true;
      if (this.subSectionL2Query === '') {
        if (this.storyData.metadata.section !== null && this.storyData.metadata.section !== '') {
          if (this.storyData.metadata.subSection !== null && this.storyData.metadata.subSection !== '') {
            this.filteredSubSectionL2Suggestion = this.subSectionL2Suggestion[this.storyData.metadata.subSection];
          } else {
            const sug = this.subSectionSuggestion[this.storyData.metadata.section];
            for (const subl2 in this.subSectionL2Suggestion) {
              if (subl2) {
                const a = subl2;
                if (sug.indexOf(a) > -1) {
                  this.filteredSubSectionL2Suggestion = this.filteredSubSectionL2Suggestion.concat(this.subSectionL2Suggestion[a]);
                }
              }
            }
          }
        } else {
          this.filteredSubSectionL2Suggestion = this.allSubSectionsL2;
        }
      }
    }
    if (model === 'agency') {
      this.insideAgency = true;
      if (this.agencyQuery === '') {
        this.filteredAgencySuggestion = this.agencySuggestion;
      }
    }
    if (model === 'contentBucket') {
      this.insideContentBucket = true;
      if (this.contentBucketQuery === '') {
        this.filteredContentBucketSuggestion = this.contentBucketSuggestion;
      }
    }
    if (model === 'primaryLocation') {
      this.insidePrimaryLocation = true;
      if (this.primaryLocationQuery === '') {
        this.filteredPrimaryLocationSuggestion = this.primaryLocationSuggestion;
      }
    }
    if (model === 'column') {
      this.insideColumn = true;
      if (this.columnQuery === '') {
        this.filteredColumnSuggestion = this.columnSuggestion;
      }
    }
    if (model === 'attribution') {
      this.insideAttribution = true;
      if (this.attributionQuery === '') {
        this.filteredAttributionSuggestion = this.attributionSuggestion;
      }
    }

    this.focusedCard = null;
    this.lastindex = null;
    this.filterAutoCompleteUp({ keyCode: 0 }, model);
  }

  focusOutSuggest(model) {
    if (model === 'section') {
      this.insideSection = false;
      this.filteredSectionSuggestion = [];
    }
    if (model === 'subSection') {
      this.insideSubSection = false;
      this.filteredSubSectionSuggestion = [];
    }
    if (model === 'category') {
      this.insideCategory = false;
      this.filteredCategorySuggestion = [];
    }
    if (model === 'brand') {
      this.insideBrand = false;
      this.filteredBrandSuggestion = [];
    }
    if (model === 'model') {
      this.insideModel = false;
      this.filteredModelSuggestion = [];
    }
    if (model === 'agency') {
      this.insideAgency = false;
      this.filteredAgencySuggestion = [];
    }
    if (model === 'contentBucket') {
      this.insideContentBucket = false;
      this.filteredContentBucketSuggestion = [];
    }
    if (model === 'primaryLocation') {
      this.insidePrimaryLocation = false;
      this.filteredPrimaryLocationSuggestion = [];
    }
    if (model === 'column') {
      this.insideColumn = false;
      this.filteredColumnSuggestion = [];
    }
    if (model === 'attribution') {
      this.insideAttribution = false;
      this.filteredColumnSuggestion = [];
    }
    if (model === 'subSectionL2') {
      this.insideSubSectionL2 = false;
      this.filteredSubSectionL2Suggestion = [];
    }
    this.currentSelection = 0;
  }

  callToggles(ev, model) {
    // console.log(ev);
    const key = ev.keyCode || ev.charCode;
    if (key === 32) {
      ev.preventDefault();
      if (model.indexOf('disclaimer') > -1) {
        const index = (model.replace('disclaimer', '') as number);
        this.callDisclaimer(this.wireDisclaimers[index]);
      } else {
        this.toggleSwitch(model);
      }
      ev.stopPropagation();
    }
  }
  toggleTwitterAccount(account) {
    this.twitterCheck[account.id] = !this.twitterCheck[account.id];
  }

  callDisclaimer(stringDesc) {
    if (this.storyData !== null && this.storyData.metadata !== null) {
      if (this.storyData.metadata.disclaimer.trim() === stringDesc.trim()) {
        this.storyData.metadata.disclaimer = '';
      } else {
        this.storyData.metadata.disclaimer = (stringDesc && stringDesc !== null && stringDesc.trim() !== '') ? stringDesc : '';
      }
    }
  }
  callAffiliateDisclaimer(stringDesc, e) {
    if (!this.storyData.metadata['affiliateDisclaimer']) {
      this.storyData.metadata['affiliateDisclaimer'] = stringDesc;
    } else {
      this.storyData.metadata['affiliateDisclaimer'] = '';
    }

  }

  checkLastPublishedHeadline() {
    if (this.storyEditMode && this.storyData && (!this.storyData.lastPublishedHeadline
      || (this.storyData.lastPublishedHeadline === null) || (this.storyData.lastPublishedHeadline.trim() === '')
      || (this.isNewsletterFieldsEnabled() && (!this.storyData.lastPublishedSummary
        || (this.storyData.lastPublishedSummary === null) || (this.storyData.lastPublishedSummary.trim() === ''))))) {
      if (this.id && this.id !== '' && this.id !== 'new') {
        this.restService.http_get(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), this.page_id, this.version_api)
          + '/' + this.id)
          .subscribe(
            data => {
              if (data && data !== null && !data.hasOwnProperty('error')) {
                const lastVersion = data['changes'][data['changes'].length - 1];
                if (!this.storyData.lastPublishedHeadline || (this.storyData.lastPublishedHeadline === null)
                  || (this.storyData.lastPublishedHeadline.trim() === '')) {
                  this.storyData.lastPublishedHeadline = this.htmlToPlaintext(lastVersion.mobileHeadline);
                }
                if (this.isNewsletterFieldsEnabled() &&
                  (!this.storyData.lastPublishedSummary || (this.storyData.lastPublishedSummary === null)
                    || (this.storyData.lastPublishedSummary.trim() === ''))) {
                  this.storyData.lastPublishedSummary = this.htmlToPlaintext(lastVersion.summary);
                }
              }
            },
            error => {
            }
          );
      }
    }
  }

  multipleHeadlineCheck() {
    // console.log('headline check called');
    // const lastVersion = (this.versionHistory !== null && this.versionHistory['changes'] && this.versionHistory['changes'].length > 0)
    //   ? (this.versionHistory['changes'][this.versionHistory['changes'].length - 1]) : null;
    if (this.storyData && (!this.storyData.lastPublishedHeadline
      || (this.storyData.lastPublishedHeadline === null) || (this.storyData.lastPublishedHeadline.trim() === ''))) {
      this.storyData.lastPublishedHeadline = this.htmlToPlaintext(this.storyData.mobileHeadline);
    }
    if (this.isNewsletterFieldsEnabled() && this.storyData && (!this.storyData.lastPublishedSummary
      || (this.storyData.lastPublishedSummary === null) || (this.storyData.lastPublishedSummary.trim() === ''))) {
      this.storyData.lastPublishedSummary = this.htmlToPlaintext(this.storyData.summary);
    }
    const lastHeadline = (this.storyData && this.storyData.lastPublishedHeadline
      && (this.storyData.lastPublishedHeadline !== null) && (this.storyData.lastPublishedHeadline.trim() !== ''))
      ? this.htmlToPlaintext(this.storyData.lastPublishedHeadline) : null;
    const lastSummary = (this.isNewsletterFieldsEnabled() && this.storyData && this.storyData.lastPublishedSummary
      && (this.storyData.lastPublishedSummary !== null) && (this.storyData.lastPublishedSummary.trim() !== ''))
      ? this.htmlToPlaintext(this.storyData.lastPublishedSummary) : null;
    // console.log(lastVersion, lastHeadline);
    const headline = ((this.storyData.mobileHeadline !== '')
      ? this.storyData.mobileHeadline
      : (this.storyData.title !== '' ? this.storyData.title : ''));
    const summary = (this.storyData.summary !== '' && this.isNewsletterFieldsEnabled()) ? this.storyData.summary : '';
    if (headline !== '' && (this.storyData !== null)) {
      // console.log(this.storyData.browserNotificationHeadline !== null && this.storyData.browserNotificationHeadline.trim() === '');
      // console.log(headline);
      if ((this.storyData.headline !== null && this.storyData.headline.trim() === '')
        || (lastHeadline !== null && this.storyData.headline === lastHeadline)) {
        this.storyData.headline = this.htmlToPlaintext(headline);
      }
      if ((this.storyData.mobileAppNotificationHeadline !== null && this.storyData.mobileAppNotificationHeadline.trim() === '')
        || (lastHeadline !== null && this.storyData.mobileAppNotificationHeadline === lastHeadline)) {
        this.storyData.mobileAppNotificationHeadline = this.htmlToPlaintext(headline);
      }

      if ((this.storyData.browserNotificationHeadline !== null && this.storyData.browserNotificationHeadline.trim() === '')
        || (lastHeadline !== null && this.storyData.browserNotificationHeadline === lastHeadline)) {
        // console.log(this.storyData.browserNotificationHeadline);
        this.storyData.browserNotificationHeadline = this.htmlToPlaintext(headline);
      }
      if ((this.storyData.facebookHeadline !== null && this.storyData.facebookHeadline.trim() === '')
        || (lastHeadline !== null && this.storyData.facebookHeadline === lastHeadline)) {
        this.storyData.facebookHeadline = this.htmlToPlaintext(headline);
      }
      if ((this.storyData.twitterHeadline !== null && this.storyData.twitterHeadline.trim() === '')
        || (lastHeadline !== null && this.storyData.twitterHeadline === lastHeadline)) {
        this.storyData.twitterHeadline = this.htmlToPlaintext(headline);
      }
      if (this.isStoryUrlCreatedFromHeadline) {
        if (this.storyData.headline !== null && this.storyData.headline.trim() === '') {
          this.storyData.headline = this.htmlToPlaintext(headline);
        }
      }
      else {
        if (this.storyData.urlHeadline !== null && this.storyData.urlHeadline.trim() === '') {
          this.storyData.urlHeadline = this.htmlToPlaintext(headline);
        }
      }
      if (this.isNewsletterFieldsEnabled()
        && ((this.storyData.newsletterHeadline !== null && this.storyData.newsletterHeadline.trim() === '')
          || (lastHeadline !== null && this.storyData.newsletterHeadline === lastHeadline))) {
        this.storyData.newsletterHeadline = this.htmlToPlaintext(headline);
      }
      if (this.isH2enabled() && (this.storyData.h2HeaderHeadline !== null && this.storyData.h2HeaderHeadline.trim() === '')
        || (lastHeadline !== null && this.storyData.h2HeaderHeadline === lastHeadline)) {
        this.storyData.h2HeaderHeadline = this.htmlToPlaintext(headline);
      }
      if (this.isH3enabled() && (this.storyData.h3HeaderHeadline !== null && this.storyData.h3HeaderHeadline.trim() === '')
        || (lastHeadline !== null && this.storyData.h2HeaderHeadline === lastHeadline)) {
        this.storyData.h3HeaderHeadline = this.htmlToPlaintext(headline);
      }
    }

    if (this.isNewsletterFieldsEnabled() && summary !== '' && (this.storyData !== null)) {
      if ((this.storyData.newsletterSummary !== null && this.storyData.newsletterSummary.trim() === '')
        || (lastSummary !== null && this.storyData.newsletterSummary === lastSummary)) {
        this.storyData.newsletterSummary = this.htmlToPlaintext(summary);
      }
    }
  }

  getStoryMetaList() {
    if (this.isAuthorIdEnabled || this.isAuthorSuggestionEnabled) {
      this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/story/editor/authorsuggestions')
        .subscribe(
          data => {
            if (data.hasOwnProperty('authorsList')) {
              if(this.isAuthorIdEnabled) {
                this.authorsSuggestion = data['authorsList'];
              } else {
                data['authorsList'].forEach(author => {
                  this.authorsSuggestion.push(author.name);
                });
              }
            }
          });
    }

    if(this.enableCategory)
    {
      this.allModels = [];
      this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/story/productcategories')
      .subscribe(
        data => {
          if(data)
          {
            this.categories = data;
            for(let item of data)
            {
              this.categorySuggestionMain.push(item.categoryName);
            }
          }
        });
    }

    // let data=this.localstorageService.getSuggestionData();
    
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/story/editor/suggestions')
      .subscribe(
        data => {
          if (data.hasOwnProperty('breakingNewsImageUrl')) {
            this.breakingNewsImageUrl = data['breakingNewsImageUrl'];
          }
          if (data.hasOwnProperty('breakingNewsImageCaption')) {
            this.breakingNewsImageCaption = data['breakingNewsImageCaption'];
          }
          if (data.hasOwnProperty('states')) {
            this.countryMap = data['states'];
            this.countryArray = Object.keys(data['states']);
          }
          if (data.hasOwnProperty('authors') && (!this.isAuthorIdEnabled && !this.isAuthorSuggestionEnabled)) {
            this.authorsSuggestion = data['authors'];
          }

          if (data.hasOwnProperty('attribution')) {
            this.attributionSuggestion = data['attribution'];
          }
          if (data.hasOwnProperty('agencyNames')) {
            this.agencySuggestion = data['agencyNames'];
          }
          if (data.hasOwnProperty('contentBuckets')) {
            this.contentBucketSuggestion = data['contentBuckets'];
          }
          if (data.hasOwnProperty('columns')) {
            this.columnSuggestion = data['columns'];
          }
          if (data.hasOwnProperty('wireDisclaimers')) {
            this.wireDisclaimers = data['wireDisclaimers'];
          }
          if (data.hasOwnProperty('sections')) {
            this.subSectionSuggestion = data['sections'];
            if(this.userRestrictedSections && this.userRestrictedSections.length > 0) {
              for (const section of this.userRestrictedSections) {
                if(section) {
                  console.log(section);
                  this.sectionSuggestion.push(section);
                  this.allSubSections = this.allSubSections.concat(data['sections'][section]);
                }
              }
            } else {
              for (const section in data['sections']) {
                if (section) {
                  const sec = section;
                  // console.log(this.domainConfig['config']['story'])// .split('name=')[1].split(',')[0];
                  if (this.domainConfig['config'] && this.domainConfig['config']['story']
                        && this.domainConfig['config']['story']['restrictSection'] && this.storyType == 'gallery') {
                    if(sec === this.domainConfig['config']['story']['defaultPhotogallerySection'] ) {
                      this.sectionQuery = this.domainConfig['config']['story']['defaultPhotogallerySection'];
                      this.sectionSuggestion.push(sec);
                      this.allSubSections = this.allSubSections.concat(data['sections'][sec]);
                    } else if (!this.domainConfig['config']['story']['defaultPhotogallerySection'] && sec == 'photos') {
                      this.sectionQuery = sec;
                      this.sectionSuggestion.push(sec);
                      this.allSubSections = this.allSubSections.concat(data['sections'][sec]);
                    }
                  } else if (this.domainConfig['config'] && this.domainConfig['config']['story']
                          && this.domainConfig['config']['story']['restrictSection'] && this.storyType == 'video') {
                    if (sec == 'videos') {
                      this.sectionQuery = sec;
                      this.sectionSuggestion.push(sec);
                      this.allSubSections = this.allSubSections.concat(data['sections'][sec]);
                      this.storyData.metadata.section = sec;
                    }
                  } else {
                    //regular case
                    this.sectionSuggestion.push(sec);
                    this.allSubSections = this.allSubSections.concat(data['sections'][sec]);
                  }
                }
              }
            }

          }
          if (data.hasOwnProperty('subSections')) {
            this.subSectionL2Suggestion = data['subSections'];
            for (const subsection in data['subSections']) {
              if (subsection) {
                const sec = subsection; // .split('name=')[1].split(',')[0];
                // this.sectionSuggestion.push(sec);
                this.allSubSectionsL2 = this.allSubSectionsL2.concat(data['subSections'][sec]);
              }
            }
          }
          
        },
        err => {
          // console.log(err);
        }
      );
      this.loadBrands();
    if (this.isPrimaryLocationEnabled()) {
      this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/story/editor/cities').subscribe((data) => {
        if (data) {
          this.primaryLocationSuggestion = data;
        }
      });
    }
  }
  setStoryHeight() {
    const intViewportHeight = window.innerHeight - 172;
    const styles = {
      'min-height': + intViewportHeight + 'px'
    };
    return styles;
  }

  scr(ev) {
    this.storySec.nativeElement.scrollBy(0, ev);
  }

  childKeyDownEventCatcher(ev) {
    this.childKeyDownEvent = ev;
  }

  addInlineElement(ev) {
  }


  /**
   * Load Brands 
   */
  private  loadBrands(){
    if (this.enableBrand) {
      this.restService.http_get(this.config.get('product').utilUrl + '/api/cms/auto/manufacturers')
      .subscribe(
        data => {
              this.brandSuggestionMain=data;

        },
        err => {
          // console.log(err);
        }
      );
  }
  }

  
  /**
   * load Models of a Brand 
   * @param brand 
   */
  private loadModels(brand:String){
    if(this.enableModel){
      this.restService.http_get(this.config.get('product').utilUrl + '/api/cms/auto/'+brand+"/Products")
      .subscribe(
        data => {
          this.modelSuggestionMain[''+brand]=data;
          this.filteredModelSuggestion =data;
       },
        err => {
          // console.log(err);
        }
      );
     } 
  }

  @HostListener('window:unload', ['$event'])
  public onunload(event) {
    // console.log('unload');
    if (this.storyData.id && this.isLocked) {
      this.releaselocknow(this.storyData.id);
    }
    this.storyData.elements = [];
    // this.viewPortItems = $.extend(true, [], []);
    this.viewPortItems = Object.assign([], []);
    this.storyData = null;
    return false;
  }

  @HostListener('window:beforeunload', ['$event'])
  public confirmUnload($event) {
    this.snotify.clear();
    $event = window.event;
    $event.preventDefault();
    // $event.returnValue = 'Are you sure you want to leave the story?';
    // return false;
    if (((this.storyData !== null) && this.isLocked && (this.storyData.id !== null)
      && (this.changeFlag || (this.tempCardArray.objs.length > 0))) || (this.requestInQueue > 0)) {
      const message = ((this.storyData && this.storyData.metadata.status !== 'PUBLISHED') ?
        'Changes not yet saved, close tab?' :
        'Publishing in progress, close tab?');
      if (typeof $event === 'undefined') {
        $event = window.event;
      }
      if ($event) {
        $event.returnValue = message;
      }
      return message;
    } else {
      return true;
    }
  }


  ngOnDestroy() {
    if (this.stompClient && this.stompClient.connected) {
      this.stompClient.disconnect();
    }
    if (this.storyData && (this.storyData !== null) && (this.storyData.id !== null) && this.isLocked) {
      this.releaselocknow(this.storyData.id);
    }
    // unsubscribe to ensure no memory leaks
    this.destroyStoryAutoSaveInterval();
    if (this.subscription.length > 0) {
      this.subscription.forEach(s => s.unsubscribe());
    }
    this.storyData = null;
    if (this.dragulaService.find('sixth-bag')) {
      this.dragulaService.destroy('sixth-bag');
    }
    this.snotify.clear();
    this.sharedService.overflowauto();
    // $(document).ready(function () {
    // $('.mainContainer .rightListContainer')
    // .css({ 'margin-top': 64 + 'px', 'padding-top': 28 + 'px', 'padding-left': 30 + 'px', 'padding-right': 30 + 'px' });
    // });
  }

  releaselocknow(id) {
    // const token = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral));
    // const domain = sessionStorage.getItem(StaticDataService.domainLiteral);
    // const auth = `Bearer ` + token.access_token;
    // const url = this.config.get('product').baseUrl
    //   + '/story/lock/release'
    //   + '?Authorization=' + auth
    //   + '&Domain=' + domain
    //   + '&articleId='
    //   + String(id);
    // $.ajax({
    //   url: url,
    //   crossDomain: true,
    //   type: 'GET',
    //   success: () => {
    //     this.isLocked = false;
    //   }
    // });
     this.lockRelease(id, data => {
       return data;
     });
  }

  acquirelocknow() {
    if (this.storyData && this.storyData.id !== null) {
      // console.log(' or here');
      this.restService.http_get(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.lockAcquire_api)
        + '?articleId='
        + String(this.storyData.id)
      )
        .subscribe(
          data => {
            // console.log(data);
          },
          error => {
            // console.log(error);
          });
    }
  }

  @HostListener('window:paste', ['$event'])
  public pastefunc(e) {
    //enabled for quill editor and ckeditor for both
    // if (!this.isCKEditorEnabled) {
    const plaintext = (e.originalEvent || e).clipboardData.getData('text/plain');
    const htmltext = (e.originalEvent || e).clipboardData.getData('text/html');

    if (this.headlineFocusFlag || this.summaryFocusFlag) {
      e.stopImmediatePropagation();
      e.preventDefault();
      const text = this.htmlToPlainTextExcludingPara(plaintext);
      if (this.headlineFocusFlag) {
        this.pasteOnEditor(this.headlineEditor, text);
      }
      if (this.summaryFocusFlag) {
        this.pasteOnEditor(this.summaryEditor, text);
      }
      return false;
    } else if (this.introFocusFlag) {
      e.stopImmediatePropagation();
      e.preventDefault();
      //   const text = this.htmlToPlainTextExcludingAttributes(htmltext).replace(/<\p><\/p>/gm, '').replace(/<br ?\/?>/g, '');
      const text = this.text2HTML(plaintext).replace(/<\p><\/p>/gm, '').replace(/<br ?\/?>/g, '');
      this.pasteOnEditor(this.introEditor, text);
      return false;
    }
    // }
  }

  pasteOnEditor(editor, text) {
    const len = ((editor.getSelection() !== null) ? (editor.getSelection()) : (editor.selection.savedRange));
    const oldh = editor.getBounds(len.index);
    if (len.length > 0) {
      editor.deleteText(len.index, len.length);
      editor.clipboard.dangerouslyPasteHTML(len.index, text);
    } else {
      editor.clipboard.dangerouslyPasteHTML(len.index, text);
    }
    setTimeout(e => {
      const l = ((editor.getSelection() !== null) ? (editor.getSelection()) : (editor.selection.savedRange));
      const newh = editor.getBounds(l.index);
      const diff = newh.top - oldh.top;
      if ((diff > 0) && (editor !== this.headlineEditor)) {
        this.scr(diff);
      }
    }, 5);
  }

  text2HTML(inputText) {
    let text = inputText.replace(/&/g, '&amp;').
      replace(/</g, '&lt;').
      replace(/>/g, '&gt;');
    text = text.replace(/\r\n?|\n/g, '<br>');
    text = text.replace(/<br ?\/?>/g, '</p><p>');
    text = '<p>' + text + '</p>';
    return text;
  }


  htmlToPlainTextExcludingPara(text) {
    if (typeof text === 'string') {
      return this.htmlSpecialCharToText(text);
    } else {
      return text;
    }
  }

  htmlToPlainTextExcludingAttributes(text) {
    if (typeof text === 'string') {
      return this.htmlSpecialCharToText(
        (text)
          .replace(new RegExp('style="[^"]*"', 'g'), '')
          .replace(new RegExp('style=\'[^\']*\'', 'g'), '')
          .replace(new RegExp('class="[^"]*"', 'g'), '')
          .replace(new RegExp('class=\'[^\']*\'', 'g'), '')
          .replace(new RegExp('href="[^"]*"', 'g'), '')
          .replace(new RegExp('href=\'[^\']*\'', 'g'), '')
          .replace(new RegExp('src="[^"]*"', 'g'), '')
          .replace(new RegExp('src=\'[^\']*\'', 'g'), '')
          .replace(new RegExp('<p><br></p>', 'g'), '')
        // string.replace("<p><br></p>", "");


      );
    } else {
      return text;
    }
  }

  @HostListener('window:resize') onResize() {
    // guard against resize before view is rendered
    this.setStoryHeight();
  }

  quillGetHTML(inputDelta) {
    const tempQuill = new Quill(document.createElement('div'));
    tempQuill.setContents(inputDelta);
    return tempQuill.root.innerHTML;
  }

  getDifference(a, b) {
    let i = 0;
    let j = 0;
    let result = '';

    while (j < b.length) {
      if (a[i] !== b[j] || i === a.length) {
        result += b[j];
      } else {
        i++;
      }
      j++;
    }
    return result;
  }

  ngDoCheck() {
    const self = this;
    // const localtempvar = self.storyData ? $.extend(true, {}, self.storyData) : null;
    const localtempvar = self.storyData ? Object.assign({}, self.storyData) : null;
    //  const localvar = self.tempStoryData ? $.extend(true, {}, self.tempStoryData) : null;
    const localvar = self.tempStoryData ? Object.assign({}, self.tempStoryData) : null;
    // console.log(this.elementChangeData);
    if (localtempvar) {
      delete localtempvar['createdDate'];
      delete localtempvar['lastModifiedDate'];
    }
    // console.log("this.lastStoryData: "+ this.lastStoryData);
    // console.log("localtempvar "+ localtempvar);
    const cochange = this.getDifference(this.lastStoryData ? this.lastStoryData : '', localtempvar ? JSON.stringify(localtempvar) : '');
    const cotempchange = this.getDifference(this.lastStoryTempData ? this.lastStoryTempData : '', localvar ? JSON.stringify(localvar) : '');
    const elementChange = this.getDifference(
      this.lastStoryData && JSON.parse(this.lastStoryData).elements ? JSON.stringify(JSON.parse(this.lastStoryData).elements) : '',
      localtempvar && localtempvar.elements ? JSON.stringify(localtempvar.elements) : ''
    );
    // console.log("cochange : " + cochange);
    if (this.storyLoaded && cochange !== '') {
      console.log('word cochange'+cochange)
      if (localtempvar) {
        this.lastStoryData = JSON.stringify(localtempvar);
      }
      if (this.firstLoadCheck > 0) {
        this.tagResetFlag = true;
        console.log('word ngDoCheck');
        this.changeFlag = true;
        // if (!this.versionLock && this.storyEditMode) {
        // }
        this.sharedService.sendData('saved|true');
      }
      this.firstLoadCheck++;
    }

    if (this.storyLoaded && elementChange !== '') {
      // console.log(elementChange);
      this.checkAllElementsVisibility();
    }

    const dateAtMoment = Math.round((new Date()).getTime());
    if (this.storyData && this.storyEditMode) {
      if (this.storyData.metadata.status === 'SCHEDULED') {
        this.sendPublishDisableCommand(true);
      } else if (this.storyData.metadata.status === 'EMBARGO') {
        this.sendPublishDisableCommand(true);
      } else if (this.storyData.metadata.status === 'PUBLISHED') {
        if (!this.storyData.metadata.deleteMode) {
          this.sendPublishDisableCommand(false);
        } else {
          this.sendPublishDisableCommand(true);
        }
      } else {
        if (this.disableElement('story-save')) {
          this.sendPublishDisableCommand(true);
        } else {
          this.sendPublishDisableCommand(false);
        }
      }
    } else {
      if (this.isLocked && this.storyData && this.storyData.metadata
        && this.storyData.metadata.status && this.storyData.metadata.status === 'SCHEDULED') {
        this.sendPublishDisableCommand(false);
      } else {
        this.sendPublishDisableCommand(true);
      }
    }


    if (this.storyLoaded && cotempchange !== '') {
      this.temporaryChangesFlag = true;
      this.lastStoryTempData = JSON.stringify(localvar);
    }

    if(this.storyType=='liveblog' && this.storyData && this.storyData.introElements && this.liveblogIntroEmbed && this.storyData.introElements.length>0){
      this.viewPoerItemLiveblogEmbed=[...this.storyData.introElements]
    }
  }

  canDeactivate() {
    if (this.storyData && this.storyData !== null && this.storyData.isDeleted !== 1) {
      if (this.isLocked && ((this.requestInQueue > 0) || this.changeFlag) && this.retryLimit > 0) {
        const x = window.confirm('Story is saving, do you want to discard changes?');
        if (!x) {
          // console.log('jquery called');
          return false;
        } else {
          return true;
        }
      } else {
        this.destroyViewComponents();
        return true;
      }
    } else {
      return true;
    }
  }

  lockRelease(story_id, callback) {
    if (this.isLocked === true) {
      this.restService.http_get(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.lockRelease_api)
        + '?articleId='
        + String(story_id)
      )
        .subscribe(
          data => {
            // console.log('released => ' + data);
            this.isLocked = false;
            this.destroyViewComponents();
            callback(data);
          },
          error => {
            // console.log(error);
            callback(false);
          });
    } else {
      callback(true);
    }
  }

  lockAcquire(story_id, callback) {
    this.restService.http_get(
      this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), this.page_id, this.lockAcquire_api)
      + '?articleId='
      + String(story_id)
    )
      .subscribe(
        data => {
          this.isLocked = true;
          this.destroyViewComponents();
          callback(data);
        },
        error => {
          callback(false);
        });
  }

  openPreview(platform) {
    this.focusedCard = null;
    this.lastindex = null;
    let prviewUrl = this.config.get('product').previewUrl;
    if (this.domainConfig['config'] && this.domainConfig['config']['previewUrl'] && this.domainConfig['config']['previewUrl']['url']) {
      prviewUrl = this.domainConfig['config']['previewUrl']['url'];
    }
    if(prviewUrl=="") return this.snotify.error("Don't have a permission",'', this.sharedService.getConfig(false))
    const url = prviewUrl + '/preview/story/' + this.storyData.id;
    if (this.storyData.id !== null && this.storyData.metadata !== null && !this.storyData.metadata.killed) {
      if (this.disableElement('publish-story')) {
        this.iframeLoading = 0;
        this.iframeStyle = this.sanitizer.bypassSecurityTrustStyle((platform === 'mobile')
          ? 'width:425px;height:96vh;border:none;position:relative;z-index:21;'
          : 'width:100%;height:96vh;border:none;position:relative;z-index:21;');
        this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.previewPlatform = platform;
        this.previewPopup = true;
        this.sharedService.overflowhidden();
      } else {
        this.publishError();
      }
    }
  }

  iframeLoaded(ev) {
    console.log('end', new Date());
    this.iframeLoading += 1;
  }
  closePreview() {
    this.previewUrl = null;
    this.previewPlatform = null;
    this.previewPopup = false;
    this.iframeLoading = 0;
    this.sharedService.overflowauto();
  }

  makeRenderable(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  unlockStory(story_id, callback) {
    this.restService.http_get(
      this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), this.page_id, this.unlock_story_api)
      + '?articleId='
      + String(story_id)
    )
      .subscribe(
        data => {
          this.destroyViewComponents();
          callback(data);
        },
        error => {
          callback(false);
        });
  }

  disableInnerFocus(ev) {
    this.innerFocusFlag = false;
    // console.log('emit wala');
  }

  destroyViewComponents() {
    this.destroyStoryAutoSaveInterval();

  }

  overrideSave() {
    // console.log('override fired');
    this.destroyStoryAutoSaveInterval();
    setTimeout(e => {

      this.saveStory(true);
      setTimeout(e2 => {
        this.generateStoryAutoSaveInterval();
      }, 100);
    }, 50);
  }

  // Pranav : TBC
  retryLimit = 10;
  generateStoryAutoSaveInterval() {
    // console.log('generate');
    if (!this.autosave && this.retryLimit > 0) {
      this.autosave = setInterval(() => {
        if (this.retryLimit > 0)
          console.log('Autosave called');
          this.saveStory(false);
      }, 1500);
    }
  }

  destroyStoryAutoSaveInterval() {
    // console.log('destroy');
    if (this.autosave) {
      clearInterval(this.autosave);
      this.autosave = null;
    }
  }

  sendPublishDisableCommand(flag) {
    if (flag) {
      this.sharedService.sendData('publish_disable|true');
    } else {
      this.sharedService.sendData('publish_disable|false');
    }
  }

  autoSaveRequest(event) {
    console.log("In autosaveRequest...");
    this.changeFlag = true;
    this.overrideSave();
  }

  checkSummary(text) {
    if (text && text !== null) {
      const check = /<[a-z][\s\S]*>/i.test(text);
      const check2 = /(\<\/ul\>)(.{1,})(\<ul\>)/g.test(text);
      if (text.indexOf('<ul>') > -1) {
        if ((text.substr(0, 4) === '<ul>') && (text.substr(text.length - 5, 5) === '</ul>') && !check2) {
          return true;
        } else {
          return false;
        }
      } else {
        if (text.indexOf('</a>') > -1) {
          return true;
        } else {
          return this.isSummaryTagStripDisabled() || !check;
        }
      }
    } else {
      return true;
    }
  }


  initStoryView(id, option) {
    this.restService.http_get(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), this.page_id, this.get_api)
      + '/' + id)
      .subscribe(
        data => {
          if(this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['socket'] && this.domainConfig['config']['socket']['enableSocket'] && this.domainConfig['config']['socket']['enableSocket'] === 'true')
          {
            this.initiateSocket(data.id);
          }
          if ((data.webId || data.wireFeedId) && (this.domainConfig['config']
            && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['disableHeadlineLimit'] === 'true')) {
            this.headlineMaxLength = this.getHeadlineMaxLength(true);
            this.showHeadlineerror = true;
          }
          if (!data.hasOwnProperty('error')) {
            if (data.wireFeedId && data.wireFeedId !== null) {
              // const url = this.config.get('product').baseUrl
              //   + '/api/cms/wire'
              //   + '/' + data.wireFeedId;
              // this.restService.http_get(url).subscribe(wiredata => {
              //   this.originalStory = wiredata;
              // });
            } else {
              this.showLanuageTab = true;
            }
            if (data['headline'] && (data['headline'] !== '')
              && (data['mobileHeadline'] === null || data['mobileHeadline'] === '')) {
              this.headline = data['headline'];
              data['mobileHeadline'] = data['headline'];
            } else {
              this.headline = data.mobileHeadline;
            }
            if (data['metadata']['status'] === 'SCHEDULED') {
              this.storyEditMode = false;
              this.checkIfScheduleIsPublished();
              if (this.isLocked) {
                this.snotify.info('Remove schedule to Edit this story', '', this.sharedService.getConfig(false));
              }
            }
            // console.log('wordCOunt => ' + data.metadata.wordCount);
            this.setImageCaption(data);
            if (this.sharedService.currentDomainConfiguration['notificationPlatformsEnabled'].indexOf('webengage') > -1) {
              this.fetchWebengageAnalyticsUrl(data);
            }
            if (this.sharedService.currentDomainConfiguration['notificationPlatformsEnabled'].indexOf('moengage') > -1) {
              this.fetchMoengageAnalyticsUrl(data);
            }
            if (data['elements'] && (data['elements'].length > 0)) {
              /*   this.viewPortItems = $.extend(true, [], (
                  (data['elements'].length > this.initialElementCount)
                    ? data['elements'].slice(0, this.initialElementCount)
                    : data['elements'])
                ); */
              this.viewPortItems = Object.assign([], (
                (data['elements'].length > this.initialElementCount)
                  ? data['elements'].slice(0, this.initialElementCount)
                  : data['elements']));
              this.elementCountFlag = true;
              this.storyData = data;
              this.precheckedPlag();
              this.wirePreviewStory = $.extend(true, {}, data);
              this.wirePreviewStory.headline = this.headline;
              this.storyData['elements'] = this.storyData['elements'].filter(e => (e !== null));
              const elements = data['elements'] ? data['elements'] : [];
              const leadElementId = (data.leadMedia && data.leadMedia.elements && data.leadMedia.elements[0])
                ? [data.leadMedia.elements[0]] : [];
              this.getElementData(true, [...elements, ...leadElementId], res => {
                // console.log(res);
                this.elementDataLoaded = true;
                if (res && (data['type'] === 'story')) {
                  const newResArray = this.storyData['elements'].map(e => this.Elements[e]);
                  const len = newResArray.length;
                  if (len > 0 && [len - 1] && newResArray[len - 1]['type'] === 'paragraph') {
                    this.showTempPara = false;
                    this.tempParaId = null;
                  } else {
                    this.showTempPara = true;
                    this.tempParaData = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
                    this.tempParaData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
                  }
                }
                if (this.storyData.metadata.secondarySections === null) {
                  this.storyData.metadata.secondarySections = [];
                }
                if (this.storyData.metadata.secondaryBrands === null) {
                  this.storyData.metadata.secondaryBrands = [];
                }
                if (this.storyData.metadata.deadLinkUrl === null) {
                  this.storyData.metadata.deadLinkUrl = '';
                }
                if (res && data['type'] === 'liveblog' && res.length > 0) {
                  const newarr = res.map(e => {
                    if (e.type === 'liveblog' && e.liveBlog && e.liveBlog.inlineElementId) {
                      return e.liveBlog.inlineElementId;
                    } else {
                      return null;
                    }
                  }).filter(e => e);
                  this.getElementData(false, newarr, e => { });
                }
              });
            } else {
              this.storyData = data;
              this.showTempPara = true;
              this.tempParaData = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
              this.tempParaData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
              setTimeout(e => {
                // this.runWordCountCheck();
              }, 30);
            }
            // console.log(data.summary);
            this.summary = data.summary;
            if (+data.metadata.homePagePosition > 0 || data.metadata.homePageEndTime) {
              this.homepageToggle = true;
              const nowDate = new Date(this.storyData.metadata.homePageEndTime);
              this.homepageCalendarConfig['startDate'] =
                (((nowDate.getMonth() + 1) > 10) ? (nowDate.getMonth() + 1) : '0' + (nowDate.getMonth() + 1))
                + '/' + ((nowDate.getDate() > 10) ? nowDate.getDate() : '0' + nowDate.getDate())
                + '/' + nowDate.getFullYear()
                + ' ' + nowDate.getHours() + ':' + nowDate.getMinutes();
              this.setCalendarMinDateForHomepageOption();
            }
            if (data.metadata.outdatedTime) {
              const nowDate = new Date(this.storyData.metadata.outdatedTime);
              this.endTimeCalendarConfig['startDate'] =
                (((nowDate.getMonth() + 1) > 10) ? (nowDate.getMonth() + 1) : '0' + (nowDate.getMonth() + 1))
                + '/' + ((nowDate.getDate() > 10) ? nowDate.getDate() : '0' + nowDate.getDate())
                + '/' + nowDate.getFullYear()
                + ' ' + nowDate.getHours() + ':' + nowDate.getMinutes();
              this.setCalendarMinDateForEndTime();
            }
            setTimeout(e => {
              // this.headlineEditor.focus();
              if (this.headlineEditor) {
                if (this.isCKEditorEnabled) {
                  this.headlineEditor.editing.view.focus();
                } else {
                  this.headlineEditor.setSelection(
                    ((data.mobileHeadline && data.mobileHeadline !== null) ? data.mobileHeadline.length : 0)
                    , 0);
                }
              }
              this.setFocus('headline');
              if (data.type === 'story') {
                this.getRelatedStoryEmits(null);
              }

            }, 300);
            this.sharedService.setTitle(this.htmlToPlaintext(data.mobileHeadline));
            this.checkLastPublishedHeadline();
            this.setStoryData(null);
            this.discareUrlChanges(false);
            this.generateStoryAutoSaveInterval();
            if (data.metadata.breakingNews && data.metadata.breakingNewsId && data.title === '') {
              setTimeout(e => {
                this.addAutomaticBylineForBreakingNews();
              }, 500);
            }
            if (data.metadata.storyType == null) {
              this.storyData.metadata.storyType = 'DIGITAL';
            }
            if (this.storyData.metadata.section) {
              this.sectionQuery = this.storyData.metadata.section;
            }
            if (this.storyData.metadata.subSection) {
              this.subSectionQuery = this.storyData.metadata.subSection;
            }
            if (this.storyData.metadata.section) {
              this.sectionQuery = this.storyData.metadata.section;
            }
            if (this.storyData.metadata.subSection) {
              this.subSectionQuery = this.storyData.metadata.subSection;
            }
            if (this.storyData.metadata.subSectionL2) {
              this.subSectionL2Query = this.storyData.metadata.subSectionL2;
            }
            if (this.storyData.metadata.contentBucket) {
              this.contentBucketQuery = this.storyData.metadata.contentBucket;
            }
            if (this.storyData.autoBacklinkStatus && this.storyData.autoBacklinkStatus.autoBacklinkResponse) {
              this.autoBackLinkList = this.storyData.autoBacklinkStatus.autoBacklinkResponse;
            }
            if (this.storyData.metadata.videoMetadata && this.storyData.metadata.videoMetadata.videoDuration) {
              console.log(this.storyData.metadata.videoMetadata.videoDuration)
              const time = this.storyData.metadata.videoMetadata.videoDuration.split(":");
              this.minuteMeta = (time[0] ? time[0] : '');
              this.secondMeta = (time[1] ? time[1] : '');

            }
            if (this.storyData.metadata.category) {
              this.categoryQuery = this.storyData.metadata.category;
              if (this.categoryQuery != null) {
                let el = this.categories.filter(e => (e.categoryName == this.categoryQuery));
                this.filteredCategorySuggestion = [];
                if (el && el.length > 0) {
                  console.log("brand query in 3 : ", this.brandQuery);
                  console.log("this.storyData.metadata.brand query in 3 : ", this.storyData.metadata.brand);
                  if(this.productCategoryApiSubscription != null && this.productCategoryApiSubscription != undefined)
                    this.productCategoryApiSubscription.unsubscribe();
                  this.productCategoryApiSubscription = this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/story/brandproduct/' + el[0].id +'?searchChars=' + this.storyData.metadata.brand)
                    .subscribe(
                      data => {
                        if (data) {
                          for (const brand in data) {
                            this.brandSuggestionMain.push(brand);
                            let models = data[brand];

                            let brandModels = [];
                            for (const model in models) {
                              this.allModels.push(model);
                              brandModels.push(model);
                            }
                            this.modelSuggestionMain[brand] = brandModels;
                          }
                          this.filteredBrandSuggestion = this.brandSuggestionMain;
                        }
                      });
                }
              }
            }
            if (this.storyData.metadata.brand) {
              this.brandQuery = this.storyData.metadata.brand;
            }
            if (this.storyData.metadata.model) {
              this.modelQuery = this.storyData.metadata.model;
            }
            if (this.storyData.metadata.agency) {
              this.agencyQuery = this.storyData.metadata.agency;
            }
            if (this.storyData.metadata.column) {
              this.columnQuery = this.storyData.metadata.column;
            }
            if (this.storyData.metadata.attribution) {
              this.attributionQuery = this.storyData.metadata.attribution;
            }
            if (this.storyData.metadata.primaryLocation) {
              this.primaryLocationQuery = this.storyData.metadata.primaryLocation;
            }
            if(this.storyData.metadata.blogDisclaimer) {
              this.blogDisclaimerEdit = this.storyData.metadata.blogDisclaimer;
            } else {
              this.blogDisclaimerEdit = this.blogDisclaimer;
            }
            this.focusOnHeadline = true;
            if (this.storyData.type === 'photogallery') {
              this.storyData.type = 'gallery';
              this.storyType = 'gallery';
            } else if (this.storyData && (this.storyData.type === 'highlights' || this.storyData.type === 'listicle')) {
              this.storyType = this.storyData.type;
              this.selectedType = this.storyData.type;
              this.sharedService.setValue(this.selectedType);
            } else if (this.storyData && (this.storyData.type === 'newsroom' || this.storyData.type === 'liveblog')) {
              this.storyType = 'liveblog';
              this.selectedType = this.storyData.type;
              this.sharedService.setValue(this.selectedType);
            } else if (this.storyData && (this.storyData.type === 'video')) {
              this.storyType = 'video';
              this.selectedType = this.storyData.type;
              this.sharedService.setValue(this.selectedType);
            } else if (this.storyData && (this.storyData.type === 'web-story')) {
              this.storyType = 'web-story';
              this.selectedType = this.storyData.type;
              this.showWebStoriesTab = true;
            } else {
              this.storyType = this.storyData.type;
            }
            // if (document.getElementById('headline')) {
            //   document.getElementById('headline').focus();
            // }
            this.summaryMaxLength = this.getSummaryMaxLength();
            this.setCalendarDate();
            const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
            const role = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[currentDomain].role;
            if (option && role && (role === 'ROLE_ADMIN' || role === 'ROLE_EDITOR' || role === 'ROLE_SUPER_ADMIN' || role==='ROLE_SITE_MANAGER')) {
              const { timeout, closeOnClick, ...config } = this.sharedService.getConfig('lock'); // Omit props what i don't need
              this.snotify.confirm('Locked by ' + data.lockedByUserName + ', Unlock?', '', {
                ...config,
                buttons: [
                  {
                    text: 'Yes', action: (toast) => {
                      this.snotify.remove(toast.id);
                      this.unlockStory(this.id, flag => {
                        if (flag) {
                          this.lockAcquire(this.id, flag2 => {
                            if (flag2) {
                              this.initStoryView(this.id, false);
                              this.storyEditMode = true;
                              // console.log('edit now');
                            } else {
                              // console.log('lock nhi mila');
                            }
                          });
                        } else {
                          this.changeFlag = false;
                          this.storyEditMode = false;
                        }
                      });
                      this.googleAnalytics("Skippable Alerts",'Locked by ' + data.lockedByUserName + ', Unlock?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' , null);

                    }, bold: false
                  },
                  { text: 'No', action: (toast) => { this.snotify.remove(toast.id); 
                    this.googleAnalytics("Skippable Alerts",'Locked by ' + data.lockedByUserName + ', Unlock?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' , null);
                  } }
                ]
              });
            }

            // Fix for canonical url missing base url
            // If for any reason, canonical url doesn't come with base url, we append base url to it
            if(data && data.metadata && data.metadata.canonicalUrl && data.metadata.canonicalUrl.trim() !== ''){
              if((data.metadata.canonicalUrl as String).charAt(0) == '/'){
                this.storyData.metadata.canonicalUrl = this.sharedService.currentDomainUrl + this.storyData.metadata.canonicalUrl;
              }
            }

          } else {
          }
        },
        error => {
          if (error.status !== 401) {
            setTimeout(e => {
              this.snotify.error('Story Id doesn\'t exist', '', this.sharedService.getConfig(false));
            }, 10);
            this.ngZone.run(() => {
              this.router.navigate(['/lite/dash/workspace']);
            });
          } else {
            this.ngZone.run(() => {
              this.router.navigate(['/login']);
            });
          }
        }
      );
  }

  receiveCardData(ev) {
    if (this.elementDataArray === null) {
      this.elementDataArray = [];
    }
    const index = this.storyData.elements.indexOf(ev.id);
    if (index > -1) {
      this.elementDataArray[index] = ev;
    }
  }

  @HostListener('window:focus', ['$event'])
  onFocus(event: any): void {
    this.windowFocused = true;
  }

  @HostListener('window:blur', ['$event'])
  onBlur(event: any): void {
    this.windowFocused = false;
  }

  toggleBlogCheckbox(){
    this.storyData.metadata.blogDisclaimerFlag = !this.storyData.metadata.blogDisclaimerFlag;
    if(this.storyData.metadata.blogDisclaimerFlag === true) {
      this.storyData.metadata.blogDisclaimer = this.blogDisclaimerEdit;
    } else {
      this.storyData.metadata.blogDisclaimer = '';
    }
  }
  toggleEditDisclaimer() {
    this.editDisclaimer = !this.editDisclaimer;
  }

  initiateSocket(id) {
    const ws = new SockJS(this.serverUrl
      + '?access_token='
      + JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).access_token);
    this.stompClient = Stomp.over(ws);
    this.stompClient.debug = false;
    const self = this;
    const domain = sessionStorage.getItem(StaticDataService.domainLiteral);
    this.stompClient.connect({}, function (frame) {
      console.log('story ' + id + ' socket online!');
      self.stompClient.subscribe('/topic/story-' + id + '-' + domain, (message) => {
        // console.log(JSON.parse(message.body));
        const body = JSON.parse(message.body);

        // console.log(body.metadata.status, (self.storyData ? self.storyData.metadata.status : 'not here'));

        if (
          self.storyData && self.storyEditMode &&
          self.storyData.metadata.status === 'EMBARGO' &&
          body.metadata.status === 'EDITED'
        ) {
          self.storyData.metadata.status = body.metadata.status;
          self.storyData.embargoAt = null;
  
        }

        if (self.storyData && (self.storyData.lockedByUserId !== body.lockedByUserId)) {
          if (self.isLocked) {
            self.storyEditMode = false;
            self.isLocked = false;
            self.destroyStoryAutoSaveInterval();
            self.changeFlag = false;
            self.snotify.warning('Story has now been locked by ' + body.lockedByUserName,
              '', self.sharedService.getConfig(false));
          } else {
            self.snotify.warning('Story has now been locked by ' + body.lockedByUserName,
              '', self.sharedService.getConfig(false));
          }
        }
      },
        err => {
          // console.log('sorry could not subscribe to socket');
        });
    });
  }

  // basicStoryLoading(data) {
  //   if (data['headline'] && (data['headline'] !== '')
  //     && (data['mobileHeadline'] === null || data['mobileHeadline'] === '')) {
  //     this.headline = data['headline'];
  //     data['mobileHeadline'] = data['headline'];
  //   } else {
  //     this.headline = data.mobileHeadline;
  //   }
  //   if (data['metadata']['status'] === 'SCHEDULED') {
  //     this.storyEditMode = false;
  //     if (this.isLocked) {
  //       this.snotify.info('Remove schedule to Edit this story', '', this.sharedService.getConfig(false));
  //     }
  //   } else {
  //     if (this.isLocked) {
  //       this.storyEditMode = true;
  //     } else {
  //       this.storyEditMode = false;
  //     }
  //   }
  //   this.getVersionHistory();
  //   if (data['elements'] && (data['elements'].length > 0)) {
  //     /*  this.viewPortItems = $.extend(true, [], (
  //        (data['elements'].length > this.initialElementCount)
  //          ? data['elements'].slice(0, this.initialElementCount)
  //          : data['elements'])
  //      ); */
  //     this.viewPortItems = Object.assign([], (
  //       (data['elements'].length > this.initialElementCount)
  //         ? data['elements'].slice(0, this.initialElementCount)
  //         : data['elements']));
  //     this.elementCountFlag = true;
  //     this.storyData = data;
  //     this.storyData['elements'] = this.storyData['elements'].filter(e => (e !== null));
  //     this.getElementData(false, data, res => {
  //       // console.log(res);
  //       if (res && (data['type'] === 'story')) {
  //         const len = res.length;
  //         // console.log(res);
  //         // console.log(len);
  //         if (len > 0) {
  //           if (res[len - 1] && res[len - 1]['type'] === 'paragraph') {
  //             this.showTempPara = false;
  //             // this.hideElementId = res[len - 1].id;
  //             this.tempParaId = null;
  //           } else {
  //             this.showTempPara = true;
  //             this.tempParaData = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
  //             this.tempParaData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
  //           }
  //         } else {
  //           this.showTempPara = true;
  //           this.tempParaData = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
  //           this.tempParaData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
  //         }
  //       }
  //     });
  //   } else {
  //     this.storyData = data;
  //     this.showTempPara = true;
  //     this.tempParaData = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
  //     this.tempParaData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
  //     setTimeout(e => {
  //       // this.runWordCountCheck();
  //     }, 30);
  //   }
  //   // console.log(data.summary);
  //   this.summary = data.summary;
  //   setTimeout(e => {
  //     // this.headlineEditor.focus();
  //     if (this.headlineEditor) {
  //       if (this.isCKEditorEnabled) {
  //         this.headlineEditor.editing.view.focus();
  //       } else {
  //         this.headlineEditor.setSelection(
  //           ((data.mobileHeadline && data.mobileHeadline !== null) ? data.mobileHeadline.length : 0)
  //           , 0);
  //       }
  //     }
  //     this.setFocus('headline');
  //     if (data.type === 'story') {
  //       this.getRelatedStoryEmits(null);
  //     }
  //   }, 300);
  //   this.sharedService.setTitle(this.htmlToPlaintext(data.mobileHeadline));
  //   this.checkLastPublishedHeadline();
  //   this.setStoryData(null);
  //   this.discareUrlChanges(false);
  //   if (this.storyData.metadata.section) {
  //     this.sectionQuery = this.storyData.metadata.section;
  //   }
  //   if (this.storyData.metadata.subSection) {
  //     this.subSectionQuery = this.storyData.metadata.subSection;
  //   }
  //   if (this.storyData.metadata.agency) {
  //     this.agencyQuery = this.storyData.metadata.agency;
  //   }
  //   if (this.storyData.metadata.column) {
  //     this.columnQuery = this.storyData.metadata.column;
  //   }
  //   this.focusOnHeadline = true;
  //   if (this.storyData.type === 'photogallery') {
  //     this.storyData.type = 'gallery';
  //     this.storyType = 'gallery';
  //   } else if (this.storyData && (this.storyData.type === 'highlights' || this.storyData.type === 'listicle')) {
  //     this.storyType = this.storyData.type;
  //     this.selectedType = this.storyData.type;
  //   } else if (this.storyData && (this.storyData.type === 'newsroom' || this.storyData.type === 'liveblog')) {
  //     this.storyType = 'liveblog';
  //   } else {
  //     this.storyType = this.storyData.type;
  //   }
  //   this.setCalendarDate();
  // }

 

  manualSave() {
    console.log("check save1");
    const elementMap = JSON.parse(JSON.stringify(this.elementChangeData));
    let manualElementSaveRequests = [];
    let lockAcquireRequest = [];
    let lockReleaseRequest = [];
    const lockAcquireUrl = this.config.get('product').baseUrl + '/api/cms/lock/acquire/article?articleId=';
    const lockReleaseUrl = this.config.get('product').baseUrl + '/api/cms/lock/release/article?articleId=';
    const optionsManual = StaticDataService.options;
    const len = Object.keys(elementMap).length;
    this.sharedService.sendData('saveFlag|true');
    this.saveFlag = true;
    if (len > 0) {
      const token = localStorage.getItem(StaticDataService.tokenLiteral) ?
        JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))
        : null;
      for (let ids in elementMap) {
        if (ids) {
          const cardData = elementMap[ids];
          cardData['lockedByUserId'] = token.email;
          cardData['lockedByUserName'] = token.name;
          lockAcquireRequest.push(this.http.get(lockAcquireUrl + cardData.id));
          lockReleaseRequest.push(this.http.get(lockReleaseUrl + cardData.id));
          const url = this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), StaticDataService.element_page_id, StaticDataService.element_save_api)
            + '/' + String(cardData.id) + '?autoSave=true';
          manualElementSaveRequests.push(this.http.put(url, JSON.stringify(cardData ? cardData : {})
            , optionsManual));
        }
      }

      const idMap = Object.keys(elementMap);
      idMap.forEach(id => {
        const indexOfElement = this.viewPortItems.indexOf(Number(id));
        if (indexOfElement > -1 && this.elReference && this.elReference['_results']
          && this.elReference['_results'][indexOfElement]) {
          this.elReference['_results'][indexOfElement].changeFlag = false;
          this.elReference['_results'][indexOfElement].temporaryChangesFlag = false;
          this.elReference['_results'][indexOfElement].lastCardData = elementMap[id];
        }
      });
      forkJoin(lockAcquireRequest).subscribe(locks => {
        forkJoin(manualElementSaveRequests).subscribe(resultOfManualSave => {
          resultOfManualSave.filter(e => (e && e.hasOwnProperty('id') && !e.hasOwnProperty('error'))).forEach(response => {
            this.Elements[response['id']] = response;
          });
          this.elementChangeData = {};
          if (this.callManualSaveFromVersion) {
            if (this.storyData['type'] == 'photostory') {
              this.storyData['elements'] = this.revertElements;
            }
            //this.reloadStoryAndElements();
            this.storyContainerService.reloadStoryAndElements(this.storyData, this.viewPortItems, this.initialElementCount);
            this.changeDetector.detectChanges();
            this.callManualSaveFromVersion = false;
          }
          this.runWordCountCheck();
          forkJoin(lockReleaseRequest).subscribe(releases => { });
          this.overrideSave();
        }, err => {
          forkJoin(lockReleaseRequest).subscribe(releases => { });
          this.callManualSaveFromVersion = false;
        });
      });
    } else {
      this.overrideSave();
    }
  }

  removeSaved(ev) {
    delete this.elementChangeData[ev];
  }

  getCardDatafromElement(ev) {
    if (ev.id) {
      this.elementChangeData[ev['id']] = ev;
    }
  }


  updateViewPortElements(ev) {
    console.log(ev);
    // this.viewPortItems = $.extend(true, [], ev);
    this.viewPortItems = Object.assign([], ev);
  }

  getUpadtedElementContent(ev) {
    if (ev && ev.id && ev.id !== null) {
      this.Elements[ev.id] = ev;
      // console.log(this.Elements);
    }
  }
  deleteLiveBlogImg(ev) {
    delete (this.Elements[ev]);
    console.log("VVVV")
  }

  serveElementContent(id) {
    if (id && id !== null && this.elementChangeData.hasOwnProperty(id) && this.elementChangeData[id] !== null) {
      return this.elementChangeData[id];
    } else {
      return null;
    }
  }

  checkIfLastIsPara(focus) {
    if (this.storyData && this.storyData !== null && this.storyType === 'story') {
      const len = this.storyData.elements.length;
      const dataForElement = this.Elements[this.storyData.elements[len - 1]];
      // console.log(len, dataForElement);
      if (len > 0) {
        if (!this.hideElementId) {
          if (dataForElement && dataForElement !== null && dataForElement['type'] !== 'paragraph') {
            this.resetLastPara(focus);
          } else {
            this.showTempPara = false;
            this.hideElementId = null;
            this.tempParaData = null;
            this.tempParaId = null;
            this.tempParaData = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
            this.tempParaData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
          }
        } else {
          if (this.storyData.elements[len - 1] !== this.hideElementId) {
            this.showTempPara = false;
            this.hideElementId = null;
            this.tempParaData = null;
            this.tempParaId = null;
            this.tempParaData = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
            this.tempParaData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
          }
        }
      } else {
        this.resetLastPara(focus);
      }
      // } else {
      //   setTimeout(e => {
      //     this.checkIfLastIsPara(focus);
      //   }, 200);
      // }
    }
  }

  resetLastPara(focus) {
    this.showTempPara = false;
    this.hideElementId = null;
    this.tempParaData = null;
    this.tempParaId = null;
    this.tempParaData = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
    this.tempParaData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    setTimeout(e => {
      this.showTempPara = true;
      if (focus) {
        if (this.elRef !== null && this.elRef['last'] !== null) {
          setTimeout(e2 => {
            this.elRef['last'].setFocusOnThis('start');
          }, 150);
        }
      }
      // this.elRef['last'].setFocusOnThis('start');
    }, 50);
  }

  showElementOfTempPara(ev) {
    if ((this.showTempPara) && (this.hideElementId === ev.cardId) && (ev.id === 'newElement')) {
      this.showTempPara = false;
      this.hideElementId = null;
      this.tempParaData = null;
      this.tempParaId = null;
      this.tempParaData = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
      this.tempParaData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      setTimeout(e => {
        this.checkIfLastIsPara(false);
      }, 70);
    }
  }

  lastParaIndex(ev) {
    this.lastindex = ev;
  }

  getTempParaSavedId(ev) {
    // console.log('receiced this emot', ev);
    this.hideElementId = ev.id;
    this.tempParaData = ev;
    this.tempParaId = ev.id;
    if (ev.id) {
      if (this.storyData && this.storyData !== null) {
        if (this.storyData.elements && this.storyData.elements !== null && this.storyData.elements.length > 0) {
          const id = this.storyData.elements[this.storyData.elements.length - 1];
          const ind = this.viewPortItems.indexOf(id);
          if (ind > -1) {
            this.viewPortItems.splice(ind + 1, 0, ev.id);
          }
        } else {
          this.viewPortItems.push(ev.id);
        }
      }
      this.storyData.elements.push(ev.id);
    }
  }

  getElementData(saveflag, data, callback) {
    // console.log(data);
    const elements = data ? data : null;
    if (elements && (elements.length > 0)) {
      // console.log('got elements in story');
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.all_element_api),
        elements,
        res => {
          // console.log(this.storyData.elements);
          if (saveflag) {
            this.elementDataArray = res;

          }
          // console.log(res);
          if (res && (res !== null) && !res.hasOwnProperty('error')) {
            for (const el of res) {
              this.getUpadtedElementContent(el);
            }
            callback(res);
          } else {
            callback(null);
          }
        });
    } else {
      // console.log('no elements to load');
      callback(null);
    }
  }

  setCalendarDate() {
    if (this.storyData !== null && this.picker && this.picker !== null) {
      const nowDate2 = new Date();
      if (this.storyData.metadata.status === 'SCHEDULED' && this.storyData.scheduledAt && this.storyData.scheduledAt !== null) {
        const nowDate = new Date(this.storyData.scheduledAt);
        this.singleCalendarConfig['startDate'] =
          (((nowDate.getMonth() + 1) > 10) ? (nowDate.getMonth() + 1) : '0' + (nowDate.getMonth() + 1))
          + '/' + ((nowDate.getDate() > 10) ? nowDate.getDate() : '0' + nowDate.getDate())
          + '/' + nowDate.getFullYear();
        this.picker.datePicker.setStartDate(this.singleCalendarConfig['startDate']);
      } else if (this.storyData.metadata.status === 'EMBARGO' && this.storyData.embargoAt && this.storyData.embargoAt !== null) {
        const nowDate = new Date(this.storyData.embargoAt);
        this.singleCalendarConfig['startDate'] =
          (((nowDate.getMonth() + 1) > 9) ? (nowDate.getMonth() + 1) : '0' + (nowDate.getMonth() + 1))
          + '/' + ((nowDate.getDate() > 9) ? nowDate.getDate() : '0' + nowDate.getDate())
          + '/' + nowDate.getFullYear();
        // this.picker.datePicker.setStartDate(this.singleCalendarConfig['startDate']);
      } else {
        this.singleCalendarConfig['startDate'] =
          (((nowDate2.getMonth() + 1) > 9) ? (nowDate2.getMonth() + 1) : '0' + (nowDate2.getMonth() + 1))
          + '/' + ((nowDate2.getDate() > 9) ? nowDate2.getDate() : '0' + nowDate2.getDate())
          + '/' + nowDate2.getFullYear();
        // this.picker.datePicker.setStartDate(this.singleCalendarConfig['startDate']);
      }
      this.singleCalendarConfig['minDate'] =
        (((nowDate2.getMonth() + 1) > 9) ? (nowDate2.getMonth() + 1) : '0' + (nowDate2.getMonth() + 1))
        + '/' + ((nowDate2.getDate() > 9) ? nowDate2.getDate() : '0' + nowDate2.getDate())
        + '/' + nowDate2.getFullYear();
      // this.picker.datePicker.setEndDate(this.singleCalendarConfig['minDate']);
    }
  }

  customFunc(ev) {
  }

  specialCharBlock(e){
    //       97 - 122 (a-z)
    //       65 - 90 (A-Z)
    //       48 - 57 (0-9)
    //config base + default ascii code
    if (e.which < 48 ||
      (e.which > 57 && e.which < 65 ) ||
      (e.which > 90 && e.which < 97) ||
      e.which > 122) {
        if(!!this.allowspecialChar && !this.allowspecialChar.includes(e.which) && this.disabledMetaFields.indexOf('blockspecialchar')==-1){
          e.preventDefault();
        }
  }
  }


  private lastSavedStory:any;
  saveStory(redirectFlag) {
  

   /* if(this.lastSavedStory)
    {
      this.lastSavedStory.lastModifiedDate=cloneDeep(this.storyData.lastModifiedDate);
      this.lastSavedStory['lastModifiedDate'] = this.storyData['lastModifiedDate'];
                    this.lastSavedStory['lastModifiedByUserName'] = this.storyData['lastModifiedByUserName'];
                    this.lastSavedStory['lastModifiedBy'] = this.storyData['lastModifiedBy'];
                    this.lastSavedStory['lastPublishedDate'] = this.storyData['lastPublishedDate'];
                    this.lastSavedStory['lastPublishedBy'] = this.storyData['lastPublishedBy'];
                    this.lastSavedStory['lastPublishedByUserName'] = this.storyData['lastPublishedByUserName'];
                    this.lastSavedStory['firstPublishedDate'] = this.storyData['firstPublishedDate'];
    }*/
     if (this.storyType !== 'deadlink' && !this.disableElement('story-save') && ((this.publishFlag || this.saveFlag) ? true : (this.changeFlag && this.saveInQueue === 0))) {
      /// this.runWordCountCheck();
      
      this.saveInQueue += 1;
      this.storyLoaded = false;
      if (this.storyData !== null) {
        if (!this.publishFlag) {
          this.storyData.softPublished = false;
        } else {
          this.storyData.lastPublishedHeadline = this.htmlToPlaintext(this.storyData.mobileHeadline);
          if (this.isNewsletterFieldsEnabled()) {
            this.storyData.lastPublishedSummary = this.htmlToPlaintext(this.storyData.summary);
          }
        }
        const headline = this.htmlToPlaintext(this.storyData.headline) !== '' ?
          this.htmlToPlaintext(this.storyData.headline) : this.htmlToPlaintext(this.storyData.mobileHeadline);
        this.storyData.title = headline;
        this.storyData.titleWoSpChar = headline;
        this.storyData.autoPublished = false;
        if (!this.storyData.expireAt && this.storyType === 'liveblog' && this.publishFlag &&
          sessionStorage.getItem(StaticDataService.domainLiteral) === '5c1c93e66a2ec202bb648bbb') {
          const actualDate = new Date();
          const epoch = new Date(actualDate.getFullYear(), actualDate.getMonth(), actualDate.getDate(), 23, 59, 59).getTime();
          this.storyData.expireAt = epoch;
        }
        if (this.saveFlag) {
          this.snotify.clear();
          this.snotify.success('SAVED', '', this.sharedService.getConfig(false));
          this.saveFlag = false;
          this.sharedService.sendData('saveFlag|false');
        }
        if (this.storyData.id !== null && String(this.storyData.id) !== '') {
          if (this.isLocked) {
            if ((this.storyData.related === undefined) || (this.storyData.related === null) || (this.storyData.related.length < 1)) {
              this.storyData.showRelated = false;
            }
            const tempPublishFlag = this.publishFlag;
            if (tempPublishFlag && !!this.storyData) {
              this.storyData.metadata.paraContentChanged = false;
            }
            if (this.domainConfig['config']['story']['restrictSection'] && (this.storyType === 'gallery' || this.storyType === 'video')) {
              if ((this.storyType === 'gallery' && (this.sectionQuery === 'photos' || this.sectionQuery === this.domainConfig['config']['story']['defaultPhotogallerySection']))
                  || (this.storyType === 'video' && this.sectionQuery === 'videos'))
                this.storyData.metadata.section = this.sectionQuery;
            }
            var clonedStory = this.sharedService.checkhrefandreplace(this.storyData);  
            this.setWordCountToStory(clonedStory);
           console.log();
            this.restService.http_put(this.config.get('product').baseUrl
              + this.config.getEndPoint(this.config.get('views'), this.page_id, this.save_api)
              + String(this.storyData.id) + (this.publishFlag ? '' : '?autoSave=true'),
              clonedStory,
              result => {
                if (result && !result.hasOwnProperty('error')) {

                  this.retryLimit = 10;

                  if ((result.webId || result.wireFeedId) && (this.domainConfig['config']
                    && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['disableHeadlineLimit'] === 'true')) {
                    this.headlineMaxLength = this.getHeadlineMaxLength(true);
                    this.showHeadlineerror = true;
                  }
                  if (tempPublishFlag) {
                    if (result.metadata.status === 'PUBLISHED' && this.storyType === 'liveblog') {
                      this.updatePublishedDateOfElements();
                      this.closeErrorModal();
                    }
                    if (result.metadata.status === 'SCHEDULED') {
                      this.storyEditMode = false;
                      this.checkIfScheduleIsPublished();
                      this.snotify.info('Remove schedule to Edit this story', '', this.sharedService.getConfig(false));
                    }

                    if (this.versionHistory && this.versionHistory.hasOwnProperty('changes')) {
                      const lastVersion = this.versionHistory['changes'][this.versionHistory['changes'].length - 1];
                      if (this.liveBlogEndTimeFlag === true) {
                        this.snotify.clear();
                        this.snotify.success('End time of liveblog changed successfully', '', this.sharedService.getConfig(false));
                        
                        this.liveBlogEndTimeFlag = false;
                      }
                      else if (this.storyData && this.storyData.softPublished) {
                        this.snotify.clear();
                        this.plagiarismPrompt();
                        this.snotify.success('Soft Published successfully', '', this.sharedService.getConfig(false));
                      } else if (lastVersion.metadata.status === 'PUBLISHED' && result.metadata.status === 'PUBLISHED') {
                        this.snotify.clear();
                        this.plagiarismPrompt();
                        this.snotify.success('Updated and published successfully', '', this.sharedService.getConfig(false));
                      } else if (result.metadata.status === 'PUBLISHED') {
                        this.snotify.clear();
                        this.plagiarismPrompt();
                        this.snotify.success('Published successfully', '', this.sharedService.getConfig(false));
                      }
                    } else {
                      if (this.storyData && this.storyData.softPublished) {
                        this.snotify.clear();
                        this.plagiarismPrompt();
                        this.snotify.success('Soft Published successfully', '', this.sharedService.getConfig(false));
                      } else if (result.metadata.status === 'PUBLISHED') {
                        this.snotify.clear();
                        this.plagiarismPrompt();
                        this.snotify.success('Published successfully', '', this.sharedService.getConfig(false));
                      }
                    }
                    if (result['metadata']['url'] && result['metadata']['url'].trim() !== '') {
                      this.storyData['metadata']['url'] = result['metadata']['url'];
                      this.checkCanoicalUrl(result['metadata']['url']);
                    }
                  }
                  // console.log(result.metadata);
                  if (this.storyData !== null) {
                    this.storyData['metadata']['sectionId'] = result['metadata']['sectionId'];
                    this.storyData['metadata']['subSectionId'] = result['metadata']['subSectionId'];
                    this.storyData['metadata']['sectionUrl'] = result['metadata']['sectionUrl'];
                    this.storyData['metadata']['subSectionUrl'] = result['metadata']['subSectionUrl'];
                    this.storyData['metadata']['subSectionL2Id'] = result['metadata']['subSectionL2Id'];
                    this.storyData['metadata']['topicIds'] = result['metadata']['topicIds'];
                    this.storyData['metadata']['topicUrls'] = result['metadata']['topicUrls'];
                    this.storyData['metadata']['isParallelPublished'] = result['metadata']['isParallelPublished'];
                    this.storyData['metadata']['parallelPublish'] = result['metadata']['parallelPublish'];
                    this.storyData['metadata']['parallelPublishedStories'] = result['metadata']['parallelPublishedStories'];
                    this.storyData['lastModifiedDate'] = result['lastModifiedDate'];
                    this.storyData['lastModifiedByUserName'] = result['lastModifiedByUserName'];
                    this.storyData['lastModifiedBy'] = result['lastModifiedBy'];
                    this.storyData['lastPublishedDate'] = result['lastPublishedDate'];
                    this.storyData['lastPublishedBy'] = result['lastPublishedBy'];
                    this.storyData['lastPublishedByUserName'] = result['lastPublishedByUserName'];
                    this.storyData['firstPublishedDate'] = result['firstPublishedDate'];
                    this.storyData['embargoDate'] = result['embargoDate'];
                    this.storyData['embargoBy'] = result['embargoBy'];
                    this.storyData['scheduledBy'] = result['scheduledBy'];
                    this.storyData['scheduledDate'] = result['scheduledDate'];
                    this.storyData['expiryDate'] = result['expiryDate'];
                    this.storyData['lockedByUserId'] = result['lockedByUserId'];
                    this.storyData['lockedByUserName'] = result['lockedByUserName'];
                    this.storyData['metadata']['topic'] = result['metadata']['topic'];
                    this.storyData['lockedDate'] = result['lockedDate'];
                    this.storyData['readByUsers'] = result['readByUsers'];
                    this.storyData['metadata']['killed'] = result['metadata']['killed'];
                    this.storyData['metadata']['killedStatusCode'] = result['metadata']['killedStatusCode'];
                    this.storyData['metadata']['redirectUrl'] = result['metadata']['redirectUrl'];
                    this.storyData['leadMedia']['elements'] = result['leadMedia']['elements'];
                    this.storyData['leadMedia']['defaultImage'] = result['leadMedia']['defaultImage'];
                    this.storyData['webEngageScheduledDate'] = result['webEngageScheduledDate'];
                    this.storyData['quickReadSummary']=result['quickReadSummary'];
                    this.storyData['quickReadStatus']=result['quickReadStatus'];
                    this.storyData['isrelatedVideoAdded'] = false;
                    setTimeout(() => {
                      this.refreshChildImages();
                    }, 3500);
                    if (this.storyType === 'liveblog') {
                      this.storyData['metadata']['sectionSpecificDefaultTags'] = result['metadata']['sectionSpecificDefaultTags'];
                    }
                    if (result.metadata.status === 'PUBLISHED') {
                      this.storyData['metadata']['seoUrl'] = result['metadata']['seoUrl'];
                    }
                  }
                  if(!!this.storyData && this.storyData['relatedVideoElementIds'] && this.storyData['relatedVideoElementIds'].length > 0) {
                    this.snotify.success(this.storyData['relatedVideoElementIds'].length + ' video' + ((this.storyData['relatedVideoElementIds'].length > 1) ? 's' : '')+' embedded successfully.', '', this.sharedService.getConfig(false));
                    this.storyData['relatedVideoElementIds'] = [];
                  }

                  if (tempPublishFlag && !!this.storyData) {
                   // this.storyData.metadata.paraContentChanged = false;
                    // console.log("paragraph changed ----- ", this.storyData.metadata.paraContentChanged)
                    this.publishFlag = false;
                  }
                  if(tempPublishFlag) {
                    for (const id of this.storyData.elements) {
                      const data = this.Elements[id];
                      const index = this.viewPortItems.indexOf(id);
                      if (index > -1) {
                        this.elReference['_results'][index].loadView(false);
                      }
                    }
                  }
                  this.saveInQueue -= 1;
                  this.setStoryData(result);
                  this.setCalendarDate();
                  this.sharedService.sendData('saved|false');
                  this.setImageCaption(result);
                  this.sharedService.setTitle(this.htmlToPlaintext(result.mobileHeadline));
                  if (redirectFlag && (String(this.id) !== String(result.id))) {
                    // this.ovee
                    // this.router.navigate(['dash/story/' + String(result.id)]);
                    console.log('story id has changed', 'this is a miracle');
                    console.log('pehle wali id => ' + this.id);
                    console.log('nayi wali id => ' + result.id);
                  }

                } else {
                  // console.log(result);
                  // lock here
                  this.retryLimit = this.retryLimit - 1;
                  this.saveInQueue -= 1;
                  if (result.status === 423) {
                    this.storyEditMode = false;
                    this.destroyStoryAutoSaveInterval();
                    this.changeFlag = false;
                    this.snotify.warning('someone locked this story forcefully',
                      'Forcefully locked', this.sharedService.getConfig(false));
                  } else if (result.status === 403) {
                    this.storyEditMode = false;
                    this.destroyStoryAutoSaveInterval();
                    this.changeFlag = false;
                    this.snotify.error('You don’t have permission to edit a story', '', this.sharedService.getConfig(false));
                  } else if ((StaticDataService.codeForSeperateMessage.indexOf(result.status) < 0)
                    && (this.lastResponseCode !== result.status)) {
                    this.snotify.error('There was some error', 'Something bad happened', this.sharedService.getConfig(false));
                  }

                }

                setTimeout(e => {
                  this.lastResponseCode = result.status;
                }, 1);
              });
            this.publishFlag = false;
          } else {
            // console.log('change detected but lock is not acquired');
          }
        } else {
          this.storyData.id = null;
          if (!this.storyData.mobileHeadline || this.storyData.mobileHeadline.trim() === '') {
            this.storyData.mobileHeadline = 'Untitled Story';
            this.headline = 'Untitled Story';
          }
          if (!this.showLanuageTab && this.originalStory && this.originalStory['headline']) {
            if (this.isStoryUrlCreatedFromHeadline) {
              this.storyData.headline = this.originalStory['headline'];
            }
            else {
              this.storyData.urlHeadline = this.originalStory['headline'];
            }
          }
          this.restService.http_post(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), this.page_id, this.save_api),
            this.sharedService.checkhrefandreplace(this.storyData), result => {

              if (!result.hasOwnProperty('error')) {
                this.disableSelectType = true;
                // console.log(this.id + '----------' + result.id);
                if (redirectFlag && (this.id !== String(result.id))) {
                  // this.router.navigate(['/dash/story/' + String(result.id)]);
                }

                if (this.storyData !== null) {
                  this.storyData['lastModifiedDate'] = result['lastModifiedDate'];
                  this.storyData['lastModifiedByUserName'] = result['lastModifiedByUserName'];
                  this.storyData['lastModifiedBy'] = result['lastModifiedBy'];
                  this.storyData['lastPublishedDate'] = result['lastPublishedDate'];
                  this.storyData['lastPublishedBy'] = result['lastPublishedBy'];
                  this.storyData['lastPublishedByUserName'] = result['lastPublishedByUserName'];
                  this.storyData['firstPublishedDate'] = result['firstPublishedDate'];
                  this.storyData['embargoDate'] = result['embargoDate'];
                  this.storyData['embargoBy'] = result['embargoBy'];
                  this.storyData['scheduledBy'] = result['scheduledBy'];
                  this.storyData['scheduledDate'] = result['scheduledDate'];
                  this.storyData['expiryDate'] = result['expiryDate'];
                  this.storyData['lockedByUserId'] = result['lockedByUserId'];
                  this.storyData['lockedByUserName'] = result['lockedByUserName'];
                  this.storyData['lockedDate'] = result['lockedDate'];
                  this.storyData['readByUsers'] = result['readByUsers'];
                  this.storyData['createdBy'] = result['createdBy'];
                  this.storyData['metadata']['killed'] = result['metadata']['killed'];
                  this.storyData['metadata']['killedStatusCode'] = result['metadata']['killedStatusCode'];
                  this.storyData['metadata']['redirectUrl'] = result['metadata']['redirectUrl'];
                  this.storyData['leadMedia']['elements'] = result['leadMedia']['elements'];
                  this.storyData['leadMedia']['defaultImage'] = result['leadMedia']['defaultImage'];
                  if ((result.webId || result.wireFeedId) && (this.domainConfig['config']
                    && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['disableHeadlineLimit'] === 'true')) {
                    this.headlineMaxLength = this.getHeadlineMaxLength(true);
                    this.showHeadlineerror = true;
                  }
                }

                this.sharedService.setTitle(this.htmlToPlaintext(result.mobileHeadline));

                this.storyData['createdDate'] = result['createdDate'];
                if (this.publishFlag) {
                  this.publishFlag = false;
                }

                this.id = result.id;
                this.storyData.id = result.id;
                this.saveInQueue -= 1;

                this.setStoryData(result);
                this.sharedService.sendData('saved|false');
                this.location.replaceState('/lite/dash/story/' + result.id);
                this.isLocked = true;
                this.id = result.id;
              } else if (StaticDataService.codeForSeperateMessage.indexOf(result.status) < 0) {
                this.saveInQueue -= 1;
                this.snotify.error('There was some error', 'Something bad happened', this.sharedService.getConfig(false));
              }

              setTimeout(e => {
                this.lastResponseCode = result.status;
              }, 1);
            });
        }
      } else {
        // console.log('storyData is null');
      }
      console.log('Set word count last'+this.changeFlag);
    }
    if (this.storyType === 'deadlink' && !this.disableElement('story-save') && ((this.publishFlag || this.saveFlag) ? true : (this.changeFlag && this.saveInQueue === 0))) {
      this.saveInQueue += 1;
      this.storyLoaded = false;
      // if (this.saveFlag) {
      //   this.snotify.clear();
      //   this.snotify.success('SAVED', '', this.sharedService.getConfig(false));
      //   this.saveFlag = false;
      //   this.sharedService.sendData('saveFlag|false');
      // }
      this.storyData.autoPublished = false;
      if (this.storyData !== null) {
        const headline = this.htmlToPlaintext(this.storyData.headline) !== '' ?
          this.htmlToPlaintext(this.storyData.headline) : this.htmlToPlaintext(this.storyData.mobileHeadline);
        this.storyData.title = headline;
        this.storyData.titleWoSpChar = headline;
      }
      if (this.storyData.id !== null && String(this.storyData.id) !== '') {
        if (this.isLocked) {
          if ((this.storyData.related === undefined) || (this.storyData.related === null) || (this.storyData.related.length < 1)) {
            this.storyData.showRelated = false;
          }
          const tempPublishFlag = this.publishFlag;
          this.restService.http_put(this.config.get('product').baseUrl
            + '/api/cms/story/deadlink/'
            + String(this.storyData.id) + (this.publishFlag ? '' : '?autoSave=true'),
            this.sharedService.checkhrefandreplace(this.storyData),
            result => {
              if (result && !result.hasOwnProperty('error')) {

                if ((result.webId || result.wireFeedId) && (this.domainConfig['config']
                  && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['disableHeadlineLimit'] === 'true')) {
                  this.headlineMaxLength = this.getHeadlineMaxLength(true);
                  this.showHeadlineerror = true;
                }

                // console.log(result.metadata);
                if (this.storyData !== null) {
                  this.storyData['lastModifiedDate'] = result['lastModifiedDate'];
                  this.storyData['lastModifiedByUserName'] = result['lastModifiedByUserName'];
                  this.storyData['lastModifiedBy'] = result['lastModifiedBy'];
                  this.storyData['lastPublishedDate'] = result['lastPublishedDate'];
                  this.storyData['lastPublishedBy'] = result['lastPublishedBy'];
                  this.storyData['lastPublishedByUserName'] = result['lastPublishedByUserName'];
                  this.storyData['firstPublishedDate'] = result['firstPublishedDate'];
                  this.storyData['leadMedia']['elements'] = result['leadMedia']['elements'];
                  this.storyData['leadMedia']['defaultImage'] = result['leadMedia']['defaultImage'];
                }
                if (result.metadata.status === 'PUBLISHED' && tempPublishFlag === true) {
                  this.snotify.clear();
                  this.plagiarismPrompt();
                  this.snotify.success('Published successfully', '', this.sharedService.getConfig(false));
                }
                if (tempPublishFlag) {
                  this.publishFlag = false;
                }

                this.saveInQueue -= 1;
                this.setStoryData(result);
                this.setCalendarDate();
                this.sharedService.sendData('saved|false');
                this.setImageCaption(result);
                this.sharedService.setTitle(this.htmlToPlaintext(result.mobileHeadline));
                if (redirectFlag && (String(this.id) !== String(result.id))) {
                  // this.ovee
                  // this.router.navigate(['dash/story/' + String(result.id)]);
                  console.log('story id has changed', 'this is a miracle');
                  console.log('pehle wali id => ' + this.id);
                  console.log('nayi wali id => ' + result.id);
                }

              } else {
                // console.log(result);
                // lock here
                this.saveInQueue -= 1;
                if (result.status === 423) {
                  this.storyEditMode = false;
                  this.destroyStoryAutoSaveInterval();
                  this.changeFlag = false;
                  this.snotify.warning('someone locked this story forcefully',
                    'Forcefully locked', this.sharedService.getConfig(false));
                } else if (result.status === 403) {
                  this.storyEditMode = false;
                  this.destroyStoryAutoSaveInterval();
                  this.changeFlag = false;
                  this.snotify.error('You don’t have permission to edit a story', '', this.sharedService.getConfig(false));
                } else if ((StaticDataService.codeForSeperateMessage.indexOf(result.status) < 0)
                  && (this.lastResponseCode !== result.status)) {
                  this.snotify.error('There was some error', 'Something bad happened', this.sharedService.getConfig(false));
                }

              }

              setTimeout(e => {
                this.lastResponseCode = result.status;
              }, 1);
            });
          this.publishFlag = false;
        } else {
          // console.log('change detected but lock is not acquired');
        }
      } else {
        this.storyData.id = null;
        if (!this.storyData.mobileHeadline || this.storyData.mobileHeadline.trim() === '') {
          this.storyData.mobileHeadline = 'Untitled Story';
          this.headline = 'Untitled Story';
        }
        if (!this.showLanuageTab && this.originalStory && this.originalStory['headline']) {
          if (this.isStoryUrlCreatedFromHeadline) {
            this.storyData.headline = this.originalStory['headline'];
          }
          else {
            this.storyData.urlHeadline = this.originalStory['headline'];
          }
        }
        this.restService.http_post(this.config.get('product').baseUrl + '/api/cms/story/deadlink',
          this.sharedService.checkhrefandreplace(this.storyData), result => {

            if (!result.hasOwnProperty('error')) {
              this.disableSelectType = true;

              if (this.storyData !== null) {
                if ((result.webId || result.wireFeedId) && (this.domainConfig['config']
                  && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['disableHeadlineLimit'] === 'true')) {
                  this.headlineMaxLength = this.getHeadlineMaxLength(true);
                  this.showHeadlineerror = true;
                }
              }

              this.sharedService.setTitle(this.htmlToPlaintext(result.mobileHeadline));

              this.storyData['createdDate'] = result['createdDate'];

              if (this.publishFlag) {
                this.publishFlag = false;
              }

              this.id = result.id;
              this.storyData.id = result.id;
              this.saveInQueue -= 1;

              this.setStoryData(result);
              this.sharedService.sendData('saved|false');
              this.location.replaceState('/lite/dash/story/' + result.id);
              this.isLocked = true;
              this.id = result.id;
            } else if (StaticDataService.codeForSeperateMessage.indexOf(result.status) < 0) {
              this.saveInQueue -= 1;
              this.snotify.error('There was some error', 'Something bad happened', this.sharedService.getConfig(false));
            }

            setTimeout(e => {
              this.lastResponseCode = result.status;
            }, 1);
          });
      }
      this.changeFlag = true;
    }
  }
  plagiarismPrompt() {
    if(!this.enablePlagiarism || (this.storyData.metadata.plagiarismChecked
      && !this.storyData.metadata.paraContentChanged)) {
        if(this.plagData && parseInt(this.plagData.plagPercent) > this.maxPlagiarism) {
        this.snotify.info('Article is more than ' + this.maxPlagiarism + '% Plagiarized', '', this.sharedService.getConfig(false));
        }
    }
  }

  checkIfScheduleIsPublished() {
    if (
      this.storyData && this.storyData.metadata
      && this.storyData.metadata.status && (this.storyData.metadata.status === 'SCHEDULED')
      && this.storyData.scheduledAt && (this.storyData.scheduledAt !== null)
    ) {
      const timeRightNow = new Date();
      if (timeRightNow.getTime() < this.storyData.scheduledAt) {
        setTimeout(e => {
          this.checkIfScheduleIsPublished();
        }, 45000);
      } else {
        this.restService.http_get(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), this.page_id, this.get_api)
          + '/' + this.storyData.id)
          .subscribe(
            data => {
              // console.log(data);
              if (!data.hasOwnProperty('error')) {
                if (data.metadata.status === 'PUBLISHED') {
                  // this.basicStoryLoading(data);
                  this.storyEditMode = true;
                  this.storyData.metadata.status = data.metadata.status;
                  this.storyData.metadata.canonicalUrl = data.metadata.canonicalUrl;
                  this.storyData.metadata.seoUrl = data.metadata.seoUrl;
                  this.storyData.lastPublishedBy = data.lastPublishedBy;
                  this.storyData.lastPublishedByUserName = data.lastPublishedByUserName;
                  this.storyData.lastPublishedDate = data.lastPublishedDate;
                  this.storyData.scheduledAt = null;
                } else {
                  console.log('error occured : TBC');
                  setTimeout(e => {
                    this.checkIfScheduleIsPublished();
                  }, 45000);
                }
              } else {
                console.log('error occured : TBC');
                setTimeout(e => {
                  this.checkIfScheduleIsPublished();
                }, 45000);
              }
            });
      }
    }
  }

  refreshChildImages() {
    if(this.leadelRef['_results'][0]) {
      this.leadelRef['_results'][0].refreshImage()
    }
    if(!!this.storyData && this.storyData.elements.length>0){
    for (const id of this.storyData.elements) {
      const data = this.Elements[id];
      const index = this.viewPortItems.indexOf(id);
      if (index > -1) {
       if(this.elReference['_results'][index] && this.elReference['_results'][index].cardType === 'image') {
         if(this.elReference['_results'][index].cardData.image.images) {
          this.elReference['_results'][index].refreshImage();
         }
       }
      }
    }
  }
  }

  updatePublishedDateOfElements() {
    setTimeout(e6 => {
      for (const id of this.storyData.elements) {
        const data = this.Elements[id];
        const index = this.viewPortItems.indexOf(id);
        if (index > -1 &&  this.elReference['_results'][index]) {
          this.elReference['_results'][index].triggerFetchUpdate(null);
        } else {
          if (!data.firstPublishedDate || data.firstPublishedDate === null) {
            this.restService.http_get(
              this.config.get('product').baseUrl
              + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
              + '/'
              + String(id)
            )
              .subscribe(
                data2 => {
                  this.Elements[id]['metadata']['status'] = data2['metadata']['status'];
                  this.Elements[id]['firstPublishedDate'] = data2['firstPublishedDate'];
                  this.Elements[id]['lastModifiedDate'] = data2['lastModifiedDate'];
                  this.Elements[id]['lastModifiedByUserName'] = data2['lastModifiedByUserName'];
                  this.Elements[id]['lastModifiedBy'] = data2['lastModifiedBy'];
                  this.Elements[id]['lastPublishedDate'] = data2['lastPublishedDate'];
                  this.Elements[id]['lastPublishedBy'] = data2['lastPublishedBy'];
                  this.Elements[id]['lastPublishedByUserName'] = data2['lastPublishedByUserName'];
                  this.Elements[id]['firstPublishedDate'] = data2['firstPublishedDate'];
                },
                error => {
                  // could not fetch date
                });
          }
        }
      }
    }, 600);
  }

  setStoryData(data) {
    if (data !== null && this.storyData !== null) {
      // this.storyData = data;
      this.storyData.lockedByUserId = data.lockedByUserId;
      this.storyData.lockedByUserName = data.lockedByUserName;
      this.storyData.lockedDate = data.lockedDate;
      // to update something in story
    }
    this.storyLoaded = true;
    this.checkStateOfStory();
    this.changeFlag = false;
    console.log('word count set change '+false);
    this.storySetFlag = true;
  }
  getKeywordsForStory(){
    let eventCategory='Recosense';
    let eventAction=sessionStorage.getItem(StaticDataService.tenantName);
    let eventLabel='';
    let eventValue=null;
   this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
   if(this.id !='new'){
    const top = 3;
    let keywords:any;
    let existingKeyowrds:any=this.storyData.metadata.keywords;
    this.snotify.info('Fetching Keywords', '', this.sharedService.getConfig(false));
    this.restService.http_get(
      this.config.get('product').utilUrl
      + this.config.getEndPoint(this.config.get('views'), this.page_id, this.keywords_generate_api)
      + '/' +this.storyData.id)
      .subscribe((res)=>{
        this.recosensejsonData=res;
        if(!!this.recosensejsonData){
          keywords=this.recosensejsonData.data['rank_wise_tags'].non_ranked_imp_tags;
          keywords= [...Array.from(new Set(keywords))]//remove duplicate for ES5 & above
          this.storyData.metadata.recosenseKeywords=[...Array.from(new Set(keywords))];
          // keywords=keywords.slice(0,top);//top size logic
          keywords.push(...existingKeyowrds)
          //recosenseKeyword;

           this.storyData.metadata.keywords=[...Array.from(new Set(keywords))];
           this.storyData.metadata.keywords=[...Array.from(new Set(this.storyData.metadata.keywords))]
        }
            else{
            this.snotify.error('No Suggested Keywords Found', '', this.sharedService.getConfig(false));
          }
      },
      (err)=>console.log(err))
   }else{
     this.snotify.error('Headline cannot be Blank', '', this.sharedService.getConfig(false));
   }

  }
  getTagsForStory() {
    if (!this.tagResetFlag) {
      let j = 0;
      for (const tag of this.suggestTagsTemp) {
        if (this.suggestTags.indexOf(tag) < 0 && j < 5) {
          // console.log(tag);
          this.suggestTags.push(tag);
          j++;
        }
      }
    } else {
      if (this.storyData.elements.length > 0) {
        this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), this.page_id, this.all_element_api),
          this.storyData.elements,
          res => {
            // console.log(res);
            let body = '';
            for (let i = 0; i <= res.length; i++) {
              if (i < res.length) {
                const element = res[i];
                // console.log(element.type);
                if (element.type === 'paragraph') {
                  body += element.paragraph.body;
                }
                if (element.type === 'image') {
                  body += (element.image.caption !== null) ? (element.image.caption + '.') : '';
                }
                if (element.type === 'listicle' || element.type === 'highlights') {
                  body += (element.title !== null) ? (element.title + '.') : '';
                  body += (element.listicle.body !== null) ? (element.listicle.body + '.') : '';
                }
                if (element.type === 'liveblog') {
                  body += (element.title !== null) ? (element.title + '.') : '';
                  body += (element.liveBlog.body !== null) ? (element.liveBlog.body + '.') : '';
                }
              }
              if (i === res.length) {
                // console.log(body);
                if (this.storyType === 'liveblog' || this.storyType === 'listicle') {
                  body += (this.storyData.introBody !== null) ? (this.storyData.introBody + '.') : '';
                }
                this.snotify.info('Fetching tags', '', this.sharedService.getConfig(false));

                const headline = this.htmlToPlaintext(this.storyData.mobileHeadline);
                const summary = this.htmlToPlaintext(this.storyData.summary);
                const body2 = this.htmlToPlaintext(body);
                this.restService.http_tag(
                  String(Math.round((new Date()).getTime())),
                  headline,
                  summary,
                  body2,
                  res2 => {
                    this.suggestTags = [];
                    this.suggestTagsTemp = [];
                    this.addNewTags(JSON.parse(res2['_body']), ret => {
                      this.snotify.clear();
                      this.tagResetFlag = false;
                      // console.log(this.suggestTagsTemp);
                      if (this.suggestTagsTemp.length > 5) {
                        this.suggestTags = Object.assign([], this.suggestTagsTemp.slice(0, 5));
                        // this.suggestTagsTemp.splice(0, 5);
                      } else {
                        this.suggestTags = Object.assign([], this.suggestTagsTemp);
                        // this.suggestTagsTemp = [];
                      }
                      // console.log(this.suggestTags);
                    });
                  });
              }
            }
          });
      }
    }
    this.focusedCard = null;
    this.lastindex = null;
  }

  addNewTags(tagList: any[], callback) {
    for (let i = 0; i <= tagList.length; i++) {
      const tag = tagList[i];
      if (i < tagList.length) {
        if (this.storyData.metadata.tags.indexOf(tag.keyword) < 0) {
          this.suggestTagsTemp.push(tag.keyword);
        }
      }
      if (i === tagList.length) {
        callback('done');
      }
    }
  }

  removeTagFromSuggest(ev) {
    this.suggestTagsTemp.splice(this.suggestTagsTemp.indexOf(this.suggestTags[ev]), 1);
    this.suggestTags.splice(ev, 1);
  }

  openSummaryPopup(displayFlag) {
    this.tempStoryData.newsletterSummary = this.storyData ?
      ((this.storyData.newsletterSummary && this.storyData.newsletterSummary.trim() !== '') ?
        this.storyData.newsletterSummary.trim() : this.htmlToPlaintext(this.storyData.summary))
      : '';
    this.tempStoryData.quickReadSummary = this.storyData ?
      ((this.storyData.quickReadSummary && this.storyData.quickReadSummary.trim() !== '') ?
        this.storyData.quickReadSummary.trim() : this.htmlToPlaintext(this.storyData.quickReadSummary))
      : '';
    this.temporaryChangesFlag = false;
    this.lastStoryTempData = JSON.stringify(this.tempStoryData);
    this.previousStoryState = JSON.stringify(this.tempStoryData);
    this.summaryPopup = displayFlag;
    this.focusHeadline();
    if (displayFlag) {
      this.sharedService.overflowhidden();
    } else {
      this.sharedService.overflowauto();
    }
  }

  closeSummaryPopup() {
    const previousHeadlineState = JSON.parse(this.previousStoryState);
    if (previousHeadlineState.newsletterSummary !== this.tempStoryData.newsletterSummary) {
      this.storyData.newsletterSummary = this.tempStoryData.newsletterSummary;
    }
    if (previousHeadlineState.quickReadSummary !== this.tempStoryData.quickReadSummary) {
      let prevState = this.storyData.quickReadStatus;

      if(this.storyData.quickReadStatus === 'Automated' || this.storyData.quickReadStatus === 'Automated_Edited' ) {
        if (this.tempStoryData.quickReadSummary !== this.storyData.quickReadSummary) {
          this.storyData.quickReadStatus = 'Automated_Edited';
        } else {
          if(prevState === 'Automated') {
            this.storyData.quickReadStatus = 'Automated';
          }
        }
      } else {
        this.storyData.quickReadStatus = 'Manual';
      }

      this.storyData.quickReadSummary = this.tempStoryData.quickReadSummary;
      if(this.storyData.quickReadSummary.length === 0) {
        this.storyData.quickReadStatus = 'None';
      }
    }
    this.temporaryChangesFlag = false;
    this.summaryPopup = false;
    this.sharedService.overflowauto();
    this.overrideSave();
    this.setFocus('summary');
  }

  fetchAutoQuickRead() {
    let tempSave = '';
    if(this.tempStoryData.quickReadSummary && this.tempStoryData.quickReadSummary.length > 0) {
      this.snotify.warning('Quick Read Summary must be empty...', '', this.sharedService.getConfig(false));
    } else {
      if(!this.tempStoryData.quickReadSummary || this.tempStoryData.quickReadSummary.length === 0) {
        this.snotify.success('Fetching Quick Read Summary...', '', this.sharedService.getConfig(false));
        tempSave = this.storyData.quickReadSummary;
        this.storyData.quickReadSummary = "";
      }
      this.fetching = true;
      setTimeout(() => {
        this.http.get(this.config.get('product').baseUrl + '/api/cms/story/generateQuickRead/'
        + this.storyData.id, {responseType: 'text'}).subscribe((result) => {
          console.log(result)
          this.storyData.quickReadSummary = result;
          this.tempStoryData.quickReadSummary = result;
          this.storyData.quickReadStatus = "Automated";
          this.fetching = false;
        }, (error) => {
          this.snotify.error('Error Fetching Caption', '', this.sharedService.getConfig(false));
          this.storyData.quickReadSummary = tempSave;
          this.tempStoryData.quickReadSummary = tempSave;
          this.fetching = false;
        });

      }, 2000);
    }
  }

  setChangesUrls() {
    const previousHeadlineState = JSON.parse(this.previousStoryState);
    if (previousHeadlineState.headline !== this.tempStoryData.headline) {
      this.storyData.headline = this.tempStoryData.headline;
    }
    if (previousHeadlineState.mobileAppNotificationHeadline !== this.tempStoryData.mobileAppNotificationHeadline) {
      this.storyData.mobileAppNotificationHeadline = this.tempStoryData.mobileAppNotificationHeadline;
    }
    if (previousHeadlineState.browserNotificationHeadline !== this.tempStoryData.browserNotificationHeadline) {
      this.storyData.browserNotificationHeadline = this.tempStoryData.browserNotificationHeadline;
    }
    if (previousHeadlineState.facebookHeadline !== this.tempStoryData.facebookHeadline) {
      this.storyData.facebookHeadline = this.tempStoryData.facebookHeadline;
    }
    if (previousHeadlineState.twitterHeadline !== this.tempStoryData.twitterHeadline) {
      this.storyData.twitterHeadline = this.tempStoryData.twitterHeadline;
    }
    if (this.isStoryUrlCreatedFromHeadline) {
      if (previousHeadlineState.headline !== this.tempStoryData.headline) {
        this.storyData.headline = this.tempStoryData.headline;
      }
    }

    if (previousHeadlineState.urlHeadline !== this.tempStoryData.urlHeadline) {
      this.storyData.urlHeadline = this.tempStoryData.urlHeadline;
    }


    if (this.isNewsletterFieldsEnabled() && (previousHeadlineState.newsletterHeadline !== this.tempStoryData.newsletterHeadline)) {
      this.storyData.newsletterHeadline = this.tempStoryData.newsletterHeadline;
    }

    if (this.isH2enabled() && previousHeadlineState.h2HeaderHeadline !== this.tempStoryData.h2HeaderHeadline) {
      this.storyData.h2HeaderHeadline = this.tempStoryData.h2HeaderHeadline;
    }
    if (this.isH3enabled() && previousHeadlineState.h3HeaderHeadline !== this.tempStoryData.h3HeaderHeadline) {
      this.storyData.h3HeaderHeadline = this.tempStoryData.h3HeaderHeadline;
    }
    this.temporaryChangesFlag = false;
    this.headlinePopup = false;
    this.sharedService.overflowauto();
    this.overrideSave();
    this.focusHeadline();
  }

  discareUrlChanges(displayFlag) {
    this.tempStoryData.headline = this.storyData ?
      ((this.storyData.headline && this.storyData.headline.trim() !== '') ?
        this.storyData.headline.trim() : this.htmlToPlaintext(this.storyData.mobileHeadline))
      : '';
    this.tempStoryData.mobileAppNotificationHeadline = this.storyData ?
      ((this.storyData.mobileAppNotificationHeadline && this.storyData.mobileAppNotificationHeadline.trim() !== '') ?
        this.storyData.mobileAppNotificationHeadline : this.htmlToPlaintext(this.storyData.mobileHeadline))
      : '';
    this.tempStoryData.browserNotificationHeadline = this.storyData ?
      ((this.storyData.browserNotificationHeadline && this.storyData.browserNotificationHeadline.trim() !== '') ?
        this.storyData.browserNotificationHeadline.trim() : this.htmlToPlaintext(this.storyData.mobileHeadline))
      : '';
    this.tempStoryData.facebookHeadline = this.storyData ?
      ((this.storyData.facebookHeadline && this.storyData.facebookHeadline.trim() !== '') ?
        this.storyData.facebookHeadline.trim() : this.htmlToPlaintext(this.storyData.mobileHeadline))
      : '';
    this.tempStoryData.twitterHeadline = this.storyData ?
      ((this.storyData.twitterHeadline && this.storyData.twitterHeadline.trim() !== '') ?
        this.storyData.twitterHeadline.trim() : this.htmlToPlaintext(this.storyData.mobileHeadline))
      : '';

    this.tempStoryData.urlHeadline = this.storyData ?
      ((this.storyData.urlHeadline && this.storyData.urlHeadline.trim() !== '') ?
        this.storyData.urlHeadline.trim() : this.htmlToPlaintext(this.storyData.mobileHeadline))
      : '';
    if (this.isStoryUrlCreatedFromHeadline) {
      this.tempStoryData.headline = this.storyData ?
        ((this.storyData.headline && this.storyData.headline.trim() !== '') ?
          this.storyData.headline.trim() : this.htmlToPlaintext(this.storyData.mobileHeadline))
        : '';
    }

    if (this.isNewsletterFieldsEnabled()) {
      this.tempStoryData.newsletterHeadline = this.storyData ?
        ((this.storyData.newsletterHeadline && this.storyData.newsletterHeadline.trim() !== '') ?
          this.storyData.newsletterHeadline.trim() : this.htmlToPlaintext(this.storyData.mobileHeadline))
        : '';
    }
    if (this.isH2enabled()) {
      this.tempStoryData.h2HeaderHeadline = this.storyData ?
        ((this.storyData.h2HeaderHeadline && this.storyData.h2HeaderHeadline.trim() !== '') ?
          this.storyData.h2HeaderHeadline.trim() : this.htmlToPlaintext(this.storyData.mobileHeadline))
        : '';
    }
    if (this.isH3enabled()) {
      this.tempStoryData.h3HeaderHeadline = this.storyData ?
        ((this.storyData.h3HeaderHeadline && this.storyData.h3HeaderHeadline.trim() !== '') ?
          this.storyData.h3HeaderHeadline.trim() : this.htmlToPlaintext(this.storyData.mobileHeadline))
        : '';
    }
    this.temporaryChangesFlag = false;
    this.isValid(this.tempStoryData.urlHeadline);
    this.tempStoryData.mobileHeadline = this.storyData ? this.htmlToPlaintextExcludeItalic(this.storyData.mobileHeadline) : '';
    this.lastStoryTempData = JSON.stringify(this.tempStoryData);
    this.previousStoryState = JSON.stringify(this.tempStoryData);
    this.headlinePopup = displayFlag;
    this.focusHeadline();
    if (displayFlag) {
      this.sharedService.overflowhidden();
    } else {
      this.sharedService.overflowauto();
    }
  }


  clearHeadline() {
    this.storyData.mobileHeadline = '';
    this.headline = '';
    this.focusHeadline();
  }
  clearSummary() {
    this.storyData.summary = '';
    this.summary = '';
  }

  focusHeadline() {
    if (document.getElementById('headline')) {
      document.getElementById('headline').focus();
      this.setFocus('headline');
    }
  }

  catchTagFocus($event) {
    this.focusedCard = null;
    this.lastindex = null;
  }

  saveDynamicMetaValue(receivedToggleValue, field) {
    if (this.storyData.metadata.dynamicMeta) {
      const index = this.storyData.metadata.dynamicMeta.filter(meta =>
        meta.key === field
      );
      if (index && index.length > 0) {
        this.storyData.metadata.dynamicMeta.forEach((meta, i) => {
          if (meta.key === field && field !='autoQuickSummary') {
            this.storyData.metadata.dynamicMeta[i].value = receivedToggleValue.value;
         }
         if(field=='autoQuickSummary'){
           this.autoSetQuickReadSummary(receivedToggleValue,i);
         } else if(field == 'blogToggle') {
            this.toggleBlog(receivedToggleValue)
          }
          }
        )

      } else {
        this.storyData.metadata.dynamicMeta.push(receivedToggleValue);
      }
    } else {
      this.storyData.metadata.dynamicMeta = [];
      this.storyData.metadata.dynamicMeta.push(receivedToggleValue);
      if(field=='autoQuickSummary'){
        let index=0;
        this.autoSetQuickReadSummary(receivedToggleValue,index);
      } else if(field == 'blogToggle') {
        this.toggleBlog(receivedToggleValue)
      }

    }
  }

  toggleBlog(receivedToggleValue) {
    if(receivedToggleValue.value === true) {
      this.storyData.metadata.section = "blog";
      this.sectionQuery = "blog";
      this.subSectionQuery = '';
        this.storyData.metadata.subSection = '';
      this.storyData.metadata.blogDisclaimerFlag = true;
      this.storyData.metadata.blogDisclaimer = this.blogDisclaimerEdit;
    } else if(receivedToggleValue.value === false) {
      this.storyData.metadata.blogDisclaimerFlag = false;
      this.storyData.metadata.blogDisclaimer = "";
    }
    // if(receivedToggleValue.value === true) {
    //   this.storyData.metadata.section = "blog";
    //   this.sectionQuery = "blog";
    //   this.subSectionQuery = '';
    //   this.storyData.metadata.subSection = '';
    //   this.storyData.metadata.blogDisclaimerFlag = true;
    //   this.storyData.metadata.blogDisclaimer = this.blogDisclaimer;
    // } else if(receivedToggleValue.value === false) {
    //   this.storyData.metadata.blogDisclaimerFlag = false;
    //   this.storyData.metadata.blogDisclaimer = "";
    // }
  }

  getStoryDynamicMetaIndex(field) {
    let dynamicMeta = { 'key': field, 'value': '' };
    if (this.storyData.metadata.dynamicMeta) {
      const exist = this.storyData.metadata.dynamicMeta.filter(meta => meta.key === field);
      if (exist && exist.length > 0) {
        return exist[0];
      } else {
        return dynamicMeta;
      }
    }
    return dynamicMeta;
  }

  toggleSwitch(button) {
    if (this.storyData) {
      if (this.storyData.metadata) {
        if (button === 'live') {
          this.storyData.metadata.live = !this.storyData.metadata.live;
        }
        if (button === 'developing') {
          this.storyData.metadata.developing = !this.storyData.metadata.developing;
        }
        if (button === 'interview') {
          this.storyData.metadata.interview = !this.storyData.metadata.interview;
        }
        if (button === 'exclusive') {
          this.storyData.metadata.exclusive = !this.storyData.metadata.exclusive;
        }
        if (button === 'inDepth') {
          this.storyData.metadata.inDepth = !this.storyData.metadata.inDepth;
        }
        if (button === 'opinion') {
          this.storyData.metadata.opinion = !this.storyData.metadata.opinion;
        }
        if (button === 'latest') {
          this.storyData.metadata.latest = !this.storyData.metadata.latest;
        }
        if (button === 'factCheck') {
          this.storyData.metadata.factCheck = !this.storyData.metadata.factCheck;
        }
        if (button === 'outdatedCheck') {
          this.storyData.metadata.outdatedCheck = !this.storyData.metadata.outdatedCheck;
          this.setCalendarMinDateForEndTime();
        }

        if (button === 'markUnimportant') {
          this.storyData.metadata.markUnimportant = !this.storyData.metadata.markUnimportant;
          if (this.storyData.metadata.markUnimportant) {
            this.storyData.metadata.breakingNews = false;
            this.storyData.metadata.bigStory = false;
          }
        }
        if (button === 'breakingNews') {
          this.storyData.metadata.breakingNews = !this.storyData.metadata.breakingNews;
          if (this.storyData.metadata.breakingNews) {
            this.columnQuery = '';
            this.storyData.metadata.column = '';
            this.storyData.metadata.sponsored = false;
            this.storyData.metadata.markUnimportant = false;
            this.storyData.metadata.bigStory = false;
            this.addAutomaticBylineForBreakingNews();
          }
        }
        if (button === 'sponsored') {
          this.storyData.metadata.sponsored = !this.storyData.metadata.sponsored;
          if (this.storyData.metadata.sponsored) {
            // this.storyData.metadata.markUnimportant = false;
            this.columnQuery = '';
            this.storyData.metadata.column = '';
            this.storyData.metadata.breakingNews = false;
            this.storyData.metadata.bigStory = false;
            this.storyData.metadata.sponsoredTitle = 'SPONSORED';
          } else {
            this.storyData.metadata.sponsoredTitle = '';
          }
        }
        if (button === 'bigStory') {
          this.storyData.metadata.bigStory = !this.storyData.metadata.bigStory;
          if (this.storyData.metadata.bigStory) {
            this.columnQuery = '';
            this.storyData.metadata.column = '';
            this.storyData.metadata.sponsored = false;
            this.storyData.metadata.markUnimportant = false;
            this.storyData.metadata.breakingNews = false;
          }
        }
        if (button === 'webcast') {
          if (this.storyData.metadata.videoMetadata == null) {
            this.storyData.metadata.videoMetadata = { 'webcast': true };
          } else {
            this.storyData.metadata.videoMetadata.webcast = !this.storyData.metadata.videoMetadata.webcast;
          }
        }
        if (button === 'syndicationFeed') {
          this.storyData.metadata.premiumStory = !this.storyData.metadata.premiumStory;
          if(this.storyData.metadata.premiumStory && this.storyType === 'story' && this.isPremiumSection){
            this.sectionQuery="Premium";
            this.storyData.metadata.section=this.sectionQuery;
            this.storyData.metadata['premiumStoryDays']=this.premiumStoryDays;
          }
          else if(this.storyData.metadata.premiumStory && this.storyType === 'story'){
            this.storyData.metadata['premiumStoryDays']=this.premiumStoryDays;
          }
          else if(this.storyType === 'story' && this.isPremiumSection) {
            this.sectionQuery="";
            this.storyData.metadata.section=this.sectionQuery;
          }

        }
        if (button === 'quick-read-summary') {
        let storyData = JSON.parse(JSON.stringify(StaticDataService.defaultStoryData));
         console.log('Quick',storyData);
         console.log(this.summary)
        }
        if (button === 'homepage') {
          this.homepageToggle = !this.homepageToggle;
          if (this.homepageToggle) {
            this.setCalendarMinDateForHomepageOption();
          } else {
            this.storyData.metadata.homePageEndTime = null;
            this.storyData.metadata.homePagePosition = null;
            this.setCalendarMinDateForHomepageOption();
          }
        }
        if (button === 'amazonMeta') {
          this.showAmazonMeta = !this.showAmazonMeta;
          this.embedCode = '';
          this.embedSourceUrl = '';
          this.embedSubType = '';
          this.amazonAds = [];
          this.newAdName = '';
          this.newAdEmbed = '';
          this.addIconClick = true;
          this.amazonNewAd = false;
          this.adTitle = ''
        }
        if (button === 'lShapeBand') {
          this.showLShapeBand = !this.showLShapeBand;
        }
      }


      if (button === 'facebook') {
        this.socialMap.facebook = !this.socialMap.facebook;
      }
      if (button === 'twitter') {
        this.socialMap.twitter = !this.socialMap.twitter;
      }
      if (button === 'tagTwitterAuthor') {
        this.tagTwitterAuthor = !this.tagTwitterAuthor;
        this.storyData.tagTwitterAuthor = this.tagTwitterAuthor;
        this.saveStory(true);
      }
      if (button === 'mobile') {
        this.socialMap.mobile = !this.socialMap.mobile;
      }
      if (button === 'web') {
        this.socialMap.web = !this.socialMap.web;
      }
      if (button != 'amazonMeta') {
        this.focusedCard = null;
        this.lastindex = null;
      }
      if (button === 'copyFromHeadline') {
        this.storyData.metadata.copyFromHeadline = !this.storyData.metadata.copyFromHeadline;
      }
      if (button === 'premiumNotification') {
        this.storyData.metadata['premiumNotification'] = !this.storyData.metadata['premiumNotification'];
      }
      if (button === 'ignoreAutoQuickReads') {
        this.storyData.metadata.ignoreAutoQuickReads = !this.storyData.metadata.ignoreAutoQuickReads;
      }
      if (button === 'handpicked') {
        this.storyData.metadata.handpicked = !this.storyData.metadata.handpicked;
      }
    }
  }

  setFocus(elementId) {
    this.focusElement = (elementId as string);
    // console.log('focus set on => ' + elementId);
    this.focusedCard = null;
    this.lastindex = null;
  }

  focusOut() {
    this.focusElement = null;
  }

  getValuefromThis(s) {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    let o = this;
    const a = s.split('.');
    for (let i = 0, n = a.length; i < n; ++i) {
      const k = a[i];
      if (k in o) {
        if (o[k] !== null) {
          o = o[k];
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
    if (o) {
      return o;
    } else {
      return null;
    }
  }

  setValuefromThis(s, item: any) {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    let o = this;
    const a = s.split('.');
    for (let i = 0, n = a.length; i < n; ++i) {
      const k = a[i];
      if (k in o) {
        if (o[k] !== null) {
          o = o[k];
        }
      }
    }
    o = item;
  }

  isStringInEnglish(text) {
    const english = /^[A-Za-z0-9]*$/;
    const str = text.replace(/[`~!@#$%^&*()-_+={}:;"'<,>.?\/\[\]]/g, '').replace(/ /g, '');
    return english.test(str);
  }

  checkIfUrlHeadlineIsValid() {

    if (this.urlValidationFlag) {
      const headline = ((this.storyData.headline !== '')
        ? this.storyData.headline
        : (this.storyData.title !== '' ? this.storyData.title : ''));
        console.log(this.isStoryUrlCreatedFromHeadline);
      if (this.isStoryUrlCreatedFromHeadline) {

        if (this.storyData.headline !== null && this.storyData.headline.trim() !== '') {
          return !this.isStringInEnglish(this.storyData.headline);
        } else if (headline !== '' && (this.storyData !== null)) {
          return !this.isStringInEnglish(this.htmlToPlaintext(headline));
        } else {
          return false;
        }
      }
      else {
        if (this.storyData.urlHeadline !== null && this.storyData.urlHeadline.trim() !== '') {
          return !this.isStringInEnglish(this.storyData.urlHeadline);
        } else if (headline !== '' && (this.storyData !== null)) {
          return !this.isStringInEnglish(this.htmlToPlaintext(headline));
        } else {
          return false;
        }
      }

    } else {
      return false;
    }
  }

  disableElement(elementName): boolean {
    if (this.storyData) {
      if (elementName === 'story-headline') {
        return (this.storyData.mobileHeadline.trim() === '' || !this.storyData.mobileHeadline);
      }

      if (elementName === 'publish-story') {
        // console.log('headline => ' + this.checkHeadlineForPublishing(false));
        // console.log('secrtion => ' + this.checkSection(null, true));
        if (!this.storyData.metadata.breakingNews) {
          if (this.storyType !== 'gallery' && this.storyType !== 'liveblog'
            && this.storyType !== 'mintlite' && this.storyType !== 'mediagallery' && this.storyType !== 'deadlink' && this.storyType !== 'photostory') {
            if (this.storyType === 'listicle') {
              console.log("called form 22")
              return !(
                this.isSummaryMandatoryDomainBased() ||
                this.checkHeadlineForPublishing(false) ||
                this.checkSection(null, true) ||
                this.checkBrand(null, true) ||
                this.checkAgency(null) || this.checkImageCaption(null) ||
                !this.checkSummary(this.storyData.summary) ||
                !this.checkLeadMedia() ||
                !this.checkPrimaryLocation() ||
                this.checkIfUrlHeadlineIsValid() ||
                this.checkHeadlineRestrictedCharacters()['flag'] ||
                this.checkSummaryRestrictedCharacters()['flag'] ||
                this.checkCaptionRestrictedCharacters()
              );
            } else {
              console.log("called form 2")
              return !(
                this.isSummaryMandatoryDomainBased() ||
                this.checkHeadlineForPublishing(false) ||
                this.checkSection(null, true) ||
                this.checkBrand(null, true) ||
                this.checkAgency(null) ||
                !this.checkSummary(this.storyData.summary) ||
                !this.checkLeadMedia() || this.checkImageCaption(null) ||
                !this.checkPrimaryLocation() ||
                this.checkIfUrlHeadlineIsValid() ||
                this.checkHeadlineRestrictedCharacters()['flag'] ||
                this.checkSummaryRestrictedCharacters()['flag'] ||
                this.checkCaptionRestrictedCharacters() ||
                !this.checkPlagCalled()
              );
            }
          }
          if (this.storyType === 'gallery' || this.storyType === 'mediagallery') {
            console.log("called form 3")
            return !(
              this.isSummaryMandatoryDomainBased() ||
              (!this.checkSummary(this.storyData.summary)) ||
              this.checkHeadlineForPublishing(false) ||
              this.checkSection(null, true) ||
              this.checkAgency(null) ||
              (this.storyData.leadMedia.elements.length < 1) || this.checkImageCaption(null) ||
              !this.checkPrimaryLocation() ||
              this.checkIfUrlHeadlineIsValid() ||
              this.checkHeadlineRestrictedCharacters()['flag'] ||
              this.checkSummaryRestrictedCharacters()['flag'] ||
              this.checkCaptionRestrictedCharacters() ||
              this.checkAllImagesCropped() ||
              this.checkCrossTenantDifference()
            );
          }
          if (this.storyType === 'liveblog' || this.storyType === 'mintlite') {
            console.log("called form 4")
            return !(
              (this.storyData.summary === null || this.storyData.summary.trim() === '') ||
              (!this.checkSummary(this.storyData.summary)) ||
              this.checkHeadlineForPublishing(false) ||
              this.checkSection(null, true) ||
              this.checkAgency(null) ||
              (
                (!this.storyData.metadata.keywords) ||
                (this.storyData.metadata.keywords === null) ||
                (this.storyData.metadata.keywords.length < 1)
              ) ||
              (this.storyData.leadMedia.elements.length < 1) ||
              !this.checkLeadMedia() || this.checkImageCaption(null) ||
              (this.storyData.introBody === null || this.htmlToPlaintext(this.storyData.introBody).trim() === '') ||
              (this.storyData.elements && this.storyData.elements.length < 1) || !this.checkPrimaryLocation() ||
              this.checkIfUrlHeadlineIsValid() ||
              this.checkHeadlineRestrictedCharacters()['flag'] ||
              this.checkSummaryRestrictedCharacters()['flag'] ||
              this.checkCaptionRestrictedCharacters()
            );
          }
          if (this.storyType === 'deadlink') {
            return !(
              (this.storyData.summary === null || this.storyData.summary.trim() === '') ||
              (!this.checkSummary(this.storyData.summary)) ||
              this.checkHeadlineForPublishing(false) ||
              this.checkDeadlinkUrl()
            );
          }
          if (this.storyType === 'photostory') {
            console.log("called form 5")
            return !(
              (!this.checkSummary(this.storyData.summary)) || this.checkHeadlineForPublishing(false) || this.checkSection(null, true) ||
              this.checkAgency(null) ||
              !this.checkSummary(this.storyData.summary) ||
              this.checkIfUrlHeadlineIsValid() ||
              (this.storyData.leadMedia.elements.length < 1) || this.checkImageCaption(null) ||
              this.checkHeadlineRestrictedCharacters()['flag'] ||
              this.checkSummaryRestrictedCharacters()['flag'] ||
              this.checkImageCaption(null) || (this.storyData.elements && (this.storyData.elements.length < 1))
            )
          }

        } else {
          console.log("check error1");
          if (this.storyType !== 'gallery' && this.storyType !== 'liveblog'
            && this.storyType !== 'mintlite' && this.storyType !== 'mediagallery' && this.storyType !== 'deadlink' && this.storyType !== 'photostory') {
            if (this.storyType === 'listicle') {

              console.log("check error2");
              console.log("called form 7")
              return !(
                this.isSummaryMandatoryDomainBased() ||
                this.checkHeadlineForPublishing(false) ||
                this.checkSection(null, false) ||
                this.checkAgency(null) || this.checkImageCaption(null) ||
                !this.checkSummary(this.storyData.summary) || !this.checkPrimaryLocation() ||
                this.checkIfUrlHeadlineIsValid() ||
                this.checkHeadlineRestrictedCharacters()['flag'] ||
                this.checkSummaryRestrictedCharacters()['flag'] ||
                this.checkCaptionRestrictedCharacters()
              );
            } else {

              console.log("check error3");
              return !(
                this.isSummaryMandatoryDomainBased() ||
                this.checkHeadlineForPublishing(false) ||
                this.checkSection(null, false) ||
                this.checkAgency(null) ||
                !this.checkSummary(this.storyData.summary) || this.checkImageCaption(null) ||
                !this.checkPrimaryLocation() ||
                this.checkIfUrlHeadlineIsValid() ||
                this.checkHeadlineRestrictedCharacters()['flag'] ||
                this.checkSummaryRestrictedCharacters()['flag'] ||
                this.checkCaptionRestrictedCharacters() ||
                !this.checkPlagCalled()
              );
            }
          }
          if (this.storyType === 'gallery' || this.storyType === 'mediagallery') {

            console.log("check error4");
            return !(
              this.isSummaryMandatoryDomainBased() ||
              this.checkHeadlineForPublishing(false) ||
              this.checkSection(null, false) ||
              this.checkAgency(null) ||
              !this.checkSummary(this.storyData.summary) ||
              (this.storyData.leadMedia.elements.length < 1) || this.checkImageCaption(null)
              || !this.checkPrimaryLocation() ||
              this.checkIfUrlHeadlineIsValid() ||
              this.checkHeadlineRestrictedCharacters()['flag'] ||
              this.checkSummaryRestrictedCharacters()['flag'] ||
              this.checkCaptionRestrictedCharacters() ||
              this.checkAllImagesCropped() ||
              this.checkCrossTenantDifference()
            );
          }
          if (this.storyType === 'liveblog' || this.storyType === 'mintlite') {
            return !(
              this.checkHeadlineForPublishing(false) ||
              this.checkSection(null, false) ||
              this.checkAgency(null) ||
              !this.checkSummary(this.storyData.summary) ||
              (this.storyData.introBody === null || this.htmlToPlaintext(this.storyData.introBody).trim() === '') ||
              (this.storyData.elements && this.storyData.elements.length < 1) ||
              !this.checkPrimaryLocation() ||
              this.checkIfUrlHeadlineIsValid() ||
              this.checkHeadlineRestrictedCharacters()['flag'] ||
              this.checkSummaryRestrictedCharacters()['flag'] ||
              this.checkCaptionRestrictedCharacters() || (this.storyData.leadMedia.elements.length < 1) || this.checkImageCaption(null)
            );
          }
          if (this.storyType === 'deadlink') {

            return !(
              (this.storyData.summary === null || this.storyData.summary.trim() === '') ||
              (!this.checkSummary(this.storyData.summary)) ||
              this.checkHeadlineForPublishing(false) ||
              this.checkDeadlinkUrl()
            );
          }
          if (this.storyType === 'photostory') {
            console.log("called form 8")
            return !(
              (!this.checkSummary(this.storyData.summary)) || this.checkHeadlineForPublishing(false) || this.checkSection(null, true) ||
              this.checkAgency(null) ||
              !this.checkSummary(this.storyData.summary) ||
              this.checkIfUrlHeadlineIsValid() ||
              (this.storyData.leadMedia.elements.length < 1) || this.checkImageCaption(null) ||
              this.checkHeadlineRestrictedCharacters()['flag'] ||
              this.checkSummaryRestrictedCharacters()['flag'] ||
              this.checkImageCaption(null) || (this.storyData.elements && (this.storyData.elements.length < 1))
            )
          }
        }
      }


      if (elementName === 'story-summary') {
        return (!this.storyData.summary || this.storyData.summary.trim() === '');
      }

      if (elementName === 'story-save') {
        if (this.storyData && this.storyData.metadata && this.storyData.metadata.status && this.storyData.metadata.status === 'SCHEDULED') {
          return (this.checkHeadline() || this.versionLock);
        } else {
          return (this.checkHeadline() || !this.storyEditMode || this.versionLock);
        }
      }

      if (elementName === 'meta-more') {
        if (
          this.storyData
          && this.storyData.metadata.editedBy
          && this.storyData.metadata.editedBy.length > 0
          && this.storyData.metadata.writtenBy
          && this.storyData.metadata.writtenBy.length > 0
          && this.storyData.metadata.reportedBy
          && this.storyData.metadata.reportedBy.length > 0
          && this.storyData.metadata.agencyByLine
          && this.storyData.metadata.agencyByLine.length > 0
          && this.storyData.metadata.column
          && this.storyData.metadata.column.trim() !== ''
        ) {
          return false;
        } else {
          return this.metaToggleFlag;
        }
      }
    }
  }
  checkPlagColor() {
    if(parseInt(this.plagData.plagPercent) > this.maxPlagiarism) {
      return 'red';
    }
    return '';
  }
  checkPlagCalled(): boolean {
    if(this.storyData.metadata.wordCount <= 100) {
      return true;
    }
    // console.log("paragraph changed ----- ", this.storyData.metadata.paraContentChanged)    if(!this.enablePlagiarism || (this.storyData.metadata.plagiarismChecked && !this.storyData.metadata.paraContentChanged)) {
    if(!this.enablePlagiarism || (this.storyData.metadata.plagiarismChecked && !this.storyData.metadata.paraContentChanged)) {
      if(this.plagData && parseInt(this.plagData.plagPercent) > this.maxPlagiarism) {
        this.stopPlagiarismPublish ? this.snotify.error('Article is more than ' + this.maxPlagiarism + '% Plagiarized. Can\'t Publish.', '', this.sharedService.getConfig(false)) : "";
          return (this.stopPlagiarismPublish ? false : true );
      }
      console.log("PLAG NOT ENABLED")
      return true;
    }
    else {
      console.log("Not checking for plag")
      // commented temporariy

      this.snotify.info('Checking for Plagiarism before Publishing...', '', this.sharedService.getConfig(false));
      this.checkPlagiarism(() => {
        this.storyData.metadata.paraContentChanged = false;
        setTimeout(() => {
          if(!this.schedulingStoryFlag) {
            this.openPublish(true)
          }
          if(this.schedulingStoryFlag) {
            this.scheduleFunctions();
            return true;
          }
        }, 100);


      })
      return false;
    }
    //comment in final
    // return true;
  }

  checkCrossTenantDifference() {
    if (this.storyData.crosstenantPhotoGallery) {
      this.sameFields = "";
      if (this.storyData.mobileHeadline === this.storyData.metadata.oldHeadline) {
        this.sameFields += "Headline,"
      }
      if (this.summary === this.storyData.metadata.oldSummary) {
        this.sameFields += " Summary,"
      }
      if (this.storyData.metadata.metaTitle === this.storyData.metadata.oldMetaTitle) {
        this.sameFields += " Meta Title,"
      }
      if (this.storyData.metadata.metaDescription === this.storyData.metadata.oldMetaDescription) {
        this.sameFields += " Meta Description"
      }
      if (this.sameFields.length > 0) {
        return true;
      }
    }
    return false;
  }

  checkAllImagesCropped() {
    if (this.cropAllGallery) {
      for (const element of this.elReference['_results']) {
        if(element['cardData']['type'] === 'image') {
          if (!element['cardData']['image']['images']['1600x900']) {
            return true;
          }
        }
      }
    }
    return false;
  }

  checkImageCaption(errmsg) {
    const imageElements = Object.keys(this.Elements);
    let isCaption = false;
    if ((this.imageCaption === null || this.imageCaption === '') && this.storyType !== 'gallery') {
      isCaption = true;
    }
    for (const imageData of imageElements) {
      if (this.Elements[imageData].type === 'image' || this.Elements[imageData].type === 'gif') {
        if (this.Elements[imageData].image.caption === null || this.Elements[imageData].image.caption === '') {
          if(this.Elements[imageData].image.sampleImage) {
            isCaption = false;
          } else {
            isCaption = true;
          }
        }
      }
    }
    if (isCaption) {
      if (errmsg) {
        this.snotify.error('Please enter image caption', '', this.sharedService.getConfig(false));
      }
      return true;
    } else {
      return false;
    }
  }
  checkHeadline() {
    if (this.storyData.id !== null) {
      return (!this.storyData.mobileHeadline || this.storyData.mobileHeadline.trim() === '');
    } else {
      return false;
    }
  }

  checkHeadlineForPublishing(errmsg) {
    if ((this.storyData.mobileHeadline === null) || (this.htmlToPlaintext(this.storyData.mobileHeadline).trim().length < 5)) {
      if (errmsg) {
        this.snotify.error('Headline must be of minimum 5 characters', '', this.sharedService.getConfig(false));
      }
      return true;
    } else if (((this.storyData.mobileHeadline === null) || (this.htmlToPlaintext(this.storyData.mobileHeadline).trim().length > 80)) && (this.showHeadlineerror)) {
      if (errmsg) {
        this.snotify.error('Headline must be of Maximum of 80 characters', '', this.sharedService.getConfig(false));
      }
      return true;
    } else if (((this.storyData.mobileHeadline === null) || (this.htmlToPlaintext(this.storyData.mobileHeadline).trim().length > 80)) && (this.showHeadlineerror)) {
      if (errmsg) {
        this.snotify.error('Headline must be of Maximum of 80 characters', '', this.sharedService.getConfig(false));
      }
      return true;
    } else if (((this.storyData.mobileHeadline === null) || (this.htmlToPlaintext(this.storyData.mobileHeadline).trim().length > 80)) && (this.showHeadlineerror)) {
      if (errmsg) {
        this.snotify.error('Headline must be of Maximum of  80 characters', '', this.sharedService.getConfig(false));
      }
      return true;
    } else {
      if (this.htmlToPlaintext(this.storyData.mobileHeadline).trim().replace(new RegExp(' ', 'g'), '').toLowerCase() === 'untitledstory') {
        if (errmsg) {
          this.snotify.error('Headline cannot be Untitled story', '', this.sharedService.getConfig(false));
        }
        return true;
      } else {
        return false;
      }
    }
  }
  secondarySectionsNeeded() {
    if (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story']
      && this.domainConfig['config']['story']['secondarySection'] === 'true') {
      return true;
    }
    return false;
  }


  secondaryBrandsNeeded() {
    if (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story']
      && this.domainConfig['config']['story']['secondaryBrand'] === 'true') {
      return true;
    }
    return false;
  }

  checkSection(errmsg, checkForSubSection) {
    const domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    const sectionAll = Object.keys(this.subSectionSuggestion);

    let sectionQueryPresentForGallery = false;
    if (this.domainConfig['config']['story']['restrictSection'] && (this.storyType == 'gallery' || this.storyType == 'video') && !this.storyData.metadata.section) {
      if (this.sectionQuery !== null && this.sectionQuery.trim() !== '' && (this.sectionQuery === 'photos' || this.sectionQuery === 'videos')) {
        sectionQueryPresentForGallery = true;
      }
    }

    if (!this.storyData.metadata.section) {
      if (!sectionQueryPresentForGallery) {
        if (errmsg) {
          this.snotify.error('Fill Section', '', this.sharedService.getConfig(false));
          if (checkForSubSection && this.domainConfig && this.domainConfig['config']
            && this.domainConfig['config']['story']
            && this.domainConfig['config']['story']['checkForSubSection'] === 'true') {
            this.snotify.error('Fill SubSection', '', this.sharedService.getConfig(false));
          }
        }
        return true;
      }
    } else {
      if (checkForSubSection && this.domainConfig && this.domainConfig['config']
        && this.domainConfig['config']['story']
        && this.domainConfig['config']['story']['checkForSubSection'] === 'true') {
        for (const sec of sectionAll) {
          if (sec.toLowerCase() === this.storyData.metadata.section.toLowerCase()) {
            if (this.subSectionSuggestion[sec] !== null
              && this.subSectionSuggestion[sec].length > 0) {
              if (!this.storyData.metadata.section) {
                if (errmsg) {
                  this.snotify.error('Fill SubSection', '', this.sharedService.getConfig(false));
                }
                return true;
              } else {
                return false;
              }
            } else {
              return false;
            }
          }
        }
      } else {
        return false;
      }
    }
  }

  checkBrand(errmsg, checkForModel) {
    const domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    const brandAll = Object.keys(this.modelSuggestionMain);
    console.log("publishing..." + errmsg + " " + checkForModel)
    if ((!this.storyData.metadata.brand || this.storyData.metadata.brand.trim() === '') ||
      (!this.storyData.metadata.brand || this.storyData.metadata.brand.trim() === ''))
      return false;

    let allCheck = false;
    if (this.storyData.metadata.brand && this.storyData.metadata.brand.trim() != '') {
      if ((!this.storyData.metadata.model || this.storyData.metadata.model.trim() === '') && checkForModel &&
        this.domainConfig['config'] && this.domainConfig['config']['story'] &&
        this.domainConfig['config']['story']['checkForModel'] === 'true') {
        this.snotify.error('Fill Model', '', this.sharedService.getConfig(false));
        allCheck = true;
      }
    }

    console.log(this.storyData.metadata.secondaryBrands);
    if (this.storyData.metadata.secondaryBrands) {
      console.log("inside for secondaryBrands")
      let index = 1;
      for (let pair of this.storyData.metadata.secondaryBrands) {
        if (!pair['brand'] || pair['brand'] == "") {
          this.snotify.error('Fill Brand' + index, '', this.sharedService.getConfig(false));
          allCheck = true;
        }
        if (this.domainConfig['config']['story']['checkForModel'] === 'true' && (!pair['model'] || pair['model'] == "")) {
          this.snotify.error('Fill Model' + index, '', this.sharedService.getConfig(false));
          allCheck = true;
        }
        index++;
      }
    }
    return allCheck;
    // if ((this.storyData.metadata.brand === null) || (this.storyData.metadata.brand.trim() === '')) {
    //   if (errmsg) {
    //     this.snotify.error('Fill Brand', '', this.sharedService.getConfig(false));
    //     if (checkForModel && this.domainConfig && this.domainConfig['config']
    //       && this.domainConfig['config']['story']
    //       && this.domainConfig['config']['story']['checkForModel'] === 'true') {
    //       this.snotify.error('Fill Model', '', this.sharedService.getConfig(false));
    //     }
    //   }
    //   console.log("returning true checkbrand")
    //   return true;
    // } else {
    //   if (checkForModel && this.domainConfig && this.domainConfig['config']
    //     && this.domainConfig['config']['story']
    //     && this.domainConfig['config']['story']['checkForModel'] === 'true') {
    //     for (const sec of brandAll) {
    //       if (sec.toLowerCase() === this.storyData.metadata.brand.toLowerCase()) {
    //         if (this.modelSuggestionMain[sec] !== null
    //           && this.modelSuggestionMain[sec].length > 0) {
    //           if ((this.storyData.metadata.model === null) || (this.storyData.metadata.model.trim() === '')) {
    //             if (errmsg) {
    //               this.snotify.error('Fill Model', '', this.sharedService.getConfig(false));
    //             }

    //   console.log("returning true1 checkbrand")
    //             return true;
    //           } else {

    //   console.log("returning flase2 checkbrand")
    //             return false;
    //           }
    //         } else {

    //   console.log("returning false1 checkbrand")
    //           return false;
    //         }
    //       }
    //     }
    //   } else {

    //   console.log("returning false3 checkbrand")
    //     return false;
    //   }
    // }
  }

  checkAgency(errmsg) {
    if (this.storyData.metadata !== null && (this.storyData.metadata.agency === null) || (this.storyData.metadata.agency.trim() === '')) {
      if (this.isAuthorIdEnabled) {
        return !(
          (this.storyData.metadata.authorsList && this.storyData.metadata.authorsList.length > 0)
          || (this.storyData.metadata.editedByList && this.storyData.metadata.editedByList.length > 0)
          || (this.storyData.metadata.writtenByList && this.storyData.metadata.writtenByList.length > 0)
          || (this.storyData.metadata.reportedByList && this.storyData.metadata.reportedByList.length > 0)
          || (this.storyData.metadata.agencyByLine && this.storyData.metadata.agencyByLine.length > 0)
          || (this.storyData.metadata.column && this.storyData.metadata.column.trim() !== '')
        );
      } else {
        return !(
          (this.storyData.metadata.authors && this.storyData.metadata.authors.length > 0)
          || (this.storyData.metadata.editedBy && this.storyData.metadata.editedBy.length > 0)
          || (this.storyData.metadata.writtenBy && this.storyData.metadata.writtenBy.length > 0)
          || (this.storyData.metadata.reportedBy && this.storyData.metadata.reportedBy.length > 0)
          || (this.storyData.metadata.agencyByLine && this.storyData.metadata.agencyByLine.length > 0)
          || (this.storyData.metadata.column && this.storyData.metadata.column.trim() !== '')
        );
      }
    } else {
      // console.log(this.storyData.metadata.agency)
      return false;
    }
  }

  checkLeadMedia() {
    if (this.storyData && (this.storyData.leadMedia.elements.length > 0) && this.leadelRef &&
      this.leadelRef['_results'] && this.leadelRef['_results'][0] &&
      this.leadelRef['_results'][0].cardData && this.leadelRef['_results'][0].cardData.type &&
      this.leadelRef['_results'][0].cardData.type === 'image') {
      // console.log(this.leadelRef['_results'][0].cardData.image.images);
      if (!this.leadelRef['_results'][0].cardData.image.images['960x540']
        || this.leadelRef['_results'][0].cardData.image.images['960x540'] === null
        || (this.leadelRef['_results'][0].cardData.image.images['960x540'].trim() === '')
      ) {
        // console.log(this.leadelRef['_results'][0].cardData.image.images['960x540']);
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  checkCanoicalUrl(url) {
    if (url && url.trim() !== '') {
      // console.log(url.charAt(0));
      if (this.isPrimaryLocationEnabled()) {
        if (this.storyData && (this.storyData !== null && this.storyData !== undefined)
          && (this.storyData.metadata && this.storyData.metadata.primaryLocation !== null
            && this.storyData.metadata.primaryLocation !== undefined && this.storyData.metadata.primaryLocation.trim() !== '')) {
          this.storyData.metadata.canonicalUrl =
            (this.storyData.metadata.canonicalUrl !== null && this.storyData.metadata.canonicalUrl.trim() !== '')
              ? this.storyData.metadata.canonicalUrl :
              ((url.charAt(0) !== '/') ? url : (this.sharedService.currentDomainUrl
                + (url.split('/')[1].trim().search(' ') > 1 ? url.replace(url.split('/')[1],
                  this.findAndReplace(url.split('/')[1].trim(), ' ', '-')) : url)));
        }
      } else {
        this.storyData.metadata.canonicalUrl =
          (this.storyData.metadata.canonicalUrl !== null && this.storyData.metadata.canonicalUrl.trim() !== '')
            ? this.storyData.metadata.canonicalUrl :
            ((url.charAt(0) !== '/') ? url : (this.sharedService.currentDomainUrl + url));
      }
    }
  }

  findAndReplace(str, target, replacement) {
    let i = 0;
    const length = str.length;
    for (i; i < length; i++) {
      str = str.replace(target, replacement);
    }
    return str;
  }

  isLightboxfun() {
    this.isLightbox = false;
  }

  public listClick(event, selectedValue1) {
    this.selectedValue = selectedValue1;
    if (selectedValue1 === 1) {
      this.leadMediaImageToggle = !this.leadMediaImageToggle;
      this.leadMediaImageGifToggle = false;
    } else if (selectedValue1 === 2) {
      this.leadMediaImageGifToggle = !this.leadMediaImageGifToggle;
      this.leadMediaImageToggle = false;
    } else {
      this.leadMediaImageToggle = false;
      this.leadMediaImageGifToggle = false;
    }
  }

  public pinnedListClick(event, selectedValue1) {
    if (selectedValue1 === 1) {
      this.pinnedMediaImageToggle = !this.pinnedMediaImageToggle;
    } else {
      this.pinnedMediaImageToggle = false;
    }
  }

  checkAllElementsVisibility() {
    let arr = [];
    const ElRef = this.elReference;
    if (ElRef !== null && ElRef['_results'].length > 0) {
      const len = ElRef['_results'].length;
      for (let i = 0; i <= len; i++) {
        const j = i;
        const el = ElRef['_results'][j];
        if (i < len) {
          // console.log(el.checkIfELementIsInView());
          if (el.checkIfELementIsInView()) {
            arr.push((this.storyData.elements.indexOf(el.id) as number));
          }
        }
        if (i === len) {
          this.sliceItemsOnViewCheck(arr);
        }
      }
    }
  }

  addCompanyChart() {
    if (this.storyData.elements.length > 0) {
      console.log(JSON.stringify(this.storyData));
      if(this.storyData.metadata.keywords.length == 0) {
        this.snotify.error('Please enter keywords', '', this.sharedService.getConfig(false));
        return;
      }
      // return;
      const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true); // Omit props what i don't need
      this.snotify.confirm('Please Automated Chart Addition before formatting content, will lead to a formatting loss. Do you wish to Proceed?', '', {
        ...config,
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.automatedChartAdditionInProgress = true;
              this.restService.http_get(
                this.config.get('product').baseUrl + '/api/cms/automated/company-chart/' + this.storyData.id).subscribe((result) => {
                  this.snotify.clear();
                  setTimeout(e => {
                    this.automatedChartAdditionInProgress = false;
                  }, 1000);
                  if (result['result'].includes('No')) {
                    this.snotify.warning(result['result'], '', this.sharedService.getConfig(false));
                  } else {
                    this.initStoryView(this.storyData.id, false);
                    this.snotify.success(result['result'], '', this.sharedService.getConfig(false));
                  }
                  for (let ele of this.elReference['_results']) {
                    if (ele.cardData.type === 'paragraph') {
                      ele.loadView(false);
                    }
                    this.automatedChartDone = true;
                  }
                }, (error) => {
                  console.log(error);
                });
                this.googleAnalytics("Skippable Alerts",'Please Automated Chart Addition before formatting content, will lead to a formatting loss. Do you wish to Proceed?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' , null);
            }, bold: false
          },
          { text: 'No', action: (toast) => { this.snotify.remove(toast.id); 
            this.googleAnalytics("Skippable Alerts",'Please Automated Chart Addition before formatting content, will lead to a formatting loss. Do you wish to Proceed?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' , null);
          } }
        ]
      });
    } else {
      this.snotify.error('Please enter Paragraph', '', this.sharedService.getConfig(false));
    }
  }

  manualAutoBacklinkCountIncr(){
    if(!this.storyData['metadata']['totalLinkCount']){
      this.storyData['metadata']['totalLinkCount']=1;
      // this.saveStory(true);
    }else{
      this.storyData['metadata']['totalLinkCount']=this.storyData['metadata']['totalLinkCount']+1;
      // this.saveStory(true)
    }
  }
  manualAutoBacklinkCountDecr(){
    if(this.storyData['metadata']['totalLinkCount']==this.storyData['metadata']['autoBackLinkCount']
       && this.storyData['metadata']['totalLinkCount']>0
       && this.storyData['metadata']['autoBackLinkCount']>0)
       {
      this.storyData['metadata']['totalLinkCount']= this.storyData['metadata']['totalLinkCount']-1;
      this.storyData['metadata']['autoBackLinkCount']= this.storyData['metadata']['autoBackLinkCount']-1;
    }
    if (this.storyData['metadata']['totalLinkCount'] > this.storyData['metadata']['autoBackLinkCount']) {
      this.storyData['metadata']['totalLinkCount'] = this.storyData['metadata']['totalLinkCount'] - 1;
    }
    // this.saveStory(true);
  }
  addBacklinking() {
    let eventCategory='Auto Backlink';
    let eventAction=sessionStorage.getItem(StaticDataService.tenantName);
    let eventLabel='';
    let eventValue=null;
   this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
    if (this.storyData.elements.length > 0) {
      // this.snotify.info('Auto-Backlinking in progres...', '', this.sharedService.getConfig(false));
      const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true); // Omit props what i don't need
      this.snotify.confirm('Please Auto Backlink before formatting content. Auto backlinking will lead to a formatting loss. Do you wish to Proceed? ', '', {
        ...config,
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              //after 'yes' immediately remove toastr so that user can't be able to click twice
              this.snotify.remove(toast.id);
              this.autoBacklinkingInProgress = true;
              this.restService.http_get(
                this.config.get('product').utilUrl + '/api/cms/autobacklink' + '/' + this.storyData.id).subscribe((result) => {
                  this.snotify.clear();
                  setTimeout(e => {
                    this.autoBacklinkingInProgress = false;
                  }, 1000);
                  if (result['result'].includes('No')) {
                    this.snotify.warning(result['result'], '', this.sharedService.getConfig(false));
                    this.autoBackLinkList=[];
                    this.autoBackLinkList=result['autoBacklinkResponse'];
                    console.log('warning', this.autoBackLinkList)
                  } else {
                    this.initStoryView(this.storyData.id, false);
                    this.snotify.success(result['result'], '', this.sharedService.getConfig(false));
                    this.autoBackLinkList=[];
                    this.autoBackLinkList=result['autoBacklinkResponse'];
                    console.log('success', this.autoBackLinkList)

                  }
                  for (let ele of this.elReference['_results']) {
                    if (ele.cardData.type === 'paragraph') {
                      ele.loadView(false);
                    }
                    this.autoBacklinkingDone = true;
                  }
                  this.initStoryView(this.storyData.id, false)
                  //console.log(`backlinking story data ${this.storyData.id}`, this.storyData)
                }, (error) => {
                  console.log(error);
                });
                this.googleAnalytics("Skippable Alerts",'Please Auto Backlink before formatting content. Auto backlinking will lead to a formatting loss. Do you wish to Proceed? ',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' , null);

            }, bold: false
          },
          { text: 'No', action: (toast) => { this.snotify.remove(toast.id);
            this.googleAnalytics("Skippable Alerts",'Please Auto Backlink before formatting content. Auto backlinking will lead to a formatting loss. Do you wish to Proceed? ',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' , null);
          } }
        ]
      });

      //);
    } else {
      this.snotify.error('Please enter Paragraph', '', this.sharedService.getConfig(false));
    }

  }

  cancelAutobacklinking() {
    this.deleteBacklinking();
    this.subscriptionCheck = this.route.params.subscribe();
    this.subscriptionCheck.unsubscribe();
    this.autoBacklinkingInProgress = false;
    this.snotify.clear()
  }

  cancelAutomatedChartAddition() {
    console.log("Temo");
  }

  deleteBacklinking() {
    this.storyData['metadata']['autoBackLinked'] = false
    this.storyData['metadata']['autoBackLinkCount'] = 0
    this.storyData['metadata']['totalLinkCount'] = 0
    for (let ele of this.elReference['_results']) {
      ele.deleteBacklinking();
    }
    this.autoBacklinkingDone = false;
    this.saveStory(true);
    this.autoBackLinkList=[];//remove list
    console.log('deleteBacklinking data ', this.storyData)
  }

  sliceItemsOnViewCheck(arr) {
    const total = this.storyData.elements.length;
    const min = Math.min.apply(null, arr);
    const max = Math.max.apply(null, arr);
    // console.log(min, max);
    const start = ((min > this.buffer) ? (min - this.buffer) : 0);
    const end = (((max + this.buffer) < total) ? (max + this.buffer) : (total));
    // console.log(start, end);
    if (total > this.initialElementCount) {
      if (arr.length > 0) {
        // this.viewPortItems = $.extend(true, [], this.storyData.elements.slice(start, end));
        //this.viewPortItems = Object.assign([], this.storyData.elements.slice(start, end));
        if(start<(this.storyData.elements.indexOf(this.viewPortItems[0])))
        {
          let temparr = this.storyData.elements.slice(start, this.storyData.elements.indexOf(this.viewPortItems[0]));
          for(let k=temparr.length-1;k>=0;k--)
          {
            this.viewPortItems.unshift(temparr[k]);
          }
          //this.viewPortItems.unshift(this.storyData.elements.slice(start, this.storyData.elements.indexOf(this.viewPortItems[0])))
        }
        if(end>(this.storyData.elements.indexOf(this.viewPortItems[this.viewPortItems.length-1])))
        {
          let temparr = this.storyData.elements.slice(this.storyData.elements.indexOf(this.viewPortItems[this.viewPortItems.length-1])+1,end);
          for(let k=0;k<temparr.length;k++)
          {
            this.viewPortItems.push(temparr[k]);
          }
          //this.viewPortItems.push(this.storyData.elements.slice(this.storyData.elements.indexOf(this.viewPortItems[this.viewPortItems.length-1])+1,end));
          //Object.assign(this.viewPortItems,this.storyData.elements.slice(this.storyData.elements.indexOf(this.viewPortItems[this.viewPortItems.length-1])+1,end))
        }
      }
    } else {
      // this.viewPortItems = $.extend(true, [], this.storyData.elements);
      this.viewPortItems = Object.assign([], this.storyData.elements);
    }
  }

  focusOnElement(ev, direction) {
    if (direction.indexOf('lead|') > -1) {
      const dirsplit = direction.split('|');
      if (dirsplit[1] === 'up') {
        if (this.isCKEditorEnabled) {
          this.summaryEditor.editing.view.focus();
        } else {
          this.summaryEditor.focus();
        }
        this.setFocus('summary');
      }
      if (dirsplit[1] === 'down') {
        if (this.storyType !== 'liveblog' && this.storyType !== 'mintlite') {
          if (this.storyData.elements && (this.storyData.elements.length > 0)) {
            if (this.showTempPara
              && (this.storyData.elements[0] === this.hideElementId)
              && (this.storyType === 'story')
            ) {
              this.elRef['last'].setFocusOnThis('start');
            } else {
              this.elReference['_results'][0].setFocusOnThis('start');
            }
          } else {
            if (this.storyType === 'story') {
              this.elRef['last'].setFocusOnThis(ev.pos ? ev.pos : null);
            } else if (this.storyType === 'video') {
              // console.log('upload button cllled');
              this.elReference['first'].setFocusOnThis('start');
            } else if (this.storyType === 'listicle') {
              this.elListRef['_results'][0].setFocusOnThis('start');
            }
          }
        } else {
          if (this.isCKEditorEnabled) {
            this.introEditor.editing.view.focus();
          } else {
            this.introEditor.focus();
          }
        }
      }
    } else if (direction.indexOf('pinned|') > -1) {
      const dirsplit = direction.split('|');
      if (dirsplit[1] === 'up') {
        console.log('up');
      }
      if (dirsplit[1] === 'down') {
        console.log('down');
      }
    } else if (ev.current) {
      const index = this.storyData.elements.indexOf(ev.current);
      const viewPortIndex = this.viewPortItems.indexOf(ev.current);
      // console.log(index);
      if (direction === 'up') {

        if ((this.storyType === 'story')) {
          if (ev.current === 'newElement') {
            if (this.storyData.elements.length > 0) {
              if (this.storyData.elements.length > 1) {
                this.elReference['last'].setFocusOnThis(null);
              } else {
                if (this.isCKEditorEnabled) {
                  this.summaryEditor.editing.view.focus();
                } else {
                  this.summaryEditor.focus();
                }
                this.setFocus('summary');
              }
            } else {
              if (this.storyData.leadMedia.elements.length === 0) {
                if (this.isCKEditorEnabled) {
                  this.summaryEditor.editing.view.focus();
                } else {
                  this.summaryEditor.focus();
                }
                this.setFocus('summary');
              } else {
                this.leadelRef['_results'][0].setFocusOnThis(null);
              }
            }
          } else {
            if (viewPortIndex > -1) {
              if (viewPortIndex === 0 && index === 0) {
                if (this.storyData.leadMedia.elements.length > 0) {
                  this.leadelRef['_results'][0].setFocusOnThis(null);
                } else {
                  if (this.isCKEditorEnabled) {
                    this.summaryEditor.editing.view.focus();
                  } else {
                    this.summaryEditor.focus();
                  }
                  this.setFocus('summary');
                }
              } else {
                setTimeout(e => {
                  this.elReference['_results'][viewPortIndex - 1].setFocusOnThis(null);
                }, 50);
              }
            }
          }
        }

        if (this.storyType === 'gallery' || this.storyType === 'mediagallery') {
          if (this.storyData.elements && (this.storyData.elements.length > 0)) {
            if (this.storyData.elements[0] === ev.current) {
              if (this.isCKEditorEnabled) {
                this.summaryEditor.editing.view.focus();
              } else {
                this.summaryEditor.focus();
              }
              this.setFocus('summary');
            } else {
              this.elReference['_results'][viewPortIndex - 1].setFocusOnThis(null);
            }
          } else {
            if (this.isCKEditorEnabled) {
              this.summaryEditor.editing.view.focus();
            } else {
              this.summaryEditor.focus();
            }
            this.setFocus('summary');
          }
        }

        if (this.storyType === 'video') {
          if (this.storyData.leadMedia.elements.length === 0) {
            if (this.isCKEditorEnabled) {
              this.summaryEditor.editing.view.focus();
            } else {
              this.summaryEditor.focus();
            }
            this.setFocus('summary');
          } else {
            this.leadelRef['_results'][0].setFocusOnThis(null);
          }
        }

        if (this.storyType === 'listicle') {
          if (viewPortIndex > -1) {
            if (viewPortIndex === 0 && index === 0) {
              if (this.isCKEditorEnabled) {
                this.introEditor.editing.view.focus();
              } else {
                this.introEditor.focus();
              }
            } else {
              setTimeout(e => {
                this.elReference['_results'][viewPortIndex - 1].setFocusOnThis(ev.pos ? ev.pos : null);
              }, 50);
            }
          } else {
            if (ev.current === 'newListElement') {
              if (this.storyData.elements.length > 0) {
                const id = this.storyData.elements[this.storyData.elements.length - 1];
                const index2 = this.viewPortItems.indexOf(id);
                if (index2 > -1) {
                  this.elReference['_results'][index2].setFocusOnThis(ev.pos ? ev.pos : null);
                }
              } else {
                if (this.isCKEditorEnabled) {
                  this.introEditor.editing.view.focus();
                } else {
                  this.introEditor.focus();
                }
              }
            }
          }
        }

        if (this.storyType === 'liveblog' || this.storyType === 'mintlite') {
          if (viewPortIndex > -1) {
            if (viewPortIndex === 0 && index === 0) {
              // this.elLiveRef['_results'][0].setFocusOnThis(null);
              this.liveblogButton.nativeElement.focus();
            } else {
              setTimeout(e => {
                this.elReference['_results'][viewPortIndex - 1].setFocusOnThis(ev.pos ? ev.pos : null);
              }, 50);
            }
          } else {
            if (ev.current === 'newLiveblogElement') {
              if (this.isCKEditorEnabled) {
                this.introEditor.editing.view.focus();
              } else {
                this.introEditor.focus();
              }
            }
          }
        }
      }

      if (direction === 'down') {

        if (this.storyType === 'story') {
          if ((ev.current !== 'newElement') && (index > -1) && (viewPortIndex > -1)) {
            if (index < (this.storyData.elements.length - 2)) {
              this.elReference['_results'][viewPortIndex + 1].setFocusOnThis(ev.pos ? ev.pos : null);
            } else if (index === (this.storyData.elements.length - 2)) {
              this.elReference['last'].setFocusOnThis(ev.pos ? ev.pos : null);
            } else {
              if (this.showTempPara && this.elRef) {
                this.elRef['last'].setFocusOnThis(ev.pos ? ev.pos : null);
              } else {
                if (this.elReference['last'].cardId !== ev.current) {
                  this.elReference['last'].setFocusOnThis(ev.pos ? ev.pos : null);
                }
              }
            }
          }
        }

        if (this.storyType === 'gallery' || this.storyType === 'mediagallery') {
          if (index < (this.storyData.elements.length - 1)) {
            this.elReference['_results'][viewPortIndex + 1].setFocusOnThis(ev.pos ? ev.pos : null);
          } else {
            // console.log('upload button cllled');
            this.galleryUploadElement.nativeElement.focus();
          }
        }

        if (this.storyType === 'video') {
          if (this.storyData['elements'].length > 0) {
            this.elReference['_results'][0].setFocusOnThis(null);
          }
        }

        if (this.storyType === 'listicle') {
          if (viewPortIndex > -1) {
            if (index < (this.storyData.elements.length - 1)) {
              this.elReference['_results'][viewPortIndex + 1].setFocusOnThis('start');
            }
            if (index === (this.storyData.elements.length - 1)) {
              this.elListRef['_results'][0].setFocusOnThis('start');
            }
          } else {
            if (ev.current === 'newListElement') {
              this.listicleButton.nativeElement.focus();
            }
          }
        }

        if (this.storyType === 'liveblog' || this.storyType === 'mintlite') {
          // console.log(index);
          if (viewPortIndex > -1) {
            if (index < (this.storyData.elements.length - 1)) {
              this.elReference['_results'][viewPortIndex + 1].setFocusOnThis('start');
            }
            if (index === (this.storyData.elements.length - 1)) {
              // this.elListRef['_results'][0].setFocusOnThis('start');
              // this.mobprev.nativeElement.focus();
            }
          } else {
            // console.log(ev);
            if (ev.current === 'newLiveblogElement') {
              // console.log(this.liveblogButton);
              this.liveblogButton.nativeElement.focus();
            }
          }
        }
      }
    }
  }


  mergeParaWithUpper(ev) {
    // console.log(ev);
    if (ev.originalId) {
      const index = this.storyData['elements'].indexOf(ev.originalId);
      const viewPortindex = this.viewPortItems.indexOf(ev.originalId);
      if (!ev.content || ev.content === null || ev.content.trim() === '') {
        // console.log('check 1');
        this.viewPortItems.splice(viewPortindex, 1);
        this.storyData.elements.splice(index, 1);
        if (ev.current === 'newElement') {
          this.hideElementId = null;
        }
        setTimeout(e6 => {
          // console.log('check 2 here');
          this.checkIfLastIsPara(false);
        }, 500);
        // this.focusOnElement({
        //   current: ev.current
        // }, 'up');
        if (index >= 1) {
          // console.log('check 3 here');
          this.elReference['_results'][viewPortindex - 1].setFocusOnThis(null);
        } else {
          // console.log('check 4 here');
          this.focusOnElement({
            current: ev.current
          }, 'up');
        }
      } else {
        // console.log('check 2');
        if ((index > 0) && (viewPortindex > 0) && (this.elReference['_results'][viewPortindex - 1].cardData.type === 'paragraph')) {
          this.elReference['_results'][viewPortindex - 1].addContentInPara(ev.content);
          this.viewPortItems.splice(viewPortindex, 1);
          this.storyData.elements.splice(index, 1);
          setTimeout(e6 => {
            this.checkIfLastIsPara(false);
          }, 500);
        } else {
          this.focusOnElement({
            current: ev.current
          }, 'up');
        }
      }
    } else {
      // const index = this.storyData['elements'].indexOf(ev.current);
      // console.log('new Element is not saved yet');
    }
  }

  saveCardEmit(ev) {
    if (!this.storyData.elements || this.storyData.elements === null) {
      this.storyData.elements = [];
    }
    // console.log(ev);
    if (ev.type === 'post') {
      const first = (this.storyData && this.storyData !== null && this.storyData.elements && this.storyData.elements.length > 0)
        ? this.storyData.elements[0] : null;
      const last = (this.storyData && this.storyData !== null && this.storyData.elements && this.storyData.elements.length > 0)
        ? this.storyData.elements[this.storyData.elements.length - 1] : null;
      this.tempCardArray.elIds[this.tempCardArray.ids.indexOf(ev.tempViewId)] = ev.data;
      setTimeout(e6 => {
        this.removeTempCardView(ev.tempViewId);
      }, 20);
      if ((ev.format) === 'liveblog' || (ev.format) === 'mintlite') {
        this.viewPortItems.unshift(ev.data);
        this.storyData.elements.unshift(ev.data);
        setTimeout(e => {
          this.elLiveRef['last'].setFocusOnThis('start');
        }, 500);
        this.openPublish(false);
      } else {
        // console.log(first, last);
        const ind = this.viewPortItems.indexOf(last);
        if (ind > -1) {
          this.viewPortItems.splice(ind + 1, 0, ev.data);
        } else {
          this.viewPortItems.push(ev.data);
        }
        this.storyData.elements.push(ev.data);
        if (this.storyType === 'listicle') {
          setTimeout(e => {
            // console.log(this.elListRef);
            this.elListRef['_results'][0].setFocusOnThis('start');
          }, 500);
        }
      }
      this.currentcardID = String(ev.data);
      console.log(this.currentcardID);
    } else {
      // console.log('put');
    }
  }

  saveCardTemporarily(ev) {
    // console.log(ev);
    // console.log('temporarily saved');
    if (ev.format === 'liveblog' || ev.format === 'mintlite') {
      this.tempCardArray.ids.unshift(ev.id);
      this.tempCardArray.objs.unshift(ev.data);
      this.tempCardArray.elIds.unshift(null);
      this.tempCardArray.format.unshift(ev.format);
    } else {
      this.tempCardArray.ids.push(ev.id);
      this.tempCardArray.objs.push(ev.data);
      this.tempCardArray.elIds.push(null);
      this.tempCardArray.format.push(ev.format);
    }
    // console.log(this.tempCardArray);
  }

  removeTempCardView(id) {
    const index = this.tempCardArray.ids.indexOf(id);
    // console.log(id, index, this.tempCardArray, 'remove temporary');
    if (this.tempCardArray.objs.length > 0) {
      if (index > -1) {
        this.tempCardArray.ids.splice(index, 1);
        this.tempCardArray.objs.splice(index, 1);
        this.tempCardArray.elIds.splice(index, 1);
        this.tempCardArray.format.splice(index, 1);
      } else {
        // console.log('id not found');
      }
    }
  }

  deleteCardEmit(ev) {
    console.log('called delete function')
    const ind = this.viewPortItems.indexOf(ev);
    if (this.storyData.elements.indexOf(ev) > -1) {
      if (ind > -1) {
        this.viewPortItems.splice(ind, 1);
      }
      this.storyData.elements.splice(this.storyData.elements.indexOf(ev), 1);
      this.changeFlag = true;
    } else {
      // console.log('element id not found');
    }
    this.checkForSourceUrlInEmbed(null);
    // console.log('ev got deleted =>' + ev);
    if (this.storyType === 'story') {
      setTimeout(e => {
        this.checkIfLastIsPara(false);
      }, 50);
    }

    if (this.storyType === 'gallery' || this.storyType === 'mediagallery' || this.storyType === 'photostory') {
      if (this.storyData.leadMedia.elements && this.storyData.leadMedia.elements.indexOf(ev) > -1) {
        this.storyData.leadMedia.elements = [];
        this.storyData.ampValidated = false;
      }
    }
    if (this.elementDataArray && this.elementDataArray.length > 0) {
      this.elementDataArray = this.elementDataArray.filter(data => data.id !== ev);
    }
  }
  deleteCardEmitEmbedLiveblog(ev) {
    console.log('deleteCardEmitEmbedLiveblog called delete function')
    // this.storyData.pinnedArticles
    const ind = this.viewPoerItemLiveblogEmbed.indexOf(ev);
    if (this.storyData.elements.indexOf(ev) > -1) {
      if (ind > -1) {
        this.viewPoerItemLiveblogEmbed.splice(ind, 1);
      }
      this.storyData.elements.splice(this.storyData.elements.indexOf(ev), 1);
      this.changeFlag = true;
    }
    //same data remove from newnodes
     if (this.storyData.introElements.indexOf(ev) > -1) {
      if (ind > -1) {
        // this.viewPortItems.splice(ind, 1);
        this.viewPoerItemLiveblogEmbed.splice(ind, 1);
      }
      this.storyData.introElements.splice(this.storyData.introElements.indexOf(ev), 1);
      this.changeFlag = true;
    } else {
      // console.log('element id not found');
    }
    this.checkForSourceUrlInEmbed(null);
    // console.log('ev got deleted =>' + ev);
    if (this.storyType === 'story') {
      setTimeout(e => {
        this.checkIfLastIsPara(false);
      }, 50);
    }

    if (this.storyType === 'gallery' || this.storyType === 'mediagallery' || this.storyType === 'photostory') {
      if (this.storyData.leadMedia.elements && this.storyData.leadMedia.elements.indexOf(ev) > -1) {
        this.storyData.leadMedia.elements = [];
        this.storyData.ampValidated = false;
      }
    }
    if (this.elementDataArray && this.elementDataArray.length > 0) {
      this.elementDataArray = this.elementDataArray.filter(data => data.id !== ev);
    }
  }

  deletePinCardEmit(ev) {
    const ind = this.viewPortItems.indexOf(ev);
    if (this.storyData.pinnedArticles.indexOf(ev) > -1) {
      if (ind > -1) {
        this.viewPortItems.splice(ind, 1);
      }
      this.storyData.pinnedArticles.splice(this.storyData.pinnedArticles.indexOf(ev), 1);
      this.changeFlag = true;
    } else {
      // console.log('element id not found');
    }
    this.checkForSourceUrlInEmbed(null);
    if (this.elementDataArray && this.elementDataArray.length > 0) {
      this.elementDataArray = this.elementDataArray.filter(data => data.id !== ev);
    }
  }



  pinCardEmit(ev) {
    const ind = this.viewPortItems.indexOf(ev);
    if (this.storyData.elements.indexOf(ev) > -1) {
      if (ind > -1) {
        this.viewPortItems.splice(ind, 1);
      }
      this.storyData.elements.splice(this.storyData.elements.indexOf(ev), 1);
      // this.storyData.pinnedArticles.push(ev);
      this.storyData.pinnedArticles.splice(0, 0, ev);
      this.changeFlag = true;

    } else {
      // console.log('element id not found');
    }
    this.checkForSourceUrlInEmbed(null);
    if (this.elementDataArray && this.elementDataArray.length > 0) {
      this.elementDataArray = this.elementDataArray.filter(data => data.id !== ev);
    }
  }

  unPinCardEmit(ev) {
    if (this.storyData.pinnedArticles.indexOf(ev) > -1) {
      this.storyData.pinnedArticles.splice(this.storyData.pinnedArticles.indexOf(ev), 1);
      this.storyData.elements.push(ev);
      this.changeFlag = true;
    } else {
      // console.log('element id not found');
    }
    this.checkForSourceUrlInEmbed(null);
    if (this.elementDataArray && this.elementDataArray.length > 0) {
      this.elementDataArray = this.elementDataArray.filter(data => data.id !== ev);
    }

  }


  deleteVideoElement(ev) {
    if (this.storyData.elements.indexOf(ev) > -1) {
      // this.videoUrl = '';
      // this.videoUrlPopup = true;
    } else {
      // console.log('element id not found');
    }
  }

  getLeadMediaVideo(obj, autoEmbedded = false) {
    let paraid;
    let videoid;
    this.videoUrl = obj.standardEmbedCode != null || obj.standardEmbedCode !== undefined ? obj.standardEmbedCode : null;
    this.videoUrl = this.videoUrl.substring(this.videoUrl.indexOf('<iframe'), (this.videoUrl.indexOf('</div') > -1)?this.videoUrl.indexOf('</div'):this.videoUrl.length);
    const fd = new FormData();
    this.videoLeadImage = (obj.images && obj.images.img_720) ? obj.images.img_720 : '';
    fd.set('file', this.videoLeadImage);
    this.http.post(this.config.get('product').imageUploadUrl
      + this.config.get('product').imageUploadByUrlEndPoint, fd).
      subscribe(res => {
        this.cropperImageUrl.data = res['images']['original'];
        this.cropperImageUrl.url = res['images']['original'];
      })
    let videoCard;
    let paragraphCard;
    if (!autoEmbedded) {
      videoCard = JSON.parse(JSON.stringify(StaticDataService.defaultVideoCardData));
      videoCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      videoCard.title = obj.name;
      
      if (this.videoUrl.indexOf('src="//players.brightcove.net') > -1) {
        if (this.videoUrl.split('src="') && this.videoUrl.split('src="') !== null && this.videoUrl.split('src="').length > 1) {
          if (this.videoUrl.split('src="')[1].split('"')[0].charAt(0) === '/') {
            videoCard.video.embedUrl = 'https:' + this.videoUrl.split('src="')[1].split('"')[0];
            videoCard.video.body = this.videoUrl.replace('src="', 'src="https:');
          } else {
            videoCard.video.embedUrl = this.videoUrl.split('src="')[1].split('"')[0];
            videoCard.video.body = this.videoUrl;
          }
        }
      } else if (this.videoUrl.indexOf('src=\'//players.brightcove.net') > -1) {
        if (this.videoUrl.split('src=\'') && this.videoUrl.split('src=\'') !== null && this.videoUrl.split('src=\'').length > 1) {
          if (this.videoUrl.split('src=\'')[1].split('\'')[0].charAt(0) === '/') {
            videoCard.video.embedUrl = 'https:' + this.videoUrl.split('src=\'')[1].split('\'')[0];
            videoCard.video.body = this.videoUrl.replace('src=\'', 'src=\'https:');
          } else {
            videoCard.video.embedUrl = this.videoUrl.split('src=\'')[1].split('\'')[0];
            videoCard.video.body = this.videoUrl;
          }
        }
      } else if (this.sharedService.isEmbedStripEnabled() && this.videoUrl.indexOf('cdn.jwplayer.com') > -1) {
        if (this.videoUrl.indexOf('src="') > -1) {
          const url = this.videoUrl.split('iframe src="')[1].split('"')[0];
          videoCard.video.embedUrl = url;
          videoCard.video.body = this.sharedService.checkEmbed(this.videoUrl);
        } else if (this.videoUrl.indexOf('src=\'') > -1) {
          const url = this.videoUrl.split('iframe src=\'')[1].split('\'')[0];
          videoCard.video.embedUrl = url;
          videoCard.video.body = this.sharedService.checkEmbed(this.videoUrl);
        }
      } else {
        if (this.videoUrl.indexOf('src="') > -1) {
          videoCard.video.embedUrl = this.videoUrl.split('src="')[1].split('"')[0];
          videoCard.video.body = this.videoUrl;
        } else if (this.videoUrl.indexOf('src=\'') > -1) {
          videoCard.video.embedUrl = this.videoUrl.split('src=\'')[1].split('\'')[0];
          videoCard.video.body = this.videoUrl;
        } else {
          this.snotify.error('Enter a valid embed', '', this.sharedService.getConfig(false));
          return false;
        }
      }
    } else {
      videoCard = JSON.parse(JSON.stringify(StaticDataService.defaultEmbedCardData));
      videoCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      if (this.videoUrl.indexOf('src="') > -1) {
        const url = this.videoUrl.split('iframe src="')[1].split('"')[0];
        videoCard.embed.url = url;
        videoCard.embed.body = this.sharedService.checkEmbed(this.videoUrl);
      } else if (this.videoUrl.indexOf('src=\'') > -1) {
        const url = this.videoUrl.split('iframe src=\'')[1].split('\'')[0];
        videoCard.embed.url = url;
        videoCard.embed.body = this.sharedService.checkEmbed(this.videoUrl);
      }
    }
    videoCard.metadata.videoMetadata = {};
    videoCard.metadata.videoMetadata.duration = obj.duration;
    this.increasePendingCount();
    if(this.elementDestination === 'leadMedia'){
      this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      videoCard, result => {
        this.decreasePendingCount(null);
        if (this.elementDestination === 'leadMedia') {
          this.leadMediaVideoFlag = true;
          this.showLeadThumbnailCropper = true;
          this.storyData.leadMedia.elements = [result.id];
        } else if (this.elementDestination === 'elements') {
          this.decideTaskToPerformNew([result], 0, e => {
            setTimeout(() => {
              this.checkIfLastIsPara(false);
            }, 250);
          });
        }
        this.disableshowVideoGallery();

      });
    }else{
       //creating new element for pragraph which store video title
       if(this.storyType=='story'){
        paragraphCard=JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
      paragraphCard.domainId=videoCard.domainId;
      paragraphCard.paragraph.body=`<h2>Watch: ${obj.name}</h2>`
        this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      paragraphCard, result => {
        this.decreasePendingCount(null);
        if (this.elementDestination === 'leadMedia') {
          this.leadMediaVideoFlag = true;
          this.showLeadThumbnailCropper = true;
          this.storyData.leadMedia.elements = [result.id];
        } else if (this.elementDestination === 'elements') {
          paraid=result.id;
          this.decideTaskToPerformNew([result], 0, e => {
            // console.log('rsult',[result])
            console.log('e=>',e)
            setTimeout(() => {
              this.checkIfLastIsPara(false);
            }, 250);
            if(!e){
              this.restService.http_post(this.config.get('product').baseUrl
              + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
              videoCard, result => {
                this.decreasePendingCount(null);
                if (this.elementDestination === 'leadMedia') {
                  this.leadMediaVideoFlag = true;
                  this.showLeadThumbnailCropper = true;
                  this.storyData.leadMedia.elements = [result.id];
                } else if (this.elementDestination === 'elements') {
                  videoid=result.id;
                  let storyElements= this.storyData.elements;
                  let index= storyElements.findIndex((v)=>v==paraid)
                  storyElements.splice(index+1,0,videoid);
                  this.storyData.elements=[...storyElements];
                //  console.log(' this.storyData.elements', this.storyData.elements)
                  // this.storyData.elements.push(videoid);
                  // this.decideTaskToPerformNew([result], 0, e => {
                    setTimeout(() => {
                      this.checkIfLastIsPara(false);
                    }, 250);
                  // });
                }
                this.disableshowVideoGallery();
        
              });
            }
          });
        
        } 
      
      });

       }
     else{
      //for anyother story for video element
      //liveblog intro embed video element
      this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      videoCard, result => {
        this.decreasePendingCount(null);
        if (this.elementDestination === 'leadMedia') {
          this.leadMediaVideoFlag = true;
          this.showLeadThumbnailCropper = true;
          this.storyData.leadMedia.elements = [result.id];
        } else if (this.elementDestination === 'elements') {
          this.decideTaskToPerformNew([result], 0, e => {
            setTimeout(() => {
              this.checkIfLastIsPara(false);
            }, 250);
          });
        }
        this.disableshowVideoGallery();

      });

     }
    }
   
      //taking cache value
      console.log(this.storyData)
      if(this.storyData['leadMedia']['video'] && !!this.storyData['leadMedia']['video']['caption'])
          this.storyData['leadMedia']['video']['caption']='';

      if(this.storyData['leadMedia']['video'] && this.storyData['leadMedia']['video']['image'] && !!this.storyData['leadMedia']['video']['image']['caption'])
      this.storyData['leadMedia']['video']['image']['caption']='';
  }

  getLeadMediaId(obj) {
    this.SingleselectedFileFlag = true;
    this.SingleselectedGifFileFlag = false;
    if (!this.storyData.leadMedia
      || !this.storyData.leadMedia.elements
      || !this.storyData.leadMedia.id
      || !this.storyData.leadMedia.mediaType
    ) {
      this.storyData.leadMedia = {
        'elements': [],
        'id': null,
        'mediaType': null
      };
    }
    this.disableshowGallery();
    if (obj.type === 'wire') {
      this.saveCard(obj, 'leadMedia');
    } else {
      if (obj.id) {
        this.imageUploadInProgress = true;
        this.createDuplicateImageChild(obj.id, fn => {
          this.imageUploadInProgress = false;
          if (fn !== false) {
            // const imageUrl = this.sharedService.getImageOnPriority(fn.image.images, 'original');
            const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage +
              this.sharedService.getImageOnPriority(fn.image.images, 'original');
              let link=this.sharedService.getImageOnPriority(fn.image.images, 'original');
              //check whether link is null or not
              if(!link){
               this.showCropper = false;
               this.imageUploadInProgress = false;
               return this.snotify.error("Lead Media is not valid.",'',this.sharedService.getConfig(false))
              }
            this.showCropper = true;
            this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
              if (data !== false) {
                if (fn.hasOwnProperty('imageAmpValidated') && fn.imageAmpValidated) {
                  this.cropStartForImageFromInternalImages(fn, data);
                } else {
                  this.sharedService.checkImageForAMP(reader, flag => {
                    if (flag) {
                      this.cropStartForImageFromInternalImages(fn, data);
                    } else {
                      this.sharedService.showAMPConfirmPopup(() => { // yes
                        this.cropStartForImageFromInternalImages(fn, data);
                      },
                        () => { // no
                          this.cancelCropping();
                        }
                      );
                    }
                  });
                }
              } else {
                this.cancelCropping();
                this.snotify.error('Image path does not exist.', '', this.sharedService.getConfig(false));
              }
            });
          } else {
            // console.log('couldn\'nt create duplicate child');
          }
        });
        // console.log(this.storyData);
        this.changeFlag = true;
      }
    }
  }

  cropStartForImageFromInternalImages(element, data) {
    const imageUrl2 = this.isSecondImagePresent(element);
    if (imageUrl2) {
      this.sharedService.createObjectFromImageUrl(imageUrl2, (data2, reader2) => {
        if (data2 !== false) {
          this.setCroppingData(element, {
            data: data.data,
            url: data.url,
            data2: data2.data,
            url2: data2.url
          });
        } else {
          this.cancelCropping();
          this.snotify.error('Image path does not exist for second image.', '', this.sharedService.getConfig(false));
        }
      });
    } else {
      this.setCroppingData(element, data);
    }
  }

  setCroppingData(element, data) {
    this.tempLeadMedia = element.id;
    this.cropperImageUrl = data;
  }

  isSecondImagePresent(element) {
    const elementImageURL2 = this.isMultipleLeadImageAllowed && element['image']['images'].hasOwnProperty('original2')
      ? element['image']['images']['original2'] : false;
    const imageUrl2 = elementImageURL2 ?
      (this.config.get('product').baseUrl + StaticDataService.proxyImage + elementImageURL2) : false;
    return imageUrl2;
  }

  getphotogalleryIds(obj, elementPosition?) {
    this.disableshowGallery();
    if(obj.length > 0) {
      this.showLoader = true;
      this.imageCroppingQue = [];
      this.croppingInProgress = false;
      this.destroyStoryAutoSaveInterval();
      
      for (let i = 0; i < obj.length; i++) {
        const element = obj[i];
        const imagePath = element;
        if (element.imgtype === 'wire') {
          console.log("HERE IT IS")
          // this.saveCard(element, 'elements');
          const defaultImagecardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
          defaultImagecardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
          const fd = new FormData();
          fd.set('file', imagePath.id);
          this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadByUrlEndPoint, fd).
          subscribe(res => {
          this.decreasePendingCount(null);
          if (defaultImagecardData && res && !res.hasOwnProperty('error')) {
            defaultImagecardData.id = null;
            defaultImagecardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
            defaultImagecardData.image.images['original'] = res['images']['original'];
            defaultImagecardData.image.caption = imagePath.data.caption ? imagePath.data.caption : '';
            defaultImagecardData.image.imageCredit = imagePath.data.credit ? imagePath.data.credit : '';
            defaultImagecardData.metadata.authors = imagePath.data.byLine ? [imagePath.data.byLine] : [];
            defaultImagecardData.metadata.agency = imagePath.data.agency ? imagePath.data.agency : '';

            this.increasePendingCount();
            this.restService.http_post(this.config.get('product').baseUrl
              + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
              defaultImagecardData, result => {
                // this.showLoader = false;
                console.log('result -- > ', result);

                    if(elementPosition && elementPosition == 'top')
                      this.viewPortItems.unshift(result.id);
                    else
                      this.viewPortItems.push(result.id);

                    if(elementPosition && elementPosition == 'top')
                      this.storyData.elements.unshift(result.id);
                    else
                      this.storyData.elements.push(result.id);
                    
                    setTimeout(e => {
                      this.elReference['_results'][this.viewPortItems.indexOf(result.id)].onelementFocus();
                      // this.startCroppingGallery(result.id);
                      this.imageCroppingQue.push(result.id);
                      this.triggerSequentialCropping();
                      // this.showLoader = false;
                    }, 1000);

                  if (i == obj.length - 1) {
                    this.generateStoryAutoSaveInterval();
                  }
                  this.decreasePendingCount(null);
                }
              );
          }
        },
          err => {
            if(err.status==404){
            this.snotify.error( err.error.errorMessage,this.sharedService.getConfig(false))
            }
              this.showCropper = false;
              this.imageUploadInProgress = false;
              this.imageUploadInProgress = false;
          });
        } else {
          console.log('inside else :::>>>> ');
          if (this.storyData.elements.indexOf(element.id) < 0) {
            this.createDuplicateImageChild(element.id, fn => {
              if (fn !== false) {

                if(elementPosition && elementPosition == 'top')
                  this.viewPortItems.unshift(fn.id);
                else
                  this.viewPortItems.push(fn.id);

                if(elementPosition && elementPosition == 'top')
                  this.storyData.elements.unshift(fn.id);
                else
                  this.storyData.elements.push(fn.id);

                setTimeout(e => {
                  // this.startCroppingGallery(fn.id);
                  this.imageCroppingQue.push(fn.id);
                  this.triggerSequentialCropping();
                  // this.showLoader = false;
                }, 1000);
              
                
              } else {
                // console.log('couldn\'nt create duplicate child');
              }
              if (i == obj.length - 1) {
                this.generateStoryAutoSaveInterval();
              }
            });
          } else {
            this.snotify.info(element.id + ' already exists in gallery', '', this.sharedService.getConfig(false));
            // this.toastr.info('<img width="120px" alt="" src="'
            //   + this.elReference['_results'][this.storyData.elements.indexOf(element.id)].cardData.image.images['960x540']
            //   + '"> <span style="color: white;">Image already exists</span>');
          }
        }
      }
      console.log(this.storyData.elements)

      this.changeFlag = true;
    }
  }
  
  
  startCroppingGallery(id: any) {
    if (this.cropAllGallery) {
     let cropped = this.elReference['_results'][this.viewPortItems.indexOf(id)].startCropping();
     if(cropped == false) {
      this.imageCroppingQue.push(id);
      this.croppingInProgress = false;
      // this.triggerSequentialCropping();
     }
    }
  }

  updatePhotoStoryLeadMedia(ev) {
    if (this.storyData && this.storyData.leadMedia && this.storyData.leadMedia.elements && this.storyData.leadMedia.elements[0]
      && (this.storyData.leadMedia.elements[0] === ev)) {
      this.storyData.leadMedia.elements = [];
      this.storyData.imageAmpValidated = false;
    } else {
      this.storyData.leadMedia.elements = [ev];
      this.storyData.imageAmpValidated = this.Elements[ev].imageAmpValidated;
    }
  }

  currentCardId(ev) {
    this.lastFocusedCard = this.focusedCard ? this.focusedCard : ev;
    this.focusedCard = ev;
    // console.log(this.lastFocusedCard);
    // console.log(this.focusedCard);
  }

  getImageParents(ev) {
    // console.log(ev);
    if (this.excludeImageListingIds.indexOf(ev) < 0) {
      this.excludeImageListingIds.push(ev);
    }
  }

  ampValidationInput(ev) {
    this.storyData.imageAmpValidated = (ev && ev !== null) ? true : false;
  }

  deleteImageParents(ev) {
    // console.log(ev);

    const index = this.excludeImageListingIds.indexOf(ev);
    if (index > -1) {
      this.excludeImageListingIds.splice(index, 1);
    }
  }

  // versioning start

  changeViewInReadMode(storyObject) {
    // this.storyData = storyObject ? $.extend(true, {}, storyObject) : null;
    this.storyData = storyObject ? Object.assign({}, storyObject) : null;
    this.headline = storyObject.mobileHeadline;
    this.summary = storyObject.summary;
    this.sectionQuery = storyObject.metadata.section;
    this.agencyQuery = storyObject.metadata.agency;
    this.columnQuery = storyObject.metadata.column;
    this.attributionQuery = storyObject.metadata.attribution;
    this.subSectionQuery = storyObject.metadata.subSection;
    this.categoryQuery = storyObject.metadata.category;
    this.brandQuery = storyObject.metadata.brand;
    this.modelQuery = storyObject.metadata.model;
    this.changeFlag = false;
    setTimeout(e => {
      this.setMetaFields();
    }, 20);
  }

  transformStoryView(storyObject: any, index) {
    // console.log('updating to this', storyObject);
    const self = this;
    if (storyObject && !this.ifVersionTimeline) {
      this.previousVersionstoryData = this.storyData;
      // console.log(storyObject);
      // this.storyData = storyObject ? $.extend(true, {}, storyObject) : null;
      this.storyData = storyObject ? Object.assign({}, storyObject) : null;
      this.headline = storyObject.mobileHeadline;
      this.summary = storyObject.summary;
      this.sectionQuery = storyObject.metadata.section;
      this.agencyQuery = storyObject.metadata.agency;
      this.columnQuery = storyObject.metadata.column;
      this.attributionQuery = storyObject.metadata.attributionQuery;
      this.subSectionQuery = storyObject.metadata.subSection;
      this.categoryQuery = storyObject.metadata.category;
      this.brandQuery = storyObject.metadata.brand;
      this.modelQuery = storyObject.metadata.model;
      // this.subSectionL2Query = storyObject.metadata.subSectionL2;
      if (!index) {
        this.changeFlag = false;
      }
      // if (this.lastFocusedElement) {
      //   this.lastFocusedElement.focus();
      // }
      setTimeout(e => {
        this.setMetaFields();
      }, 20);
    } else if (index) {
      if (this.ifVersionTimeline) {
        const length = this.versionHistory['changes'].length;
        const newData = this.versionHistory['changes'][length - index - 1];
        // console.log(newData);
        // this.storyData = $.extend(true, {}, newData);
        this.storyData = Object.assign({}, newData);
        this.headline = newData.mobileHeadline;
        this.summary = newData.summary;
        this.sectionQuery = newData.metadata.section;
        this.agencyQuery = newData.metadata.agency;
        this.columnQuery = newData.metadata.column;
        this.attributionQuery = newData.metadata.attribution;
        this.subSectionQuery = newData.metadata.subSection;
        this.categoryQuery = newData.metadata.category;
        this.brandQuery = newData.metadata.brand;
        this.modelQuery = newData.metadata.model;
        this.destroyStoryAutoSaveInterval();
        this.ifVersionTimeline = false;
      } else {
        // console.log('fix this');
      }
    } else {
      // console.log('nothing was provided in versioning');
    }
  }

  setMetaFields() {
    if (this.sectionSuggestion.indexOf(this.sectionQuery) > -1) {
      this.selectAutoComplete('section', this.sectionQuery);
      if (this.subSectionSuggestion[this.sectionQuery].indexOf(this.subSectionQuery) > -1) {
        this.selectAutoComplete('subSection', this.subSectionQuery);
      } else {
        this.subSectionQuery = '';
      }
    } else {
      this.sectionQuery = '';
      if (this.allSubSections.indexOf(this.subSectionQuery) > -1) {
        this.selectAutoComplete('subSection', this.sectionQuery);
        for (const subSectionArr in this.subSectionSuggestion) {
          if (subSectionArr) {
            const key = subSectionArr;
            const array = this.subSectionSuggestion[key];
            if (array.includes(this.subSectionQuery) > -1) {
              this.sectionQuery = key;
              this.selectAutoComplete('section', key);
            }
          }
        }
      } else {
        this.subSectionQuery = '';
      }
    }

    if(this.categorySuggestion.indexOf(this.categoryQuery) > -1)
    {
      this.selectAutoComplete('category', this.categoryQuery);
    }
    if (this.brandSuggestionMain.indexOf(this.brandQuery) > -1) {
      this.selectAutoComplete('brand', this.brandQuery);
      if (this.modelSuggestionMain[this.brandQuery].indexOf(this.modelQuery) > -1) {
        this.selectAutoComplete('model', this.modelQuery);
      } else {
        this.modelQuery = '';
      }
    } else {
      this.brandQuery = '';
      if (this.allModels.indexOf(this.modelQuery) > -1) {
        this.selectAutoComplete('model', this.brandQuery);
        for (const modelArr in this.modelSuggestionMain) {
          if (modelArr) {
            const key = modelArr;
            const array = this.modelSuggestionMain[key];
            if (array.includes(this.modelQuery) > -1) {
              this.brandQuery = key;
              this.selectAutoComplete('brand', key);
            }
          }
        }
      } else {
        this.modelQuery = '';
      }
    }

    if (this.agencySuggestion.indexOf(this.agencyQuery) > -1) {
      this.selectAutoComplete('agency', this.agencyQuery);
    } else {
      this.agencyQuery = '';
    }
    if (this.contentBucketSuggestion.indexOf(this.contentBucketQuery) > -1) {
      this.selectAutoComplete('contentBucket', this.contentBucketQuery);
    } else {
      this.contentBucketQuery = '';
    }

    if (this.primaryLocationSuggestion.indexOf(this.primaryLocationQuery) > -1) {
      this.selectAutoComplete('primaryLocation', this.primaryLocationQuery);
    } else {
      this.primaryLocationQuery = '';
    }

    if (this.columnSuggestion.indexOf(this.columnQuery) > -1) {
      this.selectAutoComplete('column', this.columnQuery);
    } else {
      this.columnQuery = '';
    }
    if (this.attributionSuggestion.indexOf(this.attributionQuery) > -1) {
      this.selectAutoComplete('attribution', this.attributionQuery);
    } else {
      this.attributionQuery = '';
    }
  }

  openVersionInPreview(index) {
    // const self = this;
    // if (!this.versionLock) {
    //   this.previousVersionstoryData = $.extend(true, {}, self.storyData);
    // }
    // // console.log(index);
    // this.storyEditMode = false;
    // this.versionLock = true;
    // this.ifVersionTimeline = true;
    // this.transformStoryView(null, index);
    let eventCategory='Story Versioning';
    let eventAction=sessionStorage.getItem(StaticDataService.tenantName);
    let eventLabel='';
    let eventValue=null;
   this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)

    this.storyDataToRestore = cloneDeep(this.storyData);
    this.enableRestoreVersion = true;
    this.revertedIndex = cloneDeep(index);
    this.elementDataToRestore = [];
    //const elementMap = JSON.parse(JSON.stringify(this.Elements));
    const elementMap = cloneDeep(this.Elements);
    for (let ids in elementMap) {
      this.elementDataToRestore.push(elementMap[ids]);
    }
    let versionNumber = this.versionHistory['changes'].length - 1 - index;
    console.log("versionNumber ::: ", versionNumber);
    if (this.versionHistory['elementChanges'] && this.versionHistory['elementChanges'][versionNumber]) {
      //this.viewPortItems = [];
      let data = cloneDeep(this.versionHistory['changes'][index]);
      let elements = cloneDeep(this.versionHistory['elementChanges'][versionNumber]);
      this.restoreGivenVersion(data, elements, false);
      // this.Elements = {};
      // this.elementChangeData = {};
      // for (const el of elements) {
      //   this.getUpadtedElementContent(el);
      //   this.getCardDatafromElement(el);
      // }
      // this.initChangeStoryVersionView(data);
      // this.callManualSaveFromVersion = true;
      // this.manualSave();
    }
    else {
      //element history doesnot exist;
    }
  }

  restoreCurrentVersion() {
    this.revertedIndex = -1;
    let data = cloneDeep(this.storyDataToRestore);
    let elements = cloneDeep(this.elementDataToRestore);
    this.restoreGivenVersion(data, elements, true);
    this.enableRestoreVersion = false;
  }

  restoreGivenVersion(data: any, elements: any, restoreCurrent: boolean) {
    this.Elements = {};
    this.elementChangeData = {};
    for (const el of elements) {
      this.getUpadtedElementContent(el);
      this.getCardDatafromElement(el);
    }
    this.elementDataLoaded = false;
    this.initChangeStoryVersionView(data, restoreCurrent);
    this.callManualSaveFromVersion = true;
    this.manualSave();
  }


  reloadStoryAndElements() {
    if (this.storyData['elements'] && (this.storyData['elements'].length > 0)) {
      this.viewPortItems = Object.assign([], (
        (this.storyData['elements'].length > this.initialElementCount)
          ? this.storyData['elements'].slice(0, this.initialElementCount)
          : this.storyData['elements']));
    }
    this.changeDetector.detectChanges();
  }


  initChangeStoryVersionView(data: any, restoreCurrent: boolean) {

    //stop autosave ass we are changing story data
    this.destroyStoryAutoSaveInterval();

    //change elements that needs to be changed
    this.viewPortItems = [];
    this.storyData.leadMedia.elements = null;
    this.storyData.elements = [];

    this.changeDetector.detectChanges();
    if (this.storyData['type'] == 'photostory') {
      this.revertElements = cloneDeep(data.elements);
      data.elements = this.storyData.elements;
    }
    this.storyData = data;

    //retain data that needs not to be changed like status, lockedby fields etc;
    if (!restoreCurrent) {
      let previousStoryData = cloneDeep(this.storyDataToRestore);
      this.storyContainerService.retainStoryData(this.storyData, previousStoryData);
    }
    // this.storyData.metadata.status = JSON.parse(JSON.stringify(this.storyDataToRestore.metadata.status));
    // this.storyData.lockedByUserId = this.storyDataToRestore.lockedByUserId;
    // this.storyData.lockedByUserName = this.storyDataToRestore.lockedByUserName;
    // this.storyData.lockedDate = this.storyDataToRestore.lockedDate;

    if (data.wireFeedId && data.wireFeedId !== null) {
    } else {
      this.showLanuageTab = true;
    }
    if (data['headline'] && (data['headline'] !== '')
      && (data['mobileHeadline'] === null || data['mobileHeadline'] === '')) {
      this.headline = data['headline'];
      data['mobileHeadline'] = data['headline'];
    } else {
      this.headline = data.mobileHeadline;
    }
    this.setImageCaption(data);
    if (this.sharedService.currentDomainConfiguration['notificationPlatformsEnabled'].indexOf('webengage') > -1) {
      this.fetchWebengageAnalyticsUrl(data);
    }
    if ((data['type'] != 'photostory' && data['elements'] && (data['elements'].length > 0)) || (data['type'] == 'photostory' && this.revertElements && (this.revertElements.length > 0))) {
      this.elementCountFlag = true;
      this.wirePreviewStory = $.extend(true, {}, data);
      this.wirePreviewStory.headline = this.headline;
      if (data['type'] != 'photostory') {
        this.storyData['elements'] = this.storyData['elements'].filter(e => (e !== null));
      }
      else {
        this.revertElements = this.revertElements.filter(e => (e !== null));
      }
      this.elementDataLoaded = true;
      if (data['type'] === 'story') {
        const newResArray = this.storyData['elements'].map(e => this.Elements[e]);
        const len = newResArray.length;
        if (len > 0 && [len - 1] && newResArray[len - 1]['type'] === 'paragraph') {
          this.showTempPara = false;
          this.tempParaId = null;
        } else {
          this.showTempPara = true;
          this.tempParaData = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
          this.tempParaData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
        }
      }
      if (this.storyData.metadata.secondarySections === null) {
        this.storyData.metadata.secondarySections = [];
      }
      if (this.storyData.metadata.secondaryBrands === null) {
        this.storyData.metadata.secondaryBrands = [];
      }
      if (this.storyData.metadata.deadLinkUrl === null) {
        this.storyData.metadata.deadLinkUrl = '';
      }
    } else {
      this.storyData = data;
      this.showTempPara = true;
      this.tempParaData = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
      this.tempParaData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      this.elementDataLoaded = true;
    }
    this.summary = data.summary;
    console.log('word init change story version view');
    this.changeFlag = true;
    this.saveStory(false);

    if (+data.metadata.homePagePosition > 0 || data.metadata.homePageEndTime) {
      this.homepageToggle = true;
      const nowDate = new Date(this.storyData.metadata.homePageEndTime);
      this.homepageCalendarConfig['startDate'] =
        (((nowDate.getMonth() + 1) > 10) ? (nowDate.getMonth() + 1) : '0' + (nowDate.getMonth() + 1))
        + '/' + ((nowDate.getDate() > 10) ? nowDate.getDate() : '0' + nowDate.getDate())
        + '/' + nowDate.getFullYear()
        + ' ' + nowDate.getHours() + ':' + nowDate.getMinutes();
      this.setCalendarMinDateForHomepageOption();
    }
    if (data.metadata.outdatedTime) {
      const nowDate = new Date(this.storyData.metadata.outdatedTime);
      this.endTimeCalendarConfig['startDate'] =
        (((nowDate.getMonth() + 1) > 10) ? (nowDate.getMonth() + 1) : '0' + (nowDate.getMonth() + 1))
        + '/' + ((nowDate.getDate() > 10) ? nowDate.getDate() : '0' + nowDate.getDate())
        + '/' + nowDate.getFullYear()
        + ' ' + nowDate.getHours() + ':' + nowDate.getMinutes();
      this.setCalendarMinDateForEndTime();
    }
    setTimeout(e => {
      if (this.headlineEditor) {
        if (this.isCKEditorEnabled) {
          this.headlineEditor.editing.view.focus();
        } else {
          this.headlineEditor.setSelection(
            ((data.mobileHeadline && data.mobileHeadline !== null) ? data.mobileHeadline.length : 0)
            , 0);
        }
      }
      this.setFocus('headline');
      if (data.type === 'story') {
        this.getRelatedStoryEmits(null);
      }

    }, 300);
    this.sharedService.setTitle(this.htmlToPlaintext(data.mobileHeadline));
    this.checkLastPublishedHeadline();
    this.setStoryData(null);
    this.discareUrlChanges(false);
    this.generateStoryAutoSaveInterval();

    if (data.metadata.breakingNews && data.metadata.breakingNewsId && data.title === '') {
      setTimeout(e => {
        this.addAutomaticBylineForBreakingNews();
      }, 500);
    }
    if (data.metadata.storyType == null) {
      this.storyData.metadata.storyType = 'DIGITAL';
    }
    if (this.storyData.metadata.section) {
      this.sectionQuery = this.storyData.metadata.section;
    }
    if (this.storyData.metadata.subSection) {
      this.subSectionQuery = this.storyData.metadata.subSection;
    }
    if (this.storyData.metadata.category) {
      this.categoryQuery = this.storyData.metadata.category;
    }
    if (this.storyData.metadata.brand) {
      this.brandQuery = this.storyData.metadata.brand;
    }
    if (this.storyData.metadata.model) {
      this.modelQuery = this.storyData.metadata.model;
    }
    if (this.storyData.metadata.agency) {
      this.agencyQuery = this.storyData.metadata.agency;
    }
    if (this.storyData.metadata.column) {
      this.columnQuery = this.storyData.metadata.column;
    }
    if (this.storyData.metadata.attribution) {
      this.attributionQuery = this.storyData.metadata.attribution;
    }
    if (this.storyData.metadata.primaryLocation) {
      this.primaryLocationQuery = this.storyData.metadata.primaryLocation;
    }
    this.focusOnHeadline = true;
    if (this.storyData.type === 'photogallery') {
      this.storyData.type = 'gallery';
      this.storyType = 'gallery';
    } else if (this.storyData && (this.storyData.type === 'highlights' || this.storyData.type === 'listicle')) {
      this.storyType = this.storyData.type;
      this.selectedType = this.storyData.type;
      this.sharedService.setValue(this.selectedType);
    } else if (this.storyData && (this.storyData.type === 'newsroom' || this.storyData.type === 'liveblog')) {
      this.storyType = 'liveblog';
      this.selectedType = this.storyData.type;
      this.sharedService.setValue(this.selectedType);
    } else if (this.storyData && (this.storyData.type === 'video')) {
      this.storyType = 'video';
      this.selectedType = this.storyData.type;
      this.sharedService.setValue(this.selectedType);
    } else {
      this.storyType = this.storyData.type;
    }
    this.summaryMaxLength = this.getSummaryMaxLength();
    this.setCalendarDate();
  }


  checkRestorableVersions(obj, index) {
    let versionNumber = this.versionHistory['changes'].length - 1 - index;

    if (this.enableVersionRestoration && this.enableVersionRestorationForStoryType !== undefined &&
      this.enableVersionRestorationForStoryType.split(',').indexOf(this.storyType) !== -1 && obj.metadata.status === 'PUBLISHED' &&
      !obj.metadata.killed && this.versionHistory['elementChanges'] && this.versionHistory['elementChanges'][versionNumber]) {
      return true;
    } else {
      return false;
    }
  }



  cancelOverrideVersion() {
    this.ifVersionTimeline = false;
    this.storyData = this.previousVersionstoryData;
    this.transformStoryView(this.previousVersionstoryData, null);
    this.storyEditMode = true;
    this.versionLock = false;
    this.previousVersionstoryData = null;
    this.overrideSave();
  }

  overrideStoryVersion() {
    this.storyEditMode = true;
    this.versionLock = false;
    this.overrideSave();
    this.previousVersionstoryData = null;
  }

  updateStack(object, forward) {
  }

  pushInVersionStack(object) {
  }

  getValuefromVersion(obj) {
    if (obj) {
      // console.log("obj",obj);
      const version = {
        state: obj.metadata.status ? ((obj.metadata.killed && obj.metadata.status === 'PUBLISHED')
          ? 'KILLED' : (obj.softPublished === true ? 'SOFT PUBLISHED' : obj.metadata.status)) : '',
        user: (obj.metadata.status === this.storyFlowArray[0][0]) ? obj.createdBy :
          (obj.softPublished === true) ? obj.lastModifiedByUserName :
            (obj.metadata.status === this.storyFlowArray[0][5]) ? obj.lastPublishedByUserName : obj.lastModifiedByUserName,
        time: (obj.metadata.status === this.storyFlowArray[0][0]) ? obj.createdDate :
          (obj.softPublished === true) ? obj.lastModifiedDate :
            (obj.metadata.status === this.storyFlowArray[0][5]) ? obj.lastPublishedDate : obj.lastModifiedDate
      };
      return version;
    } else {
      return null;
    }
  }
  // versioning end
  getDate(seconds) {
    if (seconds) {
      const date = new Date(seconds);
      return ((date.getHours() < 10) ? '0' + date.getHours() : date.getHours()) + ':'
        + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes());
    } else {
      return 'not present';
    }
  }

  getNewTypeVersionDate(datestring) {
    const dt = new Date(datestring.replace('+0000', 'Z'));
    return this.getVersionDate(Math.round(dt.getTime()));
  }

  getVersionDate(seconds) {
    if (seconds) {
      const date = new Date(seconds);
      const res =
        (this.monthNames[date.getMonth()])
        + ' '
        + (date.getDate())
        + ', '
        + (date.getFullYear())
        + ' ['
        + ((date.getHours() < 10) ? '0' + date.getHours() : date.getHours())
        + ':'
        + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes()
          + ']'
        );
      return res;
    } else {
      return 'not present';
    }
  }

  getFullDate(seconds) {
    if (seconds) {
      const date = new Date(seconds);
      const res = (
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours())
        + ':'
        + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes())
        + ' HRS, '
        + (this.monthNames[date.getMonth()])
        + ' '
        + (date.getDate())
        + ', '
        + (date.getFullYear())
      );
      return res;
    } else {
      return 'not present';
    }
  }

  getNewTypeDate(datestring) {
    if (datestring && datestring !== null) {
      const dt = new Date(datestring.replace('+0000', 'Z'));
      return this.getFullDate(Math.round(dt.getTime()));
    } else {
      return 'not present';
    }
  }

  htmlToPlaintext(text) {
    if (typeof text === 'string') {
      return text ? this.htmlSpecialCharToText(String(text).replace(/<[^>]+>/gm, '')) : '';
    } else {
      return text;
    }
  }

  showImagePopUpTop = false;

  showGallery(elementPosition?) {
    this.showImagePopUpTop = elementPosition == 'top' ? true : false;
    this.isLightbox = true;
    this.isPhotopopup = true;
    this.leadMediaImageToggle = true;
    this.sharedService.overflowhidden();
  }
  showViewImages() {
    // this.sharedService.overflowhidden();
    this.disableshowGallery();
    this.getViewImageList();
  }
  disableshowGallery() {
    this.isLightbox = false;
    this.isPhotopopup = false;
    this.leadMediaImageToggle = false;
    // for photgallery viewimages//
    this.showViewImagePopup =  false;
    this.isDraggedImages=false;
    //--------------------------//
    this.sharedService.overflowauto();
  }
  getViewImageList(){
    this.viewImagesData=[];
if(!!this.storyData && this.storyData.elements.length>0){
    this.restService.http_post(this.config.get('product').baseUrl
    + '/api/cms/element/get-all-by-ids/',
    this.storyData.elements, result => {
      this.isLightbox = true;
      this.showViewImagePopup =  true;
      this.viewImagesData= result;
    }),
    err => {
       console.log('getViewImageList',err);
    }
  }   

  }
  showVideoGallery(destination) {
    this.isLightboxVideo = true;
    this.isVideopopup = true;
    this.leadMediaVideoToggle = true;
    this.elementDestination = destination;
    this.sharedService.overflowhidden();
    if(destination=='elements'){
      let eventCategory='Insert Video';
    let eventAction=sessionStorage.getItem(StaticDataService.tenantName);
    let eventLabel='';
    let eventValue=null;;
    this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue);
    }
  }
  showVideoGalleryLiveblogEmbed(destination,flag) {
    console.log('called showVideoGalleryLiveblogEmbed')
    this.isLiveblogEmbedCalled=flag;
    this.isLightboxVideo = true;
    this.isVideopopup = true;
    this.leadMediaVideoToggle = true;
    this.elementDestination = destination;
    this.sharedService.overflowhidden();
  }
  disableshowVideoGallery() {
    this.isLightboxVideo = false;
    this.isVideopopup = false;
    this.leadMediaVideoToggle = false;
    this.elementDestination = null;
    if(this.enableJW === 'true')
    {
      this.showJW = true;
      this.showYT = false;
    }
    else if(this.enableYT)
    {
      this.showJW = false;
      this.showYT = true;
    }
    this.sharedService.overflowauto();
  }
  deleteImageCardEmit(ev) {
    // console.log((this.Elements[ev]));
    if (this.storyData.leadMedia.elements.indexOf(ev) > -1) {
      this.storyData.leadMedia.elements.splice(this.storyData.leadMedia.elements.indexOf(ev), 1);
      this.storyData.leadMedia.defaultImage = false;
      delete (this.Elements[ev]);
      this.storyData.imageAmpValidated = false;
      this.changeFlag = true;
    } else if (this.storyData.leadMediaGif.elements.indexOf(ev) > -1) {
      this.storyData.leadMediaGif.elements.splice(this.storyData.leadMediaGif.elements.indexOf(ev), 1);
      this.storyData.leadMediaGif.defaultImage = false;
      delete (this.Elements[ev]);
      this.storyData.imageAmpValidated = false;
      this.changeFlag = true;
    } else {
      // console.log('element id not found');
    }
    this.isPhotopopup = false;
    this.sharedService.overflowauto();
  }

  openInlineImageOption(type) {
    let eventCategory;
    let eventAction = sessionStorage.getItem(StaticDataService.tenantName);
    let eventLabel='';
    let eventValue=null;
    if (type === 'image') {
      this.inlineImageToggle = !this.inlineImageToggle;
      eventCategory='Insert Image';
      this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue);
    } else if(type === 'sample_image') {
      this.sampleImageToggle = !this.sampleImageToggle;
      console.log("clicked")
    } else if (type === 'embed') {
      this.inlineEmbedToggle = !this.inlineEmbedToggle;
      eventCategory='Insert Embed';
      this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue);
    } else if (type === 'table') {
      this.inlineTableToggle = !this.inlineTableToggle;
    }
    else {
      this.inlineReviewToggle = !this.inlineReviewToggle;
      eventCategory='Insert Review';
      this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue);
    }
  }
  openInlineImageOptionLiveblogEmbed(type,flag) {
    if (type === 'image') {
      this.inlineImageToggle = !this.inlineImageToggle;
    }
  }

  addInlineImage() {
    this.inlineImageFlag = true;
    this.sharedService.overflowhidden();
  }

  addSampleFromGallery() {
    this.sampleGalleryFlag = true;
  }

  addInlineImageLiveblogEmbed(flag) {
    console.log('called addInlineImageLiveblogEmbed')
    this.isLiveblogEmbedCalled=flag;
    this.inlineImageFlag = true;
    this.sharedService.overflowhidden();
  }


  addStepsInlineImage(currentStep, type) {
    if(type === 'howToSteps') { this.howToStepsInlineImageFlag = true; }
    if(type === 'recipe') { this.recipeInlineImageFlag = true; }
    this.sharedService.overflowhidden();
    this.updateCurrentHowToStep(currentStep);
  }

  updateCurrentHowToStep(currentStep) {
    this.currentStep = currentStep;
  }

  disableInlineImage() {
    this.inlineImageFlag = false;
    this.inlineImageToggle = false;
    this.sharedService.overflowauto();
  }

  disableSampleImage() {
    this.sampleGalleryFlag = false;
    this.sampleImageToggle = false;
    this.sharedService.overflowauto();
  }

  disableStepsInlineImage() {
    this.howToStepsInlineImageFlag = false;
    this.recipeInlineImageFlag = false;
    // this.inlineImageToggle = false; // TBC
    this.sharedService.overflowauto();
  }

  multipleInlineUpload(event, model) {
    
    const Files = event.target.files;
    const length = Files['length'];
    this.tempElementList = [];
    this.showLoader = true;
    let tempId;
    if (event.target.files && (event.target.files.length > 0)) {
      
      //this.destroyStoryAutoSaveInterval();
      let hasAnImage = false;
      for (let i = 0; i < length; i++) {
        let file_name = <File>event.target.files[i].name;
        console.log(file_name)
        const image = <File>Files[i];
        if(!this.checkSpecialChars(file_name)){
          if ((image.size / 1000000) <= 11) {
            hasAnImage = true;
            this.destroyStoryAutoSaveInterval();
            const fd = new FormData();
            fd.append('file', image, image.name);
            this.increasePendingCount();
            this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadEndPoint, fd).
              subscribe(res => {
                this.decreasePendingCount(null);
                  this.saveCardByPath(res['images'].original, 'tempElements', null, null, (id) => {
                    if(i === 0) {
                      this.createDuplicateImageChild(id, fn => {
                        if (fn !== false) {
                          const arr = [];
                          arr.push(fn);
                          tempId = fn.id;
                          this.decideTaskToPerformNew(arr, 0, e => {
                            setTimeout(() => {
                              this.checkIfLastIsPara(false);
                            }, 250);
                          });
                        }
                      });
                    } else {
                      this.tempElementList.push(id)
                    }
                  });
              },
                err => {
                  this.decreasePendingCount(null);
                  this.showLoader = false;
                });
          }
          if (i === (length - 1)) {
            setTimeout(e => {
              let insertIndex = this.storyData.elements.indexOf(tempId)
              for(let ix=0; ix < this.tempElementList.length; ix++) {
                this.createDuplicateImageChild(this.tempElementList[ix], fn => {
                  if (fn !== false) {
                    this.viewPortItems.splice(insertIndex+1, 0, fn.id);
                    this.storyData.elements.splice(insertIndex+1, 0, fn.id);
                  }
                });
              }
              this.changeFlag = true;
              this.generateStoryAutoSaveInterval();
              this.showLoader = false;
            }, 2000);
          }
        } else {
          this.showLoader = false;
        }
       

      }
    }
    event.target.value = null;
    this.isLightbox = false;
    this.leadMediaImageToggle = false;
    this.inlineImageToggle = false;
  }

  multipleSampleUpload(event, model) {
    const Files = event.target.files;
    const length = Files['length'];
    this.tempElementList = [];
    this.showLoader = true;
    let tempId;
    if (event.target.files && (event.target.files.length > 0)) {
      let hasAnImage = false;
      this.sampleImgList = [];
      for (let i = 0; i < length; i++) {
        let file_name = <File>event.target.files[i].name;
        console.log(file_name)
        const image = <File>Files[i];
        if(!this.checkSpecialChars(file_name)) {
          if ((image.size / 1000000) <= 11) {
            hasAnImage = true;
            const fd = new FormData();
            fd.append('file', image, image.name);
            this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadEndPoint, fd).
              subscribe(res => {
                this.saveCardByPath(res['images'].original, 'sampleimages', null, null, (id) => {
                  this.sampleImgList.push(id);
                  if (i === (length - 1)) {
                    setTimeout(e => {
                      console.log("LAST")
                      this.showLoader = false;
                      this.makeSampleImageElement();
                    }, 2000);
                  }
                });
              },
                err => {
                  this.decreasePendingCount(null);
                  this.showLoader = false;
                });
          }
        } else {
          this.showLoader = false;
        }
       
      }
    }
    event.target.value = null;
    // this.isLightbox = false;
    // this.leadMediaImageToggle = false;
    // this.inlineImageToggle = false;
  }

  makeSampleImageElement() {
    const card = JSON.parse(JSON.stringify(StaticDataService.defaultSampleImageCardData));
    card.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    card['sampleImagesIdList'] = this.sampleImgList;
    this.increasePendingCount();

    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      card, result => {
        this.decreasePendingCount(null);
        this.closeRelatedStoryModal(null);
        const arr = [];
        arr.push(result);
        this.decideTaskToPerformNew(arr, 0, e => {
          setTimeout(() => {
            console.log("first")
            this.checkIfLastIsPara(false);
          }, 250);
        });
      });

  }

  addMultipleInlineImages(ev) {
    this.disableInlineImage();
    let tempId;
    const element = ev[0];
    if (element.imgtype === 'wire') {
      this.saveCard(element, 'elements');
      if(ev.length > 1) {
        for(let i=1; i<ev.length; i++) {
          if (ev[i].imgtype === 'wire') {
            this.saveCard(ev[i], 'elements');
          }
        }
      }
    } else {
      if (this.storyData.elements.indexOf(element.id) < 0)
      {
        this.createDuplicateImageChild(element.id, fn => {
          if (fn !== false) {
            const arr = [];
            arr.push(fn);
            tempId = fn.id;
            this.decideTaskToPerformNew(arr, 0, e => {
              setTimeout(() => {
                this.checkIfLastIsPara(false);
                let insertIndex = this.storyData.elements.indexOf(tempId)
                if(ev.length > 1) {
                  for(let i=1; i<ev.length; i++) {
                    if(ev[i].imgtype === 'wire') {
                      for(let i=1; i<ev.length; i++) {
                        if (ev[i].imgtype === 'wire') {
                          this.saveCard(ev[i], 'elements');
                        }
                      }
                    } else {
                      this.createDuplicateImageChild(ev[i].id, fn => {
                        if (fn !== false) {
                          this.viewPortItems.splice(insertIndex+1, 0, fn.id);
                          this.storyData.elements.splice(insertIndex+1, 0, fn.id);
                        }
                      });
                    }
                  }
                }
              }, 250);
            });
          }
        });
      }
    }
  }

  addMultipleSampleImages(ev) {
    this.disableSampleImage();
    let tempId;
    this.sampleImgList = [];
    const element = ev[0];
    if (element.imgtype === 'wire') {
      this.sampleImgList.push(this.saveCard(element, 'sampleimages'));
      if(ev.length > 1) {
        for(let i=1; i<ev.length; i++) {
          if (ev[i].imgtype === 'wire') {
            this.sampleImgList.push(this.saveCard(element, 'sampleimages'));
          }
        }
      }
    } else {
      console.log(ev)
      this.createDuplicateImageChild(element.id, fn => {
            if (fn !== false) {
              this.sampleImgList.push(fn.id);
            }
      }, 'sampleimage');
      for(let i=1; i<ev.length; i++) {
        if (ev[i].imgtype === 'wire') {
          this.sampleImgList.push(this.saveCard(element, 'sampleimages'));
        } else {
          this.createDuplicateImageChild(ev[i].id, fn => {
            if (fn !== false) {
              this.sampleImgList.push(fn.id);
            }
            if(i === ev.length-1) {
              setTimeout(() => {
                this.makeSampleImageElement();
              }, 2000);
            }
          }, 'sampleimage');
        }
      }
    }
  }

  addInlineImageEmit(ev) {
    // console.log('image event :: ');
    // console.log(ev);
    this.disableStepsInlineImage()
    if (ev.type === 'wire') {
      // console.log(ev);
      this.saveCard(ev, 'elements');
      this.disableInlineImage();
    } else {
      this.createDuplicateImageChild(ev.id, fn => {
        if (fn !== false) {
          const arr = [];
          arr.push(fn);
          this.decideTaskToPerformNew(arr, 0, e => {
            setTimeout(() => {
              this.checkIfLastIsPara(false);
            }, 250);
          });
          this.disableInlineImage();
        } else {
          // console.log('couldn\'nt create duplicate child');
        }
      });
    }
  }

  addStepsInlineImageEmit(ev, model) {
    this.disableStepsInlineImage()
    if (ev.type === 'wire') {
      console.log(ev);
      this.saveCard(ev, model);
    } else {

      this.restService.http_get(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
        + '/' + ev.id
      )
        .subscribe(result => {
          console.log('addStepsInlineImageEmit, result :: ');
          console.log(result);

          const elementImageURL = this.sharedService.getImageOnPriority(result['image']['images'], 'original');
          const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage + elementImageURL;
          this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
            if (data !== false) {
              console.log("image data : 1 :: ", data);
              this.openCropper(false, data, model);
            } else {
              this.snotify.error('Image path does not exist.', '', this.sharedService.getConfig(false));
            }
          });
        },
          err => {
            this.snotify.error('Image could not be added', '', this.sharedService.getConfig(false));
          });
    }
  }
  openCropper(isCropForLeadMedia, data, model) {
    this.cropperImageUrl.data = data.data;
    this.cropperImageUrl.url = data.url;
    if(model === 'howToSteps') {
      this.showHowToStepsCropper = true;
    } else if(model === 'recipe') {
      this.showRecipeStepsCropper = true;
    }

  }

  attachStepImage(image, model) {
    if(model === 'howToSteps') {
      this.steps = this.tempHowToStepsData.get('steps') as FormArray;
    } else if(model === 'recipe') {
      this.steps = this.tempRecipeData.get('steps') as FormArray;
    }
    this.steps.at(this.currentStep).patchValue({stepImage: image});
    // console.log(this.tempHowToStepsData.getRawValue());
    this.disableStepsInlineImage();
  }

  createDuplicateImageChild(id, callback, type?) {
    this.restService.http_get(
      this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
      + '/' + id
    )
      .subscribe(result => {
        // let defaultImagecardData = $.extend(true, {}, result);
        // console.log(' result :: ');
        // console.log(result);
        let defaultImagecardData = Object.assign({}, result);
        defaultImagecardData['id'] = null;
        defaultImagecardData['parentElementId'] = id;
        defaultImagecardData['relatedStories'] = null;
        defaultImagecardData['relatedVideoStories'] = null;
        console.log("THIS IS THE TYPE ==>",type)
        if(type === 'sampleimage') {
          defaultImagecardData.image.sampleImage = true;
        }
        setTimeout(e => {
          this.increasePendingCount();
          this.restService.http_post(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
            defaultImagecardData, result2 => {
              this.decreasePendingCount(null);
              if (!result2.hasOwnProperty('error')) {
                callback(result2);
              } else {
                callback(false);
              }
            });
          this.restService.http_put(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), 'element', 'update_parent') + '/' + id,
            result, result2 => {
            });
        }, 50);
      },
        err => {
          // console.log(err);
          callback(false);
        });
  }

  saveCardByPath(imagePath, model, i, length, callback?, elementPosition?) {
    // console.log(imagePath);
    console.log("inside saveCardByPath method", model);
    // debugger;
    const defaultImagecardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
    defaultImagecardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    if (defaultImagecardData) {
      defaultImagecardData.id = null;
      defaultImagecardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
      defaultImagecardData.image.images = {};
      defaultImagecardData.image.images['original'] = imagePath.replace(/"/gi, '');
      if(model === 'sampleimages') {
        console.log("sample image work")
        defaultImagecardData.image.sampleImage = true;
      }
      // this.increasePendingCount();
      console.log('hitting api for element creation')
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        defaultImagecardData, result => {
          console.log("inside saveCardByPath save element call response");
          this.decreasePendingCount(null);
          if (model === 'leadMedia') {
            // console.log(result);
            if (result.type && result.type === 'image') {
              // const imageUrl = this.sharedService.getImageOnPriority(result.image.images, 'original');
              const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage +
                this.sharedService.getImageOnPriority(result.image.images, 'original');
              this.showCropper = true;
              this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
                if (data !== false) {
                  this.cropStartForImageFromInternalImages(result, data);
                } else {
                  this.cancelCropping();
                  this.snotify.error('Image path does not exist.', '', this.sharedService.getConfig(false));
                }
              });
            } else {
              this.viewPortItems.push(result.id);
              this.storyData.leadMedia.elements.push(result.id);
              setTimeout(e => {
                this.leadelRef['_results'][0].onelementFocus();
              }, 500);
            }
          } else if (model === 'elements') {
            console.log('inside saveCardByPath method for elements');
            const arr = [];
            arr.push(result);
            if (i != null && length != null && i == (length - 1)) {
              this.generateStoryAutoSaveInterval();
            }
            console.log('going inside decideTaskToPerformNew')
            this.decideTaskToPerformNew(arr, 0, e => {
              setTimeout(() => {
                if (this.storyData.type === 'gallery' || this.storyData.type === 'mediagallery') {
                  this.imageCroppingQue.push(result.id);
                  this.triggerSequentialCropping();
                  // this.startCroppingGallery(result.id)
                }
                this.checkIfLastIsPara(false);
              }, 100);
            }, elementPosition);
          } else if (model === 'pinnedMedia') {
            // console.log('send correct params');
            this.storyData.pinnedArticles.push(result.id);
          } else if (model === 'tempElements') {
            callback(result.id)
          } else if (model === 'sampleimages') {
            callback(result.id)
          }
        });
    }
    return null;
  }

  triggerSequentialCropping() {
    console.log("triggered sequential cropping for uploaded image");
    console.log('this.imageCroppingQue',this.imageCroppingQue)
    if(this.imageCroppingQue.length > 0 && !this.croppingInProgress) {
      this.croppingInProgress = true;
      this.startCroppingGallery(this.imageCroppingQue.shift());
      this.showLoader = false;
    } else {
      this.showLoader = false;
    }
  }

  imageCroppingCompleted(evt: any) {
    console.log('notification received for crop completion');
    console.log(evt);
    this.croppingInProgress = false;
    this.triggerSequentialCropping();

  }
  
  saveCard(imagePath, model) {
    // console.log(imagePath);
    const defaultImagecardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
    defaultImagecardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    const fd = new FormData();
    fd.set('file', imagePath.id);
    this.increasePendingCount();
    // console.log(imagePath);
    if (model === 'leadMedia') {
      this.showCropper = true;
      this.imageUploadInProgress = true;
    }
    this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadByUrlEndPoint, fd).
      subscribe(res => {
        this.decreasePendingCount(null);
        // console.log(res);
        if (defaultImagecardData && res && !res.hasOwnProperty('error')) {
          defaultImagecardData.id = null;
          defaultImagecardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
          defaultImagecardData.image.images['original'] = res['images']['original'];
          defaultImagecardData.image.caption = imagePath.data.caption ? imagePath.data.caption : '';
          defaultImagecardData.image.imageCredit = imagePath.data.credit ? imagePath.data.credit : '';
          defaultImagecardData.metadata.authors = imagePath.data.byLine ? [imagePath.data.byLine] : [];
          defaultImagecardData.metadata.agency = imagePath.data.agency ? imagePath.data.agency : '';

          this.increasePendingCount();
          this.restService.http_post(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
            defaultImagecardData, result => {
              console.log('result -- > ', result);
              this.decreasePendingCount(null);
              if (model === 'leadMedia') {
                this.imageUploadInProgress = false;
                // console.log(result);
                if (result && !result.hasOwnProperty('error')) {
                  if (result.type && result.type === 'image') {
                    // const imageUrl = this.sharedService.getImageOnPriority(result.image.images, 'original');
                    const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage +
                      this.sharedService.getImageOnPriority(result.image.images, 'original');
                     let link=this.sharedService.getImageOnPriority(result.image.images, 'original');
                     //check whether link is null or not
                     if(!link){
                      this.showCropper = false;
                      this.imageUploadInProgress = false;
                      return this.snotify.error("Lead Media is not valid.",'',this.sharedService.getConfig(false))
                     }
                    this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
                      if (data !== false) {
                        this.sharedService.checkImageForAMP(reader, flag => {
                          // console.log(flag);
                          if (flag) {
                            // this.showCropper = true;
                            this.cropStartForImageFromInternalImages(result, data);
                          } else {
                            this.sharedService.showAMPConfirmPopup(() => { // yes
                              // this.showCropper = true;
                              this.cropStartForImageFromInternalImages(result, data);
                            },
                              () => { // no
                                this.cancelCropping();
                              }
                            );
                          }
                        });
                      } else {
                        this.cancelCropping();
                        this.snotify.error('Image path does not exist.', '', this.sharedService.getConfig(false));
                      }
                    });
                  } else {
                    this.storyData.leadMedia.elements.push(result.id);
                    setTimeout(e => {
                      this.leadelRef['_results'][0].onelementFocus();
                    }, 500);
                  }
                } else {
                  this.cancelCropping();
                  this.snotify.error('Element creation failed.', '', this.sharedService.getConfig(false));
                }
              } else if (model === 'elements') {
                const arr = [];
                arr.push(result);
                this.decideTaskToPerformNew(arr, 0, e => {
                  setTimeout(() => {
                    this.startCroppingGallery(result.id);
                    this.checkIfLastIsPara(false);
                  }, 1000);
                });
              } else if (model === 'pinnedMedia') {
                // console.log('send correct params');
                this.storyData.pinnedArticles.push(result.id);
              } else if (model === 'howToSteps') {

                const elementImageURL = this.sharedService.getImageOnPriority(result['image']['images'], 'original');
                const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage + elementImageURL;
                this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
                  if (data !== false) {
                    console.log("image data : 1 :: ", data);
                    this.openCropper(false, data, model);
                  } else {
                    this.snotify.error('Image path does not exist.', '', this.sharedService.getConfig(false));
                  }
                });
                // change here
                // this.attachStepImage(result.image);
              } else if (model === 'tempElements') {
                return result.id
              } else if (model === 'sampleImages') {
                return result.id;
              }
            });
        } else {
          if (model === 'leadMedia') {
            this.cancelCropping();
            this.snotify.error('Image creation failed.', '', this.sharedService.getConfig(false));
          }
        }
        return null;
      },
        err => {
          if(err.status==404){
           this.snotify.error( err.error.errorMessage,this.sharedService.getConfig(false))
          }
             this.showCropper = false;
            this.imageUploadInProgress = false;
             this.imageUploadInProgress = false;
        });
  }


  galleryUpload(event, model, elementPosition?) {
    const Files = event.target.files;
    const length = Files['length'];
    console.log("total images to uplaod :: ", length);
    this.showLoader = true;
    if (event.target.files && (event.target.files.length > 0)) {
      //this.destroyStoryAutoSaveInterval();
      let hasAnImage = false;
      for (let i = 0; i < length; i++) {
        let file_name = <File>event.target.files[i].name;
        const image = <File>Files[i];
        // console.log(image);
        /*if(i == length-1)
        {
          setTimeout(e => {
            this.generateStoryAutoSaveInterval();
          }, 1500);
        }*/
        if(!this.checkSpecialChars(file_name)) {
          if ((image.size / 1000000) <= 11) {
            hasAnImage = true;
            this.destroyStoryAutoSaveInterval();
            const fd = new FormData();
            fd.append('file', image, image.name);
            this.increasePendingCount();
            this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadEndPoint, fd).
              subscribe(res => {
                console.log('uploaded image :: ' + i);
                this.decreasePendingCount(null);
                this.saveCardByPath(res['images'].original, model, i, length, undefined, elementPosition);
                // this.showLoader = false;
              },
                err => {
                  this.decreasePendingCount(null);
                  this.showLoader = false;
                });
          } else {
            // this.showLoader = false;
            if (i == (length - 1) && hasAnImage) {
              this.generateStoryAutoSaveInterval();
            }
            this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
          }
        } else {
          this.showLoader = false;
        }
        // if (i === (length - 1)) {
        //   setTimeout(e => {
        //     this.showLoader = false;
        //   }, 700);
        // }

      }
    }
    event.target.value = null;
    this.isLightbox = false;
    this.leadMediaImageToggle = false;
    this.inlineImageToggle = false;
  }

  onFileChange(event, model) {
    // console.log('file uplaod called');
    let file_name = <File>event.target.files[0].name;
    let eventCategory='Insert Pdf';
    let eventAction=sessionStorage.getItem(StaticDataService.tenantName);
    let eventLabel='';
    let eventValue=null;
   this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
    const fd = new FormData();
    this.selectedFile = <File>event.target.files[0];
    // console.log(event.target.files[0] instanceof File);
    // console.log(this.selectedFile);
    if(!this.checkSpecialChars(file_name)) {
      this.showLoader = true;
      if (event.target.files && event.target.files.length > 0) {
        if ((this.selectedFile.size / 1000000) <= 11) {
          fd.append('file', this.selectedFile, this.selectedFile.name);
          this.increasePendingCount();
          this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadEndPoint, fd).
            subscribe(res => {
              this.decreasePendingCount(null);
              if (res['name'].includes('pdf')) {
                this.snotify.success('Pdf file Uploaded Successfully', '', this.sharedService.getConfig(false));
                this.previewPdf(res);
              } else {
                this.saveCardByPath(res['images'].original, model, null, null);
              }
              this.showLoader = false;
              event.target.value = null;
            },
              err => {
                this.decreasePendingCount(null);
                this.showLoader = false;
                event.target.value = null;
              });
        } else {
          this.showLoader = false;
          event.target.value = null;
          this.selectedFile = null;
          this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
        }
      }
    } else {
      console.log("not true")
    }
    
    this.isLightbox = false;
    this.leadMediaImageToggle = false;
    this.inlineImageToggle = false;
  }
  onFileChangeLiveblogEmbed(event, model,flag) {
    console.log('called onFileChangeLiveblogEmbed');
    this.isLiveblogEmbedCalled=flag;
    const fd = new FormData();
    this.selectedFile = <File>event.target.files[0];
    // console.log(event.target.files[0] instanceof File);
    // console.log(this.selectedFile);
    this.showLoader = true;
    if (event.target.files && event.target.files.length > 0) {
      if ((this.selectedFile.size / 1000000) <= 11) {
        fd.append('file', this.selectedFile, this.selectedFile.name);
        this.increasePendingCount();
        this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadEndPoint, fd).
          subscribe(res => {
            this.decreasePendingCount(null);
            if (res['name'].includes('pdf')) {
              this.snotify.success('Pdf file Uploaded Successfully', '', this.sharedService.getConfig(false));
              this.previewPdf(res);
            } else {
              this.saveCardByPath(res['images'].original, model, null, null);
            }
            this.showLoader = false;
            event.target.value = null;
          },
            err => {
              this.decreasePendingCount(null);
              this.showLoader = false;
              event.target.value = null;
            });
      } else {
        this.showLoader = false;
        event.target.value = null;
        this.selectedFile = null;
        this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
      }
    }
    this.isLightbox = false;
    this.leadMediaImageToggle = false;
    this.inlineImageToggle = false;
  }

  // showHowToStepsCropper = false;

  uplaodImageAndOpenCropper(imageFile, base64, type) {
    this.snotify.info('Uploading', '', this.sharedService.getConfig(false));
    this.sharedService.uploadImage(imageFile).
      subscribe(res => {
        this.cropperImageUrl.data = base64;
        this.cropperImageUrl.url = res['images']['original'];
        if(type === 'showCropper') {
          this.showCropper = true;
        }
        else if(type === 'showHowToStepsCropper') {
          this.showHowToStepsCropper = true;
        }
        else if(type === 'showRecipeStepsCropper') {
          this.showRecipeStepsCropper = true;
        }
      },
        error => {
          this.SingleselectedFile = null;
          this.SingleselectedGifFile = null;
          this.showLoader = false;
          this.imageUploadInProgress = false;
          this.snotify.error('Upload Failed', '', this.sharedService.getConfig(false));
        });
  }

  onFileChangeSingle(event, model) {
    let file_name = <File>event.target.files[0].name;
    const reader = new FileReader();
    if (model === 'leadMedia') {
      // console.log('file uplaod called');
      const fd = new FormData();
      this.SingleselectedFile = <File>event.target.files[0];
      // console.log(this.SingleselectedFile);
      this.imageUploadInProgress = true;
      this.SingleselectedFileFlag = false;
      this.SingleselectedGifFileFlag = false;
      if (event.target.files && event.target.files.length > 0) {
        if ((typeof event.target.files[0]) === 'object') {
          // console.log(event.target.files[0]);
          if ((this.SingleselectedFile.size / 1000000) <= 11) {
            const a = reader.readAsDataURL(event.target.files[0]);
            reader.onload = (e: any) => {
              this.sharedService.checkImageForAMP(reader, flag => {
                if (flag) {
                  this.leadMediaImageGif = false;
                  this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'showCropper');
                } else {
                  this.sharedService.showAMPConfirmPopup(() => { // yes
                    this.leadMediaImageGif = false;
                    this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'showCropper');
                  },
                    () => { // no
                      this.SingleselectedFile = null;
                      this.imageUploadInProgress = false;
                    }
                  );
                }
              });
            };
          } else {
            this.SingleselectedFile = null;
            this.imageUploadInProgress = false;
            this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
          }
        }
      }
      event.target.value = null;
      this.isLightbox = false;
      this.leadMediaImageToggle = false;
      this.inlineImageToggle = false;
    } else if (model === 'leadMediaGif') {
      const fd = new FormData();
      this.SingleselectedGifFile = <File>event.target.files[0];
      this.imageUploadInProgressGif = true;
      this.SingleselectedFileFlag = false;
      this.SingleselectedGifFileFlag = false;
      if (event.target.files && event.target.files.length > 0) {
        if ((typeof event.target.files[0]) === 'object') {
          if ((this.SingleselectedGifFile.size / 1000000) <= 11) {
            const a = reader.readAsDataURL(event.target.files[0]);
            reader.onload = (e: any) => {
              this.sharedService.checkImageForAMP(reader, flag => {
                if (this.SingleselectedGifFile['name'].includes('gif') === true) {
                  if (flag) {
                    this.leadMediaImageGif = true;
                    this.uplaodImageAndOpenCropper(this.SingleselectedGifFile, e.target.result, 'showCropper');
                  } else {
                    this.leadMediaImageGif = true;
                    this.sharedService.showAMPConfirmPopup(() => { // yes
                      this.uplaodImageAndOpenCropper(this.SingleselectedGifFile, e.target.result, 'showCropper');
                    },
                      () => { // no
                        this.SingleselectedGifFile = null;
                        this.imageUploadInProgressGif = false;  
                      }
                    );
                  }

                } else {
                  this.snotify.error('This is not Gif Image', '', this.sharedService.getConfig(false));
                  this.imageUploadInProgressGif = false;
                }
              });
            };
          } else {
            this.SingleselectedGifFile = null;
            this.imageUploadInProgressGif = false;
            this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
          }
        }
      }
      event.target.value = null;
      this.isLightbox = false;
      this.leadMediaImageToggle = false;
      this.leadMediaImageGifToggle = false;
      this.inlineImageToggle = false;
    } else if (model === 'pinnedMedia') {
      this.selectedFile = <File>event.target.files[0];
      // console.log(event.target.files[0] instanceof File);
      // console.log(this.selectedFile);
      this.showLoader = true;
      if (event.target.files && event.target.files.length > 0) {
        if ((this.selectedFile.size / 1000000) <= 11) {
          this.leadMediaImageGif = false;
          const fd = new FormData();
          fd.set('file', this.selectedFile, this.selectedFile.name);
          // console.log(fd);
          this.increasePendingCount();
          this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadEndPoint, fd).
            subscribe(res => {
              this.decreasePendingCount(null);
              this.saveCardByPath(res['images'].original, model, null, null);
              this.showLoader = false;
              event.target.value = null;
              this.selectedFile = null;
            },
              err => {
                this.decreasePendingCount(null);
                this.showLoader = false;
                event.target.value = null;
                this.selectedFile = null;
              });
        } else {
          this.showLoader = false;
          event.target.value = null;
          this.selectedFile = null;
          this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
        }
      }
      this.isPinnedLigthbox = false;
      this.pinnedMediaImageToggle = false;
    } else if (model === 'howToStepsImage' || model === 'recipeImage') {
      // console.log('file uplaod called');
      const fd = new FormData();
      this.SingleselectedFile = <File>event.target.files[0];
      // console.log(this.SingleselectedFile);
      this.imageUploadInProgress = true;
      if (event.target.files && event.target.files.length > 0) {
        if ((typeof event.target.files[0]) === 'object') {
          // console.log(event.target.files[0]);
          if ((this.SingleselectedFile.size / 1000000) <= 11) {
            const a = reader.readAsDataURL(event.target.files[0]);
            reader.onload = (e: any) => {
              this.sharedService.checkImageForAMP(reader, flag => {
                if (flag) {
                  if(model === 'howToStepsImage') {
                    this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'showHowToStepsCropper');
                  } else if(model === 'recipeImage') {
                    this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'showRecipeStepsCropper');
                  }

                } else {
                  this.sharedService.showAMPConfirmPopup(() => { // yes
                    if(model === 'howToStepsImage') {
                      this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'showHowToStepsCropper');
                    } else if(model === 'recipeImage') {
                      this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'showRecipeStepsCropper');
                    }
                  },
                    () => { // no
                      this.SingleselectedFile = null;
                      this.imageUploadInProgress = false;
                    }
                  );
                }
              });
            };
          } else {
            this.SingleselectedFile = null;
            this.imageUploadInProgress = false;
            this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
          }
        }
      }
      event.target.value = null;
      this.isLightbox = false;
      this.leadMediaImageToggle = false;
      this.inlineImageToggle = false;
    }
  }

  saveVideo() {
    if (this.videoUrl && this.videoUrl !== null && this.videoUrl.trim() !== '') {
      if (this.domainConfig && this.domainConfig['config']
        && this.domainConfig['config']['story']
        && this.domainConfig['config']['story']['autoEmbed'] === 'true') {
        this.sharedService.checkAndGetEmbed(this.videoUrl, (embed) => {
          if (embed !== null) {
            this.videoUrl = this.sharedService.checkEmbed(embed);
            // if (this.sharedService.isEmbedStripEnabled() && embed.indexOf('cdn.jwplayer.com') > -1) {
            //   this.videoUrl = '<iframe src="' + embed.split('iframe src="')[1].split('"')[0] + '"></iframe>';
            // } else {
            //   this.videoUrl = embed;
            // }
          }
          setTimeout(e => {
            this.addVideo();
          }, 20);
        });
      } else {
        this.addVideo();
      }
    } else {
      this.snotify.error('Enter a valid embed', '', this.sharedService.getConfig(false));
    }
  }

  addVideo() {
    const videoCard = JSON.parse(JSON.stringify(StaticDataService.defaultVideoCardData));
    videoCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    if (this.videoUrl.indexOf('src="//players.brightcove.net') > -1) {
      if (this.videoUrl.split('src="') && this.videoUrl.split('src="') !== null && this.videoUrl.split('src="').length > 1) {
        if (this.videoUrl.split('src="')[1].split('"')[0].charAt(0) === '/') {
          videoCard.video.embedUrl = 'https:' + this.videoUrl.split('src="')[1].split('"')[0];
          videoCard.video.body = this.videoUrl.replace('src="', 'src="https:');
        } else {
          videoCard.video.embedUrl = this.videoUrl.split('src="')[1].split('"')[0];
          videoCard.video.body = this.videoUrl;
        }
      }
    } else if (this.videoUrl.indexOf('src=\'//players.brightcove.net') > -1) {
      if (this.videoUrl.split('src=\'') && this.videoUrl.split('src=\'') !== null && this.videoUrl.split('src=\'').length > 1) {
        if (this.videoUrl.split('src=\'')[1].split('\'')[0].charAt(0) === '/') {
          videoCard.video.embedUrl = 'https:' + this.videoUrl.split('src=\'')[1].split('\'')[0];
          videoCard.video.body = this.videoUrl.replace('src=\'', 'src=\'https:');
        } else {
          videoCard.video.embedUrl = this.videoUrl.split('src=\'')[1].split('\'')[0];
          videoCard.video.body = this.videoUrl;
        }
      }
    } else {
      const duration = this.sharedService.checkForMetadataDuration(this.videoUrl);
      if (duration !== false) {
        videoCard.metadata.videoMetadata = {};
        videoCard.metadata.videoMetadata.duration = duration;
      } else {
        videoCard.metadata.videoMetadata = {};
        videoCard.metadata.videoMetadata.duration = this.videoDuration;
      }
      if (this.videoUrl.indexOf('src="') > -1) {
        videoCard.video.embedUrl = this.videoUrl.split('src="')[1].split('"')[0];
        videoCard.video.body = this.videoUrl;
      } else if (this.videoUrl.indexOf('src=\'') > -1) {
        videoCard.video.embedUrl = this.videoUrl.split('src=\'')[1].split('\'')[0];
        videoCard.video.body = this.videoUrl;
      } else {
        this.snotify.error('Enter a valid embed', '', this.sharedService.getConfig(false));
        return false;
      }
    }
    if (this.videoUrl.trim() !== '') {
      this.increasePendingCount();
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        videoCard, result => {
          this.decreasePendingCount(null);
          // console.log(result);
          // this.storyData.elements = [];
          // this.storyData.elements = [result.id];
          this.videoUrlPopup = false;
          const arr = [];
          arr.push(result);
          this.decideTaskToPerformNew(arr, 0, e => {
            setTimeout(() => {
              this.checkIfLastIsPara(false);
            }, 250);
          });
          this.videoUrl = '';
        });
    }
    // this.video_iframe_html = this.embedService.embed(videoUrl);
  }

  addListicleElement() {
    if (this.queueForPosts === 0) {
      const cardData = this.elListRef['_results'][0].cardData;
      const card = JSON.stringify(cardData);
      const num = new Date().getTime();
      if (cardData.listicle.body !== null && this.htmlToPlaintext(cardData.listicle.body).trim() !== '') {
        this.queueForPosts = 1;
        this.saveCardTemporarily({
          data: card,
          id: num,
          format: 'listicle'
        });
        // if (cardData.type === 'highlights') {
        //   cardData.listicle.body = cardData.listicle.body.replace("<p>", "").replace("</p>", "").trim();
        // }
        this.increasePendingCount();
        this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
          cardData, result => {
            this.decreasePendingCount(null);
            this.elListRef['_results'][0].resetlisticleElement();
            this.saveCardEmit({
              type: 'post',
              data: result.id,
              tempViewId: num,
              format: 'listicle'
            });
            setTimeout(e => {
              this.queueForPosts = 0;
              this.elListRef['_results'][0].resetlisticleElement();
            }, 100);
          });
      } else {
        this.snotify.warning('Please enter some text', '', this.sharedService.getConfig(false));
      }
    }
  }

  addLiveblogElement() {
    if (this.queueForPosts === 0) {
      var cardData = this.elLiveRef['_results'][0].cardData;
      cardData=this.sharedService.checkhrefandreplace(cardData); 
      const card = JSON.stringify(cardData);
      const num = new Date().getTime();
      if (cardData.title && this.htmlToPlaintext(cardData.title).trim() !== '') {
        this.queueForPosts = 1;
        this.saveCardTemporarily({
          data: card,
          id: num,
          format: 'liveblog'
        });
        this.increasePendingCount();
        this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
          cardData, result => {
            this.decreasePendingCount(null);
            this.saveCardEmit({
              type: 'post',
              data: result.id,
              tempViewId: num,
              format: 'liveblog'
            });
            this.checkForSourceUrlInEmbed(null);
            setTimeout(e => {
              this.queueForPosts = 0;
              this.elLiveRef['_results'][0].resetliveblogElement();
            }, 100);
          });
      } else {
        this.snotify.warning('Please enter the title before saving', '', this.sharedService.getConfig(false));
      }
    }
  }

  addLiveblogElementLite() {
    if (this.queueForPosts === 0) {
      var cardData = this.elLiveRef['_results'][0].cardData;
      cardData=this.sharedService.checkhrefandreplace(cardData); 
      const card = JSON.stringify(cardData);
      const num = new Date().getTime();
      if (cardData.title && this.htmlToPlaintext(cardData.title).trim() !== '') {
        this.queueForPosts = 1;
        this.saveCardTemporarily({
          data: card,
          id: num,
          format: 'mintlite'
        });
        this.increasePendingCount();
        this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
          cardData, result => {
            this.decreasePendingCount(null);
            this.saveCardEmit({
              type: 'post',
              data: result.id,
              tempViewId: num,
              format: 'mintlite'
            });
            this.checkForSourceUrlInEmbed(null);
            setTimeout(e => {
              this.queueForPosts = 0;
              this.elLiveRef['_results'][0].resetliveblogElement();
            }, 100);
          });
      } else {
        this.snotify.warning('Please enter the title before saving', '', this.sharedService.getConfig(false));
      }
    }
  }

  cancelCropping() {
    this.showCropper = false;
    this.showHowToStepsCropper = false;
    this.showLeadThumbnailCropper = false;
    this.showRecipeStepsCropper = false;
    this.cropperImageUrl = {
      url: null,
      data: null,
      blobData: null
    };
    this.imageUploadInProgress = false;
    this.imageUploadInProgressGif = false;
  }

  finishCropping(event) {
    console.log('finishCropping called');
    const requests = event.cropRequests;
    const verticalFlag = event.verticalFlag;
    const differentLeadFlag = event.differentImage;
    this.cancelCropping();
    if (this.leadMediaVideoFlag) {
      this.sharedService.croppingSequence(requests, differentLeadFlag, data => {
        const imageData = StaticDataService.defaultImageCardData;
        imageData.image.images = data.imagemap;
        const leadVideoId = this.storyData.leadMedia.elements[0];
        this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/element/' + leadVideoId).subscribe(
          res => {
            res.video.image = imageData.image;
            //updating data into element's defaultVideoCard
            for (let ele of  this.leadelRef['_results']) {
              ele.updateVideoImageData( res.video.image);
             }
            if (!this.storyData.leadMedia.video) {
              this.storyData.leadMedia.video = {};
            }
            this.storyData.leadMedia.video.image = imageData.image;
            this.storyData.leadMedia.mediaType = 'video';
            this.restService.http_put(this.config.get('product').baseUrl + '/api/cms/element/'
              + leadVideoId + '?autoSave=true', res, result => {
              })
          }
        )
        // this.storyData.leadMedia.video.image = imageData.image;
        // this.saveStory(false);
        // console.log(this.storyData.leadMedia.video);
        this.leadMediaVideoFlag = false;
      });
    }

    if (this.SingleselectedFile) {
      this.increasePendingCount();
      this.sharedService.croppingSequence(requests, differentLeadFlag, data => {
        this.decreasePendingCount(null);
        if (!data.hasOwnProperty('error')) {
          const { ampFlag, imagemap } = data;
          console.log(data);
          if (this.SingleselectedFile) {
            const ImageCardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
            ImageCardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
            ImageCardData.id = null;
            ImageCardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
            ImageCardData.imageAmpValidated = ampFlag;
            ImageCardData.image.verticalImage = verticalFlag;
            ImageCardData.image.images = imagemap;
            this.SingleselectedFile = null;
            this.increasePendingCount();
            this.restService.http_post(this.config.get('product').baseUrl
              + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
              ImageCardData, image => {
                this.decreasePendingCount(null);
                if (image.hasOwnProperty('error')) {
                  this.pickStoryImageLoad = false;
                  this.storyData.leadMedia.elements = [];
                  this.storyData.imageAmpValidated = false;
                  this.snotify.clear();
                  this.snotify.error('Try adding Lead Image again.', '', this.sharedService.getConfig(false));
                } else if (image) {
                  this.storyData.leadMedia.elements = [image.id];
                  this.storyData.imageAmpValidated = ampFlag;
                  this.storyData.leadMedia.mediaType = 'image';
                  this.pickStoryImageLoad = false;
                  setTimeout(e => {
                    this.leadelRef['_results'][0].onelementFocus();
                  }, 500);
                  this.tempLeadMedia = null;
                  this.storyData.leadMedia.video = null;
                }
              });

          } else {
            this.pickStoryImageLoad = false;
            this.pickStoryImageLoadGif = false;
            this.tempLeadMedia = null;
            // setTimeout(e => {
            this.leadelRef['_results'][0].setImageUrl(
              ampFlag,
              verticalFlag,
              imagemap
            );
            this.leadelRef['_results'][0].onelementFocus();
            this.storyData.leadMedia.video = null;
            // }, 500);
          }
        } else {
          // console.log(data);
        }
      });
    }

    if (this.SingleselectedGifFile) {
      this.increasePendingCount();
      this.sharedService.croppingSequence(requests, differentLeadFlag, data => {
        this.decreasePendingCount(null);
        if (!data.hasOwnProperty('error')) {
          const { ampFlag, imagemap } = data;
        //  console.log(data);
          if (this.SingleselectedGifFile) {
            const ImageCardDataGif = JSON.parse(JSON.stringify(StaticDataService.defaultImageGifCardData));
            ImageCardDataGif.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
            ImageCardDataGif.id = null;
            ImageCardDataGif.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
            ImageCardDataGif.imageAmpValidated = ampFlag;
            ImageCardDataGif.image.verticalImage = verticalFlag;
            ImageCardDataGif.image.images = imagemap;
            this.SingleselectedGifFile = null;
            this.increasePendingCount();
            this.restService.http_post(this.config.get('product').baseUrl
              + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
              ImageCardDataGif, image => {
                this.decreasePendingCount(null);
                if (image.hasOwnProperty('error')) {
                  this.pickStoryImageLoadGif = false;
                  this.storyData.leadMediaGif.elements = [];
                  this.storyData.imageAmpValidated = false;
                  this.snotify.clear();
                  this.snotify.error('Try adding Lead Image again.', '', this.sharedService.getConfig(false));
                } else if (image) {
                  console.log([image.image]);
                  this.storyData.leadMediaGif.elements = [image.id];
                  this.storyData.imageAmpValidated = ampFlag;
                  this.storyData.leadMediaGif.mediaType = 'gif';
                  this.pickStoryImageLoadGif = false;
                  // this.storyData.leadMediaGif.image = ImageCardDataGif.image;

                  setTimeout(e => {
                    this.leadelRefl['_results'][0].onelementFocus();
                  }, 500);
                  this.tempLeadMedia = null;
                }
              });
          } else {
            this.pickStoryImageLoadGif = false;
            this.tempLeadMedia = null;
            // setTimeout(e => {
            this.leadelRefl['_results'][0].setImageUrl(
              ampFlag,
              verticalFlag,
              imagemap
            );
            this.leadelRefl['_results'][0].onelementFocus();
            //this.storyData.leadMedia.video = null;
            // }, 500);
          }
        } else {
          // console.log(data);
        }
      });
    }

    if ((!this.SingleselectedFile && this.SingleselectedFileFlag)) {
      this.storyData.leadMedia.elements.push(this.tempLeadMedia);
      this.increasePendingCount();
      this.sharedService.croppingSequence(requests, differentLeadFlag, data => {
        this.decreasePendingCount(null);
        if (!data.hasOwnProperty('error')) {
          const { ampFlag, imagemap } = data;
          this.pickStoryImageLoad = false;
          this.pickStoryImageLoadGif = false;
          this.tempLeadMedia = null;
          // setTimeout(e => {
          this.leadelRef['_results'][0].setImageUrl(
            ampFlag,
            verticalFlag,
            imagemap
          );
          this.leadelRef['_results'][0].onelementFocus();
          this.storyData.leadMedia.video = null;
          this.storyData.imageAmpValidated = ampFlag;
          // }, 500);

        } else {
          // console.log(data);
        }
      });
    }
    if ((!this.SingleselectedGifFile && this.SingleselectedGifFileFlag)) {
      this.storyData.leadMediaGif.elements.push(this.tempLeadMedia);
    }
  }

  finishCroppingStepsImage(event, model) {
    console.log('finishCroppingStepsImage called');
    const requests = event.cropRequests;
    const verticalFlag = event.verticalFlag;
    const differentLeadFlag = event.differentImage;
    this.cancelCropping();
    this.increasePendingCount();
    this.sharedService.croppingSequence(requests, differentLeadFlag, data => {
      this.decreasePendingCount(null);
      if (!data.hasOwnProperty('error')) {
        const { ampFlag, imagemap } = data;
        console.log('data', data);
        let obj = { images: data.imagemap}
        this.attachStepImage(obj, model);
        this.SingleselectedFile = null;
        this.increasePendingCount();
      } else {
        this.snotify.error('Image cropping failed', '', this.sharedService.getConfig(false));
      }
    });
  }

  zoomSlider(x, img) {
    // console.log(x);
    if (this.angularCropper11 || this.angularCropper169 || this.angularCropper23) {
      if (img === '16:9') {
        // console.log(+x, this.initZoom169);
        // console.log(+x > this.initZoom169);
        if (+x > this.initZoom169) {
          this.angularCropper169.cropper.zoom(0.1);
          this.initZoom169 = +x;
          // console.log('zoom in');
        } else {
          this.angularCropper169.cropper.zoom(-0.1);
          this.initZoom169 = +x;
          // console.log('zoom out');
        }
      } else if (img === '1:1') {
        // console.log(this.initZoom11);
        if (+x > this.initZoom11) {
          this.angularCropper11.cropper.zoom(0.1);
          this.initZoom11 = +x;
          // console.log('zoom in');
        } else {
          this.angularCropper11.cropper.zoom(-0.1);
          this.initZoom11 = +x;
          // console.log('zoom out');
        }
      } else if (img === '2:3') {
        // console.log(this.initZoom11);
        if (+x > this.initZoom23) {
          this.angularCropper23.cropper.zoom(0.1);
          this.initZoom23 = +x;
          // console.log('zoom in');
        } else {
          this.angularCropper23.cropper.zoom(-0.1);
          this.initZoom23 = +x;
          // console.log('zoom out');
        }
      }
    }
  }

  plainValueChanged(ev) {
    // console.log(ev);
  }

  openRelatedStoryModal(type, ev) {
    let eventCategory='Insert ' + type + ' Story';
    let eventAction=sessionStorage.getItem(StaticDataService.tenantName);
    let eventLabel='';
    let eventValue=null;

    this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue);
    if (ev === 'multiple') {
      if (this.checkForRelatedStory() !== false && !this.enableMultipleRelatedStory) {
        this.snotify.error('Related stories already exists in this story', '', this.sharedService.getConfig(false));
      } else {
        this.relatedStoryType='';
        this.relatedStoryMultipleSelectFlag = true;
        if(type === 'Related Stories') {
          this.relatedStoryType='relatedstory';
          this.showRelatedStoryPopup = true;
        } else if(type === 'Also Read') {
          this.relatedStoryType='alsoread';
          this.showAlsoReadStoryPopup = true;
        }
        
        this.sharedService.overflowhidden();
      }
    }
  }
  openRelatedHowtoStoryModal(ev) {
    let eventCategory='Insert Howto Story';
    let eventAction=sessionStorage.getItem(StaticDataService.tenantName);
    let eventLabel='';
    let eventValue=null;;
    this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue);
    if (ev === 'multiple') {
      if (this.checkForRelatedHowtoStory() !== false) {
        this.snotify.error('Howto Related stories already exists in this story', '', this.sharedService.getConfig(false));
      } else {
        this.relatedStoryMultipleSelectFlag = true;
        this.showRelatedStoryPopup = true;
        this.sharedService.overflowhidden();
      }
    }
    this.relatedStoryType='howto';
  }

  openViewForSingleStorySelect(ev) {
    // console.log(ev);
  }

  closeRelatedStoryModal(ev) {
    this.showRelatedStoryPopup = false;
    this.showAlsoReadStoryPopup = false;
    this.amazonAdSearchPopup = false;
    this.sharedService.overflowauto();
  }
  closeEmbedeStoryModal(ev) {
    this.showRelatedStoryPopup = false;
    this.amazonAdSearchPopup = false;
    this.adTitle = '';
    this.sharedService.overflowauto();
  }
  getRelatedStoryIds(ev) {
    const card = JSON.parse(JSON.stringify(StaticDataService.defaultRelatedStoryCardData));
    card.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    card['relatedStories'] = ev;
    // console.log(card);
    this.increasePendingCount();
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      card, result => {
        this.decreasePendingCount(null);
        this.closeRelatedStoryModal(null);
        const arr = [];
        arr.push(result);
        this.decideTaskToPerformNew(arr, 0, e => {
          setTimeout(() => {
            this.checkIfLastIsPara(false);
          }, 250);
        });
      });
  }
  getRelatedStoryHowtoIds(ev) {
    console.log('in Save case')
    const card = JSON.parse(JSON.stringify(StaticDataService.defaultRelatedHowtoStoryCardData));
    card.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    card['relatedStoriesHowTo'] = ev;
    // console.log(card);
    this.increasePendingCount();
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      card, result => {
        this.decreasePendingCount(null);
        this.closeRelatedStoryModal(null);
        const arr = [];
        arr.push(result);
        this.decideTaskToPerformNew(arr, 0, e => {
          setTimeout(() => {
            this.checkIfLastIsPara(false);
          }, 250);
        });
      });
  }
  getAlsoReadIds(ev) {
    console.log('in Save case')
    const card = JSON.parse(JSON.stringify(StaticDataService.defaultAlsoReadCardData));
    card.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    card['alsoReadStories'] = {};
    card['alsoReadStoryIdList'] = ev;
    // console.log(card);
    this.increasePendingCount();
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      card, result => {
        this.decreasePendingCount(null);
        this.closeRelatedStoryModal(null);
        const arr = [];
        arr.push(result);
        this.decideTaskToPerformNew(arr, 0, e => {
          setTimeout(() => {
            this.checkIfLastIsPara(false);
          }, 250);
        });
      });
  }
  getEmbedStoryIds(ev) {
    this.dataFormAmazonList.push([...ev]);
    console.log('story-conatiner', ev)
    this.saveEmbedAmazon(ev);
    this.decreasePendingCount(null);
    this.closeRelatedStoryModal(null);
  }
  getWordCount(ev) {
    this.runWordCountCheck();
  }

  runWordCountCheck() {
    if (this.storyData && this.storyData !== null && this.storyData.elements &&
      (this.storyData.elements.length <= Object.keys(this.Elements).length)) {
      this.storyWordCount = 0;
      this.storySentenceCount = 0;
      this.storySyllableCount = 0;
      for (const id of this.storyData.elements) {
        const data = this.Elements[id];
        if (data && data !== null) {
          this.storyWordCount += data.metadata.wordCount;
          this.storySentenceCount += data.metadata.sentenceCount;
          this.storySyllableCount += data.metadata.syllableCount;
        }
      }
    }
    if (this.sharedService.isdomainConfig('story', 'readibilityEase') === true && this.storyType === 'story') {
      this.calculateReadibilityScore();
    }
  }

  setWordCountToStory(story){
     story.metadata.wordCount=this.storyWordCount;
     story.metadata.sentenceCount=this.storySentenceCount;
     story.metadata.syllableCount=this.storySyllableCount;
  }


  calculateReadibilityScore() {
    let avgSentenceLength = this.storyWordCount / this.storySentenceCount;
    let avgSyllables = this.storySyllableCount /this.storyWordCount;
    this.storyData.readabilityEase = 206.835 - (1.015 * avgSentenceLength) - (84.6 * avgSyllables);
  }

  checkReadibilityEase() {
    if (this.storyData.readabilityEase < 30) {
      this.readibilityType = 'Low';
    } else if (this.storyData.readabilityEase > 30 && this.storyData.readabilityEase < 60) {
      this.readibilityType = 'Medium';
    } else if (this.storyData.readabilityEase > 60) {
      this.readibilityType = 'High';
    } else {
      this.readibilityType = 'Low';
    }
    return true;
  }

  getGalleryLeadMedia(ev) {
    if (this.storyData && this.storyData.leadMedia && this.storyData.leadMedia.elements && this.storyData.leadMedia.elements[0]
      && (this.storyData.leadMedia.elements[0] === ev)) {
      this.storyData.leadMedia.elements = [];
    } else {
      this.storyData.leadMedia.elements = [ev];
    }
  }

  validateEmbed(json: string) {
    return true;
    //   if(json.trim() === ''){
    //     return true;
    //  }
    //  if(json.trim() && (json.includes('<div') && json.includes('</div>'))){
    //     return true;
    //  }
    //  if(json.trim() && (json.includes('<blockquote') && json.includes('</blockquote>'))){
    //    return true;
    // }
    //  if(json.trim() && (json.includes('<embed') && (json.includes('src=')
    //     || json.includes('type=') || json.includes('width=') || json.includes('height=')))){
    //      return true;
    //  }
    //  if(json.trim() && json.includes('<iframe') && json.split('<iframe')[1].split("</iframe>")[0].includes('src=')){
    //    if(json.split('<iframe')[0].trim() != '' || json.split('<iframe')[1].split("</iframe>")[1].trim() != ''){
    //       return false;
    //    }
    //     return true;
    //  }
    //  return false;
  }


  getSelectedOptionText(obj) {
    this.marketCode = obj.target.value;
    this.marketText = obj.target.options[obj.target.selectedIndex].text;
  }

  saveMarketEmbed() {
    if (this.marketCode || this.mutualFundList || this.marketList || this.newMarketList) {
      const marketCard = JSON.parse(JSON.stringify(StaticDataService.defaultMarketCardData));
      marketCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      if (this.marketCode) {
        marketCard.indice = {
          code: this.marketCode,
          name: this.marketText
        };
      }
      if (this.mutualFundList.length > 0) {
        marketCard.indice = {
          code: this.mutualFundList[0].code,
          name: this.mutualFundList[0].name,
          marketName: this.mutualFundList[0].marketName,
          type: this.mutualFundList[0].type
        };
      }
      if (this.marketList.length > 0) {
        marketCard.indice = {
          code: this.marketList[0].code,
          name: this.marketList[0].name,
          marketName: this.marketList[0].marketName,
          type: this.marketList[0].type
        };
      }
      if (this.newMarketList.length > 0) {
        marketCard.indicesNew = {
          code: this.newMarketList[0].code,
          name: this.newMarketList[0].name,
          marketName: this.newMarketList[0].marketName,
          type: this.newMarketList[0].type
        };
      }
      if (marketCard.indice.name || marketCard.indicesNew.name) {
        this.increasePendingCount();
        this.marketPopup = false;
        this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
          marketCard, result => {
            this.decreasePendingCount(null);
            const arr = [];
            arr.push(result);
            this.decideTaskToPerformNew(arr, 0, e => {
              setTimeout(() => {
                this.checkIfLastIsPara(false);
                this.checkForSourceUrlInEmbed(null);
              }, 500);
            });
          });
        this.marketCode = '';
        this.marketText = '';
        this.deactivateMarketSuggestion = false;
      } else {
        this.snotify.error('Please enter Company Name or Mutual Fund', '', this.sharedService.getConfig(false));
      }
    } else {
      this.snotify.error('Select a Option', '', this.sharedService.getConfig(false));
    }
  }


  saveMatchEmbed() {
    this.matchPopup = false;
  }

  saveEmbed() {

    if (((this.embedCode === null) || (this.embedCode === '')) && (this.amazonAds.length > 0)) {
      this.showAmazonMeta = false;
      this.addEmbed();
    } else if (this.embedCode && this.embedCode !== null && this.embedCode.trim() !== '') {
      if (this.domainConfig && this.domainConfig['config']
        && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['autoEmbed'] === 'true') {
        this.sharedService.checkAndGetEmbed(this.embedCode, (embed) => {
          if (embed !== null) {
            this.embedCode = embed;
          }
          setTimeout(e => {
            this.addEmbed();
          }, 20);
        });
      } else {
        this.addEmbed();
      }
    } else {
      this.snotify.error('Enter a valid embed', '', this.sharedService.getConfig(false));
    }
  }
  saveEmbedAmazon(ev) {
    this.amazonAds = ev;
    if (((this.embedCode === null) || (this.embedCode === '')) && (this.amazonAds.length > 0)) {
      this.showAmazonMeta = false;
      this.addAmazonEmbed(ev);
    } else if (this.embedCode && this.embedCode !== null && this.embedCode.trim() !== '') {
      if (this.domainConfig && this.domainConfig['config']
        && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['autoEmbed'] === 'true') {
        this.sharedService.checkAndGetEmbed(this.embedCode, (embed) => {
          if (embed !== null) {
            this.embedCode = embed;
          }
          setTimeout(e => {
            this.addAmazonEmbed(ev);
          }, 20);
        });
      } else {
        this.addAmazonEmbed(ev);
      }
    } else {
      this.snotify.error('Enter a valid embed', '', this.sharedService.getConfig(false));
    }
  }

  addEmbed() {
    let checkProductFlag=false;
    const embedCard = JSON.parse(JSON.stringify(StaticDataService.defaultEmbedCardData));
    embedCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    const duration = this.sharedService.checkForMetadataDuration(this.embedCode);
    // console.log(this.embedCode, duration);
    if (duration !== false) {
      embedCard.metadata.videoMetadata = {};
      embedCard.metadata.videoMetadata.duration = duration;
    }
    embedCard.embed.body = this.sharedService.checkEmbed(this.embedCode);
    embedCard.jsonSourceUrl = this.embedSourceUrl.trim();
    embedCard.subType = this.embedSubType.trim();
    if (this.amazonAds && this.amazonAds.length > 0) {

        embedCard.amazonAds = this.amazonAds;
        embedCard.title = this.adTitle;
        embedCard.embed.title = this.adTitle;
        embedCard.reusable = true;
        embedCard.amazonMeta = true;

    } else {
      embedCard.reusable = false;
      embedCard.amazonMeta = false;
    }
    embedCard.lshapeBand = this.showLShapeBand;
    // console.log(embedCard.amazonAds)
    // if (this.embedCode) {
    //   if (!this.validateEmbed(this.embedCode)) {
    //     this.snotify.error('Please enter valid embed', '', this.sharedService.getConfig(false));
    //     return;
    //   }
    // }
    if (this.amazonAds && this.amazonAds.length > 0) {
    this.restService.http_post(this.config.get('product').baseUrl + '/cms/affiliate/checkItems/',
    this.amazonAds, result => {
     console.log('==============',result);
     if(result.length>0){
      this.amazonAds=result;
      embedCard.amazonAds = this.amazonAds;
      for(let i in result){
        if(result[i]['isPresent']==false){
         this.snotify.error('Product Id does not exist',result[i]['value'],this.sharedService.getConfig(false))
        }else{}
      }
     }else{
       //not validating product and returning empty record
       this.snotify.error('/cms/affiliate/checkItems/','Error',this.sharedService.getConfig(false))
     }
     this.increasePendingCount();
     this.restService.http_post(this.config.get('product').baseUrl
       + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
       embedCard, result => {

         if (this.amazonAds && this.amazonAds.length > 0) {
           console.log('this.amazonAds',this.amazonAds )
          // this.postReusableElementRequest(result);
         }
         this.decreasePendingCount(null);
         if (this.flagForPinnedElement) {
           this.flagForPinnedElement = false;
           this.storyData.pinnedArticles.push(result.id);
         } else {
           const arr = [];
           arr.push(result);
           this.decideTaskToPerformNew(arr, 0, e => {
             setTimeout(() => {
               this.checkIfLastIsPara(false);
               this.checkForSourceUrlInEmbed(null);
             }, 500);
           });
         }
       });
    });
    }

   else{
      this.increasePendingCount();
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        embedCard, result => {

          if (this.amazonAds && this.amazonAds.length > 0) {
            console.log('this.amazonAds',this.amazonAds )
            this.postReusableElementRequest(result);
          }
          this.decreasePendingCount(null);
          if (this.flagForPinnedElement) {
            this.flagForPinnedElement = false;
            this.storyData.pinnedArticles.push(result.id);
          } else {
            const arr = [];
            arr.push(result);
            this.decideTaskToPerformNew(arr, 0, e => {
              setTimeout(() => {
                this.checkIfLastIsPara(false);
                this.checkForSourceUrlInEmbed(null);
              }, 500);
            });
          }
        });
   }
   this.embedPopup = false;
        this.adTitle = '';
        this.dataFormAmazonList = [];

  }


  addAmazonEmbed(ev) {
    const embedCard = JSON.parse(JSON.stringify(StaticDataService.defaultEmbedCardData));
    embedCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    const duration = this.sharedService.checkForMetadataDuration(this.embedCode);
    // console.log(this.embedCode, duration);
    if (duration !== false) {
      embedCard.metadata.videoMetadata = {};
      embedCard.metadata.videoMetadata.duration = duration;
    }
    embedCard.embed.body = this.sharedService.checkEmbed(this.embedCode);
    embedCard.jsonSourceUrl = this.embedSourceUrl.trim();
    embedCard.subType = this.embedSubType.trim();
    if (this.amazonAds && this.amazonAds.length > 0) {
      embedCard.amazonAds = this.amazonAds;
      embedCard.title = this.adTitle;
      embedCard.embed.title = this.adTitle;
      embedCard.reusable = true;
      embedCard.amazonMeta = true;
    } else {
      embedCard.reusable = false;
      embedCard.amazonMeta = false;
    }
    embedCard.lshapeBand = this.showLShapeBand;
    // console.log(embedCard.amazonAds)
    // if (this.embedCode) {
    //   if (!this.validateEmbed(this.embedCode)) {
    //     this.snotify.error('Please enter valid embed', '', this.sharedService.getConfig(false));
    //     return;
    //   }
    // }
    if (this.amazonAds && this.amazonAds.length > 0) {
      this.restService.http_post(this.config.get('product').baseUrl + '/cms/affiliate/checkItems/',
      this.amazonAds, result => {
       console.log('==============',result);
       if(result.length>0){
        this.amazonAds=result;
        embedCard.amazonAds = this.amazonAds;
        for(let i in result){
          if(result[i]['isPresent']==false){
           this.snotify.error('Product Id does not exist',result[i]['value'],this.sharedService.getConfig(false))
          }else{}
        }
       }else{
         //not validating product and returning empty record
         this.snotify.error('/cms/affiliate/checkItems/','Error',this.sharedService.getConfig(false))
       }
       this.increasePendingCount();
       this.restService.http_post(this.config.get('product').baseUrl
         + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
         embedCard, result => {

           if (this.amazonAds && this.amazonAds.length > 0) {
             console.log('this.amazonAds',this.amazonAds )
            // this.postReusableElementRequest(result);
           }
           this.decreasePendingCount(null);
           if (this.flagForPinnedElement) {
             this.flagForPinnedElement = false;
             this.storyData.pinnedArticles.push(result.id);
           } else {
             const arr = [];
             arr.push(result);
             this.decideTaskToPerformNew(arr, 0, e => {
               setTimeout(() => {
                 this.checkIfLastIsPara(false);
                 this.checkForSourceUrlInEmbed(null);
               }, 500);
             });
           }
         });
      });
      }
    else{
      this.increasePendingCount();
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        embedCard, result => {

          if (this.amazonAds && this.amazonAds.length > 0) {
            this.postReusableElementRequest(result);
          }
          this.decreasePendingCount(null);
          if (this.flagForPinnedElement) {
            this.flagForPinnedElement = false;
            this.storyData.pinnedArticles.push(result.id);
          } else {
            const arr = [];
            arr.push(result);
            this.decideTaskToPerformNew(arr, 0, e => {
              setTimeout(() => {
                this.checkIfLastIsPara(false);
                this.checkForSourceUrlInEmbed(null);
              }, 500);
            });
          }
        });
    }
    this.embedPopup = false;
    this.adTitle = '';
    this.dataFormAmazonList = [];
  }
  openEmbedPopup(model) {
    if (model === 'pinnedMedia') {
      this.flagForPinnedElement = true;
    } else {
      this.flagForPinnedElement = false;
    }
    this.embedPopup = true;
    this.embedCode = '';
    this.embedSourceUrl = '';
    this.embedSubType = '';
    this.amazonAds = [];
    this.showAmazonMeta = false;
    this.showLShapeBand = false;
    this.adTitle = '';
    this.amazonNewAd = false;
  }
  openEmbedPopupLiveblog(model,flag) {
    console.log('called openEmbedPopupLiveblog')
    this.isLiveblogEmbedCalled=flag;
    if (model === 'pinnedMedia') {
      this.flagForPinnedElement = true;
    } else {
      this.flagForPinnedElement = false;
    }
    this.embedPopup = true;
    this.embedCode = '';
    this.embedSourceUrl = '';
    this.embedSubType = '';
    this.amazonAds = [];
    this.showAmazonMeta = false;
    this.showLShapeBand = false;
    this.adTitle = '';
    this.amazonNewAd = false;
  }

  closeEmbedPopup() {
    this.embedPopup = false;
    this.embedCode = '';
    this.embedSourceUrl = '';
    this.embedSubType = '';
    this.flagForPinnedElement = false;
  }

  openCloseAmazonAdSearchPopup(openOrClose) {
    this.embedPopup = false;
    this.embedCode = '';
    this.embedSourceUrl = '';
    this.embedSubType = '';
    this.amazonAds = [];
    this.newAdName = '';
    this.newAdEmbed = '';
    // this.adTitle = '';
    this.amazonAdSearchPopup = openOrClose;

  }

  openMarketPopup() {
    this.getMarketList();
    this.getMutualFundList();
    this.mutualFundList = [];
    this.marketList = [];
    this.newMarketList = [];
    this.marketPopup = true;
    this.marketCode = '';
    this.marketText = '';
  }

  openProductPopup(){
    this.showProductPopup = true;
    // this.filteredBrandSuggestion = this.brandSuggestion;
    this.brandSuggestion = this.brandSuggestionMain;
    this.modelSuggestion = this.modelSuggestionMain;
  }
  openCategoryProductPopup(){
    this.showCategoryProductPopup = true;
    this.restService.http_get(
      this.config.get('product').baseUrl + '/api/cms/story/productcategories'
    ).subscribe(res => {
      this.filteredCategorySuggestion = res;
      this.categorySuggestion = res;
      this.brandSuggestion = [];
      this.modelSuggestion = [];
    });
  }
  closeProductPopup() {
    this.showProductPopup = false;
    this.showCategoryProductPopup = false;
    this.categoryEleQuery = '';
    this.productElement = {};
    this.brandEleQuery = '';
    this.modelEleQuery = '';
  }
  saveProductElement() {
    if (this.productElement['brand']) {
      const productCard = JSON.parse(JSON.stringify(StaticDataService.defaultProductCardData));
      console.log(this.productElement)
      // if (marketCard.indice.name) {
      this.increasePendingCount();
      productCard.product.brandName = this.productElement['brand'];
      productCard.product.modelName = this.productElement['model'];
      this.closeProductPopup();
      this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
          productCard, result => {
            this.decreasePendingCount(null);
            const arr = [];
            arr.push(result);
            this.decideTaskToPerformNew(arr, 0, e => {
              setTimeout(() => {
                this.checkIfLastIsPara(false);
                this.checkForSourceUrlInEmbed(null);
              }, 500);
            });
          });

    } else {
      this.snotify.error('Select a Brand', '', this.sharedService.getConfig(false));
    }
  }

  saveCategoryProductElement() {
    if (this.productElement['brand']) {
      const productCard = JSON.parse(JSON.stringify(StaticDataService.defaultProductCardData));
      console.log(this.productElement)
      // if (marketCard.indice.name) {
      this.increasePendingCount();
      productCard.product.brandName = this.productElement['brand'];
      productCard.product.categoryName = this.productElement['category'];
      if(this.productElement['model'].length > 0) {
        productCard.product.modelName = this.productElement['model'];
        productCard.product.modelId = this.productElement['modelId'];
        productCard.product.productUrl = this.productElement['url'];
        productCard.product.categoryId = this.productElement['categoryId']
        this.closeProductPopup();
        this.restService.http_post(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
            productCard, result => {
              this.decreasePendingCount(null);
              const arr = [];
              arr.push(result);
              this.decideTaskToPerformNew(arr, 0, e => {
                setTimeout(() => {
                  this.checkIfLastIsPara(false);
                  this.checkForSourceUrlInEmbed(null);
                }, 500);
              });
            });
      } else {
        this.snotify.error('Choose a model...', '', this.sharedService.getConfig(false));
      }


    } else {
      this.snotify.error('Select a Category & Brand', '', this.sharedService.getConfig(false));
    }
  }

  closeMarketPopup() {
    this.marketPopup = false;
    this.marketCode = '';
    this.marketText = '';
    this.deactivateMarketSuggestion = false;
  }
  openMatchPopup() {
    this.matchPopup = true;
    // this.marketCode = '';
    // this.marketText = '';
    let eventCategory='Insert Score Card';
    let eventAction=sessionStorage.getItem(StaticDataService.tenantName);
    let eventLabel='';
    let eventValue=null;
   this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
  }
  openMatchPopupLiveblogEmbed(flag) {
    console.log('called openMatchPopupLiveblogEmbed')
    this.isLiveblogEmbedCalled=flag;
    this.matchPopup = true;
  }
  closeMatchPopup() {
    this.matchPopup = false;
    // this.marketCode = '';
    //this.marketText = '';
  }
  createLocationMap(arr) {
    let map = {};
    arr.forEach(element => {
      map[element] = [];
    });
    return map;
  }

  publishOnSocialMedia() {
    // console.log('social publish');
    // console.log(this.socialMap);
    let i = 0;
    const locations = { 'geoLocations': this.createLocationMap(this.notificationLocation) };
    if (this.storyData.metadata.status === 'PUBLISHED') {
      i = 1;
      if (this.socialMap['facebook'] || this.socialMap['twitter'] || this.socialMap['mobile'] || this.socialMap['web'] || Object.keys(this.twitterCheck).length !== 0) {
        this.snotify.info('Social publishing in progress', '', this.sharedService.getConfig(false));
      } else {
        this.snotify.info('Select platform\'s to send notifications to', '', this.sharedService.getConfig(false));
      }
      if (this.socialMap['facebook'] && (this.socialMapCounter['facebook'] === 0)) {
        this.socialMapCounter['facebook'] = 1;
        this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), this.page_id, StaticDataService.facebook) + '/' + this.storyData.id,
          null, result => {
            // console.log(result);
            if (i > 0) {
              this.snotify.clear();
              i = 0;
            }
            this.socialMapCounter['facebook'] = 0;
            if (result.hasOwnProperty('status')) {
              if (result.status === false) {
                this.snotify.error(result.reason, '', this.sharedService.getConfig(false));
              } else {
                this.storyData.social.facebook = true;
                this.socialMap['facebook'] = false;
                this.snotify.success('Posted on Facebook', '', this.sharedService.getConfig(false));
              }
            } else {

            }
          });
      }
      if (this.socialMap['twitter'] && (this.socialMapCounter['twitter'] === 0)) {
        this.socialMapCounter['twitter'] = 1;
        this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), this.page_id, StaticDataService.twitter) + '/' + this.storyData.id,
          null, result => {
            // console.log(result);
            // if (!result.hasOwnProperty('error')) {
            if (i > 0) {
              this.snotify.clear();
              i = 0;
            }
            this.socialMapCounter['twitter'] = 0;
            if (result.hasOwnProperty('status')) {
              if (result.status === false) {
                this.snotify.error(result.reason, '', this.sharedService.getConfig(false));
              } else {
                this.storyData.social.twitter = true;
                this.socialMap['twitter'] = false;
                this.snotify.success('Tweeted on Twitter', '', this.sharedService.getConfig(false));
              }
            } else {

            }
            // } else {
            //   console.log('could not publish on facebook');
            // }
          });
      }
      if (this.socialMap['mobile'] && (this.socialMapCounter['mobile'] === 0)) {
        this.socialMapCounter['mobile'] = 1;
        this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), this.page_id, StaticDataService.mobile) + '/' + this.storyData.id,
          locations, result => {
            // console.log(result);
            if (i > 0) {
              this.snotify.clear();
              i = 0;
            }
            this.socialMapCounter['mobile'] = 0;
            if (result.hasOwnProperty('status')) {
              if (result.status === false) {
                this.snotify.error(result.reason, '', this.sharedService.getConfig(false));
              } else {
                this.storyData.social.mobile = true;
                this.socialMap['mobile'] = false;
                this.notificationLocation = [];
                this.snotify.success('Sent Mobile Notification', '', this.sharedService.getConfig(false));
              }
            } else {

            }
          });
      }
      if (this.twitterCheck && Object.keys(this.twitterCheck).length !== 0) {
        for (const twitter of this.twitterAccounts) {
          if (this.twitterCheck[twitter.id]) {
            this.restService.http_post(this.config.get('product').baseUrl + '/api/cms/notify/twitter/handle/'
              + this.storyData.id + '/' + twitter.id, null, result => {
                if (i > 0) {
                  this.snotify.clear();
                  i = 0;
                }
                if (result.hasOwnProperty('status')) {
                  if (result.status === false) {
                    this.snotify.error(result.reason, '', this.sharedService.getConfig(false));
                    this.twitterCheck[twitter.id] = false;
                  } else {
                    // this.storyData.social.facebook = true;
                    if (this.storyData.socialList.twitter.indexOf(twitter.id) === -1) {
                      this.storyData.socialList.twitter.push(twitter.id);
                    }
                    this.twitterCheck[twitter.id] = false;
                    this.snotify.success('Posted on' + twitter.name, '', this.sharedService.getConfig(false));
                  }
                } else {
                }
              });
          }
        }
      }
      if (this.socialMap['web'] && (this.socialMapCounter['web'] === 0)) {
        this.socialMapCounter['web'] = 1;
        this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), this.page_id, StaticDataService.browser) + '/' + this.storyData.id,
          locations, result => {
            // console.log(result);
            if (i > 0) {
              this.snotify.clear();
              i = 0;
            }
            this.socialMapCounter['web'] = 0;
            if (result.hasOwnProperty('status')) {
              if (result.status === false) {
                this.snotify.error(result.reason, '', this.sharedService.getConfig(false));
              } else {
                this.storyData.social.web = true;
                this.socialMap['web'] = false;
                this.notificationLocation = [];
                this.snotify.success('Sent Browser Notification', '', this.sharedService.getConfig(false));
              }
            } else {

            }
          });
        // this.socialMap.web = false;
      }
    } else {
      this.snotify.info('Story is not Published Yet.', '', this.sharedService.getConfig(false));
      // console.log('story is not published Yet');
    }
    this.focusedCard = null;
    this.lastindex = null;
  }

  copystoryUrl() {

    let domainUrl=this.sharedService.currentDomainUrl;
    if(domainUrl === null || domainUrl === undefined || domainUrl.trim() === ''){
      let obj = environment.domainBaseUrls.filter(e => e.id === sessionStorage.getItem(StaticDataService.domainLiteral));
      if(obj)
      domainUrl = obj[0].baseUrl;
      return '';
    } else {
      domainUrl = this.sharedService.currentDomainUrl;
    }


    if (this.storyData && this.storyData.metadata
      && (this.storyData.metadata.status === 'KILLED' || this.storyData.metadata.status === 'PUBLISHED')) {
      const url = (this.storyData.metadata && this.storyData.metadata.status
        !== 'KILLED') ?
        ((this.storyData.metadata.url.charAt(0) !== '/') ? this.storyData.metadata.url
          : (domainUrl + this.storyData.metadata.url))
        : this.storyData.metadata.redirectUrl;
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = url;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      this.snotify.info('URL copied to Clipboard', '', this.sharedService.getConfig(false));
    }
  }

  getRelatedStoryEmits(ev) {
    if (!ev) {
      for (const id of this.storyData.elements) {
        const data = this.Elements[id];
        if (data && data !== null && data.type === 'relatedstory') {
          this.storyData.related = data.relatedStories;
          break;
        }
      }
    } else {
      this.storyData.related = ev;
    }
  }
  getRelatedStoryEmitsHowto(ev) {
    if (!ev) {
      for (const id of this.storyData.elements) {
        const data = this.Elements[id];
        if (data && data !== null && data.type === 'relatedstoryhowto') {
          this.storyData.relatedHowTo = data.relatedStoriesHowTo;
          break;
        }
      }
    } else {
      this.storyData.relatedHowTo = ev;
    }
  }

  getAlsoReadEmit(ev) {
    console.log(ev)
  }

  checkForRelatedStory() {
      for (const id of this.storyData.elements) {
        const data = this.Elements[id];
        if (data && data !== null && data.type === 'relatedstory') {
          return id;
        }
      }
      return false;

   }
  checkForRelatedHowtoStory() {
      for (const id of this.storyData.elements) {
        const data = this.Elements[id];
        if (data && data !== null && data.type === 'relatedstoryhowto') {
          return id;
        }
      }
      return false;

   }

  merge_array(array1, array2) {
    let result_array = [];
    let arr = array1.concat(array2);
    let len = arr.length;
    let assoc = {};

    while (len--) {
      let item = arr[len];

      if (!assoc[item]) {
        result_array.unshift(item);
        assoc[item] = true;
      }
    }

    return result_array;
  }

  checkVideoUrl(url) {
    // var m = url.match(/^.+dailymotion.com\/(video|hub)\/([^_]+)[^#]*(#video=([^_&]+))?/);
    // ts-lint disable;
    const reg = new RegExp('(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com)|dailymotion.com)\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?');
    const reg2 = new RegExp('(http:|https:|)\/\/(dai.)?(ly)?([A-Za-z0-9._%-]*)(\&\S+)?');
    // 'https://dai.ly/x6tqrg5'
    const m = reg.exec(url);
    if (m !== null) {
      if (m[3] !== undefined && m[1] !== undefined) {
        // return m[3];
        if ((m[3] === 'youtu.be' || m[3] === 'youtube.com' || m[3] === 'dailymotion.com') && (m[1] === 'https:' || m[1] === 'http:')) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      const n = reg2.exec(url);
      if (n !== null) {
        // console.log(n);
        if ((n[2] !== undefined && n[3] !== undefined) && (n[2] === 'dai.' && n[3] === 'ly') && (n[1] === 'https:' || n[1] === 'http:')) {
          return true;
        } else {
          return false;
        }
      } else {
        return null;
      }
    }
  }

  softPublish() {
    const flagForKeywordCheck = true;
    if (this.storyData && this.storyData.metadata && !this.storyData.metadata.keywords) {
      this.storyData.metadata.keywords = [];
    }
    // console.log('disable => ' + this.disableElement('publish-story'));
    if (this.disableElement('publish-story')) {
      if (this.checkIfLiveblogHeadlineMismatch()) {
        const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true); // Omit props what i don't need
        this.snotify.confirm('Story page headline and Landing page headline are different. Do you wish to continue?', '', {
          ...config,
          buttons: [
            {
              text: 'Yes', action: (toast) => {
                this.startPublishing(flagForKeywordCheck, e => {
                  this.storyData.softPublished = true;
                  this.publishFlag = true;
                  this.publishFunctions();
                });
                this.snotify.remove(toast.id);
                this.googleAnalytics("Skippable Alerts",'Story page headline and Landing page headline are different. Do you wish to continue?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' , null);
              }, bold: false
            },
            {
              text: 'No', action: (toast) => {
                this.discareUrlChanges(true);
                this.snotify.remove(toast.id);
                this.googleAnalytics("Skippable Alerts",'Story page headline and Landing page headline are different. Do you wish to continue?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' , null);
              }
            }
          ]
        });
      } else {
        this.startPublishing(flagForKeywordCheck, e => {
          this.storyData.softPublished = true;
          this.publishFlag = true;
          this.publishFunctions();
        });
      }
    } else {
      console.log("softPublish")
      this.publishError();
    }
  }

  checkIfLiveblogHeadlineMismatch() {
    const lastHeadline = (this.storyData && this.storyData.lastPublishedHeadline
      && (this.storyData.lastPublishedHeadline !== null) && (this.storyData.lastPublishedHeadline.trim() !== ''))
      ? this.htmlToPlaintext(this.storyData.lastPublishedHeadline) : null;
    const headline = ((this.storyData.mobileHeadline !== '')
      ? this.storyData.mobileHeadline
      : (this.storyData.title !== '' ? this.storyData.title : ''));
    if (this.storyType === 'liveblog') {
      if (
        headline !== ''
        && (this.storyData !== null)
        && (
          (this.storyData.headline !== null && this.storyData.headline.replace('&nbsp;', ' ').trim() === '')
          || (lastHeadline !== null && this.storyData.headline.replace('&nbsp;', ' ').trim() === lastHeadline.replace('&nbsp;', ' ').trim())
        )
      ) {
        return false;
      } else {
        if (this.storyData.mobileHeadline.replace('&nbsp;', ' ').trim() === this.storyData.headline.replace('&nbsp;', ' ').trim()) {
          return false;
        } else {
          return true;
        }
      }
    } else {
      return false;
    }
  }
  opentab(evt) {

  }

  purgeStory() {
    this.restService.http_post(this.config.get('product').purgeUrl + '/api/cms/purge/story/' + this.storyData.id,
      null, result => {
        if (!result || !result.hasOwnProperty('error')) {
          this.revertListFlag = false;
          this.snotify.success('Purge request accepted', '', this.sharedService.getConfig(false));
        } else {
          this.snotify.error('Story could not be purged', '', this.sharedService.getConfig(false));
        }
      });
  }

  confirmParaBreak(paraStr:String) {
    if(paraStr.indexOf('|#+|') !== -1 ){
      return paraStr.split('|#+|')[1].trim();
    } else {
      return paraStr;
    }
  }

  decideTaskToPerformNew(dataArr, focus, callback, elementPosition?) {
    // debugger;
    // console.log('inside decideTaskToPerformNew :: dataArr' , dataArr);
     console.log('decideTaskToPerformNew','0---',dataArr, '1==>',this.focusedCard, '2==>',focus, '3===>',this.lastindex);
    if (this.focusedCard === 'newElement' && this.lastindex && this.lastindex.id === 'newElement'
      && this.lastindex.cardID && this.lastindex.cardID !== null) {
      this.showElementOfTempPara({
        id: this.lastindex.id,
        cardId: this.lastindex.cardID
      });
    }

    let viewPortindex = (this.focusedCard && this.focusedCard !== 'newElement')
      ? this.viewPortItems.indexOf(this.focusedCard)
      : (
        (this.focusedCard === 'newElement' && this.lastindex && this.lastindex.id === 'newElement' && this.lastindex.cardID)
          ? this.viewPortItems.indexOf(this.lastindex.cardID)
          : -1
      );
    setTimeout(e4 => {
      let index = (this.storyData && this.storyData.elements) ?
        (
          (this.focusedCard && this.focusedCard !== 'newElement')
            ? this.storyData.elements.indexOf(this.focusedCard) :
            (
              (this.focusedCard === 'newElement' && this.lastindex && this.lastindex.id === 'newElement' && this.lastindex.cardID)
                ? this.storyData.elements.indexOf(this.lastindex.cardID)
                : 0
            )
        )
        : 0;
      // console.log(viewPortindex, index, this.focusedCard);
      if (this.storyType === 'story' && this.focusedCard !== null && viewPortindex > -1) {
        if (this.elReference['_results'] && this.elReference['_results'].length > 0) {
          const currentEle = (this.focusedCard && this.focusedCard !== 'newElement')
            ? (this.elReference['_results'].filter(item => {
              return item.cardId === this.focusedCard;
            }))
            : (
              (this.focusedCard === 'newElement' && this.lastindex && this.lastindex.id === 'newElement' && this.lastindex.cardID)
                ? (this.elReference['_results'].filter(item => {
                  return item.cardId === this.lastindex.cardID;
                }))
                : []
            );
          // console.log(currentEle);
          if (currentEle[0] && currentEle[0]['cardType'] !== 'paragraph') {
            for (let i = 0; i < dataArr.length; i++) {
              const element = dataArr[i];
              viewPortindex = viewPortindex + 1;
              index = index + 1;
              this.viewPortItems.splice(viewPortindex, 0, element.id);
              this.storyData.elements.splice(index, 0, element.id);
              setTimeout(e => {
                const dataIndexInViewPort = this.viewPortItems.indexOf(element.id);
                if (dataIndexInViewPort > -1) {
                  this.elReference['_results'][dataIndexInViewPort].focusElementFromStory('start');
                }
              }, 200);
            }
            callback(null);
          } else if (currentEle[0]) {
            const paraIndex = this.lastindex['index'];
            currentEle[0].destroyCardAutoSaveInterval();
            currentEle[0].checkSplitFeasibility(paraIndex, this.lastindex['id'], (evn, arr) => {
              // console.log('evn :: ', evn);
              // console.log('arr :: ', arr);

              if (evn === 'top') {
                currentEle[0].generateCardAutoSaveInterval();
                for (let i = 0; i < dataArr.length; i++) {
                  const element = dataArr[i];
                  this.viewPortItems.splice(viewPortindex, 0, element.id);
                  this.storyData.elements.splice(index, 0, element.id);
                  viewPortindex = viewPortindex + 1;
                  index = index + 1;
                  setTimeout(e => {
                    const dataIndexInViewPort = this.viewPortItems.indexOf(element.id);
                    if (dataIndexInViewPort > -1) {
                      this.elReference['_results'][dataIndexInViewPort].focusElementFromStory('start');
                    }
                  }, 200);
                }
                callback(null);
              } else if (evn === 'bottom') {
                console.log("HERE BOTTOM")
                currentEle[0].generateCardAutoSaveInterval();
                for (let i = 0; i < dataArr.length; i++) {
                  const element = dataArr[i];
                  viewPortindex = viewPortindex + 1;
                  index = index + 1;
                  console.log(element.id)
                  this.viewPortItems.splice(viewPortindex, 0, element.id);
                  this.storyData.elements.splice(index, 0, element.id);
                  setTimeout(e => {
                    const dataIndexInViewPort = this.viewPortItems.indexOf(element.id);
                    if (dataIndexInViewPort > -1) {
                      this.elReference['_results'][dataIndexInViewPort].focusElementFromStory('start');
                    }
                  }, 700);
                }
                callback(null);
              } else if (evn === 'mid') {
                currentEle[0].splitParaByIndex(paraIndex, arr, t => {
                  const paraElement = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
                  paraElement.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
                  paraElement['id'] = null;
                  // console.log('t ::: ', t);
                  paraElement['paragraph']['body'] = t;
                  this.increasePendingCount();
                  this.restService.http_post(this.config.get('product').baseUrl
                    + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
                    paraElement, result2 => {
                      // console.log('result2 :: ', result2);
                      this.decreasePendingCount(null);
                      if (this.isCKEditorEnabled) {
                        currentEle[0].setParagraphData(this.confirmParaBreak(arr[1]));
                      } else {
                        currentEle[0].paraEditor.deleteText(0, paraIndex);
                      }
                      currentEle[0].generateCardAutoSaveInterval();
                      currentEle[0].doCheck();
                      this.viewPortItems.splice(viewPortindex, 0, result2.id);
                      this.storyData.elements.splice(index, 0, result2.id);
                      let viewIdIndex = this.viewPortItems.indexOf(result2.id);
                      let idIndex = this.storyData.elements.indexOf(result2.id);
                      for (let i = 0; i < dataArr.length; i++) {
                        const element = dataArr[i];
                        viewIdIndex = viewIdIndex + 1;
                        idIndex = idIndex + 1;
                        this.viewPortItems.splice(viewIdIndex, 0, element.id);
                        this.storyData.elements.splice(idIndex, 0, element.id);
                        setTimeout(e => {
                          const dataIndexInViewPort = this.viewPortItems.indexOf(element.id);
                          if (dataIndexInViewPort > -1) {
                            this.elReference['_results'][dataIndexInViewPort].focusElementFromStory('start');
                          }
                        }, 200);
                      }
                      callback(null);
                    });
                });

              }else{
                currentEle[0].generateCardAutoSaveInterval();
              }
            });
          }
        }
      } else {
        if (dataArr && dataArr.length > 0) {
          for (let i = 0; i < dataArr.length; i++) {
            const element = dataArr[i];
            if(this.isLiveblogEmbedCalled && this.liveblogIntroEmbed){
              this.viewPoerItemLiveblogEmbed.push(element.id)
              if(this.storyData['introElements']){
                this.storyData['introElements'].push(element.id);
                console.log('if block this.storyData.introElements',this.storyData['introElements'])
                this.isLiveblogEmbedCalled=false;
              }else{
                //if node getting null
                this.storyData['introElements']=[element.id];
                console.log('else block this.storyData.introElements',this.storyData['introElements'])
                this.isLiveblogEmbedCalled=false;
              }

            }else{
              if(elementPosition && elementPosition === 'top'){
                this.viewPortItems.unshift(element.id);
                this.storyData.elements.unshift(element.id);
              }
              else {
                this.viewPortItems.push(element.id);
                this.storyData.elements.push(element.id);
              }

              
              console.log('this.storyData.elements',this.storyData.elements)
            }
            if(this.relatedVideoStoryCase) {
              this.storyData['isrelatedVideoAdded'] = true;
              this.storyData['relatedVideoElementIds'] = [element.id];
              this.relatedVideoStoryCase = false;
            }
            setTimeout(e => {
              const dataIndexInViewPort = this.viewPortItems.indexOf(element.id);
              if (dataIndexInViewPort > -1 && this.elReference && this.elReference['_results']
                && this.elReference['_results'][dataIndexInViewPort]) {
                this.elReference['_results'][dataIndexInViewPort].focusElementFromStory('start');
              }
            }, 100);
            callback(null);
          }
        }
        if (focus) {
          setTimeout(e => {
            for (let i = 0; i < dataArr.length; i++) {
              const dataIndexInViewPort = this.viewPortItems.indexOf(dataArr[i].id);
              if (dataIndexInViewPort > -1 && this.elReference && this.elReference['_results']
                && this.elReference['_results'][dataIndexInViewPort]) {
                this.elReference['_results'][dataIndexInViewPort].focusElementFromStory('start');
              }
            }
            callback(null);
          }, 100);
        }
      }
    }, 100);
  }

  previewPdf(res) {
    if (res) {
      const DocumentData = JSON.parse(JSON.stringify(StaticDataService.defaultDocumentData));
      DocumentData.id = null;
      DocumentData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      DocumentData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
      DocumentData.image.images['original'] = res['images']['original'].replace(/"/gi, '');
      this.increasePendingCount();
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        DocumentData, result => {
          this.decreasePendingCount(null);
          if (result) {
            const arr = [];
            arr.push(result);
            this.decideTaskToPerformNew(arr, 0, e => {
              setTimeout(() => {
                this.checkIfLastIsPara(false);
              }, 250);
            });
          }
        });
    }
  }


  pdfDocumentLoaded(event) {
    if (document.getElementsByTagName('ng2-pdfjs-viewer')[0]
      && document.getElementsByTagName('ng2-pdfjs-viewer')[0].getElementsByTagName('iframe')[0]
      && document.getElementsByTagName('ng2-pdfjs-viewer')[0]
        .getElementsByTagName('iframe')[0].contentDocument.getElementsByClassName('page')[0]) {
      const height = document.getElementsByTagName('ng2-pdfjs-viewer')[0]
        .getElementsByTagName('iframe')[0].contentDocument.getElementsByClassName('page')[0].clientHeight;
      document.getElementsByTagName('ng2-pdfjs-viewer')[0].getElementsByTagName('iframe')[0]
        .setAttribute('style', 'height:' + height + 'px;');
    }
  }
  setSource(source) {
    this.storyData.metadata.storyType = source;
  }

  setImageCaption(result) {
    if (result.leadMedia.image) {
      if (result.leadMedia.elements.length > 0) {
        this.imageCaption = result.leadMedia.image.caption;
      } else {
        this.imageCaption = 'Enter caption';
      }
    } else {
      this.imageCaption = 'Enter caption';
    }
  }
  checkForSourceUrlInEmbed(ev) {
    if (this.changeFlag) {
      setTimeout(() => {
        this.checkForSourceUrlInEmbed(null);
      }, 500);
    } else {
      const res = JSON.parse(JSON.stringify(this.storyData.elements));
      for (let i = 0; i <= res.length; i++) {
        const j = i;
        if (i < res.length) {
          const data = this.Elements[res[j]];
          if (data && (data !== null) && (data.type === 'embed'
            || data.type === 'liveblog') && data.jsonSourceUrl && (data.jsonSourceUrl.trim() !== '')) {
            this.storyData['metadata']['jsonSourceUrl'] = data.jsonSourceUrl;
            return;
          }
        }
        if (i === res.length) {
          this.storyData['metadata']['jsonSourceUrl'] = null;
        }
      }
      // for (const id of this.storyData.elements) {
      //   const data = this.Elements[id];
      //   if (data && (data !== null) && (data.type === 'embed'
      //   || data.type === 'liveblog') && data.jsonSourceUrl && (data.jsonSourceUrl.trim() !== '')) {
      //     this.storyData['metadata']['jsonSourceUrl'] = data.jsonSourceUrl;
      //     return;
      //   }
      // }
    }
  }

  createNewTable(model) {
    if (model === 'pinnedMedia') {
      this.flagForPinnedElement = true;
    } else {
      this.flagForPinnedElement = false;
    }
    this.tablePopup = true;
    this.tableHTML = '';
    let eventCategory='Insert Table';
    let eventAction=sessionStorage.getItem(StaticDataService.tenantName);
    let eventLabel='';
    let eventValue=null;;
    this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue);
  }
  createNewTableLiveblogEmbed(model,flag) {
    console.log('called createNewTableLiveblogEmbed')
    this.isLiveblogEmbedCalled=flag;
    if (model === 'pinnedMedia') {
      this.flagForPinnedElement = true;
    } else {
      this.flagForPinnedElement = false;
    }
    this.tablePopup = true;
    this.tableHTML = '';
  }

  closeTable() {
    this.flagForPinnedElement = false;
    this.tablePopup = false;
    this.tableHTML = '';
  }

  changeTable() {
    const tableElement = JSON.parse(JSON.stringify(StaticDataService.defaultTableCardData));
    tableElement.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    tableElement.paragraph.body = ('' + this.tableHTML).replace('<figure class="table">', '').replace('</figure>', '');
    this.increasePendingCount();
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      tableElement, result => {
        this.decreasePendingCount(null);
        if (this.flagForPinnedElement) {
          this.storyData.pinnedArticles.push(result.id);
        } else {
          const arr = [];
          arr.push(result);
          this.decideTaskToPerformNew(arr, 0, e => {
            setTimeout(() => {
              this.checkIfLastIsPara(false);
            }, 500);
          });
        }
        setTimeout(e => {
          this.closeTable();
        }, 300);
      });

  }

  getTagsEnable() {
    return (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['getTags'] === 'true');
  }

  getSummaryMaxLength() {
    const storyType = (this.storyType && this.storyType !== '') ? this.storyType : 'story';
    if (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config'][storyType] && this.domainConfig['config'][storyType]['summary']) {
      return Number(this.domainConfig['config'][storyType]['summary']);
    } else {
      return 300;
    }
  }

  checkIfNotificationPlatformEnabled(platform) {
    return (this.domainConfig && this.domainConfig['notificationPlatformsEnabled']
      && this.domainConfig['notificationPlatformsEnabled'].indexOf(platform) > -1);
  }
  addSlide() {
    if (this.queueForPosts === 0) {
      const cardDataPhotoStory = this.elPhotostoryRef['_results'][0].cardData;
      // const card = JSON.stringify(cardDataPhotoStory);
      const num = new Date().getTime();
      if (this.htmlToPlaintext(cardDataPhotoStory.title).length < 200) {
        if (cardDataPhotoStory.paragraph.body) {
          if (!this.isSlideTitleEnabled || (cardDataPhotoStory.title && this.htmlToPlaintext(cardDataPhotoStory.title).trim() !== '')) {
            this.queueForPosts = 1;
            if (!this.storyData.elements || this.storyData.elements === null) {
              this.storyData.elements = [];
            }
            if (localStorage.getItem('tempImage')) {
              this.restService.http_get(
                this.config.get('product').baseUrl
                + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
                + '/' + localStorage.getItem('tempImage')
              ).subscribe(res => {
                cardDataPhotoStory.image = res.image;
                this.increasePendingCount();
                this.restService.http_post(this.config.get('product').baseUrl
                  + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
                  cardDataPhotoStory, result => {
                    this.decreasePendingCount(null);
                    // this.removeTempCardView(num);
                    this.viewPortItems.unshift(result.id);
                    this.storyData.elements.unshift(result.id);
                    this.currentcardID = String(result.id);
                    setTimeout(e => {
                      this.queueForPosts = 0;
                      this.elPhotostoryRef['_results'][0].resetphotoStoryElement();
                    }, 100);
                  });
              });
            } else {
              this.queueForPosts = 0;
              this.snotify.warning('Please enter the IMAGE before adding slide', '', this.sharedService.getConfig(false));
            }
          } else {
            if (!cardDataPhotoStory.title) {
              this.queueForPosts = 0;
              this.snotify.warning('Please enter the TITLE before saving', '', this.sharedService.getConfig(false));
            }
            if (!localStorage.getItem('tempImage')) {
              this.queueForPosts = 0;
              this.snotify.warning('Please enter the IMAGE before adding slide', '', this.sharedService.getConfig(false));
            }

          }
        } else {
          if (this.isSlideTitleEnabled && !cardDataPhotoStory.title) {
            this.snotify.warning('Please enter the TITLE before saving', '', this.sharedService.getConfig(false));
          }
          if (!cardDataPhotoStory.paragraph.body) {
            this.snotify.warning('Please enter the DESCRIPTION before saving', '', this.sharedService.getConfig(false));
          }

        }
      } else {
        this.queueForPosts = 0;
        this.snotify.error('Title Length Should Be Less Than 200 Characters', '', this.sharedService.getConfig(false));
      }

    }
  }


  addLiveblogPost() {
    //reset liveblog to show element limits
    this.copyliveBlogShowMaxEle=this.liveBlogShowMaxEle;
    if (this.queueForPosts === 0) {
      var cardData = this.elLiveRef['_results'][0].cardData;
      cardData=this.sharedService.checkhrefandreplace(cardData)
      const card = JSON.stringify(cardData);
      const num = new Date().getTime();
      if (cardData.title && this.htmlToPlaintext(cardData.title).trim() !== '') {
        this.saveCardTemporarily({
          data: card,
          id: num,
          format: 'liveblog'
        });
        this.queueForPosts = 1;
        if (!this.storyData.elements || this.storyData.elements === null) {
          this.storyData.elements = [];
        }
        this.increasePendingCount();
        this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
          cardData, result => {
            this.decreasePendingCount(null);
            this.removeTempCardView(num);
            this.viewPortItems.unshift(result.id);
            this.storyData.elements.unshift(result.id);
            setTimeout(e => {
              this.elLiveRef['last'].setFocusOnThis('last');
              this.elLiveRef['last'].setFocusOnThis('start');
            }, 500);
            this.currentcardID = String(result.id);
            this.checkForSourceUrlInEmbed(null);
            setTimeout(e => {
              this.queueForPosts = 0;
              this.elLiveRef['_results'][0].resetliveblogElement();
            }, 100);
          });
      } else {
        this.snotify.warning('Please enter the title before saving', '', this.sharedService.getConfig(false));
      }
    }
  }
  addLiveblogPostLite() {
    if (this.queueForPosts === 0) {
      var cardData = this.elLiveRef['_results'][0].cardData;
      cardData=this.sharedService.checkhrefandreplace(cardData);
      const card = JSON.stringify(cardData);
      const num = new Date().getTime();
      if (cardData.title && this.htmlToPlaintext(cardData.title).trim() !== '') {
        this.saveCardTemporarily({
          data: card,
          id: num,
          format: 'mintlite'
        });
        this.queueForPosts = 1;
        if (!this.storyData.elements || this.storyData.elements === null) {
          this.storyData.elements = [];
        }
        this.increasePendingCount();
        this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
          cardData, result => {
            this.decreasePendingCount(null);
            this.removeTempCardView(num);
            this.viewPortItems.unshift(result.id);
            this.storyData.elements.unshift(result.id);
            setTimeout(e => {
              this.elLiveRef['last'].setFocusOnThis('start');
            }, 500);
            this.currentcardID = String(result.id);
            this.checkForSourceUrlInEmbed(null);
            setTimeout(e => {
              this.queueForPosts = 0;
              this.elLiveRef['_results'][0].resetliveblogElement();
            }, 100);
          });
      } else {
        this.snotify.warning('Please enter the title before saving', '', this.sharedService.getConfig(false));
      }
    }
  }

  getEmbedPopupTitle() {
    if (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['autoEmbed'] === 'false') {
      return 'Add Embed code for the video, tweet, etc';
    } else {
      return 'Add Embed code/URL (youtube, dailymotion, & vimeo only) for the video, tweet, etc';
    }
  }



  getNewTagsToAdd(ev) {
    const oldTags = JSON.parse(JSON.stringify(this.storyData.metadata.tags));
    const newTags = JSON.parse(JSON.stringify(ev));
    const latestTag = newTags.filter(x => !oldTags.includes(x));
    this.storyData.metadata.tags = newTags;
    if (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['autoRelateStory'] === 'true') {
      const getList = latestTag.map(e => (this.fetchNewStoriesFronTags(e)));
      forkJoin(getList).subscribe(
        data => {
          // console.log(data);
          this.retrieveStoryIdsFromResponse(data);
        },
        err => {
          console.error(err);
        }
      );
    }
    if ((oldTags && newTags) && oldTags.length <= newTags.length) {
      if (this.storyType === 'story' && this.domainConfig && this.domainConfig['config']
        && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['autoRelatedVideoStory'] === 'tags') {
        this.fetchRelatedVideoForStory(latestTag[0]);
      }
    }
  }

  getNewTopicToAdd(ev) {
    let latestTopic = [];
    if (!this.sharedService.isdomainConfig('story', 'addTopic')) {
      this.getNewTagsToAdd(ev);
    }
    if ((this.storyType && ev) && (this.checkValidStoryTypeForTopic() || this.sharedService.isdomainConfig('story', 'addTopic'))) {
      const oldTopic = JSON.parse(JSON.stringify(this.storyData.metadata.topic));
      const newTopic = JSON.parse(JSON.stringify(ev));
      this.storyData.metadata.topic = newTopic;
      if ((oldTopic && newTopic) && oldTopic.length <= newTopic.length) {
        if (newTopic.length === oldTopic.length) {
          latestTopic.push(newTopic[newTopic.length - 1]);
        } else {
          latestTopic = newTopic.filter(x => !oldTopic.includes(x));
        }
        if (this.isAutoRelatedVideoStoryEnabled()) {
          this.fetchRelatedVideoForStory(latestTopic[0]);
        }
      }
    }
    setTimeout(() => {
      for (const id of this.storyData.elements) {
        const data = this.Elements[id];
        const index = this.viewPortItems.indexOf(id);
        if (index > -1) {
          this.elReference['_results'][index].loadView(false);
        }
      }
    }, 2000);
    
  }

  checkValidStoryTypeForTopic() {
    if (this.domainConfig['config']['story']['topicAddStoryTypes'] && this.domainConfig['config']['story']['topicAddStoryTypes'].split(',').indexOf(this.storyType) !== -1)
      return true;
    return false;
  }
  fetchRelatedVideoForStory(latestEntry) {
    // console.log(this.domainConfig['config']['story']) //&& this.domainConfig['config']['story']['autoRelatedVideoStorySections'])
    if(this.domainConfig && this.domainConfig['config']
    && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['autoRelatedVideoStorySections']) {
      let enabled_sections = this.domainConfig['config']['story']['autoRelatedVideoStorySections'].split(',');
      if(enabled_sections.indexOf(this.storyData.metadata.section) > -1 || enabled_sections[0]==='all_sections') {
        console.log('Fetching automatic video embed for - ' + latestEntry)
        if (this.domainConfig && this.domainConfig['config']
        && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['autoRelatedVideoStory']) {
          this.videoAlreadyExist = false;
          console.log(this.elementDataArray)
          if (this.elementDataArray && this.elementDataArray.length > 0) {
            for (let i = 0; i < this.elementDataArray.length; i++) {
              if (this.elementDataArray[i] && this.elementDataArray[i]['type'] &&
                (this.elementDataArray[i]['type'] === 'video' || this.checkVideoEmbedPresent(this.elementDataArray[i]))) {
                this.videoAlreadyExist = true;
                break;
              }
            }
          }
          if (!this.autoEmbedVideoAdded && !this.videoAlreadyExist) {
            const getList = this.fetchNewVideoStoriesFromTopic(latestEntry);
            if (getList) {
              getList.subscribe((res) => {
                let videoData = JSON.parse(res['_body'])['response'];
                if (videoData && videoData[0]) {
                  console.log(videoData)
                  this.elementDestination = 'elements';
                  this.relatedVideoStoryCase = true;
                  this.getLeadMediaVideo(videoData[0],true);
                  this.autoEmbedVideoAdded = true;
                }
              });
            }
          }
        }
      }
    }
  }
  checkVideoEmbedPresent(item) {
    if(item.type === 'embed') {
      if(item.embed.body.indexOf('jwplayer') > -1) {
        return true;
      }
      return false;
    }
    return false;
  }


  isAutoRelatedVideoStoryEnabled() {
    return (this.storyType === 'story' && this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['autoRelatedVideoStory'] === 'topics');
  }

  fetchNewStoriesFronTags(tag) {
    const url = this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'all_stories', 'all_story')
      + '?page=0&size=10&sort=lastModifiedDate,desc&search=,metadata.status:PUBLISHED,text~' + tag.trim();
    return this.http.get(url);
  }

  fetchNewVideoStoriesFromTopic(topic) {
    const header = new HttpHeaders({
      'Authorization': 'Bearer 55d6895dgdc74efdbcb42f654f7e9d10'
    });
    const options = {
      headers: header
    }   
    const offset = 0;
    let url = this.config.get('product').videoFeedUrl + '?limit=1' + '&sortby=updated_at&Orderby=-1';
    if (url.indexOf('sitename') === -1) {
      url += '&sitename=' + this.videoFeedDomains;
    }
    if (topic) {
      url += '&q=' + topic.trim();
    }
    url += '&from=' + offset;
    return this.httpMethod.get(url, options);
  }

  retrieveStoryIdsFromResponse(data) {

    const relId = this.checkForRelatedStory();
    if (relId !== false) {
      const elementData = this.Elements[relId];
      const existingStoryIds = elementData['relatedStories'];
      const createSet = data.filter(e => (e['content'].length > 0)).map(e => {
        const arr = e['content'].filter(e2 => (existingStoryIds.indexOf(e2['id']) === -1));
        // console.log(arr);
        return arr[0]['id'];
      });
      const updatedRelatedStories = existingStoryIds.concat(createSet);
      this.Elements[relId]['relatedStories'] = updatedRelatedStories;
      // console.log(data, existingStoryIds, createSet);
      if (this.viewPortItems.indexOf(relId) > -1) {
        this.elReference['_results'][this.viewPortItems.indexOf(relId)].updateRelatedStories(updatedRelatedStories);
      } else {
        this.overrideElementSave(elementData, updatedRelatedStories);
      }
    } else {
      const createSet = data.filter(e => (e['content'].length > 0)).map(e => (e['content'][0]['id']));
      // console.log(createSet);
      if (createSet.length > 0) {
        const card = JSON.parse(JSON.stringify(StaticDataService.defaultRelatedStoryCardData));
        card.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
        card['relatedStories'] = createSet;
        this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
          card, result => {
            const lastId = this.storyData.elements[this.storyData.elements.length - 1];
            this.storyData.elements.push(result.id);
            // console.log(lastId, this.storyData.elements, this.viewPortItems, this.elReference);
            if (!lastId || this.viewPortItems.indexOf(lastId) > -1) {
              this.viewPortItems.push(result.id);
              setTimeout(e => {
                const dataIndexInViewPort = this.viewPortItems.indexOf(result.id);
                if (dataIndexInViewPort > -1) {
                  this.elReference['_results'][dataIndexInViewPort].focusElementFromStory('start');
                }
              }, 500);
            }
            setTimeout(() => {
              this.checkIfLastIsPara(false);
            }, 250);
          });
      }
    }
  }

  overrideElementSave(obj, updatedRelatedStories) {
    this.restService.http_get(
      this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), this.page_id, this.lockAcquire_api)
      + '?articleId='
      + String(obj.id)
    ).subscribe(acquire => {
      if (acquire) {
        obj['relatedStories'] = updatedRelatedStories;
        this.restService.http_put(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
          obj, result => {
            if (!result.hasOwnProperty('error')) {
              this.getUpadtedElementContent(result);
            }
            this.restService.http_get(
              this.config.get('product').baseUrl
              + this.config.getEndPoint(this.config.get('views'), this.page_id, this.lockRelease_api)
              + '?articleId='
              + String(obj.id)
            ).subscribe(release => { });
          });
      }
    });
  }

  isSyndicationToggleEnabled() {
    return (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['syndicationFeed'] === 'true');
  }



  isHomepageOptionsEnabled() {
    return (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['liveblog'] && this.domainConfig['config']['liveblog']['homepageOptions']
      && (Number(this.domainConfig['config']['liveblog']['homepageOptions']) > 0))
      ? Number(this.domainConfig['config']['liveblog']['homepageOptions']) : 0;
  }

  showPinnedGallery() {
    this.isPinnedLigthbox = true;
    this.isPinnedPhotopopup = true;
    this.pinnedMediaImageToggle = true;
    this.sharedService.overflowhidden();
  }

  hidePinnedGallery() {
    this.isPinnedLigthbox = false;
    this.isPinnedPhotopopup = false;
    this.pinnedMediaImageToggle = false;
    this.sharedService.overflowauto();
  }

  getPinnedMediaId(obj) {
    if (!this.storyData.pinnedArticles) {
      this.storyData.pinnedArticles = [];
    }
    this.hidePinnedGallery();
    if (obj.type === 'wire') {
      this.saveCard(obj, 'pinnedMedia');
    } else {
      if (obj.id) {
        this.createDuplicateImageChild(obj.id, fn => {
          if (fn !== false) {
            this.storyData.pinnedArticles.push(fn.id);
          } else {
            // console.log('couldn\'nt create duplicate child');
          }
        });
        // console.log(this.storyData);
        this.changeFlag = true;
      }
    }
  }

  deletePinnedElement(ev) {
    if (this.storyData.pinnedArticles.indexOf(ev) > -1) {
      this.storyData.pinnedArticles.splice(this.storyData.pinnedArticles.indexOf(ev), 1);
      this.changeFlag = true;
    } else {
      // console.log('element id not found');
    }
    this.isPinnedPhotopopup = false;
    this.sharedService.overflowauto();
  }

  onPositionChange(ev) {
    const initalValue = ev.target.value;
    const newValue = initalValue.replace(/[^0-9]*/g, '');
    const maxLength = this.isHomepageOptionsEnabled();
    if (initalValue !== newValue) {
      this.storyData.metadata.homePagePosition = newValue;
    } else {
      if (initalValue !== '') {
        if (maxLength && (+initalValue > +maxLength)) {
          this.storyData.metadata.homePagePosition = maxLength;
        } else if (+initalValue < 1) {
          this.storyData.metadata.homePagePosition = 1;
        } else {
          this.storyData.metadata.homePagePosition = newValue;
        }
      }
    }
  }

  dateSelectedForHomepageOption(value) {
    this.storyData.metadata.homePageEndTime = (value.start.unix() * 1000);
  }
  dateSelectedForEndTimeOption(value) {
    this.storyData.metadata.outdatedTime = (value.start.unix() * 1000);
  }
  dateEventHandlerForHomepageOption(value) {
    if (value.event.type === 'apply') {
    }
    if (value.event.type === 'cancel') {
      this.storyData.metadata.homePageEndTime = null;
      this.setCalendarMinDateForHomepageOption();
    }
  }
  dateEventHandlerForEndTime(value) {
    if (value.event.type === 'apply') {
    }
    if (value.event.type === 'cancel') {
      this.storyData.metadata.outdatedTime = null;
      this.setCalendarMinDateForEndTime();
    }
  }
  setCalendarMinDateForHomepageOption() {
    const nowDate2 = new Date();
    this.homepageCalendarConfig['minDate'] =
      (((nowDate2.getMonth() + 1) > 9) ? (nowDate2.getMonth() + 1) : '0' + (nowDate2.getMonth() + 1))
      + '/' + ((nowDate2.getDate() > 9) ? nowDate2.getDate() : '0' + nowDate2.getDate())
      + '/' + nowDate2.getFullYear()
      + ' ' + nowDate2.getHours() + ':' + nowDate2.getMinutes();
  }
  setCalendarMinDateForEndTime() {
    const nowDate2 = new Date();
    this.endTimeCalendarConfig['minDate'] =
      (((nowDate2.getMonth() + 1) > 9) ? (nowDate2.getMonth() + 1) : '0' + (nowDate2.getMonth() + 1))
      + '/' + ((nowDate2.getDate() > 9) ? nowDate2.getDate() : '0' + nowDate2.getDate())
      + '/' + nowDate2.getFullYear()
      + ' ' + nowDate2.getHours() + ':' + nowDate2.getMinutes();
  }
  isSummaryHyperlinkEnabled() {
    return (this.storyType && this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config'][this.storyType] && this.domainConfig['config'][this.storyType]['summaryHyperlink']
      && this.domainConfig['config'][this.storyType]['summaryHyperlink'] === 'true');
  }

  // getSummaryEditorConfig() {
  //   return (this.isSummaryHyperlinkEnabled() ? this.summaryToolbarWithHyperlink : this.summaryToolbar);
  // }
  getLeadVideoFlag(type) {
    if (type === 'liveblog') {
      return this.sharedService.isdomainConfig('liveblog', 'leadVideo');
    } else {
      return this.sharedService.isdomainConfig('story', 'leadVideo');
    }
  }
  isSummaryTagStripDisabled() {
    return (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['summaryStripTagDisabled']
      && this.domainConfig['config']['story']['summaryStripTagDisabled'] === 'true');
  }
  isEditorForVernacular() {
    return (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['vernacular-editor']
      && this.domainConfig['config']['story']['vernacular-editor'] === 'true');
  }

  isNewsletterFieldsEnabled() {
    return (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['newsletter-fields'] === 'true');
  }
  isH2enabled() {
    return (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['h2Headline'] === 'true');
  }
  isH3enabled() {
    return (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['h3Headline'] === 'true');
  }


  isPrimaryLocationEnabled() {
    return (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['primary-location'] === 'true');
  }

  checkPrimaryLocation() {
    if (this.storyData.metadata.section !== 'entertainment') {
      return this.isPrimaryLocationEnabled() ? (this.storyData.metadata && this.storyData.metadata.primaryLocation
        && this.storyData.metadata.primaryLocation.trim() !== '') : true;
    }
    else {
      return true;
    }
  }

  getLocationList() {
    if (this.storyData && this.storyData.metadata && this.storyData.metadata.primaryLocation
      && this.storyData.metadata.primaryLocation !== '') {
      return this.primaryLocationSuggestion
        ? this.primaryLocationSuggestion.filter(e => e !== this.storyData.metadata.primaryLocation) : [];
    } else {
      return this.primaryLocationSuggestion ? this.primaryLocationSuggestion : [];
    }
  }

  removeSecondaryLocation(item) {
    if (this.storyData && this.storyData.metadata && this.storyData.metadata.location
      && this.storyData.metadata.location.indexOf(item) > -1) {
      this.storyData.metadata.location =
        this.storyData.metadata.location.filter(e => e !== item);
      this.snotify.error('Reset Secondary Location also', '', this.sharedService.getConfig(false));
    }
  }

  getHeadlineMaxLength(disableHeadlineLimit) {
    if (!disableHeadlineLimit) {
      if (this.domainConfig && this.domainConfig['config']
        && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['headline-limit']) {
        this.errorheadlineMaxLength = Number(this.domainConfig['config']['story']['headline-limit']);
        return Number(this.domainConfig['config']['story']['headline-limit']);
      } else {
        this.errorheadlineMaxLength = 80;
        return 80;
      }
    } else {
      this.errorheadlineMaxLength = 80;
      // this.headlineMaxLength = 80
      return this.errorheadlineMaxLength;
    }
  }
  showMessage(element) {
    if (this.lastindex && this.lastindex.id && this.lastindex.id === 'newElement') {
      this.focusedCard = null;
      this.lastindex = null;
      this.snotify.info('Data Saving in Progress. Please place cursor at the point of ' + element + ' insertion.',
        '', this.sharedService.getConfig(false));
    }
  }

  isButtonDisabled() {
    return (this.isCKEditorEnabled && this.lastindex && this.lastindex.id && this.lastindex.id === 'newElement');
  }

  isLocationDisabled() {
    return (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['locationFieldDisabled'] === 'true');
  }

  openQuotePopup() {
    this.quoteText = '';
    this.quotePopup = true;
    this.sharedService.overflowhidden();
    let eventCategory='Insert Quote';
    let eventAction=sessionStorage.getItem(StaticDataService.tenantName);
    let eventLabel='';
    let eventValue=null;
   this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
  }

  saveQuote() {
    const text = this.quoteText.trim();
    const quoteCard = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
    quoteCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    quoteCard.type = 'quote';
    quoteCard.paragraph.body = text;
    this.increasePendingCount();
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      quoteCard, result => {
        this.decreasePendingCount(null);
        this.decideTaskToPerformNew([result], 0, e => {
          setTimeout(() => {
            this.checkIfLastIsPara(false);
          }, 500);
        });
      });
    this.closeQuotePopup();
  }

  closeQuotePopup() {
    this.quotePopup = false;
    this.quoteText = '';
    this.sharedService.overflowauto();
  }

  isURLValidationEnabled() {
    return (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['urlValidation'] === 'true');

  }
  isAmazonEnabled() {
    return (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['amazonMeta'] === 'true');
  }
  isTableEnabled() {
    return (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['tableReusable'] === 'true');
  }

  addReview() {
    const reviewCard = JSON.parse(JSON.stringify(StaticDataService.defaultReviewCardData));
    reviewCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    this.increasePendingCount();
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      reviewCard, result => {
        this.decreasePendingCount(null);
        this.decideTaskToPerformNew([result], 0, e => {
          setTimeout(() => {
            this.checkIfLastIsPara(false);
          }, 500);
        });
      });
  }
  isHeadlineRestrictionEnabled() {
    return (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['headlineRestriction']
      && (this.domainConfig['config']['story']['headlineRestriction'].split(',')))
      ? this.domainConfig['config']['story']['headlineRestriction'].split(',') : [];
  }

  checkHeadlineRestrictedCharacters() {
    const headlines = this.isHeadlineRestrictionEnabled();
    if (headlines) {
      const errMap = headlines.map(e => {
        return this.sharedService.checkIfRestrictedCharactersArePresent(this.storyData.mobileHeadline, 'headline') ? e : null;
      }).filter(e => e);
      return {
        flag: (errMap && errMap.length > 0),
        err: errMap
      };
    } else {
      this.headlineErrors = [];
      return {
        flag: false,
        err: []
      };
    }
  }

  isSummaryRestrictionEnabled() {
    return (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['summaryRestriction']
      && (this.domainConfig['config']['story']['summaryRestriction'].split(',')))
      ? this.domainConfig['config']['story']['summaryRestriction'].split(',') : [];
  }

  checkSummaryRestrictedCharacters() {
    const summaries = this.isSummaryRestrictionEnabled();
    if (summaries) {
      const errMap = summaries.map(e => {
        return this.sharedService.checkIfRestrictedCharactersArePresent(this.storyData.summary, 'summary') ? e : null;
      }).filter(e => e);
      return {
        flag: (errMap && errMap.length > 0),
        err: errMap
      };
    } else {
      this.summaryErrors = [];
      return {
        flag: false,
        err: []
      };
    }
  }

  checkCaptionRestrictedCharacters() {
    if (this.captionRestrictionEnabled) {
      const elements = this.storyData['elements'] ? this.storyData['elements'] : [];
      const leadElementId = (this.storyData.leadMedia && this.storyData.leadMedia.elements && this.storyData.leadMedia.elements[0])
        ? [this.storyData.leadMedia.elements[0]] : [];
      const nestedElements = elements.map(e1 => {
        const e = this.Elements.hasOwnProperty(e1) ? this.Elements[e1] : null;
        if (e && e.type === 'liveblog' && e.liveBlog && e.liveBlog.inlineElementId) {
          return e.liveBlog.inlineElementId;
        } else {
          return null;
        }
      }).filter(e => e);
      const allElements = [...elements, ...leadElementId, ...nestedElements].filter(e => e);
      // console.log(allElements);
      const booleanArray = allElements.map(e => {
        const el = this.Elements.hasOwnProperty(e) ? this.Elements[e] : null;
        return (el && el.type === 'image' && el.image && el.image.caption
          && this.sharedService.checkIfRestrictedCharactersArePresent(el.image.caption, 'caption'));
      }).filter(e => e);
      // console.log(booleanArray);
      return (booleanArray && booleanArray.length > 0);
    } else {
      return false;
    }
  }
  getMatchDetailsToParentfn(obj) {
    if (obj) {
      const cricketCard = JSON.parse(JSON.stringify(StaticDataService.defaultCricketCardData));
      cricketCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      cricketCard.match = obj;
      this.matchPopup = false;
      this.increasePendingCount();
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        cricketCard, result => {
          this.decreasePendingCount(null);
          const arr = [];
          arr.push(result);
          this.decideTaskToPerformNew(arr, 0, e => {
            setTimeout(() => {
              this.checkIfLastIsPara(false);
              this.checkForSourceUrlInEmbed(null);
            }, 500);
          });
        });
    } else {
      this.snotify.error('Select a Option', '', this.sharedService.getConfig(false));
    }
  }
  getPopupValueToParentfn(obj) {
    this.matchPopup = obj;
  }

  openElementModal(ev) {
    if (ev === 'review') {
      this.showElementPopup = true;
    }
    else if (ev === 'table') {
      this.tableReusablePopup = true; // for  story insert table | pick from library
    }
    else {
      this.showAmazonPopup = true;
    }
    this.relatedStoryMultipleSelectFlag = false;
    this.sharedService.overflowhidden();
  }

  closeElementModal(ev) {
    this.showElementPopup = false;
    this.showAmazonPopup = false;
    this.tableReusablePopup = false;
    this.sharedService.overflowauto();
  }
  addElementToStory(ev) {
    this.closeElementModal(null);
    // this.closeEmbedModal();
    if (this.storyData.elements.indexOf(ev) === -1) {
      this.decideTaskToPerformNew([{ id: ev }], 0, e => { });
    } else {
      this.snotify.warning('This element already exists in story', '', this.sharedService.getConfig(false));
    }
  }

  setMutualFunds(event) {
    this.mutualFundList = event;
    if (this.mutualFundList.length === 0) {
      this.deactivateMarketSuggestion = false;
    }
  }
  setMarketIndex(event) {
    this.marketList = event;
    if (this.marketList.length === 0) {
      this.deactivateMarketSuggestion = false;
    }
  }

  setNewMarket(event) {
    this.newMarketList = event;
    if (this.newMarketList.length === 0) {
      this.deactivateMarketSuggestion = false;
    }
  }

  setMetadata(event, fields) {
    if (this.isAuthorIdEnabled && fields.auto) {
      this.storyData.metadata[fields.metadataModelIdWithObject] = event;
    } else {
      this.storyData.metadata[fields.metadataModelId] = event;
    }
  }

  getCurrentDataSet(fields) {
    if (this.isAuthorIdEnabled && fields.auto) {
      return this.getValuefromThis(fields.dataModelIdWithObject);
    } else {
      return this.getValuefromThis(fields.dataModelId);
    }
  }

  postReusableElementRequest(obj) {
    obj.metadata.status = 'PUBLISHED';
    this.restService.http_put(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), StaticDataService.element_page_id, StaticDataService.element_save_api)
      + '/' + String(obj.id),
      obj, result => {
      });
  }

  removeLastParaIfEmpty() {
    if (this.storyData.type === 'story') {
      const els = this.storyData.elements;
      els.forEach(id => {
        const el = this.Elements[id];
        if (el && el.type === 'paragraph' && (!el.paragraph || !el.paragraph.body ||
          (el.paragraph.body && this.htmlToPlaintext(el.paragraph.body).trim() === ''))) {
          this.storyData.elements.splice(this.storyData.elements.indexOf(el.id), 1);
          if (this.showTempPara && el.id === this.hideElementId) {
            this.resetLastPara(focus);
          }
        }
      });
    }
  }

  isSummaryMandatoryDomainBased() {
    return (this.storytypesForMandatorySummary.includes(this.storyType))
      && (!this.storyData.summary || this.storyData.summary === null || this.htmlToPlaintext(this.storyData.summary).trim() === '');
  }

  addAutomaticBylineForBreakingNews() {
    if (this.isAutomaticBylineForBreakingNews !== '') {
      const a = this.isAuthorIdEnabled ?
        (this.storyData.metadata.authorsList ?
          this.storyData.metadata.authorsList.filter(e => e.name === this.isAutomaticBylineForBreakingNews).length
          : 0)
        : (this.storyData.metadata.authors ?
          this.storyData.metadata.authors.filter(e => e === this.isAutomaticBylineForBreakingNews).length
          : 0);
      if (a === 0) {
        const b = this.isAuthorIdEnabled ?
          this.authorsSuggestion.filter(e => e.name === this.isAutomaticBylineForBreakingNews)
          : this.authorsSuggestion.filter(e => e === this.isAutomaticBylineForBreakingNews);
        if (b.length > 0) {
          if (this.isAuthorIdEnabled) {
            if (!this.storyData.metadata.authorsList) {
              this.storyData.metadata.authorsList = [];
            }
            this.storyData.metadata.authorsList = [...this.storyData.metadata.authorsList, ...b];
          } else {
            if (!this.storyData.metadata.authors) {
              this.storyData.metadata.authors = [];
            }
            this.storyData.metadata.authors = [...this.storyData.metadata.authors, ...b];
          }
        }
      }
    }
  }

  openChartPopup() {
    this.showChartPopup = true;
    let eventCategory='Insert Chart';
    let eventAction=sessionStorage.getItem(StaticDataService.tenantName);
    let eventLabel='';
    let eventValue=null;
   this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
  }

  addChartToStory(id) {
    this.closeChartPopup();
    if (this.storyData.elements.indexOf(id) === -1) {
      this.decideTaskToPerformNew([{ id }], 0, e => { });
    } else {
      this.snotify.warning('This Chart already exists in story', '', this.sharedService.getConfig(false));
    }
  }

  closeChartPopup() {
    this.showChartPopup = false;
  }

  openWebengagePopup(id) {
    this.restService.http_get(this.config.get('product').baseUrl
    + this.config.getEndPoint(this.config.get('views'), this.page_id, this.get_api)
    + '/' + id).subscribe((data) => {
     this.fillNotificationData(data);
     this.openWebEngagePopup = true;
     this.sharedService.overflowhidden();
     this.currentSegmentIds = [];
     this.currentMoSegmentIds = [];
     this.selectedMoSlug = [];
     this.currentTagIds = [];
     if(this.applications && this.applications.length > 0){
      this.selectedApplications = this.applications;
      this.notification['appTypes'] = [];
      for (let value of this.selectedApplications) {
        this.notification['appTypes'].push(value['deviceType']);
      };
     }
     if(this.notificationType && this.notificationType.length > 0){
      this.selectedNotificationType = this.notificationType.filter(t => t.name === 'Banner');
      if(this.selectedNotificationType.length > 0){
        this.selectedNotificationTypeObject = this.selectedNotificationType[0];
      }
     }

    // segmented notification
    if(this.isSegmentedNotificationEnabled && this.storyData['metadata']['section'] && this.storyData['metadata']['section'].length > 0) {
      
      let url = this.config.get('product').baseUrl + "/api/cms/section-segment?section=" + this.storyData['metadata']['section'];
      if(this.storyData['metadata']['subSection'] && this.storyData['metadata']['subSection'].length > 0) {
        url = url + "&subSection=" + this.storyData['metadata']['subSection'];
      }
  
      this.restService.http_get(encodeURI(url)).subscribe((data) => {
        if(this.enableMoEngage && data && data['moEngageSegment'] && data['moEngageSegment'].length > 0) {
          console.log("setting moengage notification segment");
          this.selectedMoSegments = [];
          this.currentMoSegmentIds = [];
          for(let segment of this.moSegments) {
            if(segment['name'] === data['moEngageSegment']) {
              console.log(JSON.stringify(segment));
              this.selectedMoSegments.push(segment);
              this.currentMoSegmentIds.push(segment['name']);
            }
          }
        }

        console.log(JSON.stringify(this.currentMoSegmentIds));

        if(this.enableWebEngage && data && data['webEngageSegment'] && data['webEngageSegment'].length > 0) {
          console.log("setting webengage notification segment");
          this.selectedSegments = [];
          this.currentSegmentIds = [];
          for(let segment of this.segments) {
            if(segment['name'] === data['webEngageSegment']) {
              console.log(JSON.stringify(segment));
              this.selectedSegments.push(segment);
              this.currentSegmentIds.push(segment['id']);
            }
          }
        }
      },(error)=> {
        console.log("error while getting segments for notification");
      });
    }
    // end of segmented call

    },(error)=> {
      this.snotify.error('Error while fetching story details', '', this.sharedService.getConfig(false));
    });
  }

  closeWebengagePopup() {
    this.openWebEngagePopup = false;
    this.sharedService.overflowauto();
  }

  openCreateSegmentPopup()
  {
    this.openWebEngagePopup = false;
    this.sharedService.overflowauto();
    this.openSegmentPopup = true;
    this.sharedService.overflowhidden();
  }

  closeCreateSegmentPopup()
  {
    this.openSegmentPopup = false;
    this.sharedService.overflowauto();
    this.openWebEngagePopup = true;
    this.sharedService.overflowhidden();
    this.newSegment = '';
  }

  createSegment()
  {
    this.mandatoryFieldSegment = false;
    if(this.newSegment === undefined ||  this.newSegment === null ||  this.newSegment=='')
    {
      console.log("segment is blank");
      this.snotify.error('Please Fill Segment Name', this.sharedService.getConfig(false));
      this.mandatoryFieldSegment = true;
    }else{
      //validate segment
      console.log("segment is submitted");
      let requestSegment = {'name':this.newSegment};
      let url = this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'create_moengage_segment');
      this.http.post(url, requestSegment).subscribe((response) => {
        this.closeCreateSegmentPopup();
        this.fetchMoSegments();
        this.snotify.success('Segment Created Successfully', '', this.sharedService.getConfig(false));
      }, (error) => {
        if(error.error && error.error.text)
        {
          this.snotify.error(error.error.text);
        }else{
          this.snotify.error('Error While Creating Segment', '', this.sharedService.getConfig(false));
        }
      });
    }
  }

  onItemSelect($event, type) {
    if (type) {
      if (type === 'application') {
        this.deviceType = '';
        this.devices = [];
        this.notification['appTypes'] = [];
        for (let value of this.selectedApplications) {
          this.deviceType = this.deviceType.concat(this.applications.filter(app => app['id'] === value['id']).map(res => res['deviceType']).toString(), ',');
          this.devices.push(value['id']);
          this.notification['appTypes'].push(value['deviceType']);
        }
      } else if (type === 'segment') {
        this.currentSegmentIds = [];
        for (let value of this.selectedSegments) {
          this.currentSegmentIds.push(value['id']);
        }
      } else if (type === 'mosegment') {
        this.currentMoSegmentIds = [];
        for (let value of this.selectedMoSegments) {
          console.log(JSON.stringify(value));
          this.currentMoSegmentIds.push(value['name']);
        }
      } else if (type === 'moSlug') {
        if(this.selectedMoSlug[0]['itemName'] !== 'Others') {
          this.notification['title'] = this.selectedMoSlug[0]['itemName'];
        } else if(this.selectedMoSlug[0]['itemName'] === 'Others') {
          this.notification['title'] = '';
        }
      } else if (type === 'crossDomain') {
        this.currentCrossDomainIds = [];
        for (let value of this.selectedCrossDomains) {
          this.currentCrossDomainIds.push(value['name']);
        }
      } else if (type === 'tag') {
        this.currentTagIds = [];
        for (let value of this.selectedTags) {
          this.currentTagIds.push(value['id']);
        }
      } else if (type === 'notificationType') {
        for (let value of this.selectedNotificationType) {
          this.selectedNotificationTypeObject = value;
          this.notification['notificationTypeId'] = value['id'];
        }
        if(this.selectedNotificationTypeObject['name'] !== 'Slug') {
          if (this.storyData['webengageNotificationTitle'] && this.storyData['webengageNotificationTitle'] !== '') {
            this.notification['title'] = this.storyData['webengageNotificationTitle'];
          } else {
            this.notification['title'] = this.storyData['mobileHeadline'];
          }
        } else {
          this.notification['title']= '';
          this.notification['description'] = this.storyData['mobileHeadline'];
        }
      }
    }
    this.sendGaEventNotificationFormEdited(type)
  }

  onSelectAll($event, type) {
    if (type) {
      if (type === 'application') {
        this.selectedApplications = $event;
        this.deviceType = '';
        this.devices = [];
        this.notification['appTypes'] = [];
        for (let value of this.selectedApplications) {
          this.deviceType = this.deviceType.concat(this.applications.filter(app => app['id'] === value['id']).map(res => res['deviceType']).toString(), ',');
          this.devices.push(value['id']);
          this.notification['appTypes'].push(value['deviceType']);
        }
      } else if (type === 'segment') {
        this.selectedSegments = $event;
        this.currentSegmentIds = [];
        for (let value of this.selectedSegments) {
          this.currentSegmentIds.push(value['id']);
        }
      }  else if (type === 'mosegment') {
        this.selectedMoSegments = $event;
        this.currentMoSegmentIds = [];
        for (let value of this.selectedMoSegments) {
          this.currentMoSegmentIds.push(value['name']);
        }
      } else if (type === 'crossDomain') {
        this.selectedCrossDomains = $event;
        this.currentCrossDomainIds = [];
        for (let value of this.selectedCrossDomains) {
          this.currentCrossDomainIds.push(value['name']);
        }
      } else if (type === 'tag') {
        this.selectedTags = $event;
        this.currentTagIds = [];
        for (let value of this.selectedTags) {
          this.currentTagIds.push(value['id']);
        }
      } else if (type === 'notificationType') {
        this.selectedNotificationType = $event;
        this.notification = JSON.parse(JSON.stringify(SharedDataService.defaultNotificationData));
        this.selectedTags = [];
        this.selectedApplications = [];
        this.selectedSegments = [];
        for (let value of this.selectedNotificationType) {
          this.selectedNotificationTypeObject = value;
          this.notification['notificationTypeId'] = value['id'];
        }
      }
    }
    this.sendGaEventNotificationFormEdited(type)
  }

  onItemDeSelect($event, type) {
    if (type) {
      if (type === 'application') {
        this.deviceType = '';
        this.devices = [];
        this.notification['appTypes'] = [];
        this.restService.http_get(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'webengage_applications')).subscribe((response) => {
            if (response) {
              this.applications = response;
              for (let value of this.selectedApplications) {
                this.deviceType = this.deviceType.concat(this.applications.filter(app => app['id'] === value['id']).map(res => res['deviceType']).toString(), ',');
                this.devices.push(value['id']);
                this.notification['appTypes'].push(value['deviceType']);
              }
            }
          }, (error) => {
            console.log(error);
            // this.snotify.error('Error While fetching Applications', '', this.sharedService.getConfig(false));
          });
      } else if (type === 'segment') {
        this.currentSegmentIds = [];
        this.fetchSegments();
        for (let value of this.selectedSegments) {
          this.currentSegmentIds.push(value['id']);
        }
      } else if (type === 'mosegment') {
        this.currentMoSegmentIds = [];
        //this.fetchSegments();
        for (let value of this.selectedMoSegments) {
          this.currentMoSegmentIds.push(value['name']);
        }
      } else if (type === 'moSlug') {
        this.selectedMoSlug = [];
        this.notification['title'] = '';
      } else if (type === 'crossDomain') {
        this.currentCrossDomainIds = [];
        for (let value of this.selectedCrossDomains) {
          this.currentCrossDomainIds.push(value['name']);
        }
      } else if (type === 'tag') {
        this.currentTagIds = [];
        this.fetchTags();
        for (let value of this.selectedTags) {
          this.currentTagIds.push(value['id']);
        }
      } else if (type === 'notificationType') {
        this.notification = JSON.parse(JSON.stringify(SharedDataService.defaultNotificationData));
        this.selectedTags = [];
        this.selectedApplications = [];
        this.selectedSegments = [];
        for (let value of this.selectedNotificationType) {
          this.selectedNotificationTypeObject = value;
          this.notification['notificationTypeId'] = value['id'];
        }
        if (this.selectedNotificationType.length === 0) {
          this.selectedNotificationTypeObject = {};
        }
      }
    }
    this.sendGaEventNotificationFormEdited(type)
  }

  onDeSelectAll(ev, type) {
    if (type) {
      if (type === 'application') {
        this.selectedApplications = ev;
        this.deviceType = '';
        this.devices = [];
        this.notification['appTypes'] = [];
        this.restService.http_get(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'webengage_applications')).subscribe((response) => {
            if (response) {
              this.applications = response;
              for (let value of this.selectedApplications) {
                this.deviceType = this.deviceType.concat(this.applications.filter(app => app['id'] === value['id']).map(res => res['deviceType']).toString(), ',');
                this.devices.push(value['id']);
                this.notification['appTypes'].push(value['deviceType']);
              }
            }
          }, (error) => {
            console.log(error);
            // this.snotify.error('Error While fetching Applications', '', this.sharedService.getConfig(false));
          });
      } else if (type === 'segment') {
        this.selectedSegments = ev;
        this.currentSegmentIds = [];
        this.fetchSegments();
        for (let value of this.selectedSegments) {
          this.currentSegmentIds.push(value['id']);
        }
      } else if (type === 'mosegment') {
        this.selectedMoSegments = ev;
        this.currentMoSegmentIds = [];
        //this.fetchSegments();
        for (let value of this.selectedMoSegments) {
          this.currentMoSegmentIds.push(value['name']);
        }
      } else if (type === 'moSlug') {
        this.selectedMoSlug = [];
        this.notification['title'] = '';
      } else if (type === 'crossDomain') {
        this.selectedCrossDomains = ev;
        this.currentCrossDomainIds = [];
        //this.fetchSegments();
        for (let value of this.selectedCrossDomains) {
          this.currentCrossDomainIds.push(value['name']);
        }
      } else if (type === 'tag') {
        this.selectedTags = ev;
        this.currentTagIds = [];
        this.fetchTags();
        for (let value of this.selectedTags) {
          this.currentTagIds.push(value['id']);
        }
      } else if (type === 'notificationType') {
        this.selectedNotificationType = ev;
        this.notification = JSON.parse(JSON.stringify(SharedDataService.defaultNotificationData));
        this.selectedTags = [];
        this.selectedApplications = [];
        this.selectedSegments = [];
        for (let value of this.selectedNotificationType) {
          this.selectedNotificationTypeObject = value;
          this.notification['notificationTypeId'] = value['id'];
        }
      }
    }
    this.sendGaEventNotificationFormEdited(type)
  }

  fetchApplications() {
    this.restService.http_get(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'webengage_applications')).subscribe((response) => {
        if (response) {
          this.applications = response;
          this.selectedApplications = this.applications;
        }
      }, (error) => {
        console.log(error);
        // this.snotify.error('Error While fetching Applications', '', this.sharedService.getConfig(false));
      });
  }

  fetchTags() {
    this.restService.http_get(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'webengage_tags')).subscribe((response) => {
        if (response && response['response'] && response['response']['data']) {
          this.tags = response['response']['data'];
        }
      }, (error) => {
        console.log(error);
        // this.snotify.error('Error While fetching Tags', '', this.sharedService.getConfig(false));
      });
  }

  fetchSegments() {
    this.restService.http_get(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'webengage_segments')).subscribe((response) => {
        if (response && response['response'] && response['response']['data']) {
          this.segments = response['response']['data'];
        }
      }, (error) => {
        console.log(error);
        //  this.snotify.error('Error While fetching Segments', '', this.sharedService.getConfig(false));
      });
  }

  fetchMoSegments(){
    this.http.get(this.config.get('product').baseUrl
    + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'get_moengage_segments')).subscribe((response) => {
        if(response){
          this.moSegments = response;
        }
    },(error)=>{
      console.log(error);
      console.log('Error While fetching moengage segments');
    });
  }

  fetchCrossDomains(){
    this.http.get(this.config.get('product').baseUrl
    + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'get_cross_domains')).subscribe((response) => {
      if(response){
        this.crossDomains = [];
        for(let item in response)
        {
          let obj = {};
          obj['name'] = response[item];
          obj['id'] = response[item];
          this.crossDomains.push(obj);
        }

      }
    },(error)=>{
      console.log(error);
      // this.snotify.error('Error While fetching Segments', '', this.sharedService.getConfig(false));
    });
  }

  fetchNotificationType() {
    this.restService.http_get(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'webengage_notificationtype')).subscribe((response) => {
        if (response) {
          this.notificationType = response;
          this.selectedNotificationType = this.notificationType.filter(t => t.name === 'Banner');
          if (this.selectedNotificationType.length > 0) {
            this.selectedNotificationTypeObject = this.selectedNotificationType[0];
          }
        }
      }, (error) => {
        console.log(error);
        //  this.snotify.error('Error While fetching Notification Type', '', this.sharedService.getConfig(false));
      });
  }

  fillNotificationData(story: any) {
    console.log(this.selectedNotificationTypeObject)
    if (story) {
      if (story['webengageNotificationTitle'] && story['webengageNotificationTitle'] !== '') {
        this.notification['title'] = story['webengageNotificationTitle'];
      } else {
        this.notification['title'] = story['mobileHeadline'];
      }
      this.notification['description'] = '';


      if (story['metadata'] && story['metadata']['status'] && story['metadata']['status'] !== 'KILLED') {
        if (story['metadata']['url'].charAt(0) !== '/') {
          this.notification['storyUrl'] = story['metadata']['url'];
        } else {
          this.notification['storyUrl'] = this.sharedService.currentDomainUrl + story['metadata']['url'];
        }
      } else {
        this.notification['storyUrl'] = story['metadata']['redirectUrl'];
      }
      this.notification['storyId'] = story['id'];
      if(story['metadata'] && story['metadata']['section'])
       {
        this.notification['section'] = story['metadata']['section'];
       }
      if (story['leadMedia'] && story['leadMedia']['image'] && story['leadMedia']['image']['images']) {
        this.notification['imageUrl'] = story['leadMedia']['image']['images']['960x540'];
      }
      if(story['leadMedia'] && story['leadMedia']['mediaType'] === 'video') {
        if (story['leadMedia']['video']['image']['images']) {
          console.log("filled")
          this.notification['imageUrl'] = story['leadMedia']['video']['image']['images']['960x540'];
        }
      }
    }
  }

  scheduleWebengageNotification() {
    const timeRightNow = new Date();
    if (timeRightNow.getTime() < this.notification.sheduledStartTime) {
      this.notification['recurringSchedule'] = true;
      this.sendWebEngageNotification();
    } else {
      this.snotify.info('Enter a time in future', '', this.sharedService.getConfig(false));
    }
  }

  removeScheduleWebengageNotification() {
    console.log("removing scheduling notification..")
  }

  selectWebengageScheduleDate(value: any, model_id: string, datepicker?: any) {
    this.notification[model_id] = value.start.unix() * 1000;
    this.notification['sheduledEndTime'] = value.end.add(10, 'minute').unix() * 1000;
    this.webEngageSheduledAt = this.notification['sheduledStartTime'];
  }

  calendarWebengageEventsHandler(e: any, model_id: string, method) {
    if (e.event.type === 'apply') {
      let notificationVendor=''
        if(this.enableWebEngage) notificationVendor='WebEngage';
        if(this.enableMoEngage) notificationVendor='MoEngage';
        if(this.enableWebEngage && this.enableMoEngage) notificationVendor=' WebEngage,MoEngage';
        let eventCategory='Notification Scheduled';
        let eventAction=sessionStorage.getItem(StaticDataService.tenantName) +notificationVendor;
        let eventLabel='';
        let eventValue=null;
       this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
      if (method) {
         this.checkForPendingRequests(method, 0, null);
      }
    }

    if (e.event.type === 'cancel') {
    }
  }

  sendWebEngageNotification() {
    let url = '';
    let moengageUrl = '';
    this.disableSendButton = true;
    this.webEngageResponse = false;
    this.moEngaeRespponse = false;
    this.mandatoryFieldUrl = false;
    this.mandatoryImageUrl = false;
    this.mandatoryFieldStoryId = false;
    this.mandatoryFieldMessage = false;
    if(this.notification){
      this.notification['tags'] = this.currentTagIds;
      this.notification['segments'] = this.currentSegmentIds;
      console.log(JSON.stringify(this.currentMoSegmentIds));
      this.notification['moSegments'] = this.currentMoSegmentIds;
      this.notification['crossDomains'] = this.currentCrossDomainIds;
      this.notification['devices'] = this.selectedApplications.map(a => a.id);
      if(!this.notification['notificationTypeId'] && this.selectedNotificationTypeObject){
        this.notification['notificationTypeId'] = this.selectedNotificationTypeObject['id'];
      }
      if(!this.notification['devices'] || this.notification['devices'].length === 0){
        this.snotify.error('Please Select Target Application..', '', this.sharedService.getConfig(false));
        return;
      }
      if (this.notification && !this.notification['storyUrl'] && (this.selectedNotificationTypeObject['name'] === 'External' || this.selectedNotificationTypeObject['name'] === 'Video' || this.selectedNotificationTypeObject['name'] === 'Banner' || this.selectedNotificationTypeObject['name'] === 'Slug')) {
        this.snotify.error('Please Fill Url', this.sharedService.getConfig(false));
        this.mandatoryFieldUrl = true;
        return;
      }
      if (this.notification && !this.notification['imageUrl'] && (this.selectedNotificationTypeObject['name'] === 'Banner' || this.selectedNotificationTypeObject['name'] === 'Slug')) {
        console.log(this.notification)
        this.snotify.error('Please Fill Image Url', this.sharedService.getConfig(false));
        this.mandatoryImageUrl = true;
        return;
      }
      if (this.notification && !this.notification['storyId'] && (this.selectedNotificationTypeObject['name'] === 'Video' || this.selectedNotificationTypeObject['name'] === 'Banner' || this.selectedNotificationTypeObject['name'] === 'Slug')) {
        this.snotify.error('Please Fill StoryId', this.sharedService.getConfig(false));
        this.mandatoryFieldStoryId = true;
        return;
      }
      if(!this.notification['notificationTypeId']){
        this.snotify.error('Please Select NotificationType..', '', this.sharedService.getConfig(false));
        return;
      }
      if(!this.notification['title']){
        this.snotify.error('Please Fill Title..', '', this.sharedService.getConfig(false));
        this.mandatoryFieldMessage = true;
        return;
      }
      if(this.notification['storyId']){
        url = this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'webengage_notify') + '?id=' + this.notification['storyId'];
        moengageUrl = this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'send_moengage_notification') + '?id=' + this.notification['storyId'];
      }else{
        url = this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'webengage_notify');
        moengageUrl = this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'send_moengage_notification');
      }
      if(this.selectedNotificationTypeObject['name'] === 'Breaking News Banner' || this.selectedNotificationTypeObject['name'] === 'Breaking News Text'){
        this.notification['flash'] = true;
      }
      if(this.selectedNotificationTypeObject['name'] === 'External'){
        this.notification['external'] = true;
      }
      if(this.selectedNotificationTypeObject['name'] === 'Banner' || this.selectedNotificationTypeObject['name'] === 'Breaking News Banner' || this.selectedNotificationTypeObject['name'] === 'Slug') {
        this.notification['imageLayout'] = true;
        }
      this.storyData['webengageNotificationTitle'] = this.notification['title'];
      if(!this.enableMoEngage && !this.enableWebEngage)
      {
        this.snotify.error('No Platform Is Enabled For Sending Notification', '', this.sharedService.getConfig(false));
        return;
      }
      if(!this.enableMoEngage)
      {
        this.moEngaeRespponse = true;
      }
      if(!this.enableCrossDomainNotification)
      {
        this.crossDomainResponse = true;
      }
      if(!this.enableWebEngage)
      {
        this.webEngageResponse = true;
      }
      if(this.enableWebEngage)
      {
        this.http.post(url,this.notification).subscribe((response) => {
          this.webEngageResponse = true;
          if(this.notification && this.notification['recurringSchedule']){
          this.snotify.success('WebEngage Notification Scheduled Successfully..', '', this.sharedService.getConfig(false));
        } else {
          if(response)
            this.snotify.success('WebEngage Notification Sent Successfully..', '', this.sharedService.getConfig(false));
        }
        //  if (this.moEngaeRespponse) {
          this.closeWebengagePopup();
        //  }
        this.storyData.metadata['notificationSent'] = true;
        if (this.webEngageSheduledAt) {
          this.storyData['webEngageScheduledAt'] = this.webEngageSheduledAt;
        }
        setTimeout(() => {
          this.fetchWebengageAnalyticsUrl(this.storyData);
          this.currentSegmentIds = [];
          this.currentTagIds = [];
          this.notification = {};
          this.selectedTags = [];
          this.selectedSegments = [];
        }, 4000)
      }, (error) => {
        this.webEngageResponse = true;
        if (error.error === 'Duplicate Notification Title/Description') {
          console.log(error.error);
        } else
          this.snotify.error('Error While Sending WebEngage Notification', '', this.sharedService.getConfig(false));
      });
      let eventCategory='Notification';
          let eventAction=sessionStorage.getItem(StaticDataService.tenantName) +' WebEngage';
          let eventLabel='';
          let eventValue=null;
        this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
      }

      if(this.enableMoEngage)
      {
        console.log("inside moengage call");
        this.http.post(moengageUrl,this.notification).subscribe((response) => {
          console.log("inside moengage success");
          this.moEngaeRespponse = true;
          if(this.notification && this.notification['recurringSchedule']){
          this.snotify.success('MoEengage Notification Scheduled Successfully..', '', this.sharedService.getConfig(false));
        } else {
          if(response)
            this.snotify.success('MoEngage Notification Sent Successfully..', '', this.sharedService.getConfig(false));
        }
        //  if (this.webEngageResponse) {
          this.closeWebengagePopup();
        //  }
        this.storyData.metadata['notificationSent'] = true;

        if (this.webEngageSheduledAt) {
          this.storyData['webEngageScheduledAt'] = this.webEngageSheduledAt;
        }
        setTimeout(() => {
          this.fetchMoengageAnalyticsUrl(this.storyData);
          this.currentSegmentIds = [];
          this.currentTagIds = [];
          this.notification = {};
          this.selectedTags = [];
          this.selectedSegments = [];
        }, 4000)
      }, (error) => {
        this.moEngaeRespponse = true;
        if (error.error === 'Duplicate Notification Title/Description') {
          console.log(error.error);
        } else
          this.snotify.error('Error While Sending MoEngage Notification', '', this.sharedService.getConfig(false));
      });
      let eventCategory='Notification';
      let eventAction=sessionStorage.getItem(StaticDataService.tenantName) +' MoEngage';
      let eventLabel='';
      let eventValue=null;
      this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
      }
      }
    setTimeout(() => {
      this.disableSendButton = false;
    }, 1000);
  }


  fetchWebengageAnalyticsUrl(data: any) {
    if (data) {
      if (data['webengageNotificationTitle']) {
        this.notification['title'] = data['webengageNotificationTitle'];
      }
      if (data['id']) {
        this.notification['storyId'] = data['id'];
      }
      this.notification['appTypes'] = ['Web', 'Android', 'Iphone', 'Ipad'];
      this.http.post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'webengage_analytics'), this.notification).subscribe((response: any[]) => {
          this.webengageAnalyticsData = response;
        },
          (error) => { });
    }
  }

  fetchMoengageAnalyticsUrl(data: any) {
   // console.log("inside fetchMoengageAnalyticsUrl call", JSON.stringify(data));
    if (data) {
      if (data['webengageNotificationTitle']) {
        this.notification['title'] = data['webengageNotificationTitle'];
      }
      if (data['id']) {
        this.notification['storyId'] = data['id'];
      }
      this.notification['appTypes'] = ['Web', 'Android', 'Iphone', 'Ipad'];
      this.http.post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'moengage_analytics'), this.notification).subscribe((response: any[]) => {
          this.moengageAnalyticsData = response;
        },
          (error) => { });
    }
  }


  setCheckForErrorIndicationInNotification(index) {
    //  return true;
    // // if(index === 3){
    // //   return true;
    // // }
  }
  getDomainConfig(currentDomainConfig) {
    // console.log(currentDomainConfig);
    this.domainConfig = currentDomainConfig;
    this.isStoryUrlCreatedFromHeadline = this.sharedService.isdomainConfig('story', 'storyUrlCreatedFromHeadline')


  }
  // removePlag(){
  //   this.plagData = null;
  //   this.storyData.metadata.plagiarismChecked = false;
  // }

  checkPlagiarism(callback) {
    let obj;
    let tempPlagData = this.plagData;
    this.plagData = null;
    this.snotify.info('Checking for Plagiarism...', '', this.sharedService.getConfig(false));
    this.sharedService.sendData('checkingPlag|true');
    this.disableEditPara = true;
    this.restService.http_put(this.config.get('product').utilUrl
          + "/api/cms/plagiarism-check/story/"+this.storyData.id,
          obj , result => {
            if (!result.hasOwnProperty('error')) {
              this.plagData = result;
              this.storyData.metadata.plagiarismChecked = true;
              this.storyData.metadata.plagiarisedContent = parseInt(this.plagData.plagPercent);
              this.storyData.metadata.paraContentChanged = false;
              if(callback) {
                callback()
              }
            } else {
              // this.plagData = tempPlagData;
              this.plagData = null;
              this.snotify.warning(result.error, '', this.sharedService.getConfig(false));
              this.storyData.metadata.plagiarismChecked = true;
              this.storyData.metadata.paraContentChanged = false;
              // let plag = "{\r\n    \"id\": \"6200fafe4ea4311cdc117d9f\",\r\n    \"storyId\": 11643792263182,\r\n    \"plagPercent\": \"95.47%\",\r\n    \"uniquePercent\": \"4.53%\",\r\n    \"matchedURLs\": [\r\n        \"https:\/\/www.livemint.com\/elections\/mulayam-singh-yadav-s-daughter-in-law-aparna-yadav-joins-bjp-ahead-of-up-polls-11642568989632.html\",\r\n        \"https:\/\/www.news18.com\/news\/politics\/up-punjab-uttarakhand-elections-2022-live-updates-goa-manipur-aap-bjp-congress-sp-cmcandidates-livenews-4673060.html\",\r\n        \"https:\/\/timesofindia.indiatimes.com\/city\/chandigarh\/farm-income-has-not-doubled-pain-has-cong\/articleshow\/89006312.cms\",\r\n        \"https:\/\/timesofindia.indiatimes.com\/india\/nadda-announces-bjps-alliance-with-apna-dal-nishad-party-in-up\/articleshow\/88999454.cms\",\r\n        \"https:\/\/economictimes.indiatimes.com\/news\/elections\/assembly-elections\/uttar-pradesh\/up-polls-bjp-president-jp-nadda-announces-alliance-with-apna-dal-nishad-party\/videoshow\/88998944.cms\",\r\n        \"https:\/\/www.zee5.com\/articles\/violation-of-covid-norms-in-up-polls-ec-advises-samajwadi-party-to-be-careful-in-future-2\",\r\n        \"https:\/\/www.indiatoday.in\/elections\/uttar-pradesh-assembly-polls-2022\/video\/up-polls-ec-lets-off-samajwadi-party-with-warning-for-violating-covid-norms-1901673-2022-01-19\",\r\n        \"https:\/\/www.deccanherald.com\/election\/congress-will-expose-failures-of-bjp-on-issues-of-farmers-women-internal-security-in-run-up-to-polls-1072463.html\",\r\n        \"https:\/\/newsonair.gov.in\/News?title=UP%3A-BJP%2C-Apna-Dal%2C-and-Nishad-Party-to-jointly-contest-upcoming-assembly-polls-on-403-seats&id=433827\",\r\n        \"https:\/\/www.hindustantimes.com\/elections\/uttar-pradesh-assembly-election\/up-assembly-polls-2022-bjp-to-jointly-contest-with-apna-dal-and-nishad-party-101642591795197.html\",\r\n        \"https:\/\/twitter.com\/ANI\/status\/1483762027936227329?s=20?ref_src=embedly\",\r\n        \"https:\/\/newsonair.com\/2022\/01\/20\/up-bjp-apna-dal-and-nishad-party-to-jointly-contest-upcoming-assembly-polls-on-403-seats\/\",\r\n        \"https:\/\/www.deccanchronicle.com\/nation\/politics\/190122\/mulayam-singh-yadavs-daughter-in-law-aparna-yadav-joins-bjp.html\",\r\n        \"https:\/\/www.indiatoday.in\/elections\/uttar-pradesh-assembly-polls-2022\/story\/violation-of-covid-norms-in-up-polls-ec-advises-samajwadi-party-to-be-careful-in-future-1901596-2022-01-19\",\r\n        \"https:\/\/www.outlookindia.com\/national\/cong-will-expose-failures-of-bjp-on-issues-of-farmers-women-internal-security-in-run-up-to-polls-news-39695\",\r\n        \"https:\/\/www.livemint.com\/elections\/assembly-elections\/up-elections-2022-bjp-to-jointly-contest-polls-with-apna-dal-nishad-party-11642591708373.html\",\r\n        \"https:\/\/www.business-standard.com\/article\/elections\/up-polls-mulayam-singh-yadav-s-daughter-in-law-aparna-yadav-joins-bjp-122011900362_1.html\",\r\n        \"https:\/\/www.freepressjournal.in\/india\/uttar-pradesh-assembly-polls-bjp-apna-dal-and-nishad-party-will-jointly-contest-polls-on-403-seats-says-jp-nadda\",\r\n        \"https:\/\/www.outlookindia.com\/national\/violation-of-covid-norms-in-up-polls-ec-advises-samajwadi-party-to-be-careful-in-future-news-39273\",\r\n        \"https:\/\/www.tribuneindia.com\/news\/punjab\/navjot-sidhu-randeep-surjewala-target-bjp-on-farmers-issue-362639?ref=epaper\",\r\n        \"https:\/\/m.economictimes.com\/news\/elections\/assembly-elections\/uttar-pradesh\/up-assembly-polls-bjp-to-jointly-contest-403-seats-with-apna-dal-nishad-party-next-month\/articleshow\/88997698.cms\"\r\n    ],\r\n    \"matchedData\": [\r\n        \"The situation was completely different in the raj (rule) of the previous government.\",\r\n        \"Assembly Election 2022 LIVE Updates: BJP national president JP Nadda on Wednesday announced that BJP, Apna Dal, and Nishad Party will jointly contest the upcoming Uttar Pradesh assembly polls on 403 seats.\",\r\n        \"They said that as part of its campaign, senior Congress leaders will hold press conferences in all the poll-bound states on Wednesday on the issue of farmers.\",\r\n        \"They said the party seeks to highlight how the BJP has failed to double farmers\u2019 income and how it has burdened them with additional taxes on farm inputs and given the agrarian community pain due to the farm laws.\",\r\n        \"Addressing a presser, he said, \u201CIn the last two days, we had discussions with all our allies in seat sharing.\",\r\n        \"Women, youths, law, and order have been our focus in the last five years.\",\r\n        \"There was \u2018Gunda raj\u2019, etc. Today everything has changed under our government.\u201D Meanwhile, Amit Palekar, an advocate by profession was announced as Aam Aadmi Party (AAP)\u2019s chief minister face for the upcoming Goa assembly elections.\",\r\n        \"With the model of \u2018Sabka Sath Sabka Vikas, development has been our agenda in all sectors.\",\r\n        \"The Election Commission on Tuesday let off the Samajwadi Party with a light rap for violating Covid-19 norms on its office premises last week, advising it to be careful and ensure such breaches do not happen in the future.\",\r\n        \"Meanwhile, the Congress will \u201Cexpose failures\u201D of the BJP on several issues, including that of farmers and women, internal security, price rise and unemployment, in the run-up to the assembly polls in five states beginning February 10, party sources told PTI.\",\r\n        \"Reportedly, the party has curated a fresh strategy for the upcoming five state polls, wherein the rallies will be telecast live on several social media platforms, that will witness a crowd of around 2 lakh people.\",\r\n        \"Bharatiya Janata Party (BJP) is all set to hold rallies in a \u2018hybrid mode\u2019 amid a ban on physical rallies due to rising cases of Covid-19.\",\r\n        \"Considering that it is the first reported violation during the current round of elections, the Commission advised it to follow all the extant guidelines diligently, according to an order.\",\r\n        \"Be it is connectivity, education, health, etc. In all these aspects our alliance has worked together.\",\r\n        \"On the other hand, Aparna Yadav, daughter-in-law of former Uttar Pradesh chief minister Mulayam Singh Yadav, officially joined the BJP on Wednesday ahead of UP polls.\"\r\n    ],\r\n    \"paraContent\": \"<p><var class=\\\"plagiarism-highlight\\\" style=\\\"font-style:normal\\\">Assembly Election 2022 LIVE Updates: BJP national president JP Nadda on Wednesday announced that BJP, Apna Dal, and Nishad Party will jointly contest the upcoming Uttar Pradesh assembly polls on 403 seats.<\/var> <var class=\\\"plagiarism-highlight\\\" style=\\\"font-style:normal\\\">Addressing a presser, he said, \u201CIn the last two days, we had discussions with all our allies in seat sharing.<\/var> We will fight all 403 seats in UP. This state has given the momentum of development with a double-engine government. <var class=\\\"plagiarism-highlight\\\" style=\\\"font-style:normal\\\">With the model of \u2018Sabka Sath Sabka Vikas, development has been our agenda in all sectors.<\/var> <var class=\\\"plagiarism-highlight\\\" style=\\\"font-style:normal\\\">Be it is connectivity, education, health, etc. In all these aspects our alliance has worked together.<\/var> <var class=\\\"plagiarism-highlight\\\" style=\\\"font-style:normal\\\">Women, youths, law, and order have been our focus in the last five years.<\/var> <var class=\\\"plagiarism-highlight\\\" style=\\\"font-style:normal\\\">The situation was completely different in the raj (rule) of the previous government.<\/var> There was \u2018Gunda raj\u2019, etc. Today everything has changed under our government.\u201D<\/p><p>Meanwhile, Amit Palekar, an advocate by profession was announced as Aam Aadmi Party (AAP)\u2019s chief minister face for the upcoming Goa assembly elections.<\/p><p><var class=\\\"plagiarism-highlight\\\" style=\\\"font-style:normal\\\">On the other hand, Aparna Yadav, daughter-in-law of former Uttar Pradesh chief minister Mulayam Singh Yadav, officially joined the BJP on Wednesday ahead of UP polls.<\/var><\/p><p><var class=\\\"plagiarism-highlight\\\" style=\\\"font-style:normal\\\">Bharatiya Janata Party (BJP) is all set to hold rallies in a \u2018hybrid mode\u2019 amid a ban on physical rallies due to rising cases of Covid-19.<\/var> <var class=\\\"plagiarism-highlight\\\" style=\\\"font-style:normal\\\">Reportedly, the party has curated a fresh strategy for the upcoming five state polls, wherein the rallies will be telecast live on several social media platforms, that will witness a crowd of around 2 lakh people.<\/var><\/p><p><var class=\\\"plagiarism-highlight\\\" style=\\\"font-style:normal\\\">The Election Commission on Tuesday let off the Samajwadi Party with a light rap for violating Covid-19 norms on its office premises last week, advising it to be careful and ensure such breaches do not happen in the future.<\/var> <var class=\\\"plagiarism-highlight\\\" style=\\\"font-style:normal\\\">Considering that it is the first reported violation during the current round of elections, the Commission advised it to follow all the extant guidelines diligently, according to an order.<\/var><\/p><p><var class=\\\"plagiarism-highlight\\\" style=\\\"font-style:normal\\\">Meanwhile, the Congress will \u201Cexpose failures\u201D of the BJP on several issues, including that of farmers and women, internal security, price rise and unemployment, in the run-up to the assembly polls in five states beginning February 10, party sources told PTI.<\/var> <var class=\\\"plagiarism-highlight\\\" style=\\\"font-style:normal\\\">They said that as part of its campaign, senior Congress leaders will hold press conferences in all the poll-bound states on Wednesday on the issue of farmers.<\/var> <var class=\\\"plagiarism-highlight\\\" style=\\\"font-style:normal\\\">They said the party seeks to highlight how the BJP has failed to double farmers\u2019 income and how it has burdened them with additional taxes on farm inputs and given the agrarian community pain due to the farm laws.<\/var><\/p>\",\r\n    \"createdDate\": 1644231422329\r\n}";
              // this.plagData = JSON.parse(plag);
              // this.storyData.metadata.plagiarismChecked = true;; // TEMPORARY REMOVE
              // console.log(this.plagData);
              if(callback) {
                callback()
              }
            }
            this.sharedService.sendData('checkingPlag|false');
            this.disableEditPara = false;
          });

  }

  seoScore() {
    let eventCategory='SEO Score';
    let eventAction=sessionStorage.getItem(StaticDataService.tenantName);
    let eventLabel='';
    let eventValue=null;
   this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
    if (!this.checkSection(false, false) && !!this.storyData.metadata.keywords && this.storyData.metadata.keywords.length >0) {
      this.seoColor = 'blue';
      this.snotify.info('Fetching SEO Details...', '', this.sharedService.getConfig(false));
      this.restService.http_get(this.config.get('product').seoUrl + '/api/cms/seo/story/' + this.storyData.id).subscribe(
        result => {
          if (this.storyData.metadata.keywords.length === 1) {
            this.seoScoreShowDetail = true;
            this.seoScoreShowScore = true;
            this.snotify.clear();
            // console.log(result)
            this.seoDetails = result['seoObjects'][0];
            let seoKeys = Object.keys(this.seoDetails['data']);
            this.seoOverallScore = this.seoDetails['data']['overview']['overallSeoScore'] / 3;
            this.seoComments = [];
            for (let seoKey of seoKeys) {
              if (this.seoDetails['data'][seoKey] && this.seoDetails['data'][seoKey]['Feedback details']) {
                let commentKeys = Object.keys(this.seoDetails['data'][seoKey]['Feedback details'])
                for (let commentKey of commentKeys) {
                  this.seoComments.push(this.seoDetails['data'][seoKey]['Feedback details'][commentKey])
                }
              }
            }
            this.seoColor = this.checkSeoColor();
          } else {
            this.seoScoreShowDetail = false;
            this.seoScoreShowScore = true;
            this.seoOverallScore = result['overallSeoScore'];
            window.open(this.domainConfig['config']['story']['seoAppUrl']);
          }
        },
        error => {
          this.snotify.clear();
          this.snotify.error(error.error, '', this.sharedService.getConfig(false));
        }
      );
    } else {
      if (this.checkSection(false, false)) {
        this.snotify.error('Enter Section', '', this.sharedService.getConfig(false));
      }
      if (!this.storyData.metadata.keywords || this.storyData.metadata.keywords.length < 1) {
        this.snotify.error('Enter Keyword(s)', '', this.sharedService.getConfig(false));
      }

    }
  }


  checkSeoCommentColor(seoComment) {
    if (seoComment['class'] === 'positive') {
      return 'green';
    } else if (seoComment['class'] === 'couldhave') {
      return 'orange';
    } else {
      return 'red';
    }
  }


  checkSeoColor(): string {
    let seoPercentage = this.seoDetails['data']['overview']['overallSeoScore'] / 3;
    if (seoPercentage >= 75) {
      return 'green';
    } else if (seoPercentage >= 30 && seoPercentage < 75) {
      return 'orange';
    } else {
      return 'red';
    }
  }
  openPlagURLpopup() {
    this.openPlagURL = true;
  }
  closePlagUrl() {
    this.openPlagURL = false;
  }

  openPlagUrlWindow(url) {
    window.open(url, '_blank')
  }

  openSeoScore() {
    this.openSeoDetailsPopup = true;
  }
  closeSeoScore() {
    this.openSeoDetailsPopup = false;
  }
  headlineClear() {
    const textHeadline = this.htmlToPlaintext(this.headline);
    if (this.storyType === 'video' && textHeadline === 'Untitled Story') {
      this.headline = '';
    }
  }

  openAmpValidate() {
    this.openAmpDetailsPopup = true;
  }
  closeAmpValidate() {
    this.openAmpDetailsPopup = false;
  }

  changeAmpButtonColorAndShowDetail(status: any) {
    if (status && status == 'FAIL') {
      this.ampButtonColor = 'icon-breaking red';
      this.showAmpDetails = true;
    } else if (status && status == 'PASS') {
      this.ampButtonColor = 'icon-breaking green';
      this.showAmpDetails = false;
    } else {
      this.ampButtonColor = 'icon-breaking';
      this.showAmpDetails = false;
    }

  }

  ampValidation() {
    if (!this.checkSection(false, false)) {
      this.snotify.clear();
      this.snotify.info('Validating AMP...', '', this.sharedService.getConfig(false));
      this.restService.http_get(this.config.get('product').baseUrl + '/cms/amp-validation/story/' + this.storyData.id).subscribe(
        result => {
          if (result["ampResultObject"] && result["ampResultObject"]['data']) {
            this.ampResult = result["ampResultObject"]['data'];
            if (this.ampResult['status'] && (this.ampResult['status'] == 'PASS' || this.ampResult['status'] == 'FAIL')) {
              this.changeAmpButtonColorAndShowDetail(this.ampResult['status']);
              if (result["ampResultObject"]['message'] && result["ampResultObject"]['message'] != '') {
                this.snotify.clear();
                this.snotify.success(result["ampResultObject"]['message'], '', this.sharedService.getConfig(false));
              }
            } else {
              this.changeAmpButtonColorAndShowDetail(this.ampResult['status']);
              if (result["ampResultObject"]['message'] && result["ampResultObject"]['message'] != '') {
                this.snotify.clear();
                this.snotify.error(result["ampResultObject"]['message'], '', this.sharedService.getConfig(false));
              }
            }
          } else {
            this.snotify.clear();
            this.snotify.error("Failed to validate AMP", '', this.sharedService.getConfig(false));
            this.ampResult = '';
            this.changeAmpButtonColorAndShowDetail('');
          }
        },
        error => {
          this.snotify.clear();
          this.snotify.error(error.message, '', this.sharedService.getConfig(false));
          this.ampResult = '';
          this.changeAmpButtonColorAndShowDetail('');
        }
      );
    } else {
      this.snotify.error('Enter Section', '', this.sharedService.getConfig(false));
    }
    let eventCategory='AMP Validator';
    let eventAction=sessionStorage.getItem(StaticDataService.tenantName);
    let eventLabel='';
    let eventValue=null;
   this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
  }

  afterChooseStoryOpenAmazonModal(e) {
    this.embedPopup = true;
    this.showAmazonMeta = true;
  }
  //crated on 04-oct-21
  checkLmDomain() {
    let domainId = sessionStorage.getItem('domainId');
    this.isLMdomain = this.lMDomainId == domainId ? true : false;
  }

  autoSetQuickReadSummary(toggle,index){
    const previousHeadlineState = JSON.parse(this.previousStoryState);
    if(previousHeadlineState==null){

      this.openSummaryPopup(true);
      this.temporaryChangesFlag=true;
    }
   let summaryData=this.summaryElement.nativeElement.innerText;
       summaryData=summaryData.trim();
   let len = summaryData.split(' ').length;
   if(len>this.quickReadMax && toggle.value){
     return this.snotify.error('Summary is more than '+ this.quickReadMax +' words.','',this.sharedService.getConfig(false))
   }
    if(summaryData !='' && len <= this.quickReadMax && toggle.value){
     this.summaryPopup=true;
     if(!this.tempStoryData.quickReadSummary){
      this.tempStoryData.newsletterSummary=summaryData;
       this.storyData.quickReadSummary=summaryData;
       this.tempStoryData.quickReadSummary=summaryData;
     }

    return  this.snotify.error("This is an automated quick read. You can do any required changes, if needed and save.",'',this.sharedService.getConfig(false))
   }
   if((summaryData=='' || summaryData=='\n') && toggle.value){
     console.log('this.newMetas',this.newMetas)
    this.storyData.metadata.dynamicMeta[index].value = false;
    return this.snotify.error("Summary can't be blank",'',this.sharedService.getConfig(false))
   }
  }


  createFaqItem(): FormGroup {
    return this.formBuilder.group({
      key: new FormControl('', [Validators.required]),
      value: new FormControl('', [Validators.required])
    });
  }

  openFaqPopup() {
    this.resetFaqSection();
    this.showFaqPopup = true;
    let eventCategory='Insert Faq';
    let eventAction=sessionStorage.getItem(StaticDataService.tenantName);
    let eventLabel='';
    let eventValue=null;
   this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
  }

  closeFaqPopup() {
    this.resetFaqSection();
    this.showFaqPopup = false;
  }

  resetFaqSection() {
    this.tempFaqData = this.formBuilder.group({
      heading: new FormControl('', [Validators.required]),
      faqs: this.formBuilder.array([ this.createFaqItem() ])
    });
  }

  addFaq() {
    this.faqs = this.tempFaqData.get('faqs') as FormArray;
    this.faqs.push(this.createFaqItem());

  }

  deleteFaq(idx){
    this.faqs = this.tempFaqData.get('faqs') as FormArray;
    this.faqs.removeAt(idx);
  }

  saveFaqs() {
    if(this.tempFaqData.valid){
      let faqData = this.tempFaqData.getRawValue();
      const card = JSON.parse(JSON.stringify(StaticDataService.defaultFaqCardData));
      card.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      card['faqs'] = faqData.faqs;
      card['faqSectionHeading'] = faqData.heading;
      this.increasePendingCount();
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        card, result => {
          this.decreasePendingCount(null);
          this.decideTaskToPerformNew([result], 0, e => {
            setTimeout(() => {
              this.checkIfLastIsPara(false);
            }, 500);
          });
          this.closeFaqPopup();
          //this.storyData.elements.push(result.id);
          //this.viewPortItems.push(result.id);
        });
    } else {
      this.tempFaqData.get('heading').markAsTouched();
      (this.tempFaqData.get('faqs') as FormArray).controls.forEach(e => {
        Object.keys((e as FormGroup).controls).forEach(e1 => {
          (e as FormGroup).controls[e1].markAsTouched();
        });
      });
      this.snotify.error('Enter required fields', '', this.sharedService.getConfig(false));
    }

  }

createStep(): FormGroup {
    return this.formBuilder.group({
      step: new FormControl('', [Validators.required]),
      stepImage: new FormControl(null)
    });
  }
  openStepPopup() {
    this.resetHowToStepsSection();
    this.showStepPopup = true;
    let eventCategory='Insert Steps';
    let eventAction=sessionStorage.getItem(StaticDataService.tenantName);
    let eventLabel='';
    let eventValue=null;
   this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
  }
  closeStepPopup() {
    this.resetHowToStepsSection();
    this.showStepPopup = false;
  }

  closeRecipePopup() {
    this.resetRecipe();
    this.showRecipePopup = false;
  }
  openRecipePopup() {
    this.resetRecipe();
    this.showRecipePopup = true;
  }

  resetRecipe() {
    this.tempRecipeData = this.formBuilder.group({
      recipeName: new FormControl('', [Validators.required]),
      description: new FormControl(''),
      recipeYield: new FormControl(''),
      recipeCuisine: new FormControl(''),
      recipeCategory: new FormControl(''),
      preparationTimeHr: new FormControl('', []),
      preparationTimeMinute: new FormControl('', []),
      cookingTimeHr: new FormControl('', []),
      cookingTimeMinute: new FormControl('', []),
      totalTimeHr: new FormControl('', []),
      totalTimeMinute: new FormControl('', []),
      keywords: new FormControl([]),
      ingredients: new FormControl([]),
      steps: this.formBuilder.array([ this.createStep() ])
    });
  }
  resetHowToStepsSection() {
    this.tempHowToStepsData = this.formBuilder.group({
      heading: new FormControl('', [Validators.required]),
      timeToComplete: new FormControl('', []),
      timeToCompleteinHrs: new FormControl('', []),
      supplies: new FormControl([]),
      tools: new FormControl([]),
      steps: this.formBuilder.array([ this.createStep() ])
    });
  }

  addStep() {
    this.steps = this.tempHowToStepsData.get('steps') as FormArray;
    this.steps.push(this.createStep());
  }

  deleteStep(idx){
    this.steps = this.tempHowToStepsData.get('steps') as FormArray;
    this.steps.removeAt(idx);
  }
  addRecipeStep() {
    this.steps = this.tempRecipeData.get('steps') as FormArray;
    this.steps.push(this.createStep());
  }
  deleteRecipeStep(idx){
    this.steps = this.tempRecipeData.get('steps') as FormArray;
    this.steps.removeAt(idx);
  }

  saveRecipe() {
    // console.log(this.tempRecipeData)
    if(this.tempRecipeData.valid){
      let recipeData = this.tempRecipeData.getRawValue();
      const card = JSON.parse(JSON.stringify(StaticDataService.defaultRecipeCardData));
      card.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      console.log(recipeData)
      if(!recipeData.preparationTimeHr) recipeData.preparationTimeHr=0;
      if(!recipeData.preparationTimeMinute) recipeData.timeToCompleteinHrs=0;
      if(!recipeData.cookingTimeHr) recipeData.timeToComplete=0;
      if(!recipeData.cookingTimeMinute) recipeData.timeToCompleteinHrs=0;
      if(!recipeData.totalTimeHr) recipeData.timeToComplete=0;
      if(!recipeData.totalTimeMinute) recipeData.timeToCompleteinHrs=0;

      card['recipe']['recipeName'] = recipeData.recipeName;
      card['recipe']['description'] = recipeData.description;
      card['recipe']['recipeYield'] = recipeData.recipeYield;
      card['recipe']['recipeCuisine'] = recipeData.recipeCuisine;
      card['recipe']['recipeCategory'] = recipeData.recipeCategory;
      card['recipe']['keywords'] = recipeData.keywords;
      card['recipe']['ingredients'] = recipeData.ingredients;
      card['recipe']['steps'] = recipeData.steps;
      card['recipe']['preparationTimeHr'] = (recipeData.preparationTimeHr === null || recipeData.preparationTimeHr === '' || recipeData.preparationTimeHr <= 999) ? recipeData.preparationTimeHr : 999;
      card['recipe']['preparationTimeMinute'] = (recipeData.preparationTimeMinute === null || recipeData.preparationTimeMinute === '' || recipeData.preparationTimeMinute <= 59) ? recipeData.preparationTimeMinute : 59;
      card['recipe']['cookingTimeHr'] = (recipeData.cookingTimeHr === null || recipeData.cookingTimeHr === '' || recipeData.cookingTimeHr <= 999) ? recipeData.cookingTimeHr : 999;
      card['recipe']['cookingTimeMinute'] = (recipeData.cookingTimeMinute === null || recipeData.cookingTimeMinute === '' || recipeData.cookingTimeMinute <= 59) ? recipeData.cookingTimeMinute : 59;
      card['recipe']['totalTimeHr'] = (recipeData.totalTimeHr === null || recipeData.totalTimeHr === '' || recipeData.totalTimeHr <= 999) ? recipeData.totalTimeHr : 999;
      card['recipe']['totalTimeMinute'] = (recipeData.totalTimeMinute === null || recipeData.totalTimeMinute === '' || recipeData.totalTimeMinute <= 59) ? recipeData.totalTimeMinute : 59;

      this.increasePendingCount();
      console.log(card);
      this.restService.http_post(this.config.get('product').baseUrl +
         this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        card, result => {
            this.decreasePendingCount(null);
            this.decideTaskToPerformNew([result], 0, e => {
              setTimeout(() => {
                this.checkIfLastIsPara(false);
              }, 500);
            });
            this.closeRecipePopup();
            // this.storyData.elements.push(result.id);
            // this.viewPortItems.push(result.id);
        });
    } else {
      console.log(this.tempRecipeData.getRawValue());
      this.tempRecipeData.get('recipeName').markAsTouched();
      (this.tempRecipeData.get('steps') as FormArray).controls.forEach(e => {
        Object.keys((e as FormGroup).controls).forEach(e1 => {
          (e as FormGroup).controls[e1].markAsTouched();
        });
      });
      this.snotify.error('Enter required fields', '', this.sharedService.getConfig(false));
    }
  }

  saveHowToSteps() {
    console.log(this.tempHowToStepsData.valid);
    if(this.tempHowToStepsData.valid){
      let howToStepsData = this.tempHowToStepsData.getRawValue();
      const card = JSON.parse(JSON.stringify(StaticDataService.defaultHowToStepsCardData));
      card.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);

      //sid if value null /''/undefinde assign 0
      if(!howToStepsData.timeToComplete) howToStepsData.timeToComplete=0;
      if(!howToStepsData.timeToCompleteinHrs) howToStepsData.timeToCompleteinHrs=0;
      //
      card['heading'] = howToStepsData.heading;
      card['timeToComplete'] = (howToStepsData.timeToComplete === null || howToStepsData.timeToComplete === '' || howToStepsData.timeToComplete <= 59) ? howToStepsData.timeToComplete : 59;
      card['timeToCompleteinHrs'] = (howToStepsData.timeToCompleteinHrs === null || howToStepsData.timeToCompleteinHrs === '' || howToStepsData.timeToCompleteinHrs <= 999) ? howToStepsData.timeToCompleteinHrs : 999;
      card['supplies'] = howToStepsData.supplies;
      card['tools'] = howToStepsData.tools;
      card['steps'] = howToStepsData.steps;
      this.increasePendingCount();
      console.log(card);
      this.restService.http_post(this.config.get('product').baseUrl +
         this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        card, result => {
            this.decreasePendingCount(null);
            this.decideTaskToPerformNew([result], 0, e => {
              setTimeout(() => {
                this.checkIfLastIsPara(false);
              }, 500);
            });
            this.closeStepPopup();
            // this.storyData.elements.push(result.id);
            // this.viewPortItems.push(result.id);

        });
    } else {
      this.tempHowToStepsData.get('heading').markAsTouched();
      // this.tempHowToStepsData.get('timeToComplete').markAsTouched();
      (this.tempHowToStepsData.get('steps') as FormArray).controls.forEach(e => {
        Object.keys((e as FormGroup).controls).forEach(e1 => {
          (e as FormGroup).controls[e1].markAsTouched();
        });
      });
      this.snotify.error('Enter required fields', '', this.sharedService.getConfig(false));
    }
  }

  suppliesChangeFunc(ev) {
    this.tempHowToStepsData.patchValue({'supplies': ev});
  }

  toolsChangeFunc(ev) {
    this.tempHowToStepsData.patchValue({'tools': ev});
  }
  ingredientsChangeFunc(ev) {
    this.tempRecipeData.patchValue({'ingredients': ev});
  }
  keywordsChangeFunc(ev) {
    this.tempRecipeData.patchValue({'keywords': ev});
  }

  removeStepImage(idx, model){
    if (model === 'howToSteps') {
      this.steps = this.tempHowToStepsData.get('steps') as FormArray;
    } else if (model === 'recipe') {
      this.steps = this.tempRecipeData.get('steps') as FormArray;
    }
    this.steps.at(idx).patchValue({stepImage: null});
  }

  getImageNameFromUrl(images) {
    let nameArr = images.original.split('/');
    let name = nameArr.slice(-1).pop();
    return name;
  }

  validateKeyPressForNumberOnlyField(ev: any) {
    // Define all the allowed keys, by keycode
    let keys = {38:true,39:true,40:true,37:true,16:true,8:true,46:true,48:true,49:true, 50:true,51:true,52:true,53:true,
      54:true,55:true,56:true,57:true,96:true,97:true,98:true,99:true,100:true,101:true,102:true,103:true,104:true,105:true};

    // If the pressed key is not listed above, do not perform any action
    if(!keys[ev.keyCode]) { ev.preventDefault(); }
  }

  validateMaxPositionValue(ev: any) {
    // Restrict the max input value to: 999
    if(ev.target.value > 999)
      ev.target.value = 999;
  }
  snowplowAnalytics(name) {
    const ur = this.router.routerState.snapshot.url;
    this.sharedService.analyticsCall((window.location.origin + ur), 'tab', [], name);
  }

  changeCheck(ev, type){
    let keys = {38:true,39:true,40:true,37:true,16:true,8:true,46:true,48:true,49:true, 50:true,51:true,52:true,53:true,
      54:true,55:true,56:true,57:true,96:true,97:true,98:true,99:true,100:true,101:true,102:true,103:true,104:true,105:true};

    // If the pressed key is not listed above, do not perform any action
    if(!keys[ev.keyCode]) { ev.preventDefault(); }

    if(type === 'second') {
      setTimeout(() => {
        if(parseInt(this.secondMeta) > 59) {
          this.secondMeta = '59';
          // this.durationSet();
        }
      }, 100);
    }
  }

  durationSet(){
    // if(!this.minuteMeta) {
    //   this.minuteMeta = '00'
    // }
    // if(!this.secondMeta) {
    //   this.secondMeta = '00'
    // }
    setTimeout(() => {
      let duration = ""+ (this.minuteMeta ? this.minuteMeta : '00') +":"+((parseInt(this.secondMeta) < 10)? '0'+parseInt(this.secondMeta) : (this.secondMeta ? this.secondMeta : '00'));

      console.log(this.minuteMeta, this.secondMeta, duration)
      this.storyData.metadata.videoMetadata.videoDuration = duration;
    }, 500);


  }

  deleteWebStorySlide(index)
  {
    delete this.Elements[this.storyData.elements[index]];
    this.storyData.elements.splice(index,1);
  }

  updateStoryData(event)
  {
    this.storyData = event;
  }

  updateSlideMetaTitle(event) {
    this.webStoryElementRef.updateSlideMetaTitle(event);
  }

  updateSlideMetaDescription(event) {
    this.webStoryElementRef.updateSlideMetaDescription(event);
  }

  updateAltText(event) {
    this.webStoryElementRef.updateAltText(event);
  }

  updateCreditInfo(event) {
    this.webStoryElementRef.updateCreditInfo(event);
  }

  updateSlideKeywords(event)
  {
    this.webStoryElementRef.updateSlideKeywords(event);
  }

  editData(type)
  {
    this.webStoryElementRef.currentEditDataType = type;
  }

  lightBoxLogo(){
    this.logoPosition = this.webStoryElementRef.currentSlideElement.logoPosition;
    this.isLightboxLogo = true;
  }
  closeLightBoxLogo()
  {
    this.logoPosition = null;
    this.isLightboxLogo = false;
  }

  lightBoxCoverImage(){

    this.isLightboxCoverImage = true;
  }

  closeLightBoxCoverImage()
  {
    this.isLightboxCoverImage = false;
  }

  uploadCoverImage(event)
  {
    //this.webStoryElementRef.uploadCoverImage(event);
    this.webStoryElementRef.insertCoverImage();
    this.closeLightBoxCoverImage();
    //this.snotify.success('Cover image uploaded successfully', '', this.sharedService.getConfig(false));
  }

  removeCoverImage()
  {
    if(this.storyData.webStoryTemplate != null && this.storyData.webStoryTemplate)
    {
      this.snotify.error('Cover image is mandatory for template, please uncheck the template first', '', this.sharedService.getConfig(false))
    } else
    {
      this.storyData.coverImageUrl = null;
      //this.storyData.leadMedia = null;
      this.storyData.leadMedia.elements = [];
      this.storyData.imageAmpValidated = false;
      this.storyData.leadMedia.mediaType = null;
      this.closeLightBoxCoverImage();
      this.snotify.success('Cover image removed successfully', '', this.sharedService.getConfig(false));
    }
  }

  setAsTemplate(value)
  {
    if(value.target.checked)
    {
      if(this.storyData.coverImageUrl == null || this.storyData.leadMedia.elements == null || this.storyData.leadMedia.elements.length == 0)
      {
        this.snotify.error('Cover image is mandatory to mark story as a template, please upload cover image first', '', this.sharedService.getConfig(false));
        document.getElementById('useAsTemplate')['checked'] = false;
      } else
      {
        this.storyData.webStoryTemplate = value.target.checked;
      }
    }else{
      this.storyData.webStoryTemplate = value.target.checked;
    }
  }

  setLogoPosition()
  {
    if(this.logoPosition != null)
    {
      this.webStoryElementRef.useLogo(this.logoPosition);
      this.webStoryElementRef.updateSlide(flag2 => {});
      this.closeLightBoxLogo();
      this.snotify.success('Logo uploaded successfully', '', this.sharedService.getConfig(false));
    }else{
      this.snotify.error('Please select logo position', '', this.sharedService.getConfig(false));
    }
  }

  selecttLogoPosition(event)
  {
    this.logoPosition = event.target.value;
  }

  align(event)
  {
    if(event.target.value == 'left')
    {
      this.webStoryElementRef.setLeftMargin('0%','auto');
    }
    if(event.target.value == 'right')
    {
      this.webStoryElementRef.setRightMargin('0%','auto');
    }
    if(event.target.value == 'top')
    {
      this.webStoryElementRef.setTopMargin('0%','auto');
    }
    if(event.target.value == 'bottom')
    {
      this.webStoryElementRef.setBottomMargin('0%','auto');
    }
    if(event.target.value == 'topBottomCenter')
    {
      this.webStoryElementRef.setTopBottomCenterMargin();
    }
    if(event.target.value == 'leftRightCenter')
    {
      this.webStoryElementRef.setLeftRightCenterMargin();
    }

  }

  changeMargin(event)
  {
    this.webStoryElementRef.changeMargin(event,5);
  }

  sizeChange(type,event)
  {
    if(type == 'width')
    {
      this.webStoryElementRef.widthChange(event.target.value)
    }
    if(type == 'topPadding')
    {
      this.webStoryElementRef.topPaddingChange(event.target.value);
    }
    if(type == 'bottomPadding')
    {
      this.webStoryElementRef.bottomPaddingChange(event.target.value);
    }
  }

  selectAnimation(event)
  {
    this.storyData.slideAnimation = event.target.value;
    this.webStoryElementRef.webStory.slideAnimation = event.target.value;
  }

  updateWebStoryHeadline()
  {
    this.storyData.mobileHeadline = this.htmlToPlaintextExcludeItalic(this.headline);
    this.storyData.metadata.metaTitle = this.storyData.mobileHeadline.replace(/\&nbsp;/g, '');
  }

  updateWebStorySummary()
  {
    this.storyData.summary = this.summary;
    if(this.storyData.metadata.copyFromHeadline)
    {
      this.storyData.metadata.metaDescription = cloneDeep(this.storyData.summary);
    }
  }

  updateWebStoryButtonUrl()
  {
    let buttonUrl = this.webStoryElementRef.buttonUrl
    if(buttonUrl !== undefined && buttonUrl != null && buttonUrl !='')
    {
      this.webStoryElementRef.currentTextboxOrButtonElements[this.webStoryElementRef.currentTextboxOrButtonElementIndex].url = cloneDeep(buttonUrl);
      this.webStoryElementRef.currentTextboxOrButtonElements[this.webStoryElementRef.currentTextboxOrButtonElementIndex].type="button";
    }else{
      this.webStoryElementRef.currentTextboxOrButtonElements[this.webStoryElementRef.currentTextboxOrButtonElementIndex].type="textbox";
    }
    this.webStoryElementRef.updateSlide(res=>{});
  }

  changeFontFamily(event)
  {
    // let fontFamily=this.webStoryElementRef.fontFamily;
    // if(fontFamily !== undefined && fontFamily != null && fontFamily !='')
    // {
    //   this.webStoryElementRef.currentTextboxOrButtonElements[this.webStoryElementRef.currentTextboxOrButtonElementIndex].fontFamily=cloneDeep(fontFamily);
    // }
    // this.webStoryElementRef.updateSlide(res=>{});
    this.webStoryElementRef.setFontFamily();
  }

  changeFontSize(event)
  {
    // let fontSize=this.webStoryElementRef.fontSize;
    // if(fontSize !== undefined && fontSize != null && fontSize !='')
    // {
    //   this.webStoryElementRef.currentTextboxOrButtonElements[this.webStoryElementRef.currentTextboxOrButtonElementIndex].fontSize=cloneDeep(fontSize);
    // }
    // this.webStoryElementRef.updateSlide(res=>{});
    this.webStoryElementRef.setFontSize();
  }

  changeFontStyle(event)
  {
    // let fontStyle=this.webStoryElementRef.fontStyle;
    // if(fontStyle !== undefined && fontStyle != null && fontStyle !='')
    // {
    //   this.webStoryElementRef.currentTextboxOrButtonElements[this.webStoryElementRef.currentTextboxOrButtonElementIndex].fontStyle=cloneDeep(fontStyle);
    // }
    // this.webStoryElementRef.updateSlide(res=>{});
    this.webStoryElementRef.setFontStyle();
  }

  changeTextAlignment(align)
  {
    this.webStoryElementRef.setTextAlignment(align);
  }

  public changeFontColor(color: string) {
    this.webStoryElementRef.fontColor = color;
    this.webStoryElementRef.setFontColor();
  }

  public changeBackgroundColor(color: string) {
    this.webStoryElementRef.backgroundColor = color;
    this.webStoryElementRef.setBackgroundColor();
  }

  public changeBorderColor(color: string) {
    this.webStoryElementRef.borderColor = color;
    this.webStoryElementRef.setBorderColor();
  }

  closeColorPicker(event)
  {
    this.webStoryElementRef.focusTextboxOrButton(event);
  }

  changeBorderStyle()
  {
    this.webStoryElementRef.setBorderStyle();
  }

  changeTextTransform(textTransform)
  {
    this.webStoryElementRef.setTextTransform(textTransform);
  }

  changeBorderLeft()
  {
    this.webStoryElementRef.changeBorderLeft();
  }

  changeBorderTop()
  {
    this.webStoryElementRef.changeBorderTop();
  }

  changeBorderRight()
  {
    this.webStoryElementRef.changeBorderRight();
  }

  changeBorderBottom()
  {
    this.webStoryElementRef.changeBorderBottom();
  }

  changeBorder()
  {
    this.webStoryElementRef.changeBorder();
  }

  changeCornerRadius()
  {
    this.webStoryElementRef.setCornerRadius();
  }

  setAsFontColor(value)
  {
    if(value.target.checked)
    {
      this.webStoryElementRef.fontColor = '#000000';
      this.webStoryElementRef.setFontColor();
    }else{
      this.webStoryElementRef.fontColor = null;
      this.webStoryElementRef.setFontColor();
    }
  }

  setAsBackgroundColor(value)
  {
    if(value.target.checked)
    {
      this.webStoryElementRef.backgroundColor = '#FFFFFF';
      this.webStoryElementRef.setBackgroundColor();
    }else{
      this.webStoryElementRef.backgroundColor = null;
      this.webStoryElementRef.setBackgroundColor();
    }
  }

  setAsBorderColor(value)
  {
    if(value.target.checked)
    {
      this.webStoryElementRef.borderColor = '#000000';
      this.webStoryElementRef.setBorderColor();
    }else{
      this.webStoryElementRef.borderColor = null;
      this.webStoryElementRef.setBorderColor();
    }
  }

  replaceElementData(ev)
  {
    if(ev!== null) {
      this.Elements = ev;
    }else{
      this.Elements={};
    }
  }


  validateMaxPositionValueMin(ev: any) {
    // Restrict the max input value to: 999
    if(ev.target.value > 59)
      ev.target.value = 59;
  }
  replacingVideoThumbnail(event){
    // for replacing video thumbnail data
    this.storyData['leadMedia']['video']['image']['images']={};
    this.storyData['leadMedia']['video']['image']['images']={...event.imagemap};
  }

  closeStoryVersion() {
    this.showStoryVersion = false;
  }

  openStoryVersion(index) {
    if (this.versionHistory.changes !== null && this.versionHistory.changes !== undefined && this.versionHistory.changes.length > 1) {
      this.storyVersionindex = index;
      this.showStoryVersion = true;
    }
  }

  restoreStory(ev) {
    console.log('index :: ', ev);
    this.openVersionInPreview(ev);
    this.closeStoryVersion();
  }

  removeAutoBackLinkFromList(word,index){
    for (let ele of this.elReference['_results']) {
     // console.log('ele.cardData',ele.cardData)
     //if not null
      if(ele.cardData && ele.cardData.paragraph && ele.cardData.paragraph.body)
     ele.getremoveAutoBackLinkFromList(ele.cardData.paragraph.body,word)
    }
  this.autoBackLinkList.splice(index,1);

  }

  getStoryUrl() {
    if(this.storyData && this.storyData.metadata && this.storyData.metadata.status && this.storyData.metadata.status !== 'KILLED') {
      if(this.storyData.metadata.url) {
        if(this.storyData.metadata.url.charAt(0) !== '/' && this.storyData.metadata.url.substring(0,4) !== 'http'){
          return this.storyData.metadata.url;
        } else {
          if(this.sharedService.currentDomainUrl === null || this.sharedService.currentDomainUrl === undefined || this.sharedService.currentDomainUrl.trim() === ''){
            let obj = environment.domainBaseUrls.filter(e => e.id === sessionStorage.getItem(StaticDataService.domainLiteral));
            if(obj)
              return obj[0].baseUrl + this.storyData.metadata.url;
            return '';
          } else {
            return this.sharedService.currentDomainUrl + this.storyData.metadata.url;
          }
        }
      } else {
        return '';
      }
    } else {
      return this.storyData.metadata.redirectUrl;
    }
  }

  updateVideoCaption(event){
    //updating video caption before publish
    //via @output from element module
    //function --> addVideoCaption

    if(this.storyData && this.storyData.leadMedia && this.storyData.leadMedia.video)
       {
        this.storyData['leadMedia']['video']['caption']=event;
       }
  }

  updateVideoImageCaption(event){
    //updating video Image caption before publish
    //via  @output element module
    //function --> addVideoCaption
    if(this.storyData && this.storyData.leadMedia && this.storyData.leadMedia.video && this.storyData.leadMedia.video.image){
      this.storyData['leadMedia']['video']['image']['caption']=event;
    }
  }

  openPodcastPopup() {
    this.showPodcastPopup = true;
  }
  openPodcastPopupLiveblogEmbed(flag) {
    console.log('called openPodcastPopupLiveblogEmbed')
    this.showPodcastPopup = true;
    this.isLiveblogEmbedCalled=flag;
  }
  closePodcastPopup() {
    this.showPodcastPopup = false;
  }

  getPodcastPublishers() {
    const url = this.config.get('product').baseUrl + '/api/cms/podcast/publishers';
    this.restService.http_get(url)
      .subscribe(data => {
        this.publisherListArray = data;
        localStorage.setItem('podcastPublisherList', JSON.stringify(data));
      });
  }

  getPodcastCardDetails(ev) {
    this.closePodcastPopup();
    this.savePodcastCard(ev);
  }

  savePodcastCard(ev) {
    let podcastData = ev;
    const card = JSON.parse(JSON.stringify(StaticDataService.defaultPodcastCardData));
    card.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);

    let obj = StaticDataService.defaultPodcastCardData.podcast;
    obj.podcastId = podcastData.id;
    obj.podcastTitle = podcastData.title;
    obj.podcastContent = podcastData.content;
    obj.podcastImage = podcastData.episode_image;
    obj.podcastUrl = podcastData.href;
    obj.podcastMp3Url = podcastData.mp3_url;
    obj.podcastPublisher.id = podcastData.publisherId;
    obj.podcastPublisher.name = podcastData.publisherName;


    card['podcast'] = obj;
    // card['podcastTitle'] = podcastData.title;
    // card['podcastContent'] = podcastData.content;
    // card['podcastImage'] = podcastData.episode_image;
    // card['podcastUrl'] = podcastData.href;
    // card['podcastMp3Url'] = podcastData.mp3_url;
    // card['podcastPublisher']['id'] = podcastData.publisherId;
    // card['podcastPublisher']['name'] = podcastData.publisherName;

    this.increasePendingCount();
    console.log(card);
    this.restService.http_post(this.config.get('product').baseUrl +
        this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      card, result => {
          this.decreasePendingCount(null);
          this.decideTaskToPerformNew([result], 0, e => {
            setTimeout(() => {
              this.checkIfLastIsPara(false);
            }, 500);
          });
          this.closePodcastPopup();
      });
  }
  loadMore(){
    //to load next reuired element
    this.copyliveBlogShowMaxEle=this.copyliveBlogShowMaxEle + this.liveBlogShowMaxEle;
  }con
  updateDragViewImages(){
    //for getting drag images from photogalley viewImages
    console.log('updateDragViewImages',this.viewImagesData)
    let data=[];
    for(let obj of this.viewImagesData){
       data.push(obj.id);
    }
    console.log('storyData',this.storyData.elements)
    console.log('data',data);
    this.showViewImagePopup=false;
    this.isLightbox=false;
    this.storyData.elements=[...data]
  }
  cancelViewImages(){
    if(this.isDraggedImages){
      const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true); // Omit props what i don't need
      this.snotify.confirm('Changes are not saved. Do you still want to proceed?', '', {
        ...config,
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.snotify.remove(toast.id);
              this.disableshowGallery();
              this.googleAnalytics("Skippable Alerts",'Changes are not saved. Do you still want to proceed?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' , null);
            }, bold: false
          },
          {
            text: 'No', action: (toast) => {
              this.snotify.remove(toast.id);
              this.googleAnalytics("Skippable Alerts",'Changes are not saved. Do you still want to proceed?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' , null);
            }
          }
        ]
      });
    }else{
      this.disableshowGallery();
    }
    
  }
  sendGaEventNotificationFormEdited(field){
    let fieldName=field;
    let notificationVendor=''
    if(this.enableWebEngage) notificationVendor='WebEngage';
    if(this.enableMoEngage) notificationVendor='MoEngage';
    if(this.enableWebEngage && this.enableMoEngage) notificationVendor=' WebEngage,MoEngage';
    let eventCategory='Notification Form';
    let eventAction=fieldName +" "+sessionStorage.getItem(StaticDataService.tenantName) +notificationVendor;
    let eventLabel='';
    let eventValue=null;
   this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)

  }
  googleAnalytics(eventCategory,eventAction,eventLabel,eventValue){
   this.gaService.gaEventView(eventCategory,eventAction,eventLabel,eventValue)
  }
}
